!(function (e, t) {
  "use strict";
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = e.document
        ? t(e, !0)
        : function (e) {
            if (!e.document)
              throw new Error("jQuery requires a window with a document");
            return t(e);
          })
    : t(e);
})("undefined" != typeof window ? window : this, function (C, e) {
  "use strict";
  var t = [],
    r = Object.getPrototypeOf,
    s = t.slice,
    g = t.flat
      ? function (e) {
          return t.flat.call(e);
        }
      : function (e) {
          return t.concat.apply([], e);
        },
    u = t.push,
    i = t.indexOf,
    n = {},
    o = n.toString,
    v = n.hasOwnProperty,
    a = v.toString,
    l = a.call(Object),
    y = {},
    m = function (e) {
      return (
        "function" == typeof e &&
        "number" != typeof e.nodeType &&
        "function" != typeof e.item
      );
    },
    x = function (e) {
      return null != e && e === e.window;
    },
    E = C.document,
    c = { type: !0, src: !0, nonce: !0, noModule: !0 };
  function b(e, t, n) {
    var r,
      i,
      o = (n = n || E).createElement("script");
    if (((o.text = e), t))
      for (r in c)
        (i = t[r] || (t.getAttribute && t.getAttribute(r))) &&
          o.setAttribute(r, i);
    n.head.appendChild(o).parentNode.removeChild(o);
  }
  function w(e) {
    return null == e
      ? e + ""
      : "object" == typeof e || "function" == typeof e
      ? n[o.call(e)] || "object"
      : typeof e;
  }
  var f = "3.6.0",
    S = function (e, t) {
      return new S.fn.init(e, t);
    };
  function p(e) {
    var t = !!e && "length" in e && e.length,
      n = w(e);
    return (
      !m(e) &&
      !x(e) &&
      ("array" === n ||
        0 === t ||
        ("number" == typeof t && 0 < t && t - 1 in e))
    );
  }
  (S.fn = S.prototype =
    {
      jquery: f,
      constructor: S,
      length: 0,
      toArray: function () {
        return s.call(this);
      },
      get: function (e) {
        return null == e
          ? s.call(this)
          : e < 0
          ? this[e + this.length]
          : this[e];
      },
      pushStack: function (e) {
        var t = S.merge(this.constructor(), e);
        return (t.prevObject = this), t;
      },
      each: function (e) {
        return S.each(this, e);
      },
      map: function (n) {
        return this.pushStack(
          S.map(this, function (e, t) {
            return n.call(e, t, e);
          })
        );
      },
      slice: function () {
        return this.pushStack(s.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      even: function () {
        return this.pushStack(
          S.grep(this, function (e, t) {
            return (t + 1) % 2;
          })
        );
      },
      odd: function () {
        return this.pushStack(
          S.grep(this, function (e, t) {
            return t % 2;
          })
        );
      },
      eq: function (e) {
        var t = this.length,
          n = +e + (e < 0 ? t : 0);
        return this.pushStack(0 <= n && n < t ? [this[n]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: u,
      sort: t.sort,
      splice: t.splice,
    }),
    (S.extend = S.fn.extend =
      function () {
        var e,
          t,
          n,
          r,
          i,
          o,
          a = arguments[0] || {},
          s = 1,
          u = arguments.length,
          l = !1;
        for (
          "boolean" == typeof a && ((l = a), (a = arguments[s] || {}), s++),
            "object" == typeof a || m(a) || (a = {}),
            s === u && ((a = this), s--);
          s < u;
          s++
        )
          if (null != (e = arguments[s]))
            for (t in e)
              (r = e[t]),
                "__proto__" !== t &&
                  a !== r &&
                  (l && r && (S.isPlainObject(r) || (i = Array.isArray(r)))
                    ? ((n = a[t]),
                      (o =
                        i && !Array.isArray(n)
                          ? []
                          : i || S.isPlainObject(n)
                          ? n
                          : {}),
                      (i = !1),
                      (a[t] = S.extend(l, o, r)))
                    : void 0 !== r && (a[t] = r));
        return a;
      }),
    S.extend({
      expando: "jQuery" + (f + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (e) {
        throw new Error(e);
      },
      noop: function () {},
      isPlainObject: function (e) {
        var t, n;
        return (
          !(!e || "[object Object]" !== o.call(e)) &&
          (!(t = r(e)) ||
            ("function" ==
              typeof (n = v.call(t, "constructor") && t.constructor) &&
              a.call(n) === l))
        );
      },
      isEmptyObject: function (e) {
        var t;
        for (t in e) return !1;
        return !0;
      },
      globalEval: function (e, t, n) {
        b(e, { nonce: t && t.nonce }, n);
      },
      each: function (e, t) {
        var n,
          r = 0;
        if (p(e)) {
          for (n = e.length; r < n; r++)
            if (!1 === t.call(e[r], r, e[r])) break;
        } else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
        return e;
      },
      makeArray: function (e, t) {
        var n = t || [];
        return (
          null != e &&
            (p(Object(e))
              ? S.merge(n, "string" == typeof e ? [e] : e)
              : u.call(n, e)),
          n
        );
      },
      inArray: function (e, t, n) {
        return null == t ? -1 : i.call(t, e, n);
      },
      merge: function (e, t) {
        for (var n = +t.length, r = 0, i = e.length; r < n; r++) e[i++] = t[r];
        return (e.length = i), e;
      },
      grep: function (e, t, n) {
        for (var r = [], i = 0, o = e.length, a = !n; i < o; i++)
          !t(e[i], i) !== a && r.push(e[i]);
        return r;
      },
      map: function (e, t, n) {
        var r,
          i,
          o = 0,
          a = [];
        if (p(e))
          for (r = e.length; o < r; o++)
            null != (i = t(e[o], o, n)) && a.push(i);
        else for (o in e) null != (i = t(e[o], o, n)) && a.push(i);
        return g(a);
      },
      guid: 1,
      support: y,
    }),
    "function" == typeof Symbol && (S.fn[Symbol.iterator] = t[Symbol.iterator]),
    S.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (e, t) {
        n["[object " + t + "]"] = t.toLowerCase();
      }
    );
  var d = (function (n) {
    var e,
      d,
      b,
      o,
      i,
      h,
      f,
      g,
      w,
      u,
      l,
      T,
      C,
      a,
      E,
      v,
      s,
      c,
      y,
      S = "sizzle" + 1 * new Date(),
      p = n.document,
      k = 0,
      r = 0,
      m = ue(),
      x = ue(),
      A = ue(),
      N = ue(),
      j = function (e, t) {
        return e === t && (l = !0), 0;
      },
      D = {}.hasOwnProperty,
      t = [],
      q = t.pop,
      L = t.push,
      H = t.push,
      O = t.slice,
      P = function (e, t) {
        for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
        return -1;
      },
      R =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      M = "[\\x20\\t\\r\\n\\f]",
      I =
        "(?:\\\\[\\da-fA-F]{1,6}" +
        M +
        "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      W =
        "\\[" +
        M +
        "*(" +
        I +
        ")(?:" +
        M +
        "*([*^$|!~]?=)" +
        M +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        I +
        "))|)" +
        M +
        "*\\]",
      F =
        ":(" +
        I +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        W +
        ")*)|.*)\\)|)",
      B = new RegExp(M + "+", "g"),
      $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
      _ = new RegExp("^" + M + "*," + M + "*"),
      z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
      U = new RegExp(M + "|>"),
      X = new RegExp(F),
      V = new RegExp("^" + I + "$"),
      G = {
        ID: new RegExp("^#(" + I + ")"),
        CLASS: new RegExp("^\\.(" + I + ")"),
        TAG: new RegExp("^(" + I + "|[*])"),
        ATTR: new RegExp("^" + W),
        PSEUDO: new RegExp("^" + F),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            M +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            M +
            "*(?:([+-]|)" +
            M +
            "*(\\d+)|))" +
            M +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + R + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            M +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            M +
            "*((?:-\\d)?\\d*)" +
            M +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      Y = /HTML$/i,
      Q = /^(?:input|select|textarea|button)$/i,
      J = /^h\d$/i,
      K = /^[^{]+\{\s*\[native \w/,
      Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      ee = /[+~]/,
      te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"),
      ne = function (e, t) {
        var n = "0x" + e.slice(1) - 65536;
        return (
          t ||
          (n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
        );
      },
      re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
      ie = function (e, t) {
        return t
          ? "\0" === e
            ? "\ufffd"
            : e.slice(0, -1) +
              "\\" +
              e.charCodeAt(e.length - 1).toString(16) +
              " "
          : "\\" + e;
      },
      oe = function () {
        T();
      },
      ae = be(
        function (e) {
          return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
        },
        { dir: "parentNode", next: "legend" }
      );
    try {
      H.apply((t = O.call(p.childNodes)), p.childNodes),
        t[p.childNodes.length].nodeType;
    } catch (e) {
      H = {
        apply: t.length
          ? function (e, t) {
              L.apply(e, O.call(t));
            }
          : function (e, t) {
              var n = e.length,
                r = 0;
              while ((e[n++] = t[r++]));
              e.length = n - 1;
            },
      };
    }
    function se(t, e, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = e && e.ownerDocument,
        p = e ? e.nodeType : 9;
      if (
        ((n = n || []),
        "string" != typeof t || !t || (1 !== p && 9 !== p && 11 !== p))
      )
        return n;
      if (!r && (T(e), (e = e || C), E)) {
        if (11 !== p && (u = Z.exec(t)))
          if ((i = u[1])) {
            if (9 === p) {
              if (!(a = e.getElementById(i))) return n;
              if (a.id === i) return n.push(a), n;
            } else if (f && (a = f.getElementById(i)) && y(e, a) && a.id === i)
              return n.push(a), n;
          } else {
            if (u[2]) return H.apply(n, e.getElementsByTagName(t)), n;
            if (
              (i = u[3]) &&
              d.getElementsByClassName &&
              e.getElementsByClassName
            )
              return H.apply(n, e.getElementsByClassName(i)), n;
          }
        if (
          d.qsa &&
          !N[t + " "] &&
          (!v || !v.test(t)) &&
          (1 !== p || "object" !== e.nodeName.toLowerCase())
        ) {
          if (((c = t), (f = e), 1 === p && (U.test(t) || z.test(t)))) {
            ((f = (ee.test(t) && ye(e.parentNode)) || e) === e && d.scope) ||
              ((s = e.getAttribute("id"))
                ? (s = s.replace(re, ie))
                : e.setAttribute("id", (s = S))),
              (o = (l = h(t)).length);
            while (o--) l[o] = (s ? "#" + s : ":scope") + " " + xe(l[o]);
            c = l.join(",");
          }
          try {
            return H.apply(n, f.querySelectorAll(c)), n;
          } catch (e) {
            N(t, !0);
          } finally {
            s === S && e.removeAttribute("id");
          }
        }
      }
      return g(t.replace($, "$1"), e, n, r);
    }
    function ue() {
      var r = [];
      return function e(t, n) {
        return (
          r.push(t + " ") > b.cacheLength && delete e[r.shift()],
          (e[t + " "] = n)
        );
      };
    }
    function le(e) {
      return (e[S] = !0), e;
    }
    function ce(e) {
      var t = C.createElement("fieldset");
      try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), (t = null);
      }
    }
    function fe(e, t) {
      var n = e.split("|"),
        r = n.length;
      while (r--) b.attrHandle[n[r]] = t;
    }
    function pe(e, t) {
      var n = t && e,
        r =
          n &&
          1 === e.nodeType &&
          1 === t.nodeType &&
          e.sourceIndex - t.sourceIndex;
      if (r) return r;
      if (n) while ((n = n.nextSibling)) if (n === t) return -1;
      return e ? 1 : -1;
    }
    function de(t) {
      return function (e) {
        return "input" === e.nodeName.toLowerCase() && e.type === t;
      };
    }
    function he(n) {
      return function (e) {
        var t = e.nodeName.toLowerCase();
        return ("input" === t || "button" === t) && e.type === n;
      };
    }
    function ge(t) {
      return function (e) {
        return "form" in e
          ? e.parentNode && !1 === e.disabled
            ? "label" in e
              ? "label" in e.parentNode
                ? e.parentNode.disabled === t
                : e.disabled === t
              : e.isDisabled === t || (e.isDisabled !== !t && ae(e) === t)
            : e.disabled === t
          : "label" in e && e.disabled === t;
      };
    }
    function ve(a) {
      return le(function (o) {
        return (
          (o = +o),
          le(function (e, t) {
            var n,
              r = a([], e.length, o),
              i = r.length;
            while (i--) e[(n = r[i])] && (e[n] = !(t[n] = e[n]));
          })
        );
      });
    }
    function ye(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }
    for (e in ((d = se.support = {}),
    (i = se.isXML =
      function (e) {
        var t = e && e.namespaceURI,
          n = e && (e.ownerDocument || e).documentElement;
        return !Y.test(t || (n && n.nodeName) || "HTML");
      }),
    (T = se.setDocument =
      function (e) {
        var t,
          n,
          r = e ? e.ownerDocument || e : p;
        return (
          r != C &&
            9 === r.nodeType &&
            r.documentElement &&
            ((a = (C = r).documentElement),
            (E = !i(C)),
            p != C &&
              (n = C.defaultView) &&
              n.top !== n &&
              (n.addEventListener
                ? n.addEventListener("unload", oe, !1)
                : n.attachEvent && n.attachEvent("onunload", oe)),
            (d.scope = ce(function (e) {
              return (
                a.appendChild(e).appendChild(C.createElement("div")),
                "undefined" != typeof e.querySelectorAll &&
                  !e.querySelectorAll(":scope fieldset div").length
              );
            })),
            (d.attributes = ce(function (e) {
              return (e.className = "i"), !e.getAttribute("className");
            })),
            (d.getElementsByTagName = ce(function (e) {
              return (
                e.appendChild(C.createComment("")),
                !e.getElementsByTagName("*").length
              );
            })),
            (d.getElementsByClassName = K.test(C.getElementsByClassName)),
            (d.getById = ce(function (e) {
              return (
                (a.appendChild(e).id = S),
                !C.getElementsByName || !C.getElementsByName(S).length
              );
            })),
            d.getById
              ? ((b.filter.ID = function (e) {
                  var t = e.replace(te, ne);
                  return function (e) {
                    return e.getAttribute("id") === t;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if ("undefined" != typeof t.getElementById && E) {
                    var n = t.getElementById(e);
                    return n ? [n] : [];
                  }
                }))
              : ((b.filter.ID = function (e) {
                  var n = e.replace(te, ne);
                  return function (e) {
                    var t =
                      "undefined" != typeof e.getAttributeNode &&
                      e.getAttributeNode("id");
                    return t && t.value === n;
                  };
                }),
                (b.find.ID = function (e, t) {
                  if ("undefined" != typeof t.getElementById && E) {
                    var n,
                      r,
                      i,
                      o = t.getElementById(e);
                    if (o) {
                      if ((n = o.getAttributeNode("id")) && n.value === e)
                        return [o];
                      (i = t.getElementsByName(e)), (r = 0);
                      while ((o = i[r++]))
                        if ((n = o.getAttributeNode("id")) && n.value === e)
                          return [o];
                    }
                    return [];
                  }
                })),
            (b.find.TAG = d.getElementsByTagName
              ? function (e, t) {
                  return "undefined" != typeof t.getElementsByTagName
                    ? t.getElementsByTagName(e)
                    : d.qsa
                    ? t.querySelectorAll(e)
                    : void 0;
                }
              : function (e, t) {
                  var n,
                    r = [],
                    i = 0,
                    o = t.getElementsByTagName(e);
                  if ("*" === e) {
                    while ((n = o[i++])) 1 === n.nodeType && r.push(n);
                    return r;
                  }
                  return o;
                }),
            (b.find.CLASS =
              d.getElementsByClassName &&
              function (e, t) {
                if ("undefined" != typeof t.getElementsByClassName && E)
                  return t.getElementsByClassName(e);
              }),
            (s = []),
            (v = []),
            (d.qsa = K.test(C.querySelectorAll)) &&
              (ce(function (e) {
                var t;
                (a.appendChild(e).innerHTML =
                  "<a id='" +
                  S +
                  "'></a><select id='" +
                  S +
                  "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                  e.querySelectorAll("[msallowcapture^='']").length &&
                    v.push("[*^$]=" + M + "*(?:''|\"\")"),
                  e.querySelectorAll("[selected]").length ||
                    v.push("\\[" + M + "*(?:value|" + R + ")"),
                  e.querySelectorAll("[id~=" + S + "-]").length || v.push("~="),
                  (t = C.createElement("input")).setAttribute("name", ""),
                  e.appendChild(t),
                  e.querySelectorAll("[name='']").length ||
                    v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"),
                  e.querySelectorAll(":checked").length || v.push(":checked"),
                  e.querySelectorAll("a#" + S + "+*").length ||
                    v.push(".#.+[+~]"),
                  e.querySelectorAll("\\\f"),
                  v.push("[\\r\\n\\f]");
              }),
              ce(function (e) {
                e.innerHTML =
                  "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                var t = C.createElement("input");
                t.setAttribute("type", "hidden"),
                  e.appendChild(t).setAttribute("name", "D"),
                  e.querySelectorAll("[name=d]").length &&
                    v.push("name" + M + "*[*^$|!~]?="),
                  2 !== e.querySelectorAll(":enabled").length &&
                    v.push(":enabled", ":disabled"),
                  (a.appendChild(e).disabled = !0),
                  2 !== e.querySelectorAll(":disabled").length &&
                    v.push(":enabled", ":disabled"),
                  e.querySelectorAll("*,:x"),
                  v.push(",.*:");
              })),
            (d.matchesSelector = K.test(
              (c =
                a.matches ||
                a.webkitMatchesSelector ||
                a.mozMatchesSelector ||
                a.oMatchesSelector ||
                a.msMatchesSelector)
            )) &&
              ce(function (e) {
                (d.disconnectedMatch = c.call(e, "*")),
                  c.call(e, "[s!='']:x"),
                  s.push("!=", F);
              }),
            (v = v.length && new RegExp(v.join("|"))),
            (s = s.length && new RegExp(s.join("|"))),
            (t = K.test(a.compareDocumentPosition)),
            (y =
              t || K.test(a.contains)
                ? function (e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                      r = t && t.parentNode;
                    return (
                      e === r ||
                      !(
                        !r ||
                        1 !== r.nodeType ||
                        !(n.contains
                          ? n.contains(r)
                          : e.compareDocumentPosition &&
                            16 & e.compareDocumentPosition(r))
                      )
                    );
                  }
                : function (e, t) {
                    if (t) while ((t = t.parentNode)) if (t === e) return !0;
                    return !1;
                  }),
            (j = t
              ? function (e, t) {
                  if (e === t) return (l = !0), 0;
                  var n =
                    !e.compareDocumentPosition - !t.compareDocumentPosition;
                  return (
                    n ||
                    (1 &
                      (n =
                        (e.ownerDocument || e) == (t.ownerDocument || t)
                          ? e.compareDocumentPosition(t)
                          : 1) ||
                    (!d.sortDetached && t.compareDocumentPosition(e) === n)
                      ? e == C || (e.ownerDocument == p && y(p, e))
                        ? -1
                        : t == C || (t.ownerDocument == p && y(p, t))
                        ? 1
                        : u
                        ? P(u, e) - P(u, t)
                        : 0
                      : 4 & n
                      ? -1
                      : 1)
                  );
                }
              : function (e, t) {
                  if (e === t) return (l = !0), 0;
                  var n,
                    r = 0,
                    i = e.parentNode,
                    o = t.parentNode,
                    a = [e],
                    s = [t];
                  if (!i || !o)
                    return e == C
                      ? -1
                      : t == C
                      ? 1
                      : i
                      ? -1
                      : o
                      ? 1
                      : u
                      ? P(u, e) - P(u, t)
                      : 0;
                  if (i === o) return pe(e, t);
                  n = e;
                  while ((n = n.parentNode)) a.unshift(n);
                  n = t;
                  while ((n = n.parentNode)) s.unshift(n);
                  while (a[r] === s[r]) r++;
                  return r
                    ? pe(a[r], s[r])
                    : a[r] == p
                    ? -1
                    : s[r] == p
                    ? 1
                    : 0;
                })),
          C
        );
      }),
    (se.matches = function (e, t) {
      return se(e, null, null, t);
    }),
    (se.matchesSelector = function (e, t) {
      if (
        (T(e),
        d.matchesSelector &&
          E &&
          !N[t + " "] &&
          (!s || !s.test(t)) &&
          (!v || !v.test(t)))
      )
        try {
          var n = c.call(e, t);
          if (
            n ||
            d.disconnectedMatch ||
            (e.document && 11 !== e.document.nodeType)
          )
            return n;
        } catch (e) {
          N(t, !0);
        }
      return 0 < se(t, C, null, [e]).length;
    }),
    (se.contains = function (e, t) {
      return (e.ownerDocument || e) != C && T(e), y(e, t);
    }),
    (se.attr = function (e, t) {
      (e.ownerDocument || e) != C && T(e);
      var n = b.attrHandle[t.toLowerCase()],
        r = n && D.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !E) : void 0;
      return void 0 !== r
        ? r
        : d.attributes || !E
        ? e.getAttribute(t)
        : (r = e.getAttributeNode(t)) && r.specified
        ? r.value
        : null;
    }),
    (se.escape = function (e) {
      return (e + "").replace(re, ie);
    }),
    (se.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }),
    (se.uniqueSort = function (e) {
      var t,
        n = [],
        r = 0,
        i = 0;
      if (
        ((l = !d.detectDuplicates),
        (u = !d.sortStable && e.slice(0)),
        e.sort(j),
        l)
      ) {
        while ((t = e[i++])) t === e[i] && (r = n.push(i));
        while (r--) e.splice(n[r], 1);
      }
      return (u = null), e;
    }),
    (o = se.getText =
      function (e) {
        var t,
          n = "",
          r = 0,
          i = e.nodeType;
        if (i) {
          if (1 === i || 9 === i || 11 === i) {
            if ("string" == typeof e.textContent) return e.textContent;
            for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
          } else if (3 === i || 4 === i) return e.nodeValue;
        } else while ((t = e[r++])) n += o(t);
        return n;
      }),
    ((b = se.selectors =
      {
        cacheLength: 50,
        createPseudo: le,
        match: G,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" },
        },
        preFilter: {
          ATTR: function (e) {
            return (
              (e[1] = e[1].replace(te, ne)),
              (e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne)),
              "~=" === e[2] && (e[3] = " " + e[3] + " "),
              e.slice(0, 4)
            );
          },
          CHILD: function (e) {
            return (
              (e[1] = e[1].toLowerCase()),
              "nth" === e[1].slice(0, 3)
                ? (e[3] || se.error(e[0]),
                  (e[4] = +(e[4]
                    ? e[5] + (e[6] || 1)
                    : 2 * ("even" === e[3] || "odd" === e[3]))),
                  (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                : e[3] && se.error(e[0]),
              e
            );
          },
          PSEUDO: function (e) {
            var t,
              n = !e[6] && e[2];
            return G.CHILD.test(e[0])
              ? null
              : (e[3]
                  ? (e[2] = e[4] || e[5] || "")
                  : n &&
                    X.test(n) &&
                    (t = h(n, !0)) &&
                    (t = n.indexOf(")", n.length - t) - n.length) &&
                    ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
                e.slice(0, 3));
          },
        },
        filter: {
          TAG: function (e) {
            var t = e.replace(te, ne).toLowerCase();
            return "*" === e
              ? function () {
                  return !0;
                }
              : function (e) {
                  return e.nodeName && e.nodeName.toLowerCase() === t;
                };
          },
          CLASS: function (e) {
            var t = m[e + " "];
            return (
              t ||
              ((t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) &&
                m(e, function (e) {
                  return t.test(
                    ("string" == typeof e.className && e.className) ||
                      ("undefined" != typeof e.getAttribute &&
                        e.getAttribute("class")) ||
                      ""
                  );
                }))
            );
          },
          ATTR: function (n, r, i) {
            return function (e) {
              var t = se.attr(e, n);
              return null == t
                ? "!=" === r
                : !r ||
                    ((t += ""),
                    "=" === r
                      ? t === i
                      : "!=" === r
                      ? t !== i
                      : "^=" === r
                      ? i && 0 === t.indexOf(i)
                      : "*=" === r
                      ? i && -1 < t.indexOf(i)
                      : "$=" === r
                      ? i && t.slice(-i.length) === i
                      : "~=" === r
                      ? -1 < (" " + t.replace(B, " ") + " ").indexOf(i)
                      : "|=" === r &&
                        (t === i || t.slice(0, i.length + 1) === i + "-"));
            };
          },
          CHILD: function (h, e, t, g, v) {
            var y = "nth" !== h.slice(0, 3),
              m = "last" !== h.slice(-4),
              x = "of-type" === e;
            return 1 === g && 0 === v
              ? function (e) {
                  return !!e.parentNode;
                }
              : function (e, t, n) {
                  var r,
                    i,
                    o,
                    a,
                    s,
                    u,
                    l = y !== m ? "nextSibling" : "previousSibling",
                    c = e.parentNode,
                    f = x && e.nodeName.toLowerCase(),
                    p = !n && !x,
                    d = !1;
                  if (c) {
                    if (y) {
                      while (l) {
                        a = e;
                        while ((a = a[l]))
                          if (
                            x
                              ? a.nodeName.toLowerCase() === f
                              : 1 === a.nodeType
                          )
                            return !1;
                        u = l = "only" === h && !u && "nextSibling";
                      }
                      return !0;
                    }
                    if (((u = [m ? c.firstChild : c.lastChild]), m && p)) {
                      (d =
                        (s =
                          (r =
                            (i =
                              (o = (a = c)[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] || [])[0] === k &&
                          r[1]) && r[2]),
                        (a = s && c.childNodes[s]);
                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                        if (1 === a.nodeType && ++d && a === e) {
                          i[h] = [k, s, d];
                          break;
                        }
                    } else if (
                      (p &&
                        (d = s =
                          (r =
                            (i =
                              (o = (a = e)[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] || [])[0] === k && r[1]),
                      !1 === d)
                    )
                      while ((a = (++s && a && a[l]) || (d = s = 0) || u.pop()))
                        if (
                          (x
                            ? a.nodeName.toLowerCase() === f
                            : 1 === a.nodeType) &&
                          ++d &&
                          (p &&
                            ((i =
                              (o = a[S] || (a[S] = {}))[a.uniqueID] ||
                              (o[a.uniqueID] = {}))[h] = [k, d]),
                          a === e)
                        )
                          break;
                    return (d -= v) === g || (d % g == 0 && 0 <= d / g);
                  }
                };
          },
          PSEUDO: function (e, o) {
            var t,
              a =
                b.pseudos[e] ||
                b.setFilters[e.toLowerCase()] ||
                se.error("unsupported pseudo: " + e);
            return a[S]
              ? a(o)
              : 1 < a.length
              ? ((t = [e, e, "", o]),
                b.setFilters.hasOwnProperty(e.toLowerCase())
                  ? le(function (e, t) {
                      var n,
                        r = a(e, o),
                        i = r.length;
                      while (i--) e[(n = P(e, r[i]))] = !(t[n] = r[i]);
                    })
                  : function (e) {
                      return a(e, 0, t);
                    })
              : a;
          },
        },
        pseudos: {
          not: le(function (e) {
            var r = [],
              i = [],
              s = f(e.replace($, "$1"));
            return s[S]
              ? le(function (e, t, n, r) {
                  var i,
                    o = s(e, null, r, []),
                    a = e.length;
                  while (a--) (i = o[a]) && (e[a] = !(t[a] = i));
                })
              : function (e, t, n) {
                  return (r[0] = e), s(r, null, n, i), (r[0] = null), !i.pop();
                };
          }),
          has: le(function (t) {
            return function (e) {
              return 0 < se(t, e).length;
            };
          }),
          contains: le(function (t) {
            return (
              (t = t.replace(te, ne)),
              function (e) {
                return -1 < (e.textContent || o(e)).indexOf(t);
              }
            );
          }),
          lang: le(function (n) {
            return (
              V.test(n || "") || se.error("unsupported lang: " + n),
              (n = n.replace(te, ne).toLowerCase()),
              function (e) {
                var t;
                do {
                  if (
                    (t = E
                      ? e.lang
                      : e.getAttribute("xml:lang") || e.getAttribute("lang"))
                  )
                    return (
                      (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                    );
                } while ((e = e.parentNode) && 1 === e.nodeType);
                return !1;
              }
            );
          }),
          target: function (e) {
            var t = n.location && n.location.hash;
            return t && t.slice(1) === e.id;
          },
          root: function (e) {
            return e === a;
          },
          focus: function (e) {
            return (
              e === C.activeElement &&
              (!C.hasFocus || C.hasFocus()) &&
              !!(e.type || e.href || ~e.tabIndex)
            );
          },
          enabled: ge(!1),
          disabled: ge(!0),
          checked: function (e) {
            var t = e.nodeName.toLowerCase();
            return (
              ("input" === t && !!e.checked) || ("option" === t && !!e.selected)
            );
          },
          selected: function (e) {
            return (
              e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
            );
          },
          empty: function (e) {
            for (e = e.firstChild; e; e = e.nextSibling)
              if (e.nodeType < 6) return !1;
            return !0;
          },
          parent: function (e) {
            return !b.pseudos.empty(e);
          },
          header: function (e) {
            return J.test(e.nodeName);
          },
          input: function (e) {
            return Q.test(e.nodeName);
          },
          button: function (e) {
            var t = e.nodeName.toLowerCase();
            return ("input" === t && "button" === e.type) || "button" === t;
          },
          text: function (e) {
            var t;
            return (
              "input" === e.nodeName.toLowerCase() &&
              "text" === e.type &&
              (null == (t = e.getAttribute("type")) ||
                "text" === t.toLowerCase())
            );
          },
          first: ve(function () {
            return [0];
          }),
          last: ve(function (e, t) {
            return [t - 1];
          }),
          eq: ve(function (e, t, n) {
            return [n < 0 ? n + t : n];
          }),
          even: ve(function (e, t) {
            for (var n = 0; n < t; n += 2) e.push(n);
            return e;
          }),
          odd: ve(function (e, t) {
            for (var n = 1; n < t; n += 2) e.push(n);
            return e;
          }),
          lt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : t < n ? t : n; 0 <= --r; ) e.push(r);
            return e;
          }),
          gt: ve(function (e, t, n) {
            for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
            return e;
          }),
        },
      }).pseudos.nth = b.pseudos.eq),
    { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
      b.pseudos[e] = de(e);
    for (e in { submit: !0, reset: !0 }) b.pseudos[e] = he(e);
    function me() {}
    function xe(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) r += e[t].value;
      return r;
    }
    function be(s, e, t) {
      var u = e.dir,
        l = e.next,
        c = l || u,
        f = t && "parentNode" === c,
        p = r++;
      return e.first
        ? function (e, t, n) {
            while ((e = e[u])) if (1 === e.nodeType || f) return s(e, t, n);
            return !1;
          }
        : function (e, t, n) {
            var r,
              i,
              o,
              a = [k, p];
            if (n) {
              while ((e = e[u]))
                if ((1 === e.nodeType || f) && s(e, t, n)) return !0;
            } else
              while ((e = e[u]))
                if (1 === e.nodeType || f)
                  if (
                    ((i =
                      (o = e[S] || (e[S] = {}))[e.uniqueID] ||
                      (o[e.uniqueID] = {})),
                    l && l === e.nodeName.toLowerCase())
                  )
                    e = e[u] || e;
                  else {
                    if ((r = i[c]) && r[0] === k && r[1] === p)
                      return (a[2] = r[2]);
                    if (((i[c] = a)[2] = s(e, t, n))) return !0;
                  }
            return !1;
          };
    }
    function we(i) {
      return 1 < i.length
        ? function (e, t, n) {
            var r = i.length;
            while (r--) if (!i[r](e, t, n)) return !1;
            return !0;
          }
        : i[0];
    }
    function Te(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)
        (o = e[s]) && ((n && !n(o, r, i)) || (a.push(o), l && t.push(s)));
      return a;
    }
    function Ce(d, h, g, v, y, e) {
      return (
        v && !v[S] && (v = Ce(v)),
        y && !y[S] && (y = Ce(y, e)),
        le(function (e, t, n, r) {
          var i,
            o,
            a,
            s = [],
            u = [],
            l = t.length,
            c =
              e ||
              (function (e, t, n) {
                for (var r = 0, i = t.length; r < i; r++) se(e, t[r], n);
                return n;
              })(h || "*", n.nodeType ? [n] : n, []),
            f = !d || (!e && h) ? c : Te(c, s, d, n, r),
            p = g ? (y || (e ? d : l || v) ? [] : t) : f;
          if ((g && g(f, p, n, r), v)) {
            (i = Te(p, u)), v(i, [], n, r), (o = i.length);
            while (o--) (a = i[o]) && (p[u[o]] = !(f[u[o]] = a));
          }
          if (e) {
            if (y || d) {
              if (y) {
                (i = []), (o = p.length);
                while (o--) (a = p[o]) && i.push((f[o] = a));
                y(null, (p = []), i, r);
              }
              o = p.length;
              while (o--)
                (a = p[o]) &&
                  -1 < (i = y ? P(e, a) : s[o]) &&
                  (e[i] = !(t[i] = a));
            }
          } else (p = Te(p === t ? p.splice(l, p.length) : p)), y ? y(null, t, p, r) : H.apply(t, p);
        })
      );
    }
    function Ee(e) {
      for (
        var i,
          t,
          n,
          r = e.length,
          o = b.relative[e[0].type],
          a = o || b.relative[" "],
          s = o ? 1 : 0,
          u = be(
            function (e) {
              return e === i;
            },
            a,
            !0
          ),
          l = be(
            function (e) {
              return -1 < P(i, e);
            },
            a,
            !0
          ),
          c = [
            function (e, t, n) {
              var r =
                (!o && (n || t !== w)) ||
                ((i = t).nodeType ? u(e, t, n) : l(e, t, n));
              return (i = null), r;
            },
          ];
        s < r;
        s++
      )
        if ((t = b.relative[e[s].type])) c = [be(we(c), t)];
        else {
          if ((t = b.filter[e[s].type].apply(null, e[s].matches))[S]) {
            for (n = ++s; n < r; n++) if (b.relative[e[n].type]) break;
            return Ce(
              1 < s && we(c),
              1 < s &&
                xe(
                  e
                    .slice(0, s - 1)
                    .concat({ value: " " === e[s - 2].type ? "*" : "" })
                ).replace($, "$1"),
              t,
              s < n && Ee(e.slice(s, n)),
              n < r && Ee((e = e.slice(n))),
              n < r && xe(e)
            );
          }
          c.push(t);
        }
      return we(c);
    }
    return (
      (me.prototype = b.filters = b.pseudos),
      (b.setFilters = new me()),
      (h = se.tokenize =
        function (e, t) {
          var n,
            r,
            i,
            o,
            a,
            s,
            u,
            l = x[e + " "];
          if (l) return t ? 0 : l.slice(0);
          (a = e), (s = []), (u = b.preFilter);
          while (a) {
            for (o in ((n && !(r = _.exec(a))) ||
              (r && (a = a.slice(r[0].length) || a), s.push((i = []))),
            (n = !1),
            (r = z.exec(a)) &&
              ((n = r.shift()),
              i.push({ value: n, type: r[0].replace($, " ") }),
              (a = a.slice(n.length))),
            b.filter))
              !(r = G[o].exec(a)) ||
                (u[o] && !(r = u[o](r))) ||
                ((n = r.shift()),
                i.push({ value: n, type: o, matches: r }),
                (a = a.slice(n.length)));
            if (!n) break;
          }
          return t ? a.length : a ? se.error(e) : x(e, s).slice(0);
        }),
      (f = se.compile =
        function (e, t) {
          var n,
            v,
            y,
            m,
            x,
            r,
            i = [],
            o = [],
            a = A[e + " "];
          if (!a) {
            t || (t = h(e)), (n = t.length);
            while (n--) (a = Ee(t[n]))[S] ? i.push(a) : o.push(a);
            (a = A(
              e,
              ((v = o),
              (m = 0 < (y = i).length),
              (x = 0 < v.length),
              (r = function (e, t, n, r, i) {
                var o,
                  a,
                  s,
                  u = 0,
                  l = "0",
                  c = e && [],
                  f = [],
                  p = w,
                  d = e || (x && b.find.TAG("*", i)),
                  h = (k += null == p ? 1 : Math.random() || 0.1),
                  g = d.length;
                for (
                  i && (w = t == C || t || i);
                  l !== g && null != (o = d[l]);
                  l++
                ) {
                  if (x && o) {
                    (a = 0), t || o.ownerDocument == C || (T(o), (n = !E));
                    while ((s = v[a++]))
                      if (s(o, t || C, n)) {
                        r.push(o);
                        break;
                      }
                    i && (k = h);
                  }
                  m && ((o = !s && o) && u--, e && c.push(o));
                }
                if (((u += l), m && l !== u)) {
                  a = 0;
                  while ((s = y[a++])) s(c, f, t, n);
                  if (e) {
                    if (0 < u) while (l--) c[l] || f[l] || (f[l] = q.call(r));
                    f = Te(f);
                  }
                  H.apply(r, f),
                    i &&
                      !e &&
                      0 < f.length &&
                      1 < u + y.length &&
                      se.uniqueSort(r);
                }
                return i && ((k = h), (w = p)), c;
              }),
              m ? le(r) : r)
            )).selector = e;
          }
          return a;
        }),
      (g = se.select =
        function (e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = "function" == typeof e && e,
            c = !r && h((e = l.selector || e));
          if (((n = n || []), 1 === c.length)) {
            if (
              2 < (o = c[0] = c[0].slice(0)).length &&
              "ID" === (a = o[0]).type &&
              9 === t.nodeType &&
              E &&
              b.relative[o[1].type]
            ) {
              if (!(t = (b.find.ID(a.matches[0].replace(te, ne), t) || [])[0]))
                return n;
              l && (t = t.parentNode), (e = e.slice(o.shift().value.length));
            }
            i = G.needsContext.test(e) ? 0 : o.length;
            while (i--) {
              if (((a = o[i]), b.relative[(s = a.type)])) break;
              if (
                (u = b.find[s]) &&
                (r = u(
                  a.matches[0].replace(te, ne),
                  (ee.test(o[0].type) && ye(t.parentNode)) || t
                ))
              ) {
                if ((o.splice(i, 1), !(e = r.length && xe(o))))
                  return H.apply(n, r), n;
                break;
              }
            }
          }
          return (
            (l || f(e, c))(
              r,
              t,
              !E,
              n,
              !t || (ee.test(e) && ye(t.parentNode)) || t
            ),
            n
          );
        }),
      (d.sortStable = S.split("").sort(j).join("") === S),
      (d.detectDuplicates = !!l),
      T(),
      (d.sortDetached = ce(function (e) {
        return 1 & e.compareDocumentPosition(C.createElement("fieldset"));
      })),
      ce(function (e) {
        return (
          (e.innerHTML = "<a href='#'></a>"),
          "#" === e.firstChild.getAttribute("href")
        );
      }) ||
        fe("type|href|height|width", function (e, t, n) {
          if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
        }),
      (d.attributes &&
        ce(function (e) {
          return (
            (e.innerHTML = "<input/>"),
            e.firstChild.setAttribute("value", ""),
            "" === e.firstChild.getAttribute("value")
          );
        })) ||
        fe("value", function (e, t, n) {
          if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
        }),
      ce(function (e) {
        return null == e.getAttribute("disabled");
      }) ||
        fe(R, function (e, t, n) {
          var r;
          if (!n)
            return !0 === e[t]
              ? t.toLowerCase()
              : (r = e.getAttributeNode(t)) && r.specified
              ? r.value
              : null;
        }),
      se
    );
  })(C);
  (S.find = d),
    (S.expr = d.selectors),
    (S.expr[":"] = S.expr.pseudos),
    (S.uniqueSort = S.unique = d.uniqueSort),
    (S.text = d.getText),
    (S.isXMLDoc = d.isXML),
    (S.contains = d.contains),
    (S.escapeSelector = d.escape);
  var h = function (e, t, n) {
      var r = [],
        i = void 0 !== n;
      while ((e = e[t]) && 9 !== e.nodeType)
        if (1 === e.nodeType) {
          if (i && S(e).is(n)) break;
          r.push(e);
        }
      return r;
    },
    T = function (e, t) {
      for (var n = []; e; e = e.nextSibling)
        1 === e.nodeType && e !== t && n.push(e);
      return n;
    },
    k = S.expr.match.needsContext;
  function A(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }
  var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
  function j(e, n, r) {
    return m(n)
      ? S.grep(e, function (e, t) {
          return !!n.call(e, t, e) !== r;
        })
      : n.nodeType
      ? S.grep(e, function (e) {
          return (e === n) !== r;
        })
      : "string" != typeof n
      ? S.grep(e, function (e) {
          return -1 < i.call(n, e) !== r;
        })
      : S.filter(n, e, r);
  }
  (S.filter = function (e, t, n) {
    var r = t[0];
    return (
      n && (e = ":not(" + e + ")"),
      1 === t.length && 1 === r.nodeType
        ? S.find.matchesSelector(r, e)
          ? [r]
          : []
        : S.find.matches(
            e,
            S.grep(t, function (e) {
              return 1 === e.nodeType;
            })
          )
    );
  }),
    S.fn.extend({
      find: function (e) {
        var t,
          n,
          r = this.length,
          i = this;
        if ("string" != typeof e)
          return this.pushStack(
            S(e).filter(function () {
              for (t = 0; t < r; t++) if (S.contains(i[t], this)) return !0;
            })
          );
        for (n = this.pushStack([]), t = 0; t < r; t++) S.find(e, i[t], n);
        return 1 < r ? S.uniqueSort(n) : n;
      },
      filter: function (e) {
        return this.pushStack(j(this, e || [], !1));
      },
      not: function (e) {
        return this.pushStack(j(this, e || [], !0));
      },
      is: function (e) {
        return !!j(this, "string" == typeof e && k.test(e) ? S(e) : e || [], !1)
          .length;
      },
    });
  var D,
    q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
  ((S.fn.init = function (e, t, n) {
    var r, i;
    if (!e) return this;
    if (((n = n || D), "string" == typeof e)) {
      if (
        !(r =
          "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length
            ? [null, e, null]
            : q.exec(e)) ||
        (!r[1] && t)
      )
        return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
      if (r[1]) {
        if (
          ((t = t instanceof S ? t[0] : t),
          S.merge(
            this,
            S.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : E, !0)
          ),
          N.test(r[1]) && S.isPlainObject(t))
        )
          for (r in t) m(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
        return this;
      }
      return (
        (i = E.getElementById(r[2])) && ((this[0] = i), (this.length = 1)), this
      );
    }
    return e.nodeType
      ? ((this[0] = e), (this.length = 1), this)
      : m(e)
      ? void 0 !== n.ready
        ? n.ready(e)
        : e(S)
      : S.makeArray(e, this);
  }).prototype = S.fn),
    (D = S(E));
  var L = /^(?:parents|prev(?:Until|All))/,
    H = { children: !0, contents: !0, next: !0, prev: !0 };
  function O(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType);
    return e;
  }
  S.fn.extend({
    has: function (e) {
      var t = S(e, this),
        n = t.length;
      return this.filter(function () {
        for (var e = 0; e < n; e++) if (S.contains(this, t[e])) return !0;
      });
    },
    closest: function (e, t) {
      var n,
        r = 0,
        i = this.length,
        o = [],
        a = "string" != typeof e && S(e);
      if (!k.test(e))
        for (; r < i; r++)
          for (n = this[r]; n && n !== t; n = n.parentNode)
            if (
              n.nodeType < 11 &&
              (a
                ? -1 < a.index(n)
                : 1 === n.nodeType && S.find.matchesSelector(n, e))
            ) {
              o.push(n);
              break;
            }
      return this.pushStack(1 < o.length ? S.uniqueSort(o) : o);
    },
    index: function (e) {
      return e
        ? "string" == typeof e
          ? i.call(S(e), this[0])
          : i.call(this, e.jquery ? e[0] : e)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (e, t) {
      return this.pushStack(S.uniqueSort(S.merge(this.get(), S(e, t))));
    },
    addBack: function (e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    },
  }),
    S.each(
      {
        parent: function (e) {
          var t = e.parentNode;
          return t && 11 !== t.nodeType ? t : null;
        },
        parents: function (e) {
          return h(e, "parentNode");
        },
        parentsUntil: function (e, t, n) {
          return h(e, "parentNode", n);
        },
        next: function (e) {
          return O(e, "nextSibling");
        },
        prev: function (e) {
          return O(e, "previousSibling");
        },
        nextAll: function (e) {
          return h(e, "nextSibling");
        },
        prevAll: function (e) {
          return h(e, "previousSibling");
        },
        nextUntil: function (e, t, n) {
          return h(e, "nextSibling", n);
        },
        prevUntil: function (e, t, n) {
          return h(e, "previousSibling", n);
        },
        siblings: function (e) {
          return T((e.parentNode || {}).firstChild, e);
        },
        children: function (e) {
          return T(e.firstChild);
        },
        contents: function (e) {
          return null != e.contentDocument && r(e.contentDocument)
            ? e.contentDocument
            : (A(e, "template") && (e = e.content || e),
              S.merge([], e.childNodes));
        },
      },
      function (r, i) {
        S.fn[r] = function (e, t) {
          var n = S.map(this, i, e);
          return (
            "Until" !== r.slice(-5) && (t = e),
            t && "string" == typeof t && (n = S.filter(t, n)),
            1 < this.length &&
              (H[r] || S.uniqueSort(n), L.test(r) && n.reverse()),
            this.pushStack(n)
          );
        };
      }
    );
  var P = /[^\x20\t\r\n\f]+/g;
  function R(e) {
    return e;
  }
  function M(e) {
    throw e;
  }
  function I(e, t, n, r) {
    var i;
    try {
      e && m((i = e.promise))
        ? i.call(e).done(t).fail(n)
        : e && m((i = e.then))
        ? i.call(e, t, n)
        : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }
  (S.Callbacks = function (r) {
    var e, n;
    r =
      "string" == typeof r
        ? ((e = r),
          (n = {}),
          S.each(e.match(P) || [], function (e, t) {
            n[t] = !0;
          }),
          n)
        : S.extend({}, r);
    var i,
      t,
      o,
      a,
      s = [],
      u = [],
      l = -1,
      c = function () {
        for (a = a || r.once, o = i = !0; u.length; l = -1) {
          t = u.shift();
          while (++l < s.length)
            !1 === s[l].apply(t[0], t[1]) &&
              r.stopOnFalse &&
              ((l = s.length), (t = !1));
        }
        r.memory || (t = !1), (i = !1), a && (s = t ? [] : "");
      },
      f = {
        add: function () {
          return (
            s &&
              (t && !i && ((l = s.length - 1), u.push(t)),
              (function n(e) {
                S.each(e, function (e, t) {
                  m(t)
                    ? (r.unique && f.has(t)) || s.push(t)
                    : t && t.length && "string" !== w(t) && n(t);
                });
              })(arguments),
              t && !i && c()),
            this
          );
        },
        remove: function () {
          return (
            S.each(arguments, function (e, t) {
              var n;
              while (-1 < (n = S.inArray(t, s, n)))
                s.splice(n, 1), n <= l && l--;
            }),
            this
          );
        },
        has: function (e) {
          return e ? -1 < S.inArray(e, s) : 0 < s.length;
        },
        empty: function () {
          return s && (s = []), this;
        },
        disable: function () {
          return (a = u = []), (s = t = ""), this;
        },
        disabled: function () {
          return !s;
        },
        lock: function () {
          return (a = u = []), t || i || (s = t = ""), this;
        },
        locked: function () {
          return !!a;
        },
        fireWith: function (e, t) {
          return (
            a ||
              ((t = [e, (t = t || []).slice ? t.slice() : t]),
              u.push(t),
              i || c()),
            this
          );
        },
        fire: function () {
          return f.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!o;
        },
      };
    return f;
  }),
    S.extend({
      Deferred: function (e) {
        var o = [
            [
              "notify",
              "progress",
              S.Callbacks("memory"),
              S.Callbacks("memory"),
              2,
            ],
            [
              "resolve",
              "done",
              S.Callbacks("once memory"),
              S.Callbacks("once memory"),
              0,
              "resolved",
            ],
            [
              "reject",
              "fail",
              S.Callbacks("once memory"),
              S.Callbacks("once memory"),
              1,
              "rejected",
            ],
          ],
          i = "pending",
          a = {
            state: function () {
              return i;
            },
            always: function () {
              return s.done(arguments).fail(arguments), this;
            },
            catch: function (e) {
              return a.then(null, e);
            },
            pipe: function () {
              var i = arguments;
              return S.Deferred(function (r) {
                S.each(o, function (e, t) {
                  var n = m(i[t[4]]) && i[t[4]];
                  s[t[1]](function () {
                    var e = n && n.apply(this, arguments);
                    e && m(e.promise)
                      ? e
                          .promise()
                          .progress(r.notify)
                          .done(r.resolve)
                          .fail(r.reject)
                      : r[t[0] + "With"](this, n ? [e] : arguments);
                  });
                }),
                  (i = null);
              }).promise();
            },
            then: function (t, n, r) {
              var u = 0;
              function l(i, o, a, s) {
                return function () {
                  var n = this,
                    r = arguments,
                    e = function () {
                      var e, t;
                      if (!(i < u)) {
                        if ((e = a.apply(n, r)) === o.promise())
                          throw new TypeError("Thenable self-resolution");
                        (t =
                          e &&
                          ("object" == typeof e || "function" == typeof e) &&
                          e.then),
                          m(t)
                            ? s
                              ? t.call(e, l(u, o, R, s), l(u, o, M, s))
                              : (u++,
                                t.call(
                                  e,
                                  l(u, o, R, s),
                                  l(u, o, M, s),
                                  l(u, o, R, o.notifyWith)
                                ))
                            : (a !== R && ((n = void 0), (r = [e])),
                              (s || o.resolveWith)(n, r));
                      }
                    },
                    t = s
                      ? e
                      : function () {
                          try {
                            e();
                          } catch (e) {
                            S.Deferred.exceptionHook &&
                              S.Deferred.exceptionHook(e, t.stackTrace),
                              u <= i + 1 &&
                                (a !== M && ((n = void 0), (r = [e])),
                                o.rejectWith(n, r));
                          }
                        };
                  i
                    ? t()
                    : (S.Deferred.getStackHook &&
                        (t.stackTrace = S.Deferred.getStackHook()),
                      C.setTimeout(t));
                };
              }
              return S.Deferred(function (e) {
                o[0][3].add(l(0, e, m(r) ? r : R, e.notifyWith)),
                  o[1][3].add(l(0, e, m(t) ? t : R)),
                  o[2][3].add(l(0, e, m(n) ? n : M));
              }).promise();
            },
            promise: function (e) {
              return null != e ? S.extend(e, a) : a;
            },
          },
          s = {};
        return (
          S.each(o, function (e, t) {
            var n = t[2],
              r = t[5];
            (a[t[1]] = n.add),
              r &&
                n.add(
                  function () {
                    i = r;
                  },
                  o[3 - e][2].disable,
                  o[3 - e][3].disable,
                  o[0][2].lock,
                  o[0][3].lock
                ),
              n.add(t[3].fire),
              (s[t[0]] = function () {
                return (
                  s[t[0] + "With"](this === s ? void 0 : this, arguments), this
                );
              }),
              (s[t[0] + "With"] = n.fireWith);
          }),
          a.promise(s),
          e && e.call(s, s),
          s
        );
      },
      when: function (e) {
        var n = arguments.length,
          t = n,
          r = Array(t),
          i = s.call(arguments),
          o = S.Deferred(),
          a = function (t) {
            return function (e) {
              (r[t] = this),
                (i[t] = 1 < arguments.length ? s.call(arguments) : e),
                --n || o.resolveWith(r, i);
            };
          };
        if (
          n <= 1 &&
          (I(e, o.done(a(t)).resolve, o.reject, !n),
          "pending" === o.state() || m(i[t] && i[t].then))
        )
          return o.then();
        while (t--) I(i[t], a(t), o.reject);
        return o.promise();
      },
    });
  var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
  (S.Deferred.exceptionHook = function (e, t) {
    C.console &&
      C.console.warn &&
      e &&
      W.test(e.name) &&
      C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t);
  }),
    (S.readyException = function (e) {
      C.setTimeout(function () {
        throw e;
      });
    });
  var F = S.Deferred();
  function B() {
    E.removeEventListener("DOMContentLoaded", B),
      C.removeEventListener("load", B),
      S.ready();
  }
  (S.fn.ready = function (e) {
    return (
      F.then(e)["catch"](function (e) {
        S.readyException(e);
      }),
      this
    );
  }),
    S.extend({
      isReady: !1,
      readyWait: 1,
      ready: function (e) {
        (!0 === e ? --S.readyWait : S.isReady) ||
          ((S.isReady = !0) !== e && 0 < --S.readyWait) ||
          F.resolveWith(E, [S]);
      },
    }),
    (S.ready.then = F.then),
    "complete" === E.readyState ||
    ("loading" !== E.readyState && !E.documentElement.doScroll)
      ? C.setTimeout(S.ready)
      : (E.addEventListener("DOMContentLoaded", B),
        C.addEventListener("load", B));
  var $ = function (e, t, n, r, i, o, a) {
      var s = 0,
        u = e.length,
        l = null == n;
      if ("object" === w(n))
        for (s in ((i = !0), n)) $(e, t, s, n[s], !0, o, a);
      else if (
        void 0 !== r &&
        ((i = !0),
        m(r) || (a = !0),
        l &&
          (a
            ? (t.call(e, r), (t = null))
            : ((l = t),
              (t = function (e, t, n) {
                return l.call(S(e), n);
              }))),
        t)
      )
        for (; s < u; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
      return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
    },
    _ = /^-ms-/,
    z = /-([a-z])/g;
  function U(e, t) {
    return t.toUpperCase();
  }
  function X(e) {
    return e.replace(_, "ms-").replace(z, U);
  }
  var V = function (e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };
  function G() {
    this.expando = S.expando + G.uid++;
  }
  (G.uid = 1),
    (G.prototype = {
      cache: function (e) {
        var t = e[this.expando];
        return (
          t ||
            ((t = {}),
            V(e) &&
              (e.nodeType
                ? (e[this.expando] = t)
                : Object.defineProperty(e, this.expando, {
                    value: t,
                    configurable: !0,
                  }))),
          t
        );
      },
      set: function (e, t, n) {
        var r,
          i = this.cache(e);
        if ("string" == typeof t) i[X(t)] = n;
        else for (r in t) i[X(r)] = t[r];
        return i;
      },
      get: function (e, t) {
        return void 0 === t
          ? this.cache(e)
          : e[this.expando] && e[this.expando][X(t)];
      },
      access: function (e, t, n) {
        return void 0 === t || (t && "string" == typeof t && void 0 === n)
          ? this.get(e, t)
          : (this.set(e, t, n), void 0 !== n ? n : t);
      },
      remove: function (e, t) {
        var n,
          r = e[this.expando];
        if (void 0 !== r) {
          if (void 0 !== t) {
            n = (t = Array.isArray(t)
              ? t.map(X)
              : (t = X(t)) in r
              ? [t]
              : t.match(P) || []).length;
            while (n--) delete r[t[n]];
          }
          (void 0 === t || S.isEmptyObject(r)) &&
            (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
        }
      },
      hasData: function (e) {
        var t = e[this.expando];
        return void 0 !== t && !S.isEmptyObject(t);
      },
    });
  var Y = new G(),
    Q = new G(),
    J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    K = /[A-Z]/g;
  function Z(e, t, n) {
    var r, i;
    if (void 0 === n && 1 === e.nodeType)
      if (
        ((r = "data-" + t.replace(K, "-$&").toLowerCase()),
        "string" == typeof (n = e.getAttribute(r)))
      ) {
        try {
          n =
            "true" === (i = n) ||
            ("false" !== i &&
              ("null" === i
                ? null
                : i === +i + ""
                ? +i
                : J.test(i)
                ? JSON.parse(i)
                : i));
        } catch (e) {}
        Q.set(e, t, n);
      } else n = void 0;
    return n;
  }
  S.extend({
    hasData: function (e) {
      return Q.hasData(e) || Y.hasData(e);
    },
    data: function (e, t, n) {
      return Q.access(e, t, n);
    },
    removeData: function (e, t) {
      Q.remove(e, t);
    },
    _data: function (e, t, n) {
      return Y.access(e, t, n);
    },
    _removeData: function (e, t) {
      Y.remove(e, t);
    },
  }),
    S.fn.extend({
      data: function (n, e) {
        var t,
          r,
          i,
          o = this[0],
          a = o && o.attributes;
        if (void 0 === n) {
          if (
            this.length &&
            ((i = Q.get(o)), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))
          ) {
            t = a.length;
            while (t--)
              a[t] &&
                0 === (r = a[t].name).indexOf("data-") &&
                ((r = X(r.slice(5))), Z(o, r, i[r]));
            Y.set(o, "hasDataAttrs", !0);
          }
          return i;
        }
        return "object" == typeof n
          ? this.each(function () {
              Q.set(this, n);
            })
          : $(
              this,
              function (e) {
                var t;
                if (o && void 0 === e)
                  return void 0 !== (t = Q.get(o, n))
                    ? t
                    : void 0 !== (t = Z(o, n))
                    ? t
                    : void 0;
                this.each(function () {
                  Q.set(this, n, e);
                });
              },
              null,
              e,
              1 < arguments.length,
              null,
              !0
            );
      },
      removeData: function (e) {
        return this.each(function () {
          Q.remove(this, e);
        });
      },
    }),
    S.extend({
      queue: function (e, t, n) {
        var r;
        if (e)
          return (
            (t = (t || "fx") + "queue"),
            (r = Y.get(e, t)),
            n &&
              (!r || Array.isArray(n)
                ? (r = Y.access(e, t, S.makeArray(n)))
                : r.push(n)),
            r || []
          );
      },
      dequeue: function (e, t) {
        t = t || "fx";
        var n = S.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = S._queueHooks(e, t);
        "inprogress" === i && ((i = n.shift()), r--),
          i &&
            ("fx" === t && n.unshift("inprogress"),
            delete o.stop,
            i.call(
              e,
              function () {
                S.dequeue(e, t);
              },
              o
            )),
          !r && o && o.empty.fire();
      },
      _queueHooks: function (e, t) {
        var n = t + "queueHooks";
        return (
          Y.get(e, n) ||
          Y.access(e, n, {
            empty: S.Callbacks("once memory").add(function () {
              Y.remove(e, [t + "queue", n]);
            }),
          })
        );
      },
    }),
    S.fn.extend({
      queue: function (t, n) {
        var e = 2;
        return (
          "string" != typeof t && ((n = t), (t = "fx"), e--),
          arguments.length < e
            ? S.queue(this[0], t)
            : void 0 === n
            ? this
            : this.each(function () {
                var e = S.queue(this, t, n);
                S._queueHooks(this, t),
                  "fx" === t && "inprogress" !== e[0] && S.dequeue(this, t);
              })
        );
      },
      dequeue: function (e) {
        return this.each(function () {
          S.dequeue(this, e);
        });
      },
      clearQueue: function (e) {
        return this.queue(e || "fx", []);
      },
      promise: function (e, t) {
        var n,
          r = 1,
          i = S.Deferred(),
          o = this,
          a = this.length,
          s = function () {
            --r || i.resolveWith(o, [o]);
          };
        "string" != typeof e && ((t = e), (e = void 0)), (e = e || "fx");
        while (a--)
          (n = Y.get(o[a], e + "queueHooks")) &&
            n.empty &&
            (r++, n.empty.add(s));
        return s(), i.promise(t);
      },
    });
  var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
    ne = ["Top", "Right", "Bottom", "Left"],
    re = E.documentElement,
    ie = function (e) {
      return S.contains(e.ownerDocument, e);
    },
    oe = { composed: !0 };
  re.getRootNode &&
    (ie = function (e) {
      return (
        S.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument
      );
    });
  var ae = function (e, t) {
    return (
      "none" === (e = t || e).style.display ||
      ("" === e.style.display && ie(e) && "none" === S.css(e, "display"))
    );
  };
  function se(e, t, n, r) {
    var i,
      o,
      a = 20,
      s = r
        ? function () {
            return r.cur();
          }
        : function () {
            return S.css(e, t, "");
          },
      u = s(),
      l = (n && n[3]) || (S.cssNumber[t] ? "" : "px"),
      c =
        e.nodeType &&
        (S.cssNumber[t] || ("px" !== l && +u)) &&
        te.exec(S.css(e, t));
    if (c && c[3] !== l) {
      (u /= 2), (l = l || c[3]), (c = +u || 1);
      while (a--)
        S.style(e, t, c + l),
          (1 - o) * (1 - (o = s() / u || 0.5)) <= 0 && (a = 0),
          (c /= o);
      (c *= 2), S.style(e, t, c + l), (n = n || []);
    }
    return (
      n &&
        ((c = +c || +u || 0),
        (i = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
        r && ((r.unit = l), (r.start = c), (r.end = i))),
      i
    );
  }
  var ue = {};
  function le(e, t) {
    for (var n, r, i, o, a, s, u, l = [], c = 0, f = e.length; c < f; c++)
      (r = e[c]).style &&
        ((n = r.style.display),
        t
          ? ("none" === n &&
              ((l[c] = Y.get(r, "display") || null),
              l[c] || (r.style.display = "")),
            "" === r.style.display &&
              ae(r) &&
              (l[c] =
                ((u = a = o = void 0),
                (a = (i = r).ownerDocument),
                (s = i.nodeName),
                (u = ue[s]) ||
                  ((o = a.body.appendChild(a.createElement(s))),
                  (u = S.css(o, "display")),
                  o.parentNode.removeChild(o),
                  "none" === u && (u = "block"),
                  (ue[s] = u)))))
          : "none" !== n && ((l[c] = "none"), Y.set(r, "display", n)));
    for (c = 0; c < f; c++) null != l[c] && (e[c].style.display = l[c]);
    return e;
  }
  S.fn.extend({
    show: function () {
      return le(this, !0);
    },
    hide: function () {
      return le(this);
    },
    toggle: function (e) {
      return "boolean" == typeof e
        ? e
          ? this.show()
          : this.hide()
        : this.each(function () {
            ae(this) ? S(this).show() : S(this).hide();
          });
    },
  });
  var ce,
    fe,
    pe = /^(?:checkbox|radio)$/i,
    de = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
    he = /^$|^module$|\/(?:java|ecma)script/i;
  (ce = E.createDocumentFragment().appendChild(E.createElement("div"))),
    (fe = E.createElement("input")).setAttribute("type", "radio"),
    fe.setAttribute("checked", "checked"),
    fe.setAttribute("name", "t"),
    ce.appendChild(fe),
    (y.checkClone = ce.cloneNode(!0).cloneNode(!0).lastChild.checked),
    (ce.innerHTML = "<textarea>x</textarea>"),
    (y.noCloneChecked = !!ce.cloneNode(!0).lastChild.defaultValue),
    (ce.innerHTML = "<option></option>"),
    (y.option = !!ce.lastChild);
  var ge = {
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""],
  };
  function ve(e, t) {
    var n;
    return (
      (n =
        "undefined" != typeof e.getElementsByTagName
          ? e.getElementsByTagName(t || "*")
          : "undefined" != typeof e.querySelectorAll
          ? e.querySelectorAll(t || "*")
          : []),
      void 0 === t || (t && A(e, t)) ? S.merge([e], n) : n
    );
  }
  function ye(e, t) {
    for (var n = 0, r = e.length; n < r; n++)
      Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
  }
  (ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead),
    (ge.th = ge.td),
    y.option ||
      (ge.optgroup = ge.option =
        [1, "<select multiple='multiple'>", "</select>"]);
  var me = /<|&#?\w+;/;
  function xe(e, t, n, r, i) {
    for (
      var o,
        a,
        s,
        u,
        l,
        c,
        f = t.createDocumentFragment(),
        p = [],
        d = 0,
        h = e.length;
      d < h;
      d++
    )
      if ((o = e[d]) || 0 === o)
        if ("object" === w(o)) S.merge(p, o.nodeType ? [o] : o);
        else if (me.test(o)) {
          (a = a || f.appendChild(t.createElement("div"))),
            (s = (de.exec(o) || ["", ""])[1].toLowerCase()),
            (u = ge[s] || ge._default),
            (a.innerHTML = u[1] + S.htmlPrefilter(o) + u[2]),
            (c = u[0]);
          while (c--) a = a.lastChild;
          S.merge(p, a.childNodes), ((a = f.firstChild).textContent = "");
        } else p.push(t.createTextNode(o));
    (f.textContent = ""), (d = 0);
    while ((o = p[d++]))
      if (r && -1 < S.inArray(o, r)) i && i.push(o);
      else if (
        ((l = ie(o)), (a = ve(f.appendChild(o), "script")), l && ye(a), n)
      ) {
        c = 0;
        while ((o = a[c++])) he.test(o.type || "") && n.push(o);
      }
    return f;
  }
  var be = /^([^.]*)(?:\.(.+)|)/;
  function we() {
    return !0;
  }
  function Te() {
    return !1;
  }
  function Ce(e, t) {
    return (
      (e ===
        (function () {
          try {
            return E.activeElement;
          } catch (e) {}
        })()) ==
      ("focus" === t)
    );
  }
  function Ee(e, t, n, r, i, o) {
    var a, s;
    if ("object" == typeof t) {
      for (s in ("string" != typeof n && ((r = r || n), (n = void 0)), t))
        Ee(e, s, n, r, t[s], o);
      return e;
    }
    if (
      (null == r && null == i
        ? ((i = n), (r = n = void 0))
        : null == i &&
          ("string" == typeof n
            ? ((i = r), (r = void 0))
            : ((i = r), (r = n), (n = void 0))),
      !1 === i)
    )
      i = Te;
    else if (!i) return e;
    return (
      1 === o &&
        ((a = i),
        ((i = function (e) {
          return S().off(e), a.apply(this, arguments);
        }).guid = a.guid || (a.guid = S.guid++))),
      e.each(function () {
        S.event.add(this, t, i, r, n);
      })
    );
  }
  function Se(e, i, o) {
    o
      ? (Y.set(e, i, !1),
        S.event.add(e, i, {
          namespace: !1,
          handler: function (e) {
            var t,
              n,
              r = Y.get(this, i);
            if (1 & e.isTrigger && this[i]) {
              if (r.length)
                (S.event.special[i] || {}).delegateType && e.stopPropagation();
              else if (
                ((r = s.call(arguments)),
                Y.set(this, i, r),
                (t = o(this, i)),
                this[i](),
                r !== (n = Y.get(this, i)) || t ? Y.set(this, i, !1) : (n = {}),
                r !== n)
              )
                return (
                  e.stopImmediatePropagation(), e.preventDefault(), n && n.value
                );
            } else
              r.length &&
                (Y.set(this, i, {
                  value: S.event.trigger(
                    S.extend(r[0], S.Event.prototype),
                    r.slice(1),
                    this
                  ),
                }),
                e.stopImmediatePropagation());
          },
        }))
      : void 0 === Y.get(e, i) && S.event.add(e, i, we);
  }
  (S.event = {
    global: {},
    add: function (t, e, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.get(t);
      if (V(t)) {
        n.handler && ((n = (o = n).handler), (i = o.selector)),
          i && S.find.matchesSelector(re, i),
          n.guid || (n.guid = S.guid++),
          (u = v.events) || (u = v.events = Object.create(null)),
          (a = v.handle) ||
            (a = v.handle =
              function (e) {
                return "undefined" != typeof S && S.event.triggered !== e.type
                  ? S.event.dispatch.apply(t, arguments)
                  : void 0;
              }),
          (l = (e = (e || "").match(P) || [""]).length);
        while (l--)
          (d = g = (s = be.exec(e[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d &&
              ((f = S.event.special[d] || {}),
              (d = (i ? f.delegateType : f.bindType) || d),
              (f = S.event.special[d] || {}),
              (c = S.extend(
                {
                  type: d,
                  origType: g,
                  data: r,
                  handler: n,
                  guid: n.guid,
                  selector: i,
                  needsContext: i && S.expr.match.needsContext.test(i),
                  namespace: h.join("."),
                },
                o
              )),
              (p = u[d]) ||
                (((p = u[d] = []).delegateCount = 0),
                (f.setup && !1 !== f.setup.call(t, r, h, a)) ||
                  (t.addEventListener && t.addEventListener(d, a))),
              f.add &&
                (f.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)),
              i ? p.splice(p.delegateCount++, 0, c) : p.push(c),
              (S.event.global[d] = !0));
      }
    },
    remove: function (e, t, n, r, i) {
      var o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        v = Y.hasData(e) && Y.get(e);
      if (v && (u = v.events)) {
        l = (t = (t || "").match(P) || [""]).length;
        while (l--)
          if (
            ((d = g = (s = be.exec(t[l]) || [])[1]),
            (h = (s[2] || "").split(".").sort()),
            d)
          ) {
            (f = S.event.special[d] || {}),
              (p = u[(d = (r ? f.delegateType : f.bindType) || d)] || []),
              (s =
                s[2] &&
                new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (a = o = p.length);
            while (o--)
              (c = p[o]),
                (!i && g !== c.origType) ||
                  (n && n.guid !== c.guid) ||
                  (s && !s.test(c.namespace)) ||
                  (r && r !== c.selector && ("**" !== r || !c.selector)) ||
                  (p.splice(o, 1),
                  c.selector && p.delegateCount--,
                  f.remove && f.remove.call(e, c));
            a &&
              !p.length &&
              ((f.teardown && !1 !== f.teardown.call(e, h, v.handle)) ||
                S.removeEvent(e, d, v.handle),
              delete u[d]);
          } else for (d in u) S.event.remove(e, d + t[l], n, r, !0);
        S.isEmptyObject(u) && Y.remove(e, "handle events");
      }
    },
    dispatch: function (e) {
      var t,
        n,
        r,
        i,
        o,
        a,
        s = new Array(arguments.length),
        u = S.event.fix(e),
        l = (Y.get(this, "events") || Object.create(null))[u.type] || [],
        c = S.event.special[u.type] || {};
      for (s[0] = u, t = 1; t < arguments.length; t++) s[t] = arguments[t];
      if (
        ((u.delegateTarget = this),
        !c.preDispatch || !1 !== c.preDispatch.call(this, u))
      ) {
        (a = S.event.handlers.call(this, u, l)), (t = 0);
        while ((i = a[t++]) && !u.isPropagationStopped()) {
          (u.currentTarget = i.elem), (n = 0);
          while ((o = i.handlers[n++]) && !u.isImmediatePropagationStopped())
            (u.rnamespace &&
              !1 !== o.namespace &&
              !u.rnamespace.test(o.namespace)) ||
              ((u.handleObj = o),
              (u.data = o.data),
              void 0 !==
                (r = (
                  (S.event.special[o.origType] || {}).handle || o.handler
                ).apply(i.elem, s)) &&
                !1 === (u.result = r) &&
                (u.preventDefault(), u.stopPropagation()));
        }
        return c.postDispatch && c.postDispatch.call(this, u), u.result;
      }
    },
    handlers: function (e, t) {
      var n,
        r,
        i,
        o,
        a,
        s = [],
        u = t.delegateCount,
        l = e.target;
      if (u && l.nodeType && !("click" === e.type && 1 <= e.button))
        for (; l !== this; l = l.parentNode || this)
          if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
            for (o = [], a = {}, n = 0; n < u; n++)
              void 0 === a[(i = (r = t[n]).selector + " ")] &&
                (a[i] = r.needsContext
                  ? -1 < S(i, this).index(l)
                  : S.find(i, this, null, [l]).length),
                a[i] && o.push(r);
            o.length && s.push({ elem: l, handlers: o });
          }
      return (
        (l = this), u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s
      );
    },
    addProp: function (t, e) {
      Object.defineProperty(S.Event.prototype, t, {
        enumerable: !0,
        configurable: !0,
        get: m(e)
          ? function () {
              if (this.originalEvent) return e(this.originalEvent);
            }
          : function () {
              if (this.originalEvent) return this.originalEvent[t];
            },
        set: function (e) {
          Object.defineProperty(this, t, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e,
          });
        },
      });
    },
    fix: function (e) {
      return e[S.expando] ? e : new S.Event(e);
    },
    special: {
      load: { noBubble: !0 },
      click: {
        setup: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, "input") && Se(t, "click", we),
            !1
          );
        },
        trigger: function (e) {
          var t = this || e;
          return (
            pe.test(t.type) && t.click && A(t, "input") && Se(t, "click"), !0
          );
        },
        _default: function (e) {
          var t = e.target;
          return (
            (pe.test(t.type) &&
              t.click &&
              A(t, "input") &&
              Y.get(t, "click")) ||
            A(t, "a")
          );
        },
      },
      beforeunload: {
        postDispatch: function (e) {
          void 0 !== e.result &&
            e.originalEvent &&
            (e.originalEvent.returnValue = e.result);
        },
      },
    },
  }),
    (S.removeEvent = function (e, t, n) {
      e.removeEventListener && e.removeEventListener(t, n);
    }),
    (S.Event = function (e, t) {
      if (!(this instanceof S.Event)) return new S.Event(e, t);
      e && e.type
        ? ((this.originalEvent = e),
          (this.type = e.type),
          (this.isDefaultPrevented =
            e.defaultPrevented ||
            (void 0 === e.defaultPrevented && !1 === e.returnValue)
              ? we
              : Te),
          (this.target =
            e.target && 3 === e.target.nodeType
              ? e.target.parentNode
              : e.target),
          (this.currentTarget = e.currentTarget),
          (this.relatedTarget = e.relatedTarget))
        : (this.type = e),
        t && S.extend(this, t),
        (this.timeStamp = (e && e.timeStamp) || Date.now()),
        (this[S.expando] = !0);
    }),
    (S.Event.prototype = {
      constructor: S.Event,
      isDefaultPrevented: Te,
      isPropagationStopped: Te,
      isImmediatePropagationStopped: Te,
      isSimulated: !1,
      preventDefault: function () {
        var e = this.originalEvent;
        (this.isDefaultPrevented = we),
          e && !this.isSimulated && e.preventDefault();
      },
      stopPropagation: function () {
        var e = this.originalEvent;
        (this.isPropagationStopped = we),
          e && !this.isSimulated && e.stopPropagation();
      },
      stopImmediatePropagation: function () {
        var e = this.originalEvent;
        (this.isImmediatePropagationStopped = we),
          e && !this.isSimulated && e.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    S.each(
      {
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: !0,
      },
      S.event.addProp
    ),
    S.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
      S.event.special[e] = {
        setup: function () {
          return Se(this, e, Ce), !1;
        },
        trigger: function () {
          return Se(this, e), !0;
        },
        _default: function () {
          return !0;
        },
        delegateType: t,
      };
    }),
    S.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (e, i) {
        S.event.special[e] = {
          delegateType: i,
          bindType: i,
          handle: function (e) {
            var t,
              n = e.relatedTarget,
              r = e.handleObj;
            return (
              (n && (n === this || S.contains(this, n))) ||
                ((e.type = r.origType),
                (t = r.handler.apply(this, arguments)),
                (e.type = i)),
              t
            );
          },
        };
      }
    ),
    S.fn.extend({
      on: function (e, t, n, r) {
        return Ee(this, e, t, n, r);
      },
      one: function (e, t, n, r) {
        return Ee(this, e, t, n, r, 1);
      },
      off: function (e, t, n) {
        var r, i;
        if (e && e.preventDefault && e.handleObj)
          return (
            (r = e.handleObj),
            S(e.delegateTarget).off(
              r.namespace ? r.origType + "." + r.namespace : r.origType,
              r.selector,
              r.handler
            ),
            this
          );
        if ("object" == typeof e) {
          for (i in e) this.off(i, t, e[i]);
          return this;
        }
        return (
          (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
          !1 === n && (n = Te),
          this.each(function () {
            S.event.remove(this, e, n, t);
          })
        );
      },
    });
  var ke = /<script|<style|<link/i,
    Ae = /checked\s*(?:[^=]|=\s*.checked.)/i,
    Ne = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
  function je(e, t) {
    return (
      (A(e, "table") &&
        A(11 !== t.nodeType ? t : t.firstChild, "tr") &&
        S(e).children("tbody")[0]) ||
      e
    );
  }
  function De(e) {
    return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
  }
  function qe(e) {
    return (
      "true/" === (e.type || "").slice(0, 5)
        ? (e.type = e.type.slice(5))
        : e.removeAttribute("type"),
      e
    );
  }
  function Le(e, t) {
    var n, r, i, o, a, s;
    if (1 === t.nodeType) {
      if (Y.hasData(e) && (s = Y.get(e).events))
        for (i in (Y.remove(t, "handle events"), s))
          for (n = 0, r = s[i].length; n < r; n++) S.event.add(t, i, s[i][n]);
      Q.hasData(e) && ((o = Q.access(e)), (a = S.extend({}, o)), Q.set(t, a));
    }
  }
  function He(n, r, i, o) {
    r = g(r);
    var e,
      t,
      a,
      s,
      u,
      l,
      c = 0,
      f = n.length,
      p = f - 1,
      d = r[0],
      h = m(d);
    if (h || (1 < f && "string" == typeof d && !y.checkClone && Ae.test(d)))
      return n.each(function (e) {
        var t = n.eq(e);
        h && (r[0] = d.call(this, e, t.html())), He(t, r, i, o);
      });
    if (
      f &&
      ((t = (e = xe(r, n[0].ownerDocument, !1, n, o)).firstChild),
      1 === e.childNodes.length && (e = t),
      t || o)
    ) {
      for (s = (a = S.map(ve(e, "script"), De)).length; c < f; c++)
        (u = e),
          c !== p &&
            ((u = S.clone(u, !0, !0)), s && S.merge(a, ve(u, "script"))),
          i.call(n[c], u, c);
      if (s)
        for (l = a[a.length - 1].ownerDocument, S.map(a, qe), c = 0; c < s; c++)
          (u = a[c]),
            he.test(u.type || "") &&
              !Y.access(u, "globalEval") &&
              S.contains(l, u) &&
              (u.src && "module" !== (u.type || "").toLowerCase()
                ? S._evalUrl &&
                  !u.noModule &&
                  S._evalUrl(
                    u.src,
                    { nonce: u.nonce || u.getAttribute("nonce") },
                    l
                  )
                : b(u.textContent.replace(Ne, ""), u, l));
    }
    return n;
  }
  function Oe(e, t, n) {
    for (var r, i = t ? S.filter(t, e) : e, o = 0; null != (r = i[o]); o++)
      n || 1 !== r.nodeType || S.cleanData(ve(r)),
        r.parentNode &&
          (n && ie(r) && ye(ve(r, "script")), r.parentNode.removeChild(r));
    return e;
  }
  S.extend({
    htmlPrefilter: function (e) {
      return e;
    },
    clone: function (e, t, n) {
      var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c = e.cloneNode(!0),
        f = ie(e);
      if (
        !(
          y.noCloneChecked ||
          (1 !== e.nodeType && 11 !== e.nodeType) ||
          S.isXMLDoc(e)
        )
      )
        for (a = ve(c), r = 0, i = (o = ve(e)).length; r < i; r++)
          (s = o[r]),
            (u = a[r]),
            void 0,
            "input" === (l = u.nodeName.toLowerCase()) && pe.test(s.type)
              ? (u.checked = s.checked)
              : ("input" !== l && "textarea" !== l) ||
                (u.defaultValue = s.defaultValue);
      if (t)
        if (n)
          for (o = o || ve(e), a = a || ve(c), r = 0, i = o.length; r < i; r++)
            Le(o[r], a[r]);
        else Le(e, c);
      return (
        0 < (a = ve(c, "script")).length && ye(a, !f && ve(e, "script")), c
      );
    },
    cleanData: function (e) {
      for (var t, n, r, i = S.event.special, o = 0; void 0 !== (n = e[o]); o++)
        if (V(n)) {
          if ((t = n[Y.expando])) {
            if (t.events)
              for (r in t.events)
                i[r] ? S.event.remove(n, r) : S.removeEvent(n, r, t.handle);
            n[Y.expando] = void 0;
          }
          n[Q.expando] && (n[Q.expando] = void 0);
        }
    },
  }),
    S.fn.extend({
      detach: function (e) {
        return Oe(this, e, !0);
      },
      remove: function (e) {
        return Oe(this, e);
      },
      text: function (e) {
        return $(
          this,
          function (e) {
            return void 0 === e
              ? S.text(this)
              : this.empty().each(function () {
                  (1 !== this.nodeType &&
                    11 !== this.nodeType &&
                    9 !== this.nodeType) ||
                    (this.textContent = e);
                });
          },
          null,
          e,
          arguments.length
        );
      },
      append: function () {
        return He(this, arguments, function (e) {
          (1 !== this.nodeType &&
            11 !== this.nodeType &&
            9 !== this.nodeType) ||
            je(this, e).appendChild(e);
        });
      },
      prepend: function () {
        return He(this, arguments, function (e) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var t = je(this, e);
            t.insertBefore(e, t.firstChild);
          }
        });
      },
      before: function () {
        return He(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this);
        });
      },
      after: function () {
        return He(this, arguments, function (e) {
          this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
        });
      },
      empty: function () {
        for (var e, t = 0; null != (e = this[t]); t++)
          1 === e.nodeType && (S.cleanData(ve(e, !1)), (e.textContent = ""));
        return this;
      },
      clone: function (e, t) {
        return (
          (e = null != e && e),
          (t = null == t ? e : t),
          this.map(function () {
            return S.clone(this, e, t);
          })
        );
      },
      html: function (e) {
        return $(
          this,
          function (e) {
            var t = this[0] || {},
              n = 0,
              r = this.length;
            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
            if (
              "string" == typeof e &&
              !ke.test(e) &&
              !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]
            ) {
              e = S.htmlPrefilter(e);
              try {
                for (; n < r; n++)
                  1 === (t = this[n] || {}).nodeType &&
                    (S.cleanData(ve(t, !1)), (t.innerHTML = e));
                t = 0;
              } catch (e) {}
            }
            t && this.empty().append(e);
          },
          null,
          e,
          arguments.length
        );
      },
      replaceWith: function () {
        var n = [];
        return He(
          this,
          arguments,
          function (e) {
            var t = this.parentNode;
            S.inArray(this, n) < 0 &&
              (S.cleanData(ve(this)), t && t.replaceChild(e, this));
          },
          n
        );
      },
    }),
    S.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (e, a) {
        S.fn[e] = function (e) {
          for (var t, n = [], r = S(e), i = r.length - 1, o = 0; o <= i; o++)
            (t = o === i ? this : this.clone(!0)),
              S(r[o])[a](t),
              u.apply(n, t.get());
          return this.pushStack(n);
        };
      }
    );
  var Pe = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
    Re = function (e) {
      var t = e.ownerDocument.defaultView;
      return (t && t.opener) || (t = C), t.getComputedStyle(e);
    },
    Me = function (e, t, n) {
      var r,
        i,
        o = {};
      for (i in t) (o[i] = e.style[i]), (e.style[i] = t[i]);
      for (i in ((r = n.call(e)), t)) e.style[i] = o[i];
      return r;
    },
    Ie = new RegExp(ne.join("|"), "i");
  function We(e, t, n) {
    var r,
      i,
      o,
      a,
      s = e.style;
    return (
      (n = n || Re(e)) &&
        ("" !== (a = n.getPropertyValue(t) || n[t]) ||
          ie(e) ||
          (a = S.style(e, t)),
        !y.pixelBoxStyles() &&
          Pe.test(a) &&
          Ie.test(t) &&
          ((r = s.width),
          (i = s.minWidth),
          (o = s.maxWidth),
          (s.minWidth = s.maxWidth = s.width = a),
          (a = n.width),
          (s.width = r),
          (s.minWidth = i),
          (s.maxWidth = o))),
      void 0 !== a ? a + "" : a
    );
  }
  function Fe(e, t) {
    return {
      get: function () {
        if (!e()) return (this.get = t).apply(this, arguments);
        delete this.get;
      },
    };
  }
  !(function () {
    function e() {
      if (l) {
        (u.style.cssText =
          "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
          (l.style.cssText =
            "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
          re.appendChild(u).appendChild(l);
        var e = C.getComputedStyle(l);
        (n = "1%" !== e.top),
          (s = 12 === t(e.marginLeft)),
          (l.style.right = "60%"),
          (o = 36 === t(e.right)),
          (r = 36 === t(e.width)),
          (l.style.position = "absolute"),
          (i = 12 === t(l.offsetWidth / 3)),
          re.removeChild(u),
          (l = null);
      }
    }
    function t(e) {
      return Math.round(parseFloat(e));
    }
    var n,
      r,
      i,
      o,
      a,
      s,
      u = E.createElement("div"),
      l = E.createElement("div");
    l.style &&
      ((l.style.backgroundClip = "content-box"),
      (l.cloneNode(!0).style.backgroundClip = ""),
      (y.clearCloneStyle = "content-box" === l.style.backgroundClip),
      S.extend(y, {
        boxSizingReliable: function () {
          return e(), r;
        },
        pixelBoxStyles: function () {
          return e(), o;
        },
        pixelPosition: function () {
          return e(), n;
        },
        reliableMarginLeft: function () {
          return e(), s;
        },
        scrollboxSize: function () {
          return e(), i;
        },
        reliableTrDimensions: function () {
          var e, t, n, r;
          return (
            null == a &&
              ((e = E.createElement("table")),
              (t = E.createElement("tr")),
              (n = E.createElement("div")),
              (e.style.cssText =
                "position:absolute;left:-11111px;border-collapse:separate"),
              (t.style.cssText = "border:1px solid"),
              (t.style.height = "1px"),
              (n.style.height = "9px"),
              (n.style.display = "block"),
              re.appendChild(e).appendChild(t).appendChild(n),
              (r = C.getComputedStyle(t)),
              (a =
                parseInt(r.height, 10) +
                  parseInt(r.borderTopWidth, 10) +
                  parseInt(r.borderBottomWidth, 10) ===
                t.offsetHeight),
              re.removeChild(e)),
            a
          );
        },
      }));
  })();
  var Be = ["Webkit", "Moz", "ms"],
    $e = E.createElement("div").style,
    _e = {};
  function ze(e) {
    var t = S.cssProps[e] || _e[e];
    return (
      t ||
      (e in $e
        ? e
        : (_e[e] =
            (function (e) {
              var t = e[0].toUpperCase() + e.slice(1),
                n = Be.length;
              while (n--) if ((e = Be[n] + t) in $e) return e;
            })(e) || e))
    );
  }
  var Ue = /^(none|table(?!-c[ea]).+)/,
    Xe = /^--/,
    Ve = { position: "absolute", visibility: "hidden", display: "block" },
    Ge = { letterSpacing: "0", fontWeight: "400" };
  function Ye(e, t, n) {
    var r = te.exec(t);
    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }
  function Qe(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
      s = 0,
      u = 0;
    if (n === (r ? "border" : "content")) return 0;
    for (; a < 4; a += 2)
      "margin" === n && (u += S.css(e, n + ne[a], !0, i)),
        r
          ? ("content" === n && (u -= S.css(e, "padding" + ne[a], !0, i)),
            "margin" !== n &&
              (u -= S.css(e, "border" + ne[a] + "Width", !0, i)))
          : ((u += S.css(e, "padding" + ne[a], !0, i)),
            "padding" !== n
              ? (u += S.css(e, "border" + ne[a] + "Width", !0, i))
              : (s += S.css(e, "border" + ne[a] + "Width", !0, i)));
    return (
      !r &&
        0 <= o &&
        (u +=
          Math.max(
            0,
            Math.ceil(
              e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - 0.5
            )
          ) || 0),
      u
    );
  }
  function Je(e, t, n) {
    var r = Re(e),
      i =
        (!y.boxSizingReliable() || n) &&
        "border-box" === S.css(e, "boxSizing", !1, r),
      o = i,
      a = We(e, t, r),
      s = "offset" + t[0].toUpperCase() + t.slice(1);
    if (Pe.test(a)) {
      if (!n) return a;
      a = "auto";
    }
    return (
      ((!y.boxSizingReliable() && i) ||
        (!y.reliableTrDimensions() && A(e, "tr")) ||
        "auto" === a ||
        (!parseFloat(a) && "inline" === S.css(e, "display", !1, r))) &&
        e.getClientRects().length &&
        ((i = "border-box" === S.css(e, "boxSizing", !1, r)),
        (o = s in e) && (a = e[s])),
      (a = parseFloat(a) || 0) +
        Qe(e, t, n || (i ? "border" : "content"), o, r, a) +
        "px"
    );
  }
  function Ke(e, t, n, r, i) {
    return new Ke.prototype.init(e, t, n, r, i);
  }
  S.extend({
    cssHooks: {
      opacity: {
        get: function (e, t) {
          if (t) {
            var n = We(e, "opacity");
            return "" === n ? "1" : n;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      gridArea: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnStart: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowStart: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: {},
    style: function (e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
          o,
          a,
          s = X(t),
          u = Xe.test(t),
          l = e.style;
        if (
          (u || (t = ze(s)), (a = S.cssHooks[t] || S.cssHooks[s]), void 0 === n)
        )
          return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
        "string" === (o = typeof n) &&
          (i = te.exec(n)) &&
          i[1] &&
          ((n = se(e, t, i)), (o = "number")),
          null != n &&
            n == n &&
            ("number" !== o ||
              u ||
              (n += (i && i[3]) || (S.cssNumber[s] ? "" : "px")),
            y.clearCloneStyle ||
              "" !== n ||
              0 !== t.indexOf("background") ||
              (l[t] = "inherit"),
            (a && "set" in a && void 0 === (n = a.set(e, n, r))) ||
              (u ? l.setProperty(t, n) : (l[t] = n)));
      }
    },
    css: function (e, t, n, r) {
      var i,
        o,
        a,
        s = X(t);
      return (
        Xe.test(t) || (t = ze(s)),
        (a = S.cssHooks[t] || S.cssHooks[s]) &&
          "get" in a &&
          (i = a.get(e, !0, n)),
        void 0 === i && (i = We(e, t, r)),
        "normal" === i && t in Ge && (i = Ge[t]),
        "" === n || n
          ? ((o = parseFloat(i)), !0 === n || isFinite(o) ? o || 0 : i)
          : i
      );
    },
  }),
    S.each(["height", "width"], function (e, u) {
      S.cssHooks[u] = {
        get: function (e, t, n) {
          if (t)
            return !Ue.test(S.css(e, "display")) ||
              (e.getClientRects().length && e.getBoundingClientRect().width)
              ? Je(e, u, n)
              : Me(e, Ve, function () {
                  return Je(e, u, n);
                });
        },
        set: function (e, t, n) {
          var r,
            i = Re(e),
            o = !y.scrollboxSize() && "absolute" === i.position,
            a = (o || n) && "border-box" === S.css(e, "boxSizing", !1, i),
            s = n ? Qe(e, u, n, a, i) : 0;
          return (
            a &&
              o &&
              (s -= Math.ceil(
                e["offset" + u[0].toUpperCase() + u.slice(1)] -
                  parseFloat(i[u]) -
                  Qe(e, u, "border", !1, i) -
                  0.5
              )),
            s &&
              (r = te.exec(t)) &&
              "px" !== (r[3] || "px") &&
              ((e.style[u] = t), (t = S.css(e, u))),
            Ye(0, t, s)
          );
        },
      };
    }),
    (S.cssHooks.marginLeft = Fe(y.reliableMarginLeft, function (e, t) {
      if (t)
        return (
          (parseFloat(We(e, "marginLeft")) ||
            e.getBoundingClientRect().left -
              Me(e, { marginLeft: 0 }, function () {
                return e.getBoundingClientRect().left;
              })) + "px"
        );
    })),
    S.each({ margin: "", padding: "", border: "Width" }, function (i, o) {
      (S.cssHooks[i + o] = {
        expand: function (e) {
          for (
            var t = 0, n = {}, r = "string" == typeof e ? e.split(" ") : [e];
            t < 4;
            t++
          )
            n[i + ne[t] + o] = r[t] || r[t - 2] || r[0];
          return n;
        },
      }),
        "margin" !== i && (S.cssHooks[i + o].set = Ye);
    }),
    S.fn.extend({
      css: function (e, t) {
        return $(
          this,
          function (e, t, n) {
            var r,
              i,
              o = {},
              a = 0;
            if (Array.isArray(t)) {
              for (r = Re(e), i = t.length; a < i; a++)
                o[t[a]] = S.css(e, t[a], !1, r);
              return o;
            }
            return void 0 !== n ? S.style(e, t, n) : S.css(e, t);
          },
          e,
          t,
          1 < arguments.length
        );
      },
    }),
    (((S.Tween = Ke).prototype = {
      constructor: Ke,
      init: function (e, t, n, r, i, o) {
        (this.elem = e),
          (this.prop = n),
          (this.easing = i || S.easing._default),
          (this.options = t),
          (this.start = this.now = this.cur()),
          (this.end = r),
          (this.unit = o || (S.cssNumber[n] ? "" : "px"));
      },
      cur: function () {
        var e = Ke.propHooks[this.prop];
        return e && e.get ? e.get(this) : Ke.propHooks._default.get(this);
      },
      run: function (e) {
        var t,
          n = Ke.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = t =
                S.easing[this.easing](
                  e,
                  this.options.duration * e,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = t = e),
          (this.now = (this.end - this.start) * t + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          n && n.set ? n.set(this) : Ke.propHooks._default.set(this),
          this
        );
      },
    }).init.prototype = Ke.prototype),
    ((Ke.propHooks = {
      _default: {
        get: function (e) {
          var t;
          return 1 !== e.elem.nodeType ||
            (null != e.elem[e.prop] && null == e.elem.style[e.prop])
            ? e.elem[e.prop]
            : (t = S.css(e.elem, e.prop, "")) && "auto" !== t
            ? t
            : 0;
        },
        set: function (e) {
          S.fx.step[e.prop]
            ? S.fx.step[e.prop](e)
            : 1 !== e.elem.nodeType ||
              (!S.cssHooks[e.prop] && null == e.elem.style[ze(e.prop)])
            ? (e.elem[e.prop] = e.now)
            : S.style(e.elem, e.prop, e.now + e.unit);
        },
      },
    }).scrollTop = Ke.propHooks.scrollLeft =
      {
        set: function (e) {
          e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
        },
      }),
    (S.easing = {
      linear: function (e) {
        return e;
      },
      swing: function (e) {
        return 0.5 - Math.cos(e * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (S.fx = Ke.prototype.init),
    (S.fx.step = {});
  var Ze,
    et,
    tt,
    nt,
    rt = /^(?:toggle|show|hide)$/,
    it = /queueHooks$/;
  function ot() {
    et &&
      (!1 === E.hidden && C.requestAnimationFrame
        ? C.requestAnimationFrame(ot)
        : C.setTimeout(ot, S.fx.interval),
      S.fx.tick());
  }
  function at() {
    return (
      C.setTimeout(function () {
        Ze = void 0;
      }),
      (Ze = Date.now())
    );
  }
  function st(e, t) {
    var n,
      r = 0,
      i = { height: e };
    for (t = t ? 1 : 0; r < 4; r += 2 - t)
      i["margin" + (n = ne[r])] = i["padding" + n] = e;
    return t && (i.opacity = i.width = e), i;
  }
  function ut(e, t, n) {
    for (
      var r,
        i = (lt.tweeners[t] || []).concat(lt.tweeners["*"]),
        o = 0,
        a = i.length;
      o < a;
      o++
    )
      if ((r = i[o].call(n, t, e))) return r;
  }
  function lt(o, e, t) {
    var n,
      a,
      r = 0,
      i = lt.prefilters.length,
      s = S.Deferred().always(function () {
        delete u.elem;
      }),
      u = function () {
        if (a) return !1;
        for (
          var e = Ze || at(),
            t = Math.max(0, l.startTime + l.duration - e),
            n = 1 - (t / l.duration || 0),
            r = 0,
            i = l.tweens.length;
          r < i;
          r++
        )
          l.tweens[r].run(n);
        return (
          s.notifyWith(o, [l, n, t]),
          n < 1 && i
            ? t
            : (i || s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l]), !1)
        );
      },
      l = s.promise({
        elem: o,
        props: S.extend({}, e),
        opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, t),
        originalProperties: e,
        originalOptions: t,
        startTime: Ze || at(),
        duration: t.duration,
        tweens: [],
        createTween: function (e, t) {
          var n = S.Tween(
            o,
            l.opts,
            e,
            t,
            l.opts.specialEasing[e] || l.opts.easing
          );
          return l.tweens.push(n), n;
        },
        stop: function (e) {
          var t = 0,
            n = e ? l.tweens.length : 0;
          if (a) return this;
          for (a = !0; t < n; t++) l.tweens[t].run(1);
          return (
            e
              ? (s.notifyWith(o, [l, 1, 0]), s.resolveWith(o, [l, e]))
              : s.rejectWith(o, [l, e]),
            this
          );
        },
      }),
      c = l.props;
    for (
      !(function (e, t) {
        var n, r, i, o, a;
        for (n in e)
          if (
            ((i = t[(r = X(n))]),
            (o = e[n]),
            Array.isArray(o) && ((i = o[1]), (o = e[n] = o[0])),
            n !== r && ((e[r] = o), delete e[n]),
            (a = S.cssHooks[r]) && ("expand" in a))
          )
            for (n in ((o = a.expand(o)), delete e[r], o))
              (n in e) || ((e[n] = o[n]), (t[n] = i));
          else t[r] = i;
      })(c, l.opts.specialEasing);
      r < i;
      r++
    )
      if ((n = lt.prefilters[r].call(l, o, c, l.opts)))
        return (
          m(n.stop) &&
            (S._queueHooks(l.elem, l.opts.queue).stop = n.stop.bind(n)),
          n
        );
    return (
      S.map(c, ut, l),
      m(l.opts.start) && l.opts.start.call(o, l),
      l
        .progress(l.opts.progress)
        .done(l.opts.done, l.opts.complete)
        .fail(l.opts.fail)
        .always(l.opts.always),
      S.fx.timer(S.extend(u, { elem: o, anim: l, queue: l.opts.queue })),
      l
    );
  }
  (S.Animation = S.extend(lt, {
    tweeners: {
      "*": [
        function (e, t) {
          var n = this.createTween(e, t);
          return se(n.elem, e, te.exec(t), n), n;
        },
      ],
    },
    tweener: function (e, t) {
      m(e) ? ((t = e), (e = ["*"])) : (e = e.match(P));
      for (var n, r = 0, i = e.length; r < i; r++)
        (n = e[r]),
          (lt.tweeners[n] = lt.tweeners[n] || []),
          lt.tweeners[n].unshift(t);
    },
    prefilters: [
      function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c,
          f = "width" in t || "height" in t,
          p = this,
          d = {},
          h = e.style,
          g = e.nodeType && ae(e),
          v = Y.get(e, "fxshow");
        for (r in (n.queue ||
          (null == (a = S._queueHooks(e, "fx")).unqueued &&
            ((a.unqueued = 0),
            (s = a.empty.fire),
            (a.empty.fire = function () {
              a.unqueued || s();
            })),
          a.unqueued++,
          p.always(function () {
            p.always(function () {
              a.unqueued--, S.queue(e, "fx").length || a.empty.fire();
            });
          })),
        t))
          if (((i = t[r]), rt.test(i))) {
            if (
              (delete t[r],
              (o = o || "toggle" === i),
              i === (g ? "hide" : "show"))
            ) {
              if ("show" !== i || !v || void 0 === v[r]) continue;
              g = !0;
            }
            d[r] = (v && v[r]) || S.style(e, r);
          }
        if ((u = !S.isEmptyObject(t)) || !S.isEmptyObject(d))
          for (r in (f &&
            1 === e.nodeType &&
            ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
            null == (l = v && v.display) && (l = Y.get(e, "display")),
            "none" === (c = S.css(e, "display")) &&
              (l
                ? (c = l)
                : (le([e], !0),
                  (l = e.style.display || l),
                  (c = S.css(e, "display")),
                  le([e]))),
            ("inline" === c || ("inline-block" === c && null != l)) &&
              "none" === S.css(e, "float") &&
              (u ||
                (p.done(function () {
                  h.display = l;
                }),
                null == l && ((c = h.display), (l = "none" === c ? "" : c))),
              (h.display = "inline-block"))),
          n.overflow &&
            ((h.overflow = "hidden"),
            p.always(function () {
              (h.overflow = n.overflow[0]),
                (h.overflowX = n.overflow[1]),
                (h.overflowY = n.overflow[2]);
            })),
          (u = !1),
          d))
            u ||
              (v
                ? "hidden" in v && (g = v.hidden)
                : (v = Y.access(e, "fxshow", { display: l })),
              o && (v.hidden = !g),
              g && le([e], !0),
              p.done(function () {
                for (r in (g || le([e]), Y.remove(e, "fxshow"), d))
                  S.style(e, r, d[r]);
              })),
              (u = ut(g ? v[r] : 0, r, p)),
              r in v ||
                ((v[r] = u.start), g && ((u.end = u.start), (u.start = 0)));
      },
    ],
    prefilter: function (e, t) {
      t ? lt.prefilters.unshift(e) : lt.prefilters.push(e);
    },
  })),
    (S.speed = function (e, t, n) {
      var r =
        e && "object" == typeof e
          ? S.extend({}, e)
          : {
              complete: n || (!n && t) || (m(e) && e),
              duration: e,
              easing: (n && t) || (t && !m(t) && t),
            };
      return (
        S.fx.off
          ? (r.duration = 0)
          : "number" != typeof r.duration &&
            (r.duration in S.fx.speeds
              ? (r.duration = S.fx.speeds[r.duration])
              : (r.duration = S.fx.speeds._default)),
        (null != r.queue && !0 !== r.queue) || (r.queue = "fx"),
        (r.old = r.complete),
        (r.complete = function () {
          m(r.old) && r.old.call(this), r.queue && S.dequeue(this, r.queue);
        }),
        r
      );
    }),
    S.fn.extend({
      fadeTo: function (e, t, n, r) {
        return this.filter(ae)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: t }, e, n, r);
      },
      animate: function (t, e, n, r) {
        var i = S.isEmptyObject(t),
          o = S.speed(e, n, r),
          a = function () {
            var e = lt(this, S.extend({}, t), o);
            (i || Y.get(this, "finish")) && e.stop(!0);
          };
        return (
          (a.finish = a),
          i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
        );
      },
      stop: function (i, e, o) {
        var a = function (e) {
          var t = e.stop;
          delete e.stop, t(o);
        };
        return (
          "string" != typeof i && ((o = e), (e = i), (i = void 0)),
          e && this.queue(i || "fx", []),
          this.each(function () {
            var e = !0,
              t = null != i && i + "queueHooks",
              n = S.timers,
              r = Y.get(this);
            if (t) r[t] && r[t].stop && a(r[t]);
            else for (t in r) r[t] && r[t].stop && it.test(t) && a(r[t]);
            for (t = n.length; t--; )
              n[t].elem !== this ||
                (null != i && n[t].queue !== i) ||
                (n[t].anim.stop(o), (e = !1), n.splice(t, 1));
            (!e && o) || S.dequeue(this, i);
          })
        );
      },
      finish: function (a) {
        return (
          !1 !== a && (a = a || "fx"),
          this.each(function () {
            var e,
              t = Y.get(this),
              n = t[a + "queue"],
              r = t[a + "queueHooks"],
              i = S.timers,
              o = n ? n.length : 0;
            for (
              t.finish = !0,
                S.queue(this, a, []),
                r && r.stop && r.stop.call(this, !0),
                e = i.length;
              e--;

            )
              i[e].elem === this &&
                i[e].queue === a &&
                (i[e].anim.stop(!0), i.splice(e, 1));
            for (e = 0; e < o; e++)
              n[e] && n[e].finish && n[e].finish.call(this);
            delete t.finish;
          })
        );
      },
    }),
    S.each(["toggle", "show", "hide"], function (e, r) {
      var i = S.fn[r];
      S.fn[r] = function (e, t, n) {
        return null == e || "boolean" == typeof e
          ? i.apply(this, arguments)
          : this.animate(st(r, !0), e, t, n);
      };
    }),
    S.each(
      {
        slideDown: st("show"),
        slideUp: st("hide"),
        slideToggle: st("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (e, r) {
        S.fn[e] = function (e, t, n) {
          return this.animate(r, e, t, n);
        };
      }
    ),
    (S.timers = []),
    (S.fx.tick = function () {
      var e,
        t = 0,
        n = S.timers;
      for (Ze = Date.now(); t < n.length; t++)
        (e = n[t])() || n[t] !== e || n.splice(t--, 1);
      n.length || S.fx.stop(), (Ze = void 0);
    }),
    (S.fx.timer = function (e) {
      S.timers.push(e), S.fx.start();
    }),
    (S.fx.interval = 13),
    (S.fx.start = function () {
      et || ((et = !0), ot());
    }),
    (S.fx.stop = function () {
      et = null;
    }),
    (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (S.fn.delay = function (r, e) {
      return (
        (r = (S.fx && S.fx.speeds[r]) || r),
        (e = e || "fx"),
        this.queue(e, function (e, t) {
          var n = C.setTimeout(e, r);
          t.stop = function () {
            C.clearTimeout(n);
          };
        })
      );
    }),
    (tt = E.createElement("input")),
    (nt = E.createElement("select").appendChild(E.createElement("option"))),
    (tt.type = "checkbox"),
    (y.checkOn = "" !== tt.value),
    (y.optSelected = nt.selected),
    ((tt = E.createElement("input")).value = "t"),
    (tt.type = "radio"),
    (y.radioValue = "t" === tt.value);
  var ct,
    ft = S.expr.attrHandle;
  S.fn.extend({
    attr: function (e, t) {
      return $(this, S.attr, e, t, 1 < arguments.length);
    },
    removeAttr: function (e) {
      return this.each(function () {
        S.removeAttr(this, e);
      });
    },
  }),
    S.extend({
      attr: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return "undefined" == typeof e.getAttribute
            ? S.prop(e, t, n)
            : ((1 === o && S.isXMLDoc(e)) ||
                (i =
                  S.attrHooks[t.toLowerCase()] ||
                  (S.expr.match.bool.test(t) ? ct : void 0)),
              void 0 !== n
                ? null === n
                  ? void S.removeAttr(e, t)
                  : i && "set" in i && void 0 !== (r = i.set(e, n, t))
                  ? r
                  : (e.setAttribute(t, n + ""), n)
                : i && "get" in i && null !== (r = i.get(e, t))
                ? r
                : null == (r = S.find.attr(e, t))
                ? void 0
                : r);
      },
      attrHooks: {
        type: {
          set: function (e, t) {
            if (!y.radioValue && "radio" === t && A(e, "input")) {
              var n = e.value;
              return e.setAttribute("type", t), n && (e.value = n), t;
            }
          },
        },
      },
      removeAttr: function (e, t) {
        var n,
          r = 0,
          i = t && t.match(P);
        if (i && 1 === e.nodeType) while ((n = i[r++])) e.removeAttribute(n);
      },
    }),
    (ct = {
      set: function (e, t, n) {
        return !1 === t ? S.removeAttr(e, n) : e.setAttribute(n, n), n;
      },
    }),
    S.each(S.expr.match.bool.source.match(/\w+/g), function (e, t) {
      var a = ft[t] || S.find.attr;
      ft[t] = function (e, t, n) {
        var r,
          i,
          o = t.toLowerCase();
        return (
          n ||
            ((i = ft[o]),
            (ft[o] = r),
            (r = null != a(e, t, n) ? o : null),
            (ft[o] = i)),
          r
        );
      };
    });
  var pt = /^(?:input|select|textarea|button)$/i,
    dt = /^(?:a|area)$/i;
  function ht(e) {
    return (e.match(P) || []).join(" ");
  }
  function gt(e) {
    return (e.getAttribute && e.getAttribute("class")) || "";
  }
  function vt(e) {
    return Array.isArray(e) ? e : ("string" == typeof e && e.match(P)) || [];
  }
  S.fn.extend({
    prop: function (e, t) {
      return $(this, S.prop, e, t, 1 < arguments.length);
    },
    removeProp: function (e) {
      return this.each(function () {
        delete this[S.propFix[e] || e];
      });
    },
  }),
    S.extend({
      prop: function (e, t, n) {
        var r,
          i,
          o = e.nodeType;
        if (3 !== o && 8 !== o && 2 !== o)
          return (
            (1 === o && S.isXMLDoc(e)) ||
              ((t = S.propFix[t] || t), (i = S.propHooks[t])),
            void 0 !== n
              ? i && "set" in i && void 0 !== (r = i.set(e, n, t))
                ? r
                : (e[t] = n)
              : i && "get" in i && null !== (r = i.get(e, t))
              ? r
              : e[t]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (e) {
            var t = S.find.attr(e, "tabindex");
            return t
              ? parseInt(t, 10)
              : pt.test(e.nodeName) || (dt.test(e.nodeName) && e.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    y.optSelected ||
      (S.propHooks.selected = {
        get: function (e) {
          var t = e.parentNode;
          return t && t.parentNode && t.parentNode.selectedIndex, null;
        },
        set: function (e) {
          var t = e.parentNode;
          t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
        },
      }),
    S.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        S.propFix[this.toLowerCase()] = this;
      }
    ),
    S.fn.extend({
      addClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).addClass(t.call(this, e, gt(this)));
          });
        if ((e = vt(t)).length)
          while ((n = this[u++]))
            if (((i = gt(n)), (r = 1 === n.nodeType && " " + ht(i) + " "))) {
              a = 0;
              while ((o = e[a++]))
                r.indexOf(" " + o + " ") < 0 && (r += o + " ");
              i !== (s = ht(r)) && n.setAttribute("class", s);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;
        if (m(t))
          return this.each(function (e) {
            S(this).removeClass(t.call(this, e, gt(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ((e = vt(t)).length)
          while ((n = this[u++]))
            if (((i = gt(n)), (r = 1 === n.nodeType && " " + ht(i) + " "))) {
              a = 0;
              while ((o = e[a++]))
                while (-1 < r.indexOf(" " + o + " "))
                  r = r.replace(" " + o + " ", " ");
              i !== (s = ht(r)) && n.setAttribute("class", s);
            }
        return this;
      },
      toggleClass: function (i, t) {
        var o = typeof i,
          a = "string" === o || Array.isArray(i);
        return "boolean" == typeof t && a
          ? t
            ? this.addClass(i)
            : this.removeClass(i)
          : m(i)
          ? this.each(function (e) {
              S(this).toggleClass(i.call(this, e, gt(this), t), t);
            })
          : this.each(function () {
              var e, t, n, r;
              if (a) {
                (t = 0), (n = S(this)), (r = vt(i));
                while ((e = r[t++]))
                  n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
              } else (void 0 !== i && "boolean" !== o) || ((e = gt(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === i ? "" : Y.get(this, "__className__") || ""));
            });
      },
      hasClass: function (e) {
        var t,
          n,
          r = 0;
        t = " " + e + " ";
        while ((n = this[r++]))
          if (1 === n.nodeType && -1 < (" " + ht(gt(n)) + " ").indexOf(t))
            return !0;
        return !1;
      },
    });
  var yt = /\r/g;
  S.fn.extend({
    val: function (n) {
      var r,
        e,
        i,
        t = this[0];
      return arguments.length
        ? ((i = m(n)),
          this.each(function (e) {
            var t;
            1 === this.nodeType &&
              (null == (t = i ? n.call(this, e, S(this).val()) : n)
                ? (t = "")
                : "number" == typeof t
                ? (t += "")
                : Array.isArray(t) &&
                  (t = S.map(t, function (e) {
                    return null == e ? "" : e + "";
                  })),
              ((r =
                S.valHooks[this.type] ||
                S.valHooks[this.nodeName.toLowerCase()]) &&
                "set" in r &&
                void 0 !== r.set(this, t, "value")) ||
                (this.value = t));
          }))
        : t
        ? (r = S.valHooks[t.type] || S.valHooks[t.nodeName.toLowerCase()]) &&
          "get" in r &&
          void 0 !== (e = r.get(t, "value"))
          ? e
          : "string" == typeof (e = t.value)
          ? e.replace(yt, "")
          : null == e
          ? ""
          : e
        : void 0;
    },
  }),
    S.extend({
      valHooks: {
        option: {
          get: function (e) {
            var t = S.find.attr(e, "value");
            return null != t ? t : ht(S.text(e));
          },
        },
        select: {
          get: function (e) {
            var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;
            for (r = o < 0 ? u : a ? o : 0; r < u; r++)
              if (
                ((n = i[r]).selected || r === o) &&
                !n.disabled &&
                (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))
              ) {
                if (((t = S(n).val()), a)) return t;
                s.push(t);
              }
            return s;
          },
          set: function (e, t) {
            var n,
              r,
              i = e.options,
              o = S.makeArray(t),
              a = i.length;
            while (a--)
              ((r = i[a]).selected =
                -1 < S.inArray(S.valHooks.option.get(r), o)) && (n = !0);
            return n || (e.selectedIndex = -1), o;
          },
        },
      },
    }),
    S.each(["radio", "checkbox"], function () {
      (S.valHooks[this] = {
        set: function (e, t) {
          if (Array.isArray(t))
            return (e.checked = -1 < S.inArray(S(e).val(), t));
        },
      }),
        y.checkOn ||
          (S.valHooks[this].get = function (e) {
            return null === e.getAttribute("value") ? "on" : e.value;
          });
    }),
    (y.focusin = "onfocusin" in C);
  var mt = /^(?:focusinfocus|focusoutblur)$/,
    xt = function (e) {
      e.stopPropagation();
    };
  S.extend(S.event, {
    trigger: function (e, t, n, r) {
      var i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p = [n || E],
        d = v.call(e, "type") ? e.type : e,
        h = v.call(e, "namespace") ? e.namespace.split(".") : [];
      if (
        ((o = f = a = n = n || E),
        3 !== n.nodeType &&
          8 !== n.nodeType &&
          !mt.test(d + S.event.triggered) &&
          (-1 < d.indexOf(".") && ((d = (h = d.split(".")).shift()), h.sort()),
          (u = d.indexOf(":") < 0 && "on" + d),
          ((e = e[S.expando]
            ? e
            : new S.Event(d, "object" == typeof e && e)).isTrigger = r ? 2 : 3),
          (e.namespace = h.join(".")),
          (e.rnamespace = e.namespace
            ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (e.result = void 0),
          e.target || (e.target = n),
          (t = null == t ? [e] : S.makeArray(t, [e])),
          (c = S.event.special[d] || {}),
          r || !c.trigger || !1 !== c.trigger.apply(n, t)))
      ) {
        if (!r && !c.noBubble && !x(n)) {
          for (
            s = c.delegateType || d, mt.test(s + d) || (o = o.parentNode);
            o;
            o = o.parentNode
          )
            p.push(o), (a = o);
          a === (n.ownerDocument || E) &&
            p.push(a.defaultView || a.parentWindow || C);
        }
        i = 0;
        while ((o = p[i++]) && !e.isPropagationStopped())
          (f = o),
            (e.type = 1 < i ? s : c.bindType || d),
            (l =
              (Y.get(o, "events") || Object.create(null))[e.type] &&
              Y.get(o, "handle")) && l.apply(o, t),
            (l = u && o[u]) &&
              l.apply &&
              V(o) &&
              ((e.result = l.apply(o, t)),
              !1 === e.result && e.preventDefault());
        return (
          (e.type = d),
          r ||
            e.isDefaultPrevented() ||
            (c._default && !1 !== c._default.apply(p.pop(), t)) ||
            !V(n) ||
            (u &&
              m(n[d]) &&
              !x(n) &&
              ((a = n[u]) && (n[u] = null),
              (S.event.triggered = d),
              e.isPropagationStopped() && f.addEventListener(d, xt),
              n[d](),
              e.isPropagationStopped() && f.removeEventListener(d, xt),
              (S.event.triggered = void 0),
              a && (n[u] = a))),
          e.result
        );
      }
    },
    simulate: function (e, t, n) {
      var r = S.extend(new S.Event(), n, { type: e, isSimulated: !0 });
      S.event.trigger(r, null, t);
    },
  }),
    S.fn.extend({
      trigger: function (e, t) {
        return this.each(function () {
          S.event.trigger(e, t, this);
        });
      },
      triggerHandler: function (e, t) {
        var n = this[0];
        if (n) return S.event.trigger(e, t, n, !0);
      },
    }),
    y.focusin ||
      S.each({ focus: "focusin", blur: "focusout" }, function (n, r) {
        var i = function (e) {
          S.event.simulate(r, e.target, S.event.fix(e));
        };
        S.event.special[r] = {
          setup: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r);
            t || e.addEventListener(n, i, !0), Y.access(e, r, (t || 0) + 1);
          },
          teardown: function () {
            var e = this.ownerDocument || this.document || this,
              t = Y.access(e, r) - 1;
            t
              ? Y.access(e, r, t)
              : (e.removeEventListener(n, i, !0), Y.remove(e, r));
          },
        };
      });
  var bt = C.location,
    wt = { guid: Date.now() },
    Tt = /\?/;
  S.parseXML = function (e) {
    var t, n;
    if (!e || "string" != typeof e) return null;
    try {
      t = new C.DOMParser().parseFromString(e, "text/xml");
    } catch (e) {}
    return (
      (n = t && t.getElementsByTagName("parsererror")[0]),
      (t && !n) ||
        S.error(
          "Invalid XML: " +
            (n
              ? S.map(n.childNodes, function (e) {
                  return e.textContent;
                }).join("\n")
              : e)
        ),
      t
    );
  };
  var Ct = /\[\]$/,
    Et = /\r?\n/g,
    St = /^(?:submit|button|image|reset|file)$/i,
    kt = /^(?:input|select|textarea|keygen)/i;
  function At(n, e, r, i) {
    var t;
    if (Array.isArray(e))
      S.each(e, function (e, t) {
        r || Ct.test(n)
          ? i(n, t)
          : At(
              n + "[" + ("object" == typeof t && null != t ? e : "") + "]",
              t,
              r,
              i
            );
      });
    else if (r || "object" !== w(e)) i(n, e);
    else for (t in e) At(n + "[" + t + "]", e[t], r, i);
  }
  (S.param = function (e, t) {
    var n,
      r = [],
      i = function (e, t) {
        var n = m(t) ? t() : t;
        r[r.length] =
          encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
      };
    if (null == e) return "";
    if (Array.isArray(e) || (e.jquery && !S.isPlainObject(e)))
      S.each(e, function () {
        i(this.name, this.value);
      });
    else for (n in e) At(n, e[n], t, i);
    return r.join("&");
  }),
    S.fn.extend({
      serialize: function () {
        return S.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = S.prop(this, "elements");
          return e ? S.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !S(this).is(":disabled") &&
              kt.test(this.nodeName) &&
              !St.test(e) &&
              (this.checked || !pe.test(e))
            );
          })
          .map(function (e, t) {
            var n = S(this).val();
            return null == n
              ? null
              : Array.isArray(n)
              ? S.map(n, function (e) {
                  return { name: t.name, value: e.replace(Et, "\r\n") };
                })
              : { name: t.name, value: n.replace(Et, "\r\n") };
          })
          .get();
      },
    });
  var Nt = /%20/g,
    jt = /#.*$/,
    Dt = /([?&])_=[^&]*/,
    qt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
    Lt = /^(?:GET|HEAD)$/,
    Ht = /^\/\//,
    Ot = {},
    Pt = {},
    Rt = "*/".concat("*"),
    Mt = E.createElement("a");
  function It(o) {
    return function (e, t) {
      "string" != typeof e && ((t = e), (e = "*"));
      var n,
        r = 0,
        i = e.toLowerCase().match(P) || [];
      if (m(t))
        while ((n = i[r++]))
          "+" === n[0]
            ? ((n = n.slice(1) || "*"), (o[n] = o[n] || []).unshift(t))
            : (o[n] = o[n] || []).push(t);
    };
  }
  function Wt(t, i, o, a) {
    var s = {},
      u = t === Pt;
    function l(e) {
      var r;
      return (
        (s[e] = !0),
        S.each(t[e] || [], function (e, t) {
          var n = t(i, o, a);
          return "string" != typeof n || u || s[n]
            ? u
              ? !(r = n)
              : void 0
            : (i.dataTypes.unshift(n), l(n), !1);
        }),
        r
      );
    }
    return l(i.dataTypes[0]) || (!s["*"] && l("*"));
  }
  function Ft(e, t) {
    var n,
      r,
      i = S.ajaxSettings.flatOptions || {};
    for (n in t) void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    return r && S.extend(!0, e, r), e;
  }
  (Mt.href = bt.href),
    S.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: bt.href,
        type: "GET",
        isLocal:
          /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
            bt.protocol
          ),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Rt,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": JSON.parse,
          "text xml": S.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (e, t) {
        return t ? Ft(Ft(e, S.ajaxSettings), t) : Ft(S.ajaxSettings, e);
      },
      ajaxPrefilter: It(Ot),
      ajaxTransport: It(Pt),
      ajax: function (e, t) {
        "object" == typeof e && ((t = e), (e = void 0)), (t = t || {});
        var c,
          f,
          p,
          n,
          d,
          r,
          h,
          g,
          i,
          o,
          v = S.ajaxSetup({}, t),
          y = v.context || v,
          m = v.context && (y.nodeType || y.jquery) ? S(y) : S.event,
          x = S.Deferred(),
          b = S.Callbacks("once memory"),
          w = v.statusCode || {},
          a = {},
          s = {},
          u = "canceled",
          T = {
            readyState: 0,
            getResponseHeader: function (e) {
              var t;
              if (h) {
                if (!n) {
                  n = {};
                  while ((t = qt.exec(p)))
                    n[t[1].toLowerCase() + " "] = (
                      n[t[1].toLowerCase() + " "] || []
                    ).concat(t[2]);
                }
                t = n[e.toLowerCase() + " "];
              }
              return null == t ? null : t.join(", ");
            },
            getAllResponseHeaders: function () {
              return h ? p : null;
            },
            setRequestHeader: function (e, t) {
              return (
                null == h &&
                  ((e = s[e.toLowerCase()] = s[e.toLowerCase()] || e),
                  (a[e] = t)),
                this
              );
            },
            overrideMimeType: function (e) {
              return null == h && (v.mimeType = e), this;
            },
            statusCode: function (e) {
              var t;
              if (e)
                if (h) T.always(e[T.status]);
                else for (t in e) w[t] = [w[t], e[t]];
              return this;
            },
            abort: function (e) {
              var t = e || u;
              return c && c.abort(t), l(0, t), this;
            },
          };
        if (
          (x.promise(T),
          (v.url = ((e || v.url || bt.href) + "").replace(
            Ht,
            bt.protocol + "//"
          )),
          (v.type = t.method || t.type || v.method || v.type),
          (v.dataTypes = (v.dataType || "*").toLowerCase().match(P) || [""]),
          null == v.crossDomain)
        ) {
          r = E.createElement("a");
          try {
            (r.href = v.url),
              (r.href = r.href),
              (v.crossDomain =
                Mt.protocol + "//" + Mt.host != r.protocol + "//" + r.host);
          } catch (e) {
            v.crossDomain = !0;
          }
        }
        if (
          (v.data &&
            v.processData &&
            "string" != typeof v.data &&
            (v.data = S.param(v.data, v.traditional)),
          Wt(Ot, v, t, T),
          h)
        )
          return T;
        for (i in ((g = S.event && v.global) &&
          0 == S.active++ &&
          S.event.trigger("ajaxStart"),
        (v.type = v.type.toUpperCase()),
        (v.hasContent = !Lt.test(v.type)),
        (f = v.url.replace(jt, "")),
        v.hasContent
          ? v.data &&
            v.processData &&
            0 ===
              (v.contentType || "").indexOf(
                "application/x-www-form-urlencoded"
              ) &&
            (v.data = v.data.replace(Nt, "+"))
          : ((o = v.url.slice(f.length)),
            v.data &&
              (v.processData || "string" == typeof v.data) &&
              ((f += (Tt.test(f) ? "&" : "?") + v.data), delete v.data),
            !1 === v.cache &&
              ((f = f.replace(Dt, "$1")),
              (o = (Tt.test(f) ? "&" : "?") + "_=" + wt.guid++ + o)),
            (v.url = f + o)),
        v.ifModified &&
          (S.lastModified[f] &&
            T.setRequestHeader("If-Modified-Since", S.lastModified[f]),
          S.etag[f] && T.setRequestHeader("If-None-Match", S.etag[f])),
        ((v.data && v.hasContent && !1 !== v.contentType) || t.contentType) &&
          T.setRequestHeader("Content-Type", v.contentType),
        T.setRequestHeader(
          "Accept",
          v.dataTypes[0] && v.accepts[v.dataTypes[0]]
            ? v.accepts[v.dataTypes[0]] +
                ("*" !== v.dataTypes[0] ? ", " + Rt + "; q=0.01" : "")
            : v.accepts["*"]
        ),
        v.headers))
          T.setRequestHeader(i, v.headers[i]);
        if (v.beforeSend && (!1 === v.beforeSend.call(y, T, v) || h))
          return T.abort();
        if (
          ((u = "abort"),
          b.add(v.complete),
          T.done(v.success),
          T.fail(v.error),
          (c = Wt(Pt, v, t, T)))
        ) {
          if (((T.readyState = 1), g && m.trigger("ajaxSend", [T, v]), h))
            return T;
          v.async &&
            0 < v.timeout &&
            (d = C.setTimeout(function () {
              T.abort("timeout");
            }, v.timeout));
          try {
            (h = !1), c.send(a, l);
          } catch (e) {
            if (h) throw e;
            l(-1, e);
          }
        } else l(-1, "No Transport");
        function l(e, t, n, r) {
          var i,
            o,
            a,
            s,
            u,
            l = t;
          h ||
            ((h = !0),
            d && C.clearTimeout(d),
            (c = void 0),
            (p = r || ""),
            (T.readyState = 0 < e ? 4 : 0),
            (i = (200 <= e && e < 300) || 304 === e),
            n &&
              (s = (function (e, t, n) {
                var r,
                  i,
                  o,
                  a,
                  s = e.contents,
                  u = e.dataTypes;
                while ("*" === u[0])
                  u.shift(),
                    void 0 === r &&
                      (r = e.mimeType || t.getResponseHeader("Content-Type"));
                if (r)
                  for (i in s)
                    if (s[i] && s[i].test(r)) {
                      u.unshift(i);
                      break;
                    }
                if (u[0] in n) o = u[0];
                else {
                  for (i in n) {
                    if (!u[0] || e.converters[i + " " + u[0]]) {
                      o = i;
                      break;
                    }
                    a || (a = i);
                  }
                  o = o || a;
                }
                if (o) return o !== u[0] && u.unshift(o), n[o];
              })(v, T, n)),
            !i &&
              -1 < S.inArray("script", v.dataTypes) &&
              S.inArray("json", v.dataTypes) < 0 &&
              (v.converters["text script"] = function () {}),
            (s = (function (e, t, n, r) {
              var i,
                o,
                a,
                s,
                u,
                l = {},
                c = e.dataTypes.slice();
              if (c[1])
                for (a in e.converters) l[a.toLowerCase()] = e.converters[a];
              o = c.shift();
              while (o)
                if (
                  (e.responseFields[o] && (n[e.responseFields[o]] = t),
                  !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                  (u = o),
                  (o = c.shift()))
                )
                  if ("*" === o) o = u;
                  else if ("*" !== u && u !== o) {
                    if (!(a = l[u + " " + o] || l["* " + o]))
                      for (i in l)
                        if (
                          (s = i.split(" "))[1] === o &&
                          (a = l[u + " " + s[0]] || l["* " + s[0]])
                        ) {
                          !0 === a
                            ? (a = l[i])
                            : !0 !== l[i] && ((o = s[0]), c.unshift(s[1]));
                          break;
                        }
                    if (!0 !== a)
                      if (a && e["throws"]) t = a(t);
                      else
                        try {
                          t = a(t);
                        } catch (e) {
                          return {
                            state: "parsererror",
                            error: a
                              ? e
                              : "No conversion from " + u + " to " + o,
                          };
                        }
                  }
              return { state: "success", data: t };
            })(v, s, T, i)),
            i
              ? (v.ifModified &&
                  ((u = T.getResponseHeader("Last-Modified")) &&
                    (S.lastModified[f] = u),
                  (u = T.getResponseHeader("etag")) && (S.etag[f] = u)),
                204 === e || "HEAD" === v.type
                  ? (l = "nocontent")
                  : 304 === e
                  ? (l = "notmodified")
                  : ((l = s.state), (o = s.data), (i = !(a = s.error))))
              : ((a = l), (!e && l) || ((l = "error"), e < 0 && (e = 0))),
            (T.status = e),
            (T.statusText = (t || l) + ""),
            i ? x.resolveWith(y, [o, l, T]) : x.rejectWith(y, [T, l, a]),
            T.statusCode(w),
            (w = void 0),
            g && m.trigger(i ? "ajaxSuccess" : "ajaxError", [T, v, i ? o : a]),
            b.fireWith(y, [T, l]),
            g &&
              (m.trigger("ajaxComplete", [T, v]),
              --S.active || S.event.trigger("ajaxStop")));
        }
        return T;
      },
      getJSON: function (e, t, n) {
        return S.get(e, t, n, "json");
      },
      getScript: function (e, t) {
        return S.get(e, void 0, t, "script");
      },
    }),
    S.each(["get", "post"], function (e, i) {
      S[i] = function (e, t, n, r) {
        return (
          m(t) && ((r = r || n), (n = t), (t = void 0)),
          S.ajax(
            S.extend(
              { url: e, type: i, dataType: r, data: t, success: n },
              S.isPlainObject(e) && e
            )
          )
        );
      };
    }),
    S.ajaxPrefilter(function (e) {
      var t;
      for (t in e.headers)
        "content-type" === t.toLowerCase() &&
          (e.contentType = e.headers[t] || "");
    }),
    (S._evalUrl = function (e, t, n) {
      return S.ajax({
        url: e,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        converters: { "text script": function () {} },
        dataFilter: function (e) {
          S.globalEval(e, t, n);
        },
      });
    }),
    S.fn.extend({
      wrapAll: function (e) {
        var t;
        return (
          this[0] &&
            (m(e) && (e = e.call(this[0])),
            (t = S(e, this[0].ownerDocument).eq(0).clone(!0)),
            this[0].parentNode && t.insertBefore(this[0]),
            t
              .map(function () {
                var e = this;
                while (e.firstElementChild) e = e.firstElementChild;
                return e;
              })
              .append(this)),
          this
        );
      },
      wrapInner: function (n) {
        return m(n)
          ? this.each(function (e) {
              S(this).wrapInner(n.call(this, e));
            })
          : this.each(function () {
              var e = S(this),
                t = e.contents();
              t.length ? t.wrapAll(n) : e.append(n);
            });
      },
      wrap: function (t) {
        var n = m(t);
        return this.each(function (e) {
          S(this).wrapAll(n ? t.call(this, e) : t);
        });
      },
      unwrap: function (e) {
        return (
          this.parent(e)
            .not("body")
            .each(function () {
              S(this).replaceWith(this.childNodes);
            }),
          this
        );
      },
    }),
    (S.expr.pseudos.hidden = function (e) {
      return !S.expr.pseudos.visible(e);
    }),
    (S.expr.pseudos.visible = function (e) {
      return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
    }),
    (S.ajaxSettings.xhr = function () {
      try {
        return new C.XMLHttpRequest();
      } catch (e) {}
    });
  var Bt = { 0: 200, 1223: 204 },
    $t = S.ajaxSettings.xhr();
  (y.cors = !!$t && "withCredentials" in $t),
    (y.ajax = $t = !!$t),
    S.ajaxTransport(function (i) {
      var o, a;
      if (y.cors || ($t && !i.crossDomain))
        return {
          send: function (e, t) {
            var n,
              r = i.xhr();
            if (
              (r.open(i.type, i.url, i.async, i.username, i.password),
              i.xhrFields)
            )
              for (n in i.xhrFields) r[n] = i.xhrFields[n];
            for (n in (i.mimeType &&
              r.overrideMimeType &&
              r.overrideMimeType(i.mimeType),
            i.crossDomain ||
              e["X-Requested-With"] ||
              (e["X-Requested-With"] = "XMLHttpRequest"),
            e))
              r.setRequestHeader(n, e[n]);
            (o = function (e) {
              return function () {
                o &&
                  ((o =
                    a =
                    r.onload =
                    r.onerror =
                    r.onabort =
                    r.ontimeout =
                    r.onreadystatechange =
                      null),
                  "abort" === e
                    ? r.abort()
                    : "error" === e
                    ? "number" != typeof r.status
                      ? t(0, "error")
                      : t(r.status, r.statusText)
                    : t(
                        Bt[r.status] || r.status,
                        r.statusText,
                        "text" !== (r.responseType || "text") ||
                          "string" != typeof r.responseText
                          ? { binary: r.response }
                          : { text: r.responseText },
                        r.getAllResponseHeaders()
                      ));
              };
            }),
              (r.onload = o()),
              (a = r.onerror = r.ontimeout = o("error")),
              void 0 !== r.onabort
                ? (r.onabort = a)
                : (r.onreadystatechange = function () {
                    4 === r.readyState &&
                      C.setTimeout(function () {
                        o && a();
                      });
                  }),
              (o = o("abort"));
            try {
              r.send((i.hasContent && i.data) || null);
            } catch (e) {
              if (o) throw e;
            }
          },
          abort: function () {
            o && o();
          },
        };
    }),
    S.ajaxPrefilter(function (e) {
      e.crossDomain && (e.contents.script = !1);
    }),
    S.ajaxSetup({
      accepts: {
        script:
          "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
      },
      contents: { script: /\b(?:java|ecma)script\b/ },
      converters: {
        "text script": function (e) {
          return S.globalEval(e), e;
        },
      },
    }),
    S.ajaxPrefilter("script", function (e) {
      void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
    }),
    S.ajaxTransport("script", function (n) {
      var r, i;
      if (n.crossDomain || n.scriptAttrs)
        return {
          send: function (e, t) {
            (r = S("<script>")
              .attr(n.scriptAttrs || {})
              .prop({ charset: n.scriptCharset, src: n.url })
              .on(
                "load error",
                (i = function (e) {
                  r.remove(),
                    (i = null),
                    e && t("error" === e.type ? 404 : 200, e.type);
                })
              )),
              E.head.appendChild(r[0]);
          },
          abort: function () {
            i && i();
          },
        };
    });
  var _t,
    zt = [],
    Ut = /(=)\?(?=&|$)|\?\?/;
  S.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var e = zt.pop() || S.expando + "_" + wt.guid++;
      return (this[e] = !0), e;
    },
  }),
    S.ajaxPrefilter("json jsonp", function (e, t, n) {
      var r,
        i,
        o,
        a =
          !1 !== e.jsonp &&
          (Ut.test(e.url)
            ? "url"
            : "string" == typeof e.data &&
              0 ===
                (e.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              Ut.test(e.data) &&
              "data");
      if (a || "jsonp" === e.dataTypes[0])
        return (
          (r = e.jsonpCallback =
            m(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
          a
            ? (e[a] = e[a].replace(Ut, "$1" + r))
            : !1 !== e.jsonp &&
              (e.url += (Tt.test(e.url) ? "&" : "?") + e.jsonp + "=" + r),
          (e.converters["script json"] = function () {
            return o || S.error(r + " was not called"), o[0];
          }),
          (e.dataTypes[0] = "json"),
          (i = C[r]),
          (C[r] = function () {
            o = arguments;
          }),
          n.always(function () {
            void 0 === i ? S(C).removeProp(r) : (C[r] = i),
              e[r] && ((e.jsonpCallback = t.jsonpCallback), zt.push(r)),
              o && m(i) && i(o[0]),
              (o = i = void 0);
          }),
          "script"
        );
    }),
    (y.createHTMLDocument =
      (((_t = E.implementation.createHTMLDocument("").body).innerHTML =
        "<form></form><form></form>"),
      2 === _t.childNodes.length)),
    (S.parseHTML = function (e, t, n) {
      return "string" != typeof e
        ? []
        : ("boolean" == typeof t && ((n = t), (t = !1)),
          t ||
            (y.createHTMLDocument
              ? (((r = (t =
                  E.implementation.createHTMLDocument("")).createElement(
                  "base"
                )).href = E.location.href),
                t.head.appendChild(r))
              : (t = E)),
          (o = !n && []),
          (i = N.exec(e))
            ? [t.createElement(i[1])]
            : ((i = xe([e], t, o)),
              o && o.length && S(o).remove(),
              S.merge([], i.childNodes)));
      var r, i, o;
    }),
    (S.fn.load = function (e, t, n) {
      var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");
      return (
        -1 < s && ((r = ht(e.slice(s))), (e = e.slice(0, s))),
        m(t)
          ? ((n = t), (t = void 0))
          : t && "object" == typeof t && (i = "POST"),
        0 < a.length &&
          S.ajax({ url: e, type: i || "GET", dataType: "html", data: t })
            .done(function (e) {
              (o = arguments),
                a.html(r ? S("<div>").append(S.parseHTML(e)).find(r) : e);
            })
            .always(
              n &&
                function (e, t) {
                  a.each(function () {
                    n.apply(this, o || [e.responseText, t, e]);
                  });
                }
            ),
        this
      );
    }),
    (S.expr.pseudos.animated = function (t) {
      return S.grep(S.timers, function (e) {
        return t === e.elem;
      }).length;
    }),
    (S.offset = {
      setOffset: function (e, t, n) {
        var r,
          i,
          o,
          a,
          s,
          u,
          l = S.css(e, "position"),
          c = S(e),
          f = {};
        "static" === l && (e.style.position = "relative"),
          (s = c.offset()),
          (o = S.css(e, "top")),
          (u = S.css(e, "left")),
          ("absolute" === l || "fixed" === l) && -1 < (o + u).indexOf("auto")
            ? ((a = (r = c.position()).top), (i = r.left))
            : ((a = parseFloat(o) || 0), (i = parseFloat(u) || 0)),
          m(t) && (t = t.call(e, n, S.extend({}, s))),
          null != t.top && (f.top = t.top - s.top + a),
          null != t.left && (f.left = t.left - s.left + i),
          "using" in t ? t.using.call(e, f) : c.css(f);
      },
    }),
    S.fn.extend({
      offset: function (t) {
        if (arguments.length)
          return void 0 === t
            ? this
            : this.each(function (e) {
                S.offset.setOffset(this, t, e);
              });
        var e,
          n,
          r = this[0];
        return r
          ? r.getClientRects().length
            ? ((e = r.getBoundingClientRect()),
              (n = r.ownerDocument.defaultView),
              { top: e.top + n.pageYOffset, left: e.left + n.pageXOffset })
            : { top: 0, left: 0 }
          : void 0;
      },
      position: function () {
        if (this[0]) {
          var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };
          if ("fixed" === S.css(r, "position")) t = r.getBoundingClientRect();
          else {
            (t = this.offset()),
              (n = r.ownerDocument),
              (e = r.offsetParent || n.documentElement);
            while (
              e &&
              (e === n.body || e === n.documentElement) &&
              "static" === S.css(e, "position")
            )
              e = e.parentNode;
            e &&
              e !== r &&
              1 === e.nodeType &&
              (((i = S(e).offset()).top += S.css(e, "borderTopWidth", !0)),
              (i.left += S.css(e, "borderLeftWidth", !0)));
          }
          return {
            top: t.top - i.top - S.css(r, "marginTop", !0),
            left: t.left - i.left - S.css(r, "marginLeft", !0),
          };
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var e = this.offsetParent;
          while (e && "static" === S.css(e, "position")) e = e.offsetParent;
          return e || re;
        });
      },
    }),
    S.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (t, i) {
        var o = "pageYOffset" === i;
        S.fn[t] = function (e) {
          return $(
            this,
            function (e, t, n) {
              var r;
              if (
                (x(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView),
                void 0 === n)
              )
                return r ? r[i] : e[t];
              r
                ? r.scrollTo(o ? r.pageXOffset : n, o ? n : r.pageYOffset)
                : (e[t] = n);
            },
            t,
            e,
            arguments.length
          );
        };
      }
    ),
    S.each(["top", "left"], function (e, n) {
      S.cssHooks[n] = Fe(y.pixelPosition, function (e, t) {
        if (t)
          return (t = We(e, n)), Pe.test(t) ? S(e).position()[n] + "px" : t;
      });
    }),
    S.each({ Height: "height", Width: "width" }, function (a, s) {
      S.each(
        { padding: "inner" + a, content: s, "": "outer" + a },
        function (r, o) {
          S.fn[o] = function (e, t) {
            var n = arguments.length && (r || "boolean" != typeof e),
              i = r || (!0 === e || !0 === t ? "margin" : "border");
            return $(
              this,
              function (e, t, n) {
                var r;
                return x(e)
                  ? 0 === o.indexOf("outer")
                    ? e["inner" + a]
                    : e.document.documentElement["client" + a]
                  : 9 === e.nodeType
                  ? ((r = e.documentElement),
                    Math.max(
                      e.body["scroll" + a],
                      r["scroll" + a],
                      e.body["offset" + a],
                      r["offset" + a],
                      r["client" + a]
                    ))
                  : void 0 === n
                  ? S.css(e, t, i)
                  : S.style(e, t, n, i);
              },
              s,
              n ? e : void 0,
              n
            );
          };
        }
      );
    }),
    S.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (e, t) {
        S.fn[t] = function (e) {
          return this.on(t, e);
        };
      }
    ),
    S.fn.extend({
      bind: function (e, t, n) {
        return this.on(e, null, t, n);
      },
      unbind: function (e, t) {
        return this.off(e, null, t);
      },
      delegate: function (e, t, n, r) {
        return this.on(t, e, n, r);
      },
      undelegate: function (e, t, n) {
        return 1 === arguments.length
          ? this.off(e, "**")
          : this.off(t, e || "**", n);
      },
      hover: function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      },
    }),
    S.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
        " "
      ),
      function (e, n) {
        S.fn[n] = function (e, t) {
          return 0 < arguments.length
            ? this.on(n, null, e, t)
            : this.trigger(n);
        };
      }
    );
  var Xt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  (S.proxy = function (e, t) {
    var n, r, i;
    if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), m(e)))
      return (
        (r = s.call(arguments, 2)),
        ((i = function () {
          return e.apply(t || this, r.concat(s.call(arguments)));
        }).guid = e.guid =
          e.guid || S.guid++),
        i
      );
  }),
    (S.holdReady = function (e) {
      e ? S.readyWait++ : S.ready(!0);
    }),
    (S.isArray = Array.isArray),
    (S.parseJSON = JSON.parse),
    (S.nodeName = A),
    (S.isFunction = m),
    (S.isWindow = x),
    (S.camelCase = X),
    (S.type = w),
    (S.now = Date.now),
    (S.isNumeric = function (e) {
      var t = S.type(e);
      return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
    }),
    (S.trim = function (e) {
      return null == e ? "" : (e + "").replace(Xt, "");
    }),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return S;
      });
  var Vt = C.jQuery,
    Gt = C.$;
  return (
    (S.noConflict = function (e) {
      return C.$ === S && (C.$ = Gt), e && C.jQuery === S && (C.jQuery = Vt), S;
    }),
    "undefined" == typeof e && (C.jQuery = C.$ = S),
    S
  );
});

var codeblackbelt;
!(function () {
  if (!codeblackbelt || !codeblackbelt.requirejs) {
    codeblackbelt ? (require = codeblackbelt) : (codeblackbelt = {});
    var requirejs, require, define;
    !(function (global, setTimeout) {
      function commentReplace(t, e) {
        return e || "";
      }
      function isFunction(t) {
        return "[object Function]" === ostring.call(t);
      }
      function isArray(t) {
        return "[object Array]" === ostring.call(t);
      }
      function each(t, e) {
        var r;
        if (t) for (r = 0; r < t.length && (!t[r] || !e(t[r], r, t)); r += 1);
      }
      function eachReverse(t, e) {
        var r;
        if (t)
          for (r = t.length - 1; -1 < r && (!t[r] || !e(t[r], r, t)); r -= 1);
      }
      function hasProp(t, e) {
        return hasOwn.call(t, e);
      }
      function getOwn(t, e) {
        return hasProp(t, e) && t[e];
      }
      function eachProp(t, e) {
        var r;
        for (r in t) if (hasProp(t, r) && e(t[r], r)) break;
      }
      function mixin(t, e, r, n) {
        return (
          e &&
            eachProp(e, function (e, i) {
              (!r && hasProp(t, i)) ||
                (!n ||
                "object" != typeof e ||
                !e ||
                isArray(e) ||
                isFunction(e) ||
                e instanceof RegExp
                  ? (t[i] = e)
                  : (t[i] || (t[i] = {}), mixin(t[i], e, r, n)));
            }),
          t
        );
      }
      function bind(t, e) {
        return function () {
          return e.apply(t, arguments);
        };
      }
      function scripts() {
        return document.getElementsByTagName("script");
      }
      function defaultOnError(t) {
        throw t;
      }
      function getGlobal(t) {
        if (!t) return t;
        var e = global;
        return (
          each(t.split("."), function (t) {
            e = e[t];
          }),
          e
        );
      }
      function makeError(t, e, r, n) {
        var i = new Error(e + "\nhttps://requirejs.org/docs/errors.html#" + t);
        return (
          (i.requireType = t),
          (i.requireModules = n),
          r && (i.originalError = r),
          i
        );
      }
      function newContext(t) {
        function e(t, e, r) {
          var n,
            i,
            o,
            a,
            c,
            s,
            u,
            l,
            d,
            f,
            h = e && e.split("/"),
            p = w.map,
            m = p && p["*"];
          if (
            (t &&
              ((s = (t = t.split("/")).length - 1),
              w.nodeIdCompat &&
                jsSuffixRegExp.test(t[s]) &&
                (t[s] = t[s].replace(jsSuffixRegExp, "")),
              "." === t[0].charAt(0) &&
                h &&
                (t = h.slice(0, h.length - 1).concat(t)),
              (function (t) {
                var e, r;
                for (e = 0; e < t.length; e++)
                  if ("." === (r = t[e])) t.splice(e, 1), (e -= 1);
                  else if (".." === r) {
                    if (
                      0 === e ||
                      (1 === e && ".." === t[2]) ||
                      ".." === t[e - 1]
                    )
                      continue;
                    0 < e && (t.splice(e - 1, 2), (e -= 2));
                  }
              })(t),
              (t = t.join("/"))),
            r && p && (h || m))
          ) {
            t: for (o = (i = t.split("/")).length; 0 < o; o -= 1) {
              if (((c = i.slice(0, o).join("/")), h))
                for (a = h.length; 0 < a; a -= 1)
                  if (
                    (n = getOwn(p, h.slice(0, a).join("/"))) &&
                    (n = getOwn(n, c))
                  ) {
                    (u = n), (l = o);
                    break t;
                  }
              !d && m && getOwn(m, c) && ((d = getOwn(m, c)), (f = o));
            }
            !u && d && ((u = d), (l = f)),
              u && (i.splice(0, l, u), (t = i.join("/")));
          }
          return getOwn(w.pkgs, t) || t;
        }
        function r(t) {
          isBrowser &&
            each(scripts(), function (e) {
              if (
                e.getAttribute("data-requiremodule") === t &&
                e.getAttribute("data-requirecontext") === b.contextName
              )
                return e.parentNode.removeChild(e), !0;
            });
        }
        function n(t) {
          var e = getOwn(w.paths, t);
          if (e && isArray(e) && 1 < e.length)
            return (
              e.shift(),
              b.require.undef(t),
              b.makeRequire(null, { skipMap: !0 })([t]),
              !0
            );
        }
        function i(t) {
          var e,
            r = t ? t.indexOf("!") : -1;
          return (
            -1 < r &&
              ((e = t.substring(0, r)), (t = t.substring(r + 1, t.length))),
            [e, t]
          );
        }
        function o(t, r, n, o) {
          var a,
            c,
            s,
            u,
            l = null,
            d = r ? r.name : null,
            f = t,
            h = !0,
            p = "";
          return (
            t || ((h = !1), (t = "_@r" + (D += 1))),
            (l = (u = i(t))[0]),
            (t = u[1]),
            l && ((l = e(l, d, o)), (c = getOwn(k, l))),
            t &&
              (l
                ? (p = n
                    ? t
                    : c && c.normalize
                    ? c.normalize(t, function (t) {
                        return e(t, d, o);
                      })
                    : -1 === t.indexOf("!")
                    ? e(t, d, o)
                    : t)
                : ((l = (u = i((p = e(t, d, o))))[0]),
                  (p = u[1]),
                  (n = !0),
                  (a = b.nameToUrl(p)))),
            {
              prefix: l,
              name: p,
              parentMap: r,
              unnormalized: !!(s =
                !l || c || n ? "" : "_unnormalized" + (F += 1)),
              url: a,
              originalName: f,
              isDefine: h,
              id: (l ? l + "!" + p : p) + s,
            }
          );
        }
        function a(t) {
          var e = t.id,
            r = getOwn(C, e);
          return r || (r = C[e] = new b.Module(t)), r;
        }
        function c(t, e, r) {
          var n = t.id,
            i = getOwn(C, n);
          !hasProp(k, n) || (i && !i.defineEmitComplete)
            ? (i = a(t)).error && "error" === e
              ? r(i.error)
              : i.on(e, r)
            : "defined" === e && r(k[n]);
        }
        function s(t, e) {
          var r = t.requireModules,
            n = !1;
          e
            ? e(t)
            : (each(r, function (e) {
                var r = getOwn(C, e);
                r &&
                  ((r.error = t),
                  r.events.error && ((n = !0), r.emit("error", t)));
              }),
              n || req.onError(t));
        }
        function u() {
          globalDefQueue.length &&
            (each(globalDefQueue, function (t) {
              var e = t[0];
              "string" == typeof e && (b.defQueueMap[e] = !0), A.push(t);
            }),
            (globalDefQueue = []));
        }
        function l(t) {
          delete C[t], delete x[t];
        }
        function d() {
          var t,
            e,
            i = 1e3 * w.waitSeconds,
            o = i && b.startTime + i < new Date().getTime(),
            a = [],
            c = [],
            u = !1,
            l = !0;
          if (!g) {
            if (
              ((g = !0),
              eachProp(x, function (t) {
                var i = t.map,
                  s = i.id;
                if (t.enabled && (i.isDefine || c.push(t), !t.error))
                  if (!t.inited && o) n(s) ? (u = e = !0) : (a.push(s), r(s));
                  else if (
                    !t.inited &&
                    t.fetched &&
                    i.isDefine &&
                    ((u = !0), !i.prefix)
                  )
                    return (l = !1);
              }),
              o && a.length)
            )
              return (
                ((t = makeError(
                  "timeout",
                  "Load timeout for modules: " + a,
                  null,
                  a
                )).contextName = b.contextName),
                s(t)
              );
            l &&
              each(c, function (t) {
                !(function t(e, r, n) {
                  var i = e.map.id;
                  e.error
                    ? e.emit("error", e.error)
                    : ((r[i] = !0),
                      each(e.depMaps, function (i, o) {
                        var a = i.id,
                          c = getOwn(C, a);
                        !c ||
                          e.depMatched[o] ||
                          n[a] ||
                          (getOwn(r, a)
                            ? (e.defineDep(o, k[a]), e.check())
                            : t(c, r, n));
                      }),
                      (n[i] = !0));
                })(t, {}, {});
              }),
              (o && !e) ||
                !u ||
                (!isBrowser && !isWebWorker) ||
                _ ||
                (_ = setTimeout(function () {
                  (_ = 0), d();
                }, 50)),
              (g = !1);
          }
        }
        function f(t) {
          hasProp(k, t[0]) || a(o(t[0], null, !0)).init(t[1], t[2]);
        }
        function h(t, e, r, n) {
          t.detachEvent && !isOpera
            ? n && t.detachEvent(n, e)
            : t.removeEventListener(r, e, !1);
        }
        function p(t) {
          var e = t.currentTarget || t.srcElement;
          return (
            h(e, b.onScriptLoad, "load", "onreadystatechange"),
            h(e, b.onScriptError, "error"),
            { node: e, id: e && e.getAttribute("data-requiremodule") }
          );
        }
        function m() {
          var t;
          for (u(); A.length; ) {
            if (null === (t = A.shift())[0])
              return s(
                makeError(
                  "mismatch",
                  "Mismatched anonymous define() module: " + t[t.length - 1]
                )
              );
            f(t);
          }
          b.defQueueMap = {};
        }
        var g,
          y,
          b,
          v,
          _,
          w = {
            waitSeconds: 7,
            baseUrl: "./",
            paths: {},
            bundles: {},
            pkgs: {},
            shim: {},
            config: {},
          },
          C = {},
          x = {},
          P = {},
          A = [],
          k = {},
          S = {},
          T = {},
          D = 1,
          F = 1;
        return (
          (v = {
            require: function (t) {
              return t.require ? t.require : (t.require = b.makeRequire(t.map));
            },
            exports: function (t) {
              if (((t.usingExports = !0), t.map.isDefine))
                return t.exports
                  ? (k[t.map.id] = t.exports)
                  : (t.exports = k[t.map.id] = {});
            },
            module: function (t) {
              return t.module
                ? t.module
                : (t.module = {
                    id: t.map.id,
                    uri: t.map.url,
                    config: function () {
                      return getOwn(w.config, t.map.id) || {};
                    },
                    exports: t.exports || (t.exports = {}),
                  });
            },
          }),
          ((y = function (t) {
            (this.events = getOwn(P, t.id) || {}),
              (this.map = t),
              (this.shim = getOwn(w.shim, t.id)),
              (this.depExports = []),
              (this.depMaps = []),
              (this.depMatched = []),
              (this.pluginMaps = {}),
              (this.depCount = 0);
          }).prototype = {
            init: function (t, e, r, n) {
              (n = n || {}),
                this.inited ||
                  ((this.factory = e),
                  r
                    ? this.on("error", r)
                    : this.events.error &&
                      (r = bind(this, function (t) {
                        this.emit("error", t);
                      })),
                  (this.depMaps = t && t.slice(0)),
                  (this.errback = r),
                  (this.inited = !0),
                  (this.ignore = n.ignore),
                  n.enabled || this.enabled ? this.enable() : this.check());
            },
            defineDep: function (t, e) {
              this.depMatched[t] ||
                ((this.depMatched[t] = !0),
                (this.depCount -= 1),
                (this.depExports[t] = e));
            },
            fetch: function () {
              if (!this.fetched) {
                (this.fetched = !0), (b.startTime = new Date().getTime());
                var t = this.map;
                if (!this.shim)
                  return t.prefix ? this.callPlugin() : this.load();
                b.makeRequire(this.map, { enableBuildCallback: !0 })(
                  this.shim.deps || [],
                  bind(this, function () {
                    return t.prefix ? this.callPlugin() : this.load();
                  })
                );
              }
            },
            load: function () {
              var t = this.map.url;
              S[t] || ((S[t] = !0), b.load(this.map.id, t));
            },
            check: function () {
              if (this.enabled && !this.enabling) {
                var t,
                  e,
                  r = this.map.id,
                  n = this.depExports,
                  i = this.exports,
                  o = this.factory;
                if (this.inited) {
                  if (this.error) this.emit("error", this.error);
                  else if (!this.defining) {
                    if (
                      ((this.defining = !0), this.depCount < 1 && !this.defined)
                    ) {
                      if (isFunction(o)) {
                        if (
                          (this.events.error && this.map.isDefine) ||
                          req.onError !== defaultOnError
                        )
                          try {
                            i = b.execCb(r, o, n, i);
                          } catch (e) {
                            t = e;
                          }
                        else i = b.execCb(r, o, n, i);
                        if (
                          (this.map.isDefine &&
                            void 0 === i &&
                            ((e = this.module)
                              ? (i = e.exports)
                              : this.usingExports && (i = this.exports)),
                          t)
                        )
                          return (
                            (t.requireMap = this.map),
                            (t.requireModules = this.map.isDefine
                              ? [this.map.id]
                              : null),
                            (t.requireType = this.map.isDefine
                              ? "define"
                              : "require"),
                            s((this.error = t))
                          );
                      } else i = o;
                      if (
                        ((this.exports = i),
                        this.map.isDefine &&
                          !this.ignore &&
                          ((k[r] = i), req.onResourceLoad))
                      ) {
                        var a = [];
                        each(this.depMaps, function (t) {
                          a.push(t.normalizedMap || t);
                        }),
                          req.onResourceLoad(b, this.map, a);
                      }
                      l(r), (this.defined = !0);
                    }
                    (this.defining = !1),
                      this.defined &&
                        !this.defineEmitted &&
                        ((this.defineEmitted = !0),
                        this.emit("defined", this.exports),
                        (this.defineEmitComplete = !0));
                  }
                } else hasProp(b.defQueueMap, r) || this.fetch();
              }
            },
            callPlugin: function () {
              var t = this.map,
                r = t.id,
                n = o(t.prefix);
              this.depMaps.push(n),
                c(
                  n,
                  "defined",
                  bind(this, function (n) {
                    var i,
                      u,
                      d,
                      f = getOwn(T, this.map.id),
                      h = this.map.name,
                      p = this.map.parentMap ? this.map.parentMap.name : null,
                      m = b.makeRequire(t.parentMap, {
                        enableBuildCallback: !0,
                      });
                    return this.map.unnormalized
                      ? (n.normalize &&
                          (h =
                            n.normalize(h, function (t) {
                              return e(t, p, !0);
                            }) || ""),
                        c(
                          (u = o(t.prefix + "!" + h, this.map.parentMap, !0)),
                          "defined",
                          bind(this, function (t) {
                            (this.map.normalizedMap = u),
                              this.init(
                                [],
                                function () {
                                  return t;
                                },
                                null,
                                { enabled: !0, ignore: !0 }
                              );
                          })
                        ),
                        void (
                          (d = getOwn(C, u.id)) &&
                          (this.depMaps.push(u),
                          this.events.error &&
                            d.on(
                              "error",
                              bind(this, function (t) {
                                this.emit("error", t);
                              })
                            ),
                          d.enable())
                        ))
                      : f
                      ? ((this.map.url = b.nameToUrl(f)), void this.load())
                      : (((i = bind(this, function (t) {
                          this.init(
                            [],
                            function () {
                              return t;
                            },
                            null,
                            { enabled: !0 }
                          );
                        })).error = bind(this, function (t) {
                          (this.inited = !0),
                            ((this.error = t).requireModules = [r]),
                            eachProp(C, function (t) {
                              0 === t.map.id.indexOf(r + "_unnormalized") &&
                                l(t.map.id);
                            }),
                            s(t);
                        })),
                        (i.fromText = bind(this, function (e, n) {
                          var c = t.name,
                            u = o(c),
                            l = useInteractive;
                          n && (e = n),
                            l && (useInteractive = !1),
                            a(u),
                            hasProp(w.config, r) && (w.config[c] = w.config[r]);
                          try {
                            req.exec(e);
                          } catch (e) {
                            return s(
                              makeError(
                                "fromtexteval",
                                "fromText eval for " + r + " failed: " + e,
                                e,
                                [r]
                              )
                            );
                          }
                          l && (useInteractive = !0),
                            this.depMaps.push(u),
                            b.completeLoad(c),
                            m([c], i);
                        })),
                        void n.load(t.name, m, i, w));
                  })
                ),
                b.enable(n, this),
                (this.pluginMaps[n.id] = n);
            },
            enable: function () {
              ((x[this.map.id] = this).enabled = !0),
                (this.enabling = !0),
                each(
                  this.depMaps,
                  bind(this, function (t, e) {
                    var r, n, i;
                    if ("string" == typeof t) {
                      if (
                        ((t = o(
                          t,
                          this.map.isDefine ? this.map : this.map.parentMap,
                          !1,
                          !this.skipMap
                        )),
                        (this.depMaps[e] = t),
                        (i = getOwn(v, t.id)))
                      )
                        return void (this.depExports[e] = i(this));
                      (this.depCount += 1),
                        c(
                          t,
                          "defined",
                          bind(this, function (t) {
                            this.undefed ||
                              (this.defineDep(e, t), this.check());
                          })
                        ),
                        this.errback
                          ? c(t, "error", bind(this, this.errback))
                          : this.events.error &&
                            c(
                              t,
                              "error",
                              bind(this, function (t) {
                                this.emit("error", t);
                              })
                            );
                    }
                    (r = t.id),
                      (n = C[r]),
                      hasProp(v, r) || !n || n.enabled || b.enable(t, this);
                  })
                ),
                eachProp(
                  this.pluginMaps,
                  bind(this, function (t) {
                    var e = getOwn(C, t.id);
                    e && !e.enabled && b.enable(t, this);
                  })
                ),
                (this.enabling = !1),
                this.check();
            },
            on: function (t, e) {
              var r = this.events[t];
              r || (r = this.events[t] = []), r.push(e);
            },
            emit: function (t, e) {
              each(this.events[t], function (t) {
                t(e);
              }),
                "error" === t && delete this.events[t];
            },
          }),
          ((b = {
            config: w,
            contextName: t,
            registry: C,
            defined: k,
            urlFetched: S,
            defQueue: A,
            defQueueMap: {},
            Module: y,
            makeModuleMap: o,
            nextTick: req.nextTick,
            onError: s,
            configure: function (t) {
              if (
                (t.baseUrl &&
                  "/" !== t.baseUrl.charAt(t.baseUrl.length - 1) &&
                  (t.baseUrl += "/"),
                "string" == typeof t.urlArgs)
              ) {
                var e = t.urlArgs;
                t.urlArgs = function (t, r) {
                  return (-1 === r.indexOf("?") ? "?" : "&") + e;
                };
              }
              var r = w.shim,
                n = { paths: !0, bundles: !0, config: !0, map: !0 };
              eachProp(t, function (t, e) {
                n[e]
                  ? (w[e] || (w[e] = {}), mixin(w[e], t, !0, !0))
                  : (w[e] = t);
              }),
                t.bundles &&
                  eachProp(t.bundles, function (t, e) {
                    each(t, function (t) {
                      t !== e && (T[t] = e);
                    });
                  }),
                t.shim &&
                  (eachProp(t.shim, function (t, e) {
                    isArray(t) && (t = { deps: t }),
                      (!t.exports && !t.init) ||
                        t.exportsFn ||
                        (t.exportsFn = b.makeShimExports(t)),
                      (r[e] = t);
                  }),
                  (w.shim = r)),
                t.packages &&
                  each(t.packages, function (t) {
                    var e;
                    (e = (t = "string" == typeof t ? { name: t } : t).name),
                      t.location && (w.paths[e] = t.location),
                      (w.pkgs[e] =
                        t.name +
                        "/" +
                        (t.main || "main")
                          .replace(currDirRegExp, "")
                          .replace(jsSuffixRegExp, ""));
                  }),
                eachProp(C, function (t, e) {
                  t.inited || t.map.unnormalized || (t.map = o(e, null, !0));
                }),
                (t.deps || t.callback) && b.require(t.deps || [], t.callback);
            },
            makeShimExports: function (t) {
              return function () {
                var e;
                return (
                  t.init && (e = t.init.apply(global, arguments)),
                  e || (t.exports && getGlobal(t.exports))
                );
              };
            },
            makeRequire: function (n, i) {
              function c(e, r, u) {
                var l, f;
                return (
                  i.enableBuildCallback &&
                    r &&
                    isFunction(r) &&
                    (r.__requireJsBuild = !0),
                  "string" == typeof e
                    ? isFunction(r)
                      ? s(makeError("requireargs", "Invalid require call"), u)
                      : n && hasProp(v, e)
                      ? v[e](C[n.id])
                      : req.get
                      ? req.get(b, e, n, c)
                      : ((l = o(e, n, !1, !0).id),
                        hasProp(k, l)
                          ? k[l]
                          : s(
                              makeError(
                                "notloaded",
                                'Module name "' +
                                  l +
                                  '" has not been loaded yet for context: ' +
                                  t +
                                  (n ? "" : ". Use require([])")
                              )
                            ))
                    : (m(),
                      b.nextTick(function () {
                        m(),
                          ((f = a(o(null, n))).skipMap = i.skipMap),
                          f.init(e, r, u, { enabled: !0 }),
                          d();
                      }),
                      c)
                );
              }
              return (
                (i = i || {}),
                mixin(c, {
                  isBrowser: isBrowser,
                  toUrl: function (t) {
                    var r,
                      i = t.lastIndexOf("."),
                      o = t.split("/")[0];
                    return (
                      -1 !== i &&
                        (!("." === o || ".." === o) || 1 < i) &&
                        ((r = t.substring(i, t.length)),
                        (t = t.substring(0, i))),
                      b.nameToUrl(e(t, n && n.id, !0), r, !0)
                    );
                  },
                  defined: function (t) {
                    return hasProp(k, o(t, n, !1, !0).id);
                  },
                  specified: function (t) {
                    return (
                      (t = o(t, n, !1, !0).id), hasProp(k, t) || hasProp(C, t)
                    );
                  },
                }),
                n ||
                  (c.undef = function (t) {
                    u();
                    var e = o(t, n, !0),
                      i = getOwn(C, t);
                    (i.undefed = !0),
                      r(t),
                      delete k[t],
                      delete S[e.url],
                      delete P[t],
                      eachReverse(A, function (e, r) {
                        e[0] === t && A.splice(r, 1);
                      }),
                      delete b.defQueueMap[t],
                      i && (i.events.defined && (P[t] = i.events), l(t));
                  }),
                c
              );
            },
            enable: function (t) {
              getOwn(C, t.id) && a(t).enable();
            },
            completeLoad: function (t) {
              var e,
                r,
                i,
                o = getOwn(w.shim, t) || {},
                a = o.exports;
              for (u(); A.length; ) {
                if (null === (r = A.shift())[0]) {
                  if (((r[0] = t), e)) break;
                  e = !0;
                } else r[0] === t && (e = !0);
                f(r);
              }
              if (
                ((b.defQueueMap = {}),
                (i = getOwn(C, t)),
                !e && !hasProp(k, t) && i && !i.inited)
              ) {
                if (!(!w.enforceDefine || (a && getGlobal(a))))
                  return n(t)
                    ? void 0
                    : s(
                        makeError("nodefine", "No define call for " + t, null, [
                          t,
                        ])
                      );
                f([t, o.deps || [], o.exportsFn]);
              }
              d();
            },
            nameToUrl: function (t, e, r) {
              var n,
                i,
                o,
                a,
                c,
                s,
                u = getOwn(w.pkgs, t);
              if ((u && (t = u), (s = getOwn(T, t))))
                return b.nameToUrl(s, e, r);
              if (req.jsExtRegExp.test(t)) a = t + (e || "");
              else {
                for (n = w.paths, o = (i = t.split("/")).length; 0 < o; o -= 1)
                  if ((c = getOwn(n, i.slice(0, o).join("/")))) {
                    isArray(c) && (c = c[0]), i.splice(0, o, c);
                    break;
                  }
                (a = i.join("/")),
                  (a =
                    ("/" ===
                      (a +=
                        e ||
                        (/^data\:|^blob\:|\?/.test(a) || r
                          ? ""
                          : ".js")).charAt(0) || a.match(/^[\w\+\.\-]+:/)
                      ? ""
                      : w.baseUrl) + a);
              }
              return w.urlArgs && !/^blob\:/.test(a) ? a + w.urlArgs(t, a) : a;
            },
            load: function (t, e) {
              req.load(b, t, e);
            },
            execCb: function (t, e, r, n) {
              return e.apply(n, r);
            },
            onScriptLoad: function (t) {
              if (
                "load" === t.type ||
                readyRegExp.test((t.currentTarget || t.srcElement).readyState)
              ) {
                interactiveScript = null;
                var e = p(t);
                b.completeLoad(e.id);
              }
            },
            onScriptError: function (t) {
              var e = p(t);
              if (!n(e.id)) {
                var r = [];
                return (
                  eachProp(C, function (t, n) {
                    0 !== n.indexOf("_@r") &&
                      each(t.depMaps, function (t) {
                        if (t.id === e.id) return r.push(n), !0;
                      });
                  }),
                  s(
                    makeError(
                      "scripterror",
                      'Script error for "' +
                        e.id +
                        (r.length ? '", needed by: ' + r.join(", ") : '"'),
                      t,
                      [e.id]
                    )
                  )
                );
              }
            },
          }).require = b.makeRequire()),
          b
        );
      }
      function getInteractiveScript() {
        return (
          (interactiveScript &&
            "interactive" === interactiveScript.readyState) ||
            eachReverse(scripts(), function (t) {
              if ("interactive" === t.readyState)
                return (interactiveScript = t);
            }),
          interactiveScript
        );
      }
      var req,
        s,
        head,
        baseElement,
        dataMain,
        src,
        interactiveScript,
        currentlyAddingScript,
        mainScript,
        subPath,
        version = "2.3.6",
        commentRegExp = /\/\*[\s\S]*?\*\/|([^:"'=]|^)\/\/.*$/gm,
        cjsRequireRegExp = /[^.]\s*require\s*\(\s*["']([^'"\s]+)["']\s*\)/g,
        jsSuffixRegExp = /\.js$/,
        currDirRegExp = /^\.\//,
        op = Object.prototype,
        ostring = op.toString,
        hasOwn = op.hasOwnProperty,
        isBrowser = !(
          "undefined" == typeof window ||
          "undefined" == typeof navigator ||
          !window.document
        ),
        isWebWorker = !isBrowser && "undefined" != typeof importScripts,
        readyRegExp =
          isBrowser && "PLAYSTATION 3" === navigator.platform
            ? /^complete$/
            : /^(complete|loaded)$/,
        defContextName = "_",
        isOpera =
          "undefined" != typeof opera && "[object Opera]" === opera.toString(),
        contexts = {},
        cfg = {},
        globalDefQueue = [],
        useInteractive = !1;
      if (void 0 === define) {
        if (void 0 !== requirejs) {
          if (isFunction(requirejs)) return;
          (cfg = requirejs), (requirejs = void 0);
        }
        void 0 === require ||
          isFunction(require) ||
          ((cfg = require), (require = void 0)),
          (req = requirejs =
            function (t, e, r, n) {
              var i,
                o,
                a = defContextName;
              return (
                isArray(t) ||
                  "string" == typeof t ||
                  ((o = t),
                  isArray(e) ? ((t = e), (e = r), (r = n)) : (t = [])),
                o && o.context && (a = o.context),
                (i = getOwn(contexts, a)) ||
                  (i = contexts[a] = req.s.newContext(a)),
                o && i.configure(o),
                i.require(t, e, r)
              );
            }),
          (req.config = function (t) {
            return req(t);
          }),
          (req.nextTick =
            void 0 !== setTimeout
              ? function (t) {
                  setTimeout(t, 4);
                }
              : function (t) {
                  t();
                }),
          require || (require = req),
          (req.version = version),
          (req.jsExtRegExp = /^\/|:|\?|\.js$/),
          (req.isBrowser = isBrowser),
          (s = req.s = { contexts: contexts, newContext: newContext }),
          req({}),
          each(["toUrl", "undef", "defined", "specified"], function (t) {
            req[t] = function () {
              var e = contexts[defContextName];
              return e.require[t].apply(e, arguments);
            };
          }),
          isBrowser &&
            ((head = s.head = document.getElementsByTagName("head")[0]),
            (baseElement = document.getElementsByTagName("base")[0]) &&
              (head = s.head = baseElement.parentNode)),
          (req.onError = defaultOnError),
          (req.createNode = function (t, e, r) {
            var n = t.xhtml
              ? document.createElementNS(
                  "http://www.w3.org/1999/xhtml",
                  "html:script"
                )
              : document.createElement("script");
            return (
              (n.type = t.scriptType || "text/javascript"),
              (n.charset = "utf-8"),
              (n.async = !0),
              n
            );
          }),
          (req.load = function (t, e, r) {
            var n,
              i = (t && t.config) || {};
            if (isBrowser)
              return (
                (n = req.createNode(i, e, r)).setAttribute(
                  "data-requirecontext",
                  t.contextName
                ),
                n.setAttribute("data-requiremodule", e),
                !n.attachEvent ||
                (n.attachEvent.toString &&
                  n.attachEvent.toString().indexOf("[native code") < 0) ||
                isOpera
                  ? (n.addEventListener("load", t.onScriptLoad, !1),
                    n.addEventListener("error", t.onScriptError, !1))
                  : ((useInteractive = !0),
                    n.attachEvent("onreadystatechange", t.onScriptLoad)),
                (n.src = r),
                i.onNodeCreated && i.onNodeCreated(n, i, e, r),
                (currentlyAddingScript = n),
                baseElement
                  ? head.insertBefore(n, baseElement)
                  : head.appendChild(n),
                (currentlyAddingScript = null),
                n
              );
            if (isWebWorker)
              try {
                setTimeout(function () {}, 0),
                  importScripts(r),
                  t.completeLoad(e);
              } catch (n) {
                t.onError(
                  makeError(
                    "importscripts",
                    "importScripts failed for " + e + " at " + r,
                    n,
                    [e]
                  )
                );
              }
          }),
          isBrowser &&
            !cfg.skipDataMain &&
            eachReverse(scripts(), function (t) {
              if (
                (head || (head = t.parentNode),
                (dataMain = t.getAttribute("data-main")))
              )
                return (
                  (mainScript = dataMain),
                  cfg.baseUrl ||
                    -1 !== mainScript.indexOf("!") ||
                    ((mainScript = (src = mainScript.split("/")).pop()),
                    (subPath = src.length ? src.join("/") + "/" : "./"),
                    (cfg.baseUrl = subPath)),
                  (mainScript = mainScript.replace(jsSuffixRegExp, "")),
                  req.jsExtRegExp.test(mainScript) && (mainScript = dataMain),
                  (cfg.deps = cfg.deps
                    ? cfg.deps.concat(mainScript)
                    : [mainScript]),
                  !0
                );
            }),
          (define = function (t, e, r) {
            var n, i;
            "string" != typeof t && ((r = e), (e = t), (t = null)),
              isArray(e) || ((r = e), (e = null)),
              !e &&
                isFunction(r) &&
                ((e = []),
                r.length &&
                  (r
                    .toString()
                    .replace(commentRegExp, commentReplace)
                    .replace(cjsRequireRegExp, function (t, r) {
                      e.push(r);
                    }),
                  (e = (
                    1 === r.length
                      ? ["require"]
                      : ["require", "exports", "module"]
                  ).concat(e)))),
              useInteractive &&
                (n = currentlyAddingScript || getInteractiveScript()) &&
                (t || (t = n.getAttribute("data-requiremodule")),
                (i = contexts[n.getAttribute("data-requirecontext")])),
              i
                ? (i.defQueue.push([t, e, r]), (i.defQueueMap[t] = !0))
                : globalDefQueue.push([t, e, r]);
          }),
          (define.amd = { jQuery: !0 }),
          (req.exec = function (text) {
            return eval(text);
          }),
          req(cfg);
      }
    })(this, "undefined" == typeof setTimeout ? void 0 : setTimeout),
      (codeblackbelt.requirejs = requirejs),
      (codeblackbelt.require = require),
      (codeblackbelt.define = define);
  }
})(),
  codeblackbelt.define("lib/require-2.3.6", function () {}),
  Object.create ||
    (Object.create = function (t, e) {
      function r() {}
      if (void 0 !== e)
        throw "The multiple-argument version of Object.create is not provided by this browser and cannot be shimmed.";
      return (r.prototype = t), new r();
    }),
  codeblackbelt.define("lib/ie8-object-create", function () {}),
  codeblackbelt.define("core/util/GlobalProperties", [], function () {
    function t() {}
    return (
      (t.setProperty = function (e, r) {
        t.getGlobals()[e] = r;
      }),
      (t.hasProperty = function (e) {
        return void 0 !== t.getGlobals()[e];
      }),
      (t.getProperty = function (e) {
        return t.getGlobals()[e];
      }),
      (t.getGlobals = function () {
        return (
          window.codeblackbelt || (window.codeblackbelt = {}),
          window.codeblackbelt
        );
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/AppLoadedChecker",
    ["core/util/GlobalProperties"],
    function (t) {
      function e() {}
      return (
        (e.hasLoadedBefore = function (t) {
          return !!e._hasLoadedBefore(t) || (e._markAsLoaded(t), !1);
        }),
        (e._hasLoadedBefore = function (r) {
          var n = e._flag(r),
            i = t.hasProperty(n),
            o = t.getProperty(n);
          return i && o;
        }),
        (e._markAsLoaded = function (r) {
          var n = e._flag(r);
          t.setProperty(n, !0);
        }),
        (e._flag = function (t) {
          return t + "Loaded";
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  (function (t, e) {
    "object" == typeof module && "object" == typeof module.exports
      ? (module.exports = t.document
          ? e(t, !0)
          : function (t) {
              if (!t.document)
                throw new Error("cbbJQuery requires a window with a document");
              return e(t);
            })
      : e(t);
  })("undefined" != typeof window ? window : this, function (t, e) {
    function r(t) {
      var e = !!t && "length" in t && t.length,
        r = ft.type(t);
      return (
        "function" !== r &&
        !ft.isWindow(t) &&
        ("array" === r ||
          0 === e ||
          ("number" == typeof e && e > 0 && e - 1 in t))
      );
    }
    function n(t, e, r) {
      if (ft.isFunction(e))
        return ft.grep(t, function (t, n) {
          return !!e.call(t, n, t) !== r;
        });
      if (e.nodeType)
        return ft.grep(t, function (t) {
          return (t === e) !== r;
        });
      if ("string" == typeof e) {
        if (Ct.test(e)) return ft.filter(e, t, r);
        e = ft.filter(e, t);
      }
      return ft.grep(t, function (t) {
        return ft.inArray(t, e) > -1 !== r;
      });
    }
    function i(t, e) {
      do {
        t = t[e];
      } while (t && 1 !== t.nodeType);
      return t;
    }
    function o(t) {
      var e = {};
      return (
        ft.each(t.match(St) || [], function (t, r) {
          e[r] = !0;
        }),
        e
      );
    }
    function a() {
      nt.addEventListener
        ? (nt.removeEventListener("DOMContentLoaded", c),
          t.removeEventListener("load", c))
        : (nt.detachEvent("onreadystatechange", c), t.detachEvent("onload", c));
    }
    function c() {
      (nt.addEventListener ||
        "load" === t.event.type ||
        "complete" === nt.readyState) &&
        (a(), ft.ready());
    }
    function s(t, e, r) {
      if (void 0 === r && 1 === t.nodeType) {
        var n = "data-" + e.replace(jt, "-$1").toLowerCase();
        if ("string" == typeof (r = t.getAttribute(n))) {
          try {
            r =
              "true" === r ||
              ("false" !== r &&
                ("null" === r
                  ? null
                  : +r + "" === r
                  ? +r
                  : Et.test(r)
                  ? ft.parseJSON(r)
                  : r));
          } catch (t) {}
          ft.data(t, e, r);
        } else r = void 0;
      }
      return r;
    }
    function u(t) {
      var e;
      for (e in t)
        if (("data" !== e || !ft.isEmptyObject(t[e])) && "toJSON" !== e)
          return !1;
      return !0;
    }
    function l(t, e, r, n) {
      if (Ft(t)) {
        var i,
          o,
          a = ft.expando,
          c = t.nodeType,
          s = c ? ft.cache : t,
          u = c ? t[a] : t[a] && a;
        if (
          (u && s[u] && (n || s[u].data)) ||
          void 0 !== r ||
          "string" != typeof e
        )
          return (
            u || (u = c ? (t[a] = rt.pop() || ft.guid++) : a),
            s[u] || (s[u] = c ? {} : { toJSON: ft.noop }),
            ("object" != typeof e && "function" != typeof e) ||
              (n
                ? (s[u] = ft.extend(s[u], e))
                : (s[u].data = ft.extend(s[u].data, e))),
            (o = s[u]),
            n || (o.data || (o.data = {}), (o = o.data)),
            void 0 !== r && (o[ft.camelCase(e)] = r),
            "string" == typeof e
              ? null == (i = o[e]) && (i = o[ft.camelCase(e)])
              : (i = o),
            i
          );
      }
    }
    function d(t, e, r) {
      if (Ft(t)) {
        var n,
          i,
          o = t.nodeType,
          a = o ? ft.cache : t,
          c = o ? t[ft.expando] : ft.expando;
        if (a[c]) {
          if (e && (n = r ? a[c] : a[c].data)) {
            ft.isArray(e)
              ? (e = e.concat(ft.map(e, ft.camelCase)))
              : e in n
              ? (e = [e])
              : ((e = ft.camelCase(e)), (e = e in n ? [e] : e.split(" "))),
              (i = e.length);
            for (; i--; ) delete n[e[i]];
            if (r ? !u(n) : !ft.isEmptyObject(n)) return;
          }
          (r || (delete a[c].data, u(a[c]))) &&
            (o
              ? ft.cleanData([t], !0)
              : dt.deleteExpando || a != a.window
              ? delete a[c]
              : (a[c] = void 0));
        }
      }
    }
    function f(t, e, r, n) {
      var i,
        o = 1,
        a = 20,
        c = n
          ? function () {
              return n.cur();
            }
          : function () {
              return ft.css(t, e, "");
            },
        s = c(),
        u = (r && r[3]) || (ft.cssNumber[e] ? "" : "px"),
        l = (ft.cssNumber[e] || ("px" !== u && +s)) && Rt.exec(ft.css(t, e));
      if (l && l[3] !== u) {
        (u = u || l[3]), (r = r || []), (l = +s || 1);
        do {
          (o = o || ".5"), (l /= o), ft.style(t, e, l + u);
        } while (o !== (o = c() / s) && 1 !== o && --a);
      }
      return (
        r &&
          ((l = +l || +s || 0),
          (i = r[1] ? l + (r[1] + 1) * r[2] : +r[2]),
          n && ((n.unit = u), (n.start = l), (n.end = i))),
        i
      );
    }
    function h(t) {
      var e = $t.split("|"),
        r = t.createDocumentFragment();
      if (r.createElement) for (; e.length; ) r.createElement(e.pop());
      return r;
    }
    function p(t, e) {
      var r,
        n,
        i = 0,
        o =
          void 0 !== t.getElementsByTagName
            ? t.getElementsByTagName(e || "*")
            : void 0 !== t.querySelectorAll
            ? t.querySelectorAll(e || "*")
            : void 0;
      if (!o)
        for (o = [], r = t.childNodes || t; null != (n = r[i]); i++)
          !e || ft.nodeName(n, e) ? o.push(n) : ft.merge(o, p(n, e));
      return void 0 === e || (e && ft.nodeName(t, e)) ? ft.merge([t], o) : o;
    }
    function m(t, e) {
      for (var r, n = 0; null != (r = t[n]); n++)
        ft._data(r, "globalEval", !e || ft._data(e[n], "globalEval"));
    }
    function g(t) {
      Ot.test(t.type) && (t.defaultChecked = t.checked);
    }
    function y(t, e, r, n, i) {
      for (
        var o, a, c, s, u, l, d, f = t.length, y = h(e), b = [], v = 0;
        v < f;
        v++
      )
        if ((a = t[v]) || 0 === a)
          if ("object" === ft.type(a)) ft.merge(b, a.nodeType ? [a] : a);
          else if (Wt.test(a)) {
            for (
              s = s || y.appendChild(e.createElement("div")),
                u = (Bt.exec(a) || ["", ""])[1].toLowerCase(),
                d = Vt[u] || Vt._default,
                s.innerHTML = d[1] + ft.htmlPrefilter(a) + d[2],
                o = d[0];
              o--;

            )
              s = s.lastChild;
            if (
              (!dt.leadingWhitespace &&
                Lt.test(a) &&
                b.push(e.createTextNode(Lt.exec(a)[0])),
              !dt.tbody)
            )
              for (
                a =
                  "table" !== u || Ht.test(a)
                    ? "<table>" !== d[1] || Ht.test(a)
                      ? 0
                      : s
                    : s.firstChild,
                  o = a && a.childNodes.length;
                o--;

              )
                ft.nodeName((l = a.childNodes[o]), "tbody") &&
                  !l.childNodes.length &&
                  a.removeChild(l);
            for (ft.merge(b, s.childNodes), s.textContent = ""; s.firstChild; )
              s.removeChild(s.firstChild);
            s = y.lastChild;
          } else b.push(e.createTextNode(a));
      for (
        s && y.removeChild(s),
          dt.appendChecked || ft.grep(p(b, "input"), g),
          v = 0;
        (a = b[v++]);

      )
        if (n && ft.inArray(a, n) > -1) i && i.push(a);
        else if (
          ((c = ft.contains(a.ownerDocument, a)),
          (s = p(y.appendChild(a), "script")),
          c && m(s),
          r)
        )
          for (o = 0; (a = s[o++]); ) Ut.test(a.type || "") && r.push(a);
      return (s = null), y;
    }
    function b() {
      return !0;
    }
    function v() {
      return !1;
    }
    function _() {
      try {
        return nt.activeElement;
      } catch (t) {}
    }
    function w(t, e, r, n, i, o) {
      var a, c;
      if ("object" == typeof e) {
        "string" != typeof r && ((n = n || r), (r = void 0));
        for (c in e) w(t, c, r, n, e[c], o);
        return t;
      }
      if (
        (null == n && null == i
          ? ((i = r), (n = r = void 0))
          : null == i &&
            ("string" == typeof r
              ? ((i = n), (n = void 0))
              : ((i = n), (n = r), (r = void 0))),
        !1 === i)
      )
        i = v;
      else if (!i) return t;
      return (
        1 === o &&
          ((a = i),
          (i = function (t) {
            return ft().off(t), a.apply(this, arguments);
          }),
          (i.guid = a.guid || (a.guid = ft.guid++))),
        t.each(function () {
          ft.event.add(this, e, i, n, r);
        })
      );
    }
    function C(t, e) {
      return ft.nodeName(t, "table") &&
        ft.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr")
        ? t.getElementsByTagName("tbody")[0] ||
            t.appendChild(t.ownerDocument.createElement("tbody"))
        : t;
    }
    function x(t) {
      return (t.type = (null !== ft.find.attr(t, "type")) + "/" + t.type), t;
    }
    function P(t) {
      var e = re.exec(t.type);
      return e ? (t.type = e[1]) : t.removeAttribute("type"), t;
    }
    function A(t, e) {
      if (1 === e.nodeType && ft.hasData(t)) {
        var r,
          n,
          i,
          o = ft._data(t),
          a = ft._data(e, o),
          c = o.events;
        if (c) {
          delete a.handle, (a.events = {});
          for (r in c)
            for (n = 0, i = c[r].length; n < i; n++)
              ft.event.add(e, r, c[r][n]);
        }
        a.data && (a.data = ft.extend({}, a.data));
      }
    }
    function k(t, e) {
      var r, n, i;
      if (1 === e.nodeType) {
        if (
          ((r = e.nodeName.toLowerCase()), !dt.noCloneEvent && e[ft.expando])
        ) {
          i = ft._data(e);
          for (n in i.events) ft.removeEvent(e, n, i.handle);
          e.removeAttribute(ft.expando);
        }
        "script" === r && e.text !== t.text
          ? ((x(e).text = t.text), P(e))
          : "object" === r
          ? (e.parentNode && (e.outerHTML = t.outerHTML),
            dt.html5Clone &&
              t.innerHTML &&
              !ft.trim(e.innerHTML) &&
              (e.innerHTML = t.innerHTML))
          : "input" === r && Ot.test(t.type)
          ? ((e.defaultChecked = e.checked = t.checked),
            e.value !== t.value && (e.value = t.value))
          : "option" === r
          ? (e.defaultSelected = e.selected = t.defaultSelected)
          : ("input" !== r && "textarea" !== r) ||
            (e.defaultValue = t.defaultValue);
      }
    }
    function S(t, e, r, n) {
      e = ot.apply([], e);
      var i,
        o,
        a,
        c,
        s,
        u,
        l = 0,
        d = t.length,
        f = d - 1,
        h = e[0],
        m = ft.isFunction(h);
      if (m || (d > 1 && "string" == typeof h && !dt.checkClone && ee.test(h)))
        return t.each(function (i) {
          var o = t.eq(i);
          m && (e[0] = h.call(this, i, o.html())), S(o, e, r, n);
        });
      if (
        d &&
        ((u = y(e, t[0].ownerDocument, !1, t, n)),
        (i = u.firstChild),
        1 === u.childNodes.length && (u = i),
        i || n)
      ) {
        for (c = ft.map(p(u, "script"), x), a = c.length; l < d; l++)
          (o = u),
            l !== f &&
              ((o = ft.clone(o, !0, !0)), a && ft.merge(c, p(o, "script"))),
            r.call(t[l], o, l);
        if (a)
          for (
            s = c[c.length - 1].ownerDocument, ft.map(c, P), l = 0;
            l < a;
            l++
          )
            (o = c[l]),
              Ut.test(o.type || "") &&
                !ft._data(o, "globalEval") &&
                ft.contains(s, o) &&
                (o.src
                  ? ft._evalUrl && ft._evalUrl(o.src)
                  : ft.globalEval(
                      (o.text || o.textContent || o.innerHTML || "").replace(
                        ne,
                        ""
                      )
                    ));
        u = i = null;
      }
      return t;
    }
    function T(t, e, r) {
      for (var n, i = e ? ft.filter(e, t) : t, o = 0; null != (n = i[o]); o++)
        r || 1 !== n.nodeType || ft.cleanData(p(n)),
          n.parentNode &&
            (r && ft.contains(n.ownerDocument, n) && m(p(n, "script")),
            n.parentNode.removeChild(n));
      return t;
    }
    function D(t, e) {
      var r = ft(e.createElement(t)).appendTo(e.body),
        n = ft.css(r[0], "display");
      return r.detach(), n;
    }
    function F(t) {
      var e = nt,
        r = ce[t];
      return (
        r ||
          ((r = D(t, e)),
          ("none" !== r && r) ||
            ((ae = (
              ae || ft("<iframe frameborder='0' width='0' height='0'/>")
            ).appendTo(e.documentElement)),
            (e = (ae[0].contentWindow || ae[0].contentDocument).document),
            e.write(),
            e.close(),
            (r = D(t, e)),
            ae.detach()),
          (ce[t] = r)),
        r
      );
    }
    function E(t, e) {
      return {
        get: function () {
          return t()
            ? void delete this.get
            : (this.get = e).apply(this, arguments);
        },
      };
    }
    function j(t) {
      if (t in Ce) return t;
      for (var e = t.charAt(0).toUpperCase() + t.slice(1), r = we.length; r--; )
        if ((t = we[r] + e) in Ce) return t;
    }
    function I(t, e) {
      for (var r, n, i, o = [], a = 0, c = t.length; a < c; a++)
        (n = t[a]),
          n.style &&
            ((o[a] = ft._data(n, "olddisplay")),
            (r = n.style.display),
            e
              ? (o[a] || "none" !== r || (n.style.display = ""),
                "" === n.style.display &&
                  qt(n) &&
                  (o[a] = ft._data(n, "olddisplay", F(n.nodeName))))
              : ((i = qt(n)),
                ((r && "none" !== r) || !i) &&
                  ft._data(n, "olddisplay", i ? r : ft.css(n, "display"))));
      for (a = 0; a < c; a++)
        (n = t[a]),
          n.style &&
            ((e && "none" !== n.style.display && "" !== n.style.display) ||
              (n.style.display = e ? o[a] || "" : "none"));
      return t;
    }
    function R(t, e, r) {
      var n = be.exec(e);
      return n ? Math.max(0, n[1] - (r || 0)) + (n[2] || "px") : e;
    }
    function M(t, e, r, n, i) {
      for (
        var o = r === (n ? "border" : "content") ? 4 : "width" === e ? 1 : 0,
          a = 0;
        o < 4;
        o += 2
      )
        "margin" === r && (a += ft.css(t, r + Mt[o], !0, i)),
          n
            ? ("content" === r && (a -= ft.css(t, "padding" + Mt[o], !0, i)),
              "margin" !== r &&
                (a -= ft.css(t, "border" + Mt[o] + "Width", !0, i)))
            : ((a += ft.css(t, "padding" + Mt[o], !0, i)),
              "padding" !== r &&
                (a += ft.css(t, "border" + Mt[o] + "Width", !0, i)));
      return a;
    }
    function q(t, e, r) {
      var n = !0,
        i = "width" === e ? t.offsetWidth : t.offsetHeight,
        o = fe(t),
        a = dt.boxSizing && "border-box" === ft.css(t, "boxSizing", !1, o);
      if (i <= 0 || null == i) {
        if (
          ((i = he(t, e, o)),
          (i < 0 || null == i) && (i = t.style[e]),
          ue.test(i))
        )
          return i;
        (n = a && (dt.boxSizingReliable() || i === t.style[e])),
          (i = parseFloat(i) || 0);
      }
      return i + M(t, e, r || (a ? "border" : "content"), n, o) + "px";
    }
    function N(t, e, r, n, i) {
      return new N.prototype.init(t, e, r, n, i);
    }
    function O() {
      return (
        t.setTimeout(function () {
          xe = void 0;
        }),
        (xe = ft.now())
      );
    }
    function B(t, e) {
      var r,
        n = { height: t },
        i = 0;
      for (e = e ? 1 : 0; i < 4; i += 2 - e)
        (r = Mt[i]), (n["margin" + r] = n["padding" + r] = t);
      return e && (n.opacity = n.width = t), n;
    }
    function U(t, e, r) {
      for (
        var n,
          i = (V.tweeners[e] || []).concat(V.tweeners["*"]),
          o = 0,
          a = i.length;
        o < a;
        o++
      )
        if ((n = i[o].call(r, e, t))) return n;
    }
    function L(t, e, r) {
      var n,
        i,
        o,
        a,
        c,
        s,
        u,
        l = this,
        d = {},
        f = t.style,
        h = t.nodeType && qt(t),
        p = ft._data(t, "fxshow");
      r.queue ||
        ((c = ft._queueHooks(t, "fx")),
        null == c.unqueued &&
          ((c.unqueued = 0),
          (s = c.empty.fire),
          (c.empty.fire = function () {
            c.unqueued || s();
          })),
        c.unqueued++,
        l.always(function () {
          l.always(function () {
            c.unqueued--, ft.queue(t, "fx").length || c.empty.fire();
          });
        })),
        1 === t.nodeType &&
          ("height" in e || "width" in e) &&
          ((r.overflow = [f.overflow, f.overflowX, f.overflowY]),
          (u = ft.css(t, "display")),
          "inline" ===
            ("none" === u ? ft._data(t, "olddisplay") || F(t.nodeName) : u) &&
            "none" === ft.css(t, "float") &&
            (dt.inlineBlockNeedsLayout && "inline" !== F(t.nodeName)
              ? (f.zoom = 1)
              : (f.display = "inline-block"))),
        r.overflow &&
          ((f.overflow = "hidden"),
          dt.shrinkWrapBlocks() ||
            l.always(function () {
              (f.overflow = r.overflow[0]),
                (f.overflowX = r.overflow[1]),
                (f.overflowY = r.overflow[2]);
            }));
      for (n in e)
        if (((i = e[n]), Ae.exec(i))) {
          if (
            (delete e[n],
            (o = o || "toggle" === i),
            i === (h ? "hide" : "show"))
          ) {
            if ("show" !== i || !p || void 0 === p[n]) continue;
            h = !0;
          }
          d[n] = (p && p[n]) || ft.style(t, n);
        } else u = void 0;
      if (ft.isEmptyObject(d))
        "inline" === ("none" === u ? F(t.nodeName) : u) && (f.display = u);
      else {
        p ? "hidden" in p && (h = p.hidden) : (p = ft._data(t, "fxshow", {})),
          o && (p.hidden = !h),
          h
            ? ft(t).show()
            : l.done(function () {
                ft(t).hide();
              }),
          l.done(function () {
            var e;
            ft._removeData(t, "fxshow");
            for (e in d) ft.style(t, e, d[e]);
          });
        for (n in d)
          (a = U(h ? p[n] : 0, n, l)),
            n in p ||
              ((p[n] = a.start),
              h &&
                ((a.end = a.start),
                (a.start = "width" === n || "height" === n ? 1 : 0)));
      }
    }
    function $(t, e) {
      var r, n, i, o, a;
      for (r in t)
        if (
          ((n = ft.camelCase(r)),
          (i = e[n]),
          (o = t[r]),
          ft.isArray(o) && ((i = o[1]), (o = t[r] = o[0])),
          r !== n && ((t[n] = o), delete t[r]),
          (a = ft.cssHooks[n]) && "expand" in a)
        ) {
          (o = a.expand(o)), delete t[n];
          for (r in o) r in t || ((t[r] = o[r]), (e[r] = i));
        } else e[n] = i;
    }
    function V(t, e, r) {
      var n,
        i,
        o = 0,
        a = V.prefilters.length,
        c = ft.Deferred().always(function () {
          delete s.elem;
        }),
        s = function () {
          if (i) return !1;
          for (
            var e = xe || O(),
              r = Math.max(0, u.startTime + u.duration - e),
              n = r / u.duration || 0,
              o = 1 - n,
              a = 0,
              s = u.tweens.length;
            a < s;
            a++
          )
            u.tweens[a].run(o);
          return (
            c.notifyWith(t, [u, o, r]),
            o < 1 && s ? r : (c.resolveWith(t, [u]), !1)
          );
        },
        u = c.promise({
          elem: t,
          props: ft.extend({}, e),
          opts: ft.extend(
            !0,
            { specialEasing: {}, easing: ft.easing._default },
            r
          ),
          originalProperties: e,
          originalOptions: r,
          startTime: xe || O(),
          duration: r.duration,
          tweens: [],
          createTween: function (e, r) {
            var n = ft.Tween(
              t,
              u.opts,
              e,
              r,
              u.opts.specialEasing[e] || u.opts.easing
            );
            return u.tweens.push(n), n;
          },
          stop: function (e) {
            var r = 0,
              n = e ? u.tweens.length : 0;
            if (i) return this;
            for (i = !0; r < n; r++) u.tweens[r].run(1);
            return (
              e
                ? (c.notifyWith(t, [u, 1, 0]), c.resolveWith(t, [u, e]))
                : c.rejectWith(t, [u, e]),
              this
            );
          },
        }),
        l = u.props;
      for ($(l, u.opts.specialEasing); o < a; o++)
        if ((n = V.prefilters[o].call(u, t, l, u.opts)))
          return (
            ft.isFunction(n.stop) &&
              (ft._queueHooks(u.elem, u.opts.queue).stop = ft.proxy(n.stop, n)),
            n
          );
      return (
        ft.map(l, U, u),
        ft.isFunction(u.opts.start) && u.opts.start.call(t, u),
        ft.fx.timer(ft.extend(s, { elem: t, anim: u, queue: u.opts.queue })),
        u
          .progress(u.opts.progress)
          .done(u.opts.done, u.opts.complete)
          .fail(u.opts.fail)
          .always(u.opts.always)
      );
    }
    function W(t) {
      return ft.attr(t, "class") || "";
    }
    function H(t) {
      return function (e, r) {
        "string" != typeof e && ((r = e), (e = "*"));
        var n,
          i = 0,
          o = e.toLowerCase().match(St) || [];
        if (ft.isFunction(r))
          for (; (n = o[i++]); )
            "+" === n.charAt(0)
              ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(r))
              : (t[n] = t[n] || []).push(r);
      };
    }
    function G(t, e, r, n) {
      function i(c) {
        var s;
        return (
          (o[c] = !0),
          ft.each(t[c] || [], function (t, c) {
            var u = c(e, r, n);
            return "string" != typeof u || a || o[u]
              ? a
                ? !(s = u)
                : void 0
              : (e.dataTypes.unshift(u), i(u), !1);
          }),
          s
        );
      }
      var o = {},
        a = t === Qe;
      return i(e.dataTypes[0]) || (!o["*"] && i("*"));
    }
    function z(t, e) {
      var r,
        n,
        i = ft.ajaxSettings.flatOptions || {};
      for (n in e) void 0 !== e[n] && ((i[n] ? t : r || (r = {}))[n] = e[n]);
      return r && ft.extend(!0, t, r), t;
    }
    function J(t, e, r) {
      for (var n, i, o, a, c = t.contents, s = t.dataTypes; "*" === s[0]; )
        s.shift(),
          void 0 === i &&
            (i = t.mimeType || e.getResponseHeader("Content-Type"));
      if (i)
        for (a in c)
          if (c[a] && c[a].test(i)) {
            s.unshift(a);
            break;
          }
      if (s[0] in r) o = s[0];
      else {
        for (a in r) {
          if (!s[0] || t.converters[a + " " + s[0]]) {
            o = a;
            break;
          }
          n || (n = a);
        }
        o = o || n;
      }
      if (o) return o !== s[0] && s.unshift(o), r[o];
    }
    function K(t, e, r, n) {
      var i,
        o,
        a,
        c,
        s,
        u = {},
        l = t.dataTypes.slice();
      if (l[1]) for (a in t.converters) u[a.toLowerCase()] = t.converters[a];
      for (o = l.shift(); o; )
        if (
          (t.responseFields[o] && (r[t.responseFields[o]] = e),
          !s && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)),
          (s = o),
          (o = l.shift()))
        )
          if ("*" === o) o = s;
          else if ("*" !== s && s !== o) {
            if (!(a = u[s + " " + o] || u["* " + o]))
              for (i in u)
                if (
                  ((c = i.split(" ")),
                  c[1] === o && (a = u[s + " " + c[0]] || u["* " + c[0]]))
                ) {
                  !0 === a
                    ? (a = u[i])
                    : !0 !== u[i] && ((o = c[0]), l.unshift(c[1]));
                  break;
                }
            if (!0 !== a)
              if (a && t.throws) e = a(e);
              else
                try {
                  e = a(e);
                } catch (t) {
                  return {
                    state: "parsererror",
                    error: a ? t : "No conversion from " + s + " to " + o,
                  };
                }
          }
      return { state: "success", data: e };
    }
    function Q(t) {
      return (t.style && t.style.display) || ft.css(t, "display");
    }
    function Y(t) {
      if (!ft.contains(t.ownerDocument || nt, t)) return !0;
      for (; t && 1 === t.nodeType; ) {
        if ("none" === Q(t) || "hidden" === t.type) return !0;
        t = t.parentNode;
      }
      return !1;
    }
    function X(t, e, r, n) {
      var i;
      if (ft.isArray(e))
        ft.each(e, function (e, i) {
          r || er.test(t)
            ? n(t, i)
            : X(
                t + "[" + ("object" == typeof i && null != i ? e : "") + "]",
                i,
                r,
                n
              );
        });
      else if (r || "object" !== ft.type(e)) n(t, e);
      else for (i in e) X(t + "[" + i + "]", e[i], r, n);
    }
    function Z() {
      try {
        return new t.XMLHttpRequest();
      } catch (t) {}
    }
    function tt() {
      try {
        return new t.ActiveXObject("Microsoft.XMLHTTP");
      } catch (t) {}
    }
    function et(t) {
      return ft.isWindow(t)
        ? t
        : 9 === t.nodeType && (t.defaultView || t.parentWindow);
    }
    var rt = [],
      nt = t.document,
      it = rt.slice,
      ot = rt.concat,
      at = rt.push,
      ct = rt.indexOf,
      st = {},
      ut = st.toString,
      lt = st.hasOwnProperty,
      dt = {},
      ft = function (t, e) {
        return new ft.fn.init(t, e);
      },
      ht = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      pt = /^-ms-/,
      mt = /-([\da-z])/gi,
      gt = function (t, e) {
        return e.toUpperCase();
      };
    (ft.fn = ft.prototype =
      {
        jquery: "1.12.4",
        constructor: ft,
        selector: "",
        length: 0,
        toArray: function () {
          return it.call(this);
        },
        get: function (t) {
          return null != t
            ? t < 0
              ? this[t + this.length]
              : this[t]
            : it.call(this);
        },
        pushStack: function (t) {
          var e = ft.merge(this.constructor(), t);
          return (e.prevObject = this), (e.context = this.context), e;
        },
        each: function (t) {
          return ft.each(this, t);
        },
        map: function (t) {
          return this.pushStack(
            ft.map(this, function (e, r) {
              return t.call(e, r, e);
            })
          );
        },
        slice: function () {
          return this.pushStack(it.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (t) {
          var e = this.length,
            r = +t + (t < 0 ? e : 0);
          return this.pushStack(r >= 0 && r < e ? [this[r]] : []);
        },
        end: function () {
          return this.prevObject || this.constructor();
        },
        push: at,
        sort: rt.sort,
        splice: rt.splice,
      }),
      (ft.extend = ft.fn.extend =
        function () {
          var t,
            e,
            r,
            n,
            i,
            o,
            a = arguments[0] || {},
            c = 1,
            s = arguments.length,
            u = !1;
          for (
            "boolean" == typeof a && ((u = a), (a = arguments[c] || {}), c++),
              "object" == typeof a || ft.isFunction(a) || (a = {}),
              c === s && ((a = this), c--);
            c < s;
            c++
          )
            if (null != (i = arguments[c]))
              for (n in i)
                (t = a[n]),
                  (r = i[n]),
                  a !== r &&
                    (u && r && (ft.isPlainObject(r) || (e = ft.isArray(r)))
                      ? (e
                          ? ((e = !1), (o = t && ft.isArray(t) ? t : []))
                          : (o = t && ft.isPlainObject(t) ? t : {}),
                        (a[n] = ft.extend(u, o, r)))
                      : void 0 !== r && (a[n] = r));
          return a;
        }),
      ft.extend({
        expando: "cbbJQuery" + ("1.12.4" + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function (t) {
          throw new Error(t);
        },
        noop: function () {},
        isFunction: function (t) {
          return "function" === ft.type(t);
        },
        isArray:
          Array.isArray ||
          function (t) {
            return "array" === ft.type(t);
          },
        isWindow: function (t) {
          return null != t && t == t.window;
        },
        isNumeric: function (t) {
          var e = t && t.toString();
          return !ft.isArray(t) && e - parseFloat(e) + 1 >= 0;
        },
        isEmptyObject: function (t) {
          var e;
          for (e in t) return !1;
          return !0;
        },
        isPlainObject: function (t) {
          var e;
          if (!t || "object" !== ft.type(t) || t.nodeType || ft.isWindow(t))
            return !1;
          try {
            if (
              t.constructor &&
              !lt.call(t, "constructor") &&
              !lt.call(t.constructor.prototype, "isPrototypeOf")
            )
              return !1;
          } catch (t) {
            return !1;
          }
          if (!dt.ownFirst) for (e in t) return lt.call(t, e);
          for (e in t);
          return void 0 === e || lt.call(t, e);
        },
        type: function (t) {
          return null == t
            ? t + ""
            : "object" == typeof t || "function" == typeof t
            ? st[ut.call(t)] || "object"
            : typeof t;
        },
        globalEval: function (e) {
          e &&
            ft.trim(e) &&
            (
              t.execScript ||
              function (e) {
                t.eval.call(t, e);
              }
            )(e);
        },
        camelCase: function (t) {
          return t.replace(pt, "ms-").replace(mt, gt);
        },
        nodeName: function (t, e) {
          return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
        },
        each: function (t, e) {
          var n,
            i = 0;
          if (r(t))
            for (n = t.length; i < n && !1 !== e.call(t[i], i, t[i]); i++);
          else for (i in t) if (!1 === e.call(t[i], i, t[i])) break;
          return t;
        },
        trim: function (t) {
          return null == t ? "" : (t + "").replace(ht, "");
        },
        makeArray: function (t, e) {
          var n = e || [];
          return (
            null != t &&
              (r(Object(t))
                ? ft.merge(n, "string" == typeof t ? [t] : t)
                : at.call(n, t)),
            n
          );
        },
        inArray: function (t, e, r) {
          var n;
          if (e) {
            if (ct) return ct.call(e, t, r);
            for (
              n = e.length, r = r ? (r < 0 ? Math.max(0, n + r) : r) : 0;
              r < n;
              r++
            )
              if (r in e && e[r] === t) return r;
          }
          return -1;
        },
        merge: function (t, e) {
          for (var r = +e.length, n = 0, i = t.length; n < r; ) t[i++] = e[n++];
          if (r !== r) for (; void 0 !== e[n]; ) t[i++] = e[n++];
          return (t.length = i), t;
        },
        grep: function (t, e, r) {
          for (var n = [], i = 0, o = t.length, a = !r; i < o; i++)
            !e(t[i], i) !== a && n.push(t[i]);
          return n;
        },
        map: function (t, e, n) {
          var i,
            o,
            a = 0,
            c = [];
          if (r(t))
            for (i = t.length; a < i; a++)
              null != (o = e(t[a], a, n)) && c.push(o);
          else for (a in t) null != (o = e(t[a], a, n)) && c.push(o);
          return ot.apply([], c);
        },
        guid: 1,
        proxy: function (t, e) {
          var r, n, i;
          if (
            ("string" == typeof e && ((i = t[e]), (e = t), (t = i)),
            ft.isFunction(t))
          )
            return (
              (r = it.call(arguments, 2)),
              (n = function () {
                return t.apply(e || this, r.concat(it.call(arguments)));
              }),
              (n.guid = t.guid = t.guid || ft.guid++),
              n
            );
        },
        now: function () {
          return +new Date();
        },
        support: dt,
      }),
      "function" == typeof Symbol &&
        (ft.fn[Symbol.iterator] = rt[Symbol.iterator]),
      ft.each(
        "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
          " "
        ),
        function (t, e) {
          st["[object " + e + "]"] = e.toLowerCase();
        }
      );
    var yt = (function (t) {
      function e(t, e, r, n) {
        var i,
          o,
          a,
          c,
          u,
          d,
          f,
          h,
          p = e && e.ownerDocument,
          m = e ? e.nodeType : 9;
        if (
          ((r = r || []),
          "string" != typeof t || !t || (1 !== m && 9 !== m && 11 !== m))
        )
          return r;
        if (
          !n &&
          ((e ? e.ownerDocument || e : O) !== F && D(e), (e = e || F), j)
        ) {
          if (11 !== m && (d = mt.exec(t)))
            if ((i = d[1])) {
              if (9 === m) {
                if (!(a = e.getElementById(i))) return r;
                if (a.id === i) return r.push(a), r;
              } else if (
                p &&
                (a = p.getElementById(i)) &&
                q(e, a) &&
                a.id === i
              )
                return r.push(a), r;
            } else {
              if (d[2]) return Q.apply(r, e.getElementsByTagName(t)), r;
              if (
                (i = d[3]) &&
                v.getElementsByClassName &&
                e.getElementsByClassName
              )
                return Q.apply(r, e.getElementsByClassName(i)), r;
            }
          if (v.qsa && !V[t + " "] && (!I || !I.test(t))) {
            if (1 !== m) (p = e), (h = t);
            else if ("object" !== e.nodeName.toLowerCase()) {
              for (
                (c = e.getAttribute("id"))
                  ? (c = c.replace(yt, "\\$&"))
                  : e.setAttribute("id", (c = N)),
                  f = x(t),
                  o = f.length,
                  u = lt.test(c) ? "#" + c : "[id='" + c + "']";
                o--;

              )
                f[o] = u + " " + l(f[o]);
              (h = f.join(",")), (p = (gt.test(t) && s(e.parentNode)) || e);
            }
            if (h)
              try {
                return Q.apply(r, p.querySelectorAll(h)), r;
              } catch (t) {
              } finally {
                c === N && e.removeAttribute("id");
              }
          }
        }
        return A(t.replace(ot, "$1"), e, r, n);
      }
      function r() {
        function t(r, n) {
          return (
            e.push(r + " ") > _.cacheLength && delete t[e.shift()],
            (t[r + " "] = n)
          );
        }
        var e = [];
        return t;
      }
      function n(t) {
        return (t[N] = !0), t;
      }
      function i(t) {
        var e = F.createElement("div");
        try {
          return !!t(e);
        } catch (t) {
          return !1;
        } finally {
          e.parentNode && e.parentNode.removeChild(e), (e = null);
        }
      }
      function o(t, e) {
        for (var r = t.split("|"), n = r.length; n--; ) _.attrHandle[r[n]] = e;
      }
      function a(t, e) {
        var r = e && t,
          n =
            r &&
            1 === t.nodeType &&
            1 === e.nodeType &&
            (~e.sourceIndex || H) - (~t.sourceIndex || H);
        if (n) return n;
        if (r) for (; (r = r.nextSibling); ) if (r === e) return -1;
        return t ? 1 : -1;
      }
      function c(t) {
        return n(function (e) {
          return (
            (e = +e),
            n(function (r, n) {
              for (var i, o = t([], r.length, e), a = o.length; a--; )
                r[(i = o[a])] && (r[i] = !(n[i] = r[i]));
            })
          );
        });
      }
      function s(t) {
        return t && void 0 !== t.getElementsByTagName && t;
      }
      function u() {}
      function l(t) {
        for (var e = 0, r = t.length, n = ""; e < r; e++) n += t[e].value;
        return n;
      }
      function d(t, e, r) {
        var n = e.dir,
          i = r && "parentNode" === n,
          o = U++;
        return e.first
          ? function (e, r, o) {
              for (; (e = e[n]); ) if (1 === e.nodeType || i) return t(e, r, o);
            }
          : function (e, r, a) {
              var c,
                s,
                u,
                l = [B, o];
              if (a) {
                for (; (e = e[n]); )
                  if ((1 === e.nodeType || i) && t(e, r, a)) return !0;
              } else
                for (; (e = e[n]); )
                  if (1 === e.nodeType || i) {
                    if (
                      ((u = e[N] || (e[N] = {})),
                      (s = u[e.uniqueID] || (u[e.uniqueID] = {})),
                      (c = s[n]) && c[0] === B && c[1] === o)
                    )
                      return (l[2] = c[2]);
                    if (((s[n] = l), (l[2] = t(e, r, a)))) return !0;
                  }
            };
      }
      function f(t) {
        return t.length > 1
          ? function (e, r, n) {
              for (var i = t.length; i--; ) if (!t[i](e, r, n)) return !1;
              return !0;
            }
          : t[0];
      }
      function h(t, r, n) {
        for (var i = 0, o = r.length; i < o; i++) e(t, r[i], n);
        return n;
      }
      function p(t, e, r, n, i) {
        for (var o, a = [], c = 0, s = t.length, u = null != e; c < s; c++)
          (o = t[c]) && ((r && !r(o, n, i)) || (a.push(o), u && e.push(c)));
        return a;
      }
      function m(t, e, r, i, o, a) {
        return (
          i && !i[N] && (i = m(i)),
          o && !o[N] && (o = m(o, a)),
          n(function (n, a, c, s) {
            var u,
              l,
              d,
              f = [],
              m = [],
              g = a.length,
              y = n || h(e || "*", c.nodeType ? [c] : c, []),
              b = !t || (!n && e) ? y : p(y, f, t, c, s),
              v = r ? (o || (n ? t : g || i) ? [] : a) : b;
            if ((r && r(b, v, c, s), i))
              for (u = p(v, m), i(u, [], c, s), l = u.length; l--; )
                (d = u[l]) && (v[m[l]] = !(b[m[l]] = d));
            if (n) {
              if (o || t) {
                if (o) {
                  for (u = [], l = v.length; l--; )
                    (d = v[l]) && u.push((b[l] = d));
                  o(null, (v = []), u, s);
                }
                for (l = v.length; l--; )
                  (d = v[l]) &&
                    (u = o ? X(n, d) : f[l]) > -1 &&
                    (n[u] = !(a[u] = d));
              }
            } else (v = p(v === a ? v.splice(g, v.length) : v)), o ? o(null, a, v, s) : Q.apply(a, v);
          })
        );
      }
      function g(t) {
        for (
          var e,
            r,
            n,
            i = t.length,
            o = _.relative[t[0].type],
            a = o || _.relative[" "],
            c = o ? 1 : 0,
            s = d(
              function (t) {
                return t === e;
              },
              a,
              !0
            ),
            u = d(
              function (t) {
                return X(e, t) > -1;
              },
              a,
              !0
            ),
            h = [
              function (t, r, n) {
                var i =
                  (!o && (n || r !== k)) ||
                  ((e = r).nodeType ? s(t, r, n) : u(t, r, n));
                return (e = null), i;
              },
            ];
          c < i;
          c++
        )
          if ((r = _.relative[t[c].type])) h = [d(f(h), r)];
          else {
            if (((r = _.filter[t[c].type].apply(null, t[c].matches)), r[N])) {
              for (n = ++c; n < i && !_.relative[t[n].type]; n++);
              return m(
                c > 1 && f(h),
                c > 1 &&
                  l(
                    t
                      .slice(0, c - 1)
                      .concat({ value: " " === t[c - 2].type ? "*" : "" })
                  ).replace(ot, "$1"),
                r,
                c < n && g(t.slice(c, n)),
                n < i && g((t = t.slice(n))),
                n < i && l(t)
              );
            }
            h.push(r);
          }
        return f(h);
      }
      function y(t, r) {
        var i = r.length > 0,
          o = t.length > 0,
          a = function (n, a, c, s, u) {
            var l,
              d,
              f,
              h = 0,
              m = "0",
              g = n && [],
              y = [],
              b = k,
              v = n || (o && _.find.TAG("*", u)),
              w = (B += null == b ? 1 : Math.random() || 0.1),
              C = v.length;
            for (
              u && (k = a === F || a || u);
              m !== C && null != (l = v[m]);
              m++
            ) {
              if (o && l) {
                for (
                  d = 0, a || l.ownerDocument === F || (D(l), (c = !j));
                  (f = t[d++]);

                )
                  if (f(l, a || F, c)) {
                    s.push(l);
                    break;
                  }
                u && (B = w);
              }
              i && ((l = !f && l) && h--, n && g.push(l));
            }
            if (((h += m), i && m !== h)) {
              for (d = 0; (f = r[d++]); ) f(g, y, a, c);
              if (n) {
                if (h > 0) for (; m--; ) g[m] || y[m] || (y[m] = J.call(s));
                y = p(y);
              }
              Q.apply(s, y),
                u && !n && y.length > 0 && h + r.length > 1 && e.uniqueSort(s);
            }
            return u && ((B = w), (k = b)), g;
          };
        return i ? n(a) : a;
      }
      var b,
        v,
        _,
        w,
        C,
        x,
        P,
        A,
        k,
        S,
        T,
        D,
        F,
        E,
        j,
        I,
        R,
        M,
        q,
        N = "sizzle" + 1 * new Date(),
        O = t.document,
        B = 0,
        U = 0,
        L = r(),
        $ = r(),
        V = r(),
        W = function (t, e) {
          return t === e && (T = !0), 0;
        },
        H = 1 << 31,
        G = {}.hasOwnProperty,
        z = [],
        J = z.pop,
        K = z.push,
        Q = z.push,
        Y = z.slice,
        X = function (t, e) {
          for (var r = 0, n = t.length; r < n; r++) if (t[r] === e) return r;
          return -1;
        },
        Z =
          "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        tt = "[\\x20\\t\\r\\n\\f]",
        et = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
        rt =
          "\\[" +
          tt +
          "*(" +
          et +
          ")(?:" +
          tt +
          "*([*^$|!~]?=)" +
          tt +
          "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
          et +
          "))|)" +
          tt +
          "*\\]",
        nt =
          ":(" +
          et +
          ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
          rt +
          ")*)|.*)\\)|)",
        it = new RegExp(tt + "+", "g"),
        ot = new RegExp(
          "^" + tt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + tt + "+$",
          "g"
        ),
        at = new RegExp("^" + tt + "*," + tt + "*"),
        ct = new RegExp("^" + tt + "*([>+~]|" + tt + ")" + tt + "*"),
        st = new RegExp("=" + tt + "*([^\\]'\"]*?)" + tt + "*\\]", "g"),
        ut = new RegExp(nt),
        lt = new RegExp("^" + et + "$"),
        dt = {
          ID: new RegExp("^#(" + et + ")"),
          CLASS: new RegExp("^\\.(" + et + ")"),
          TAG: new RegExp("^(" + et + "|[*])"),
          ATTR: new RegExp("^" + rt),
          PSEUDO: new RegExp("^" + nt),
          CHILD: new RegExp(
            "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
              tt +
              "*(even|odd|(([+-]|)(\\d*)n|)" +
              tt +
              "*(?:([+-]|)" +
              tt +
              "*(\\d+)|))" +
              tt +
              "*\\)|)",
            "i"
          ),
          bool: new RegExp("^(?:" + Z + ")$", "i"),
          needsContext: new RegExp(
            "^" +
              tt +
              "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
              tt +
              "*((?:-\\d)?\\d*)" +
              tt +
              "*\\)|)(?=[^-]|$)",
            "i"
          ),
        },
        ft = /^(?:input|select|textarea|button)$/i,
        ht = /^h\d$/i,
        pt = /^[^{]+\{\s*\[native \w/,
        mt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        gt = /[+~]/,
        yt = /'|\\/g,
        bt = new RegExp("\\\\([\\da-f]{1,6}" + tt + "?|(" + tt + ")|.)", "ig"),
        vt = function (t, e, r) {
          var n = "0x" + e - 65536;
          return n !== n || r
            ? e
            : n < 0
            ? String.fromCharCode(n + 65536)
            : String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320);
        },
        _t = function () {
          D();
        };
      try {
        Q.apply((z = Y.call(O.childNodes)), O.childNodes),
          z[O.childNodes.length].nodeType;
      } catch (t) {
        Q = {
          apply: z.length
            ? function (t, e) {
                K.apply(t, Y.call(e));
              }
            : function (t, e) {
                for (var r = t.length, n = 0; (t[r++] = e[n++]); );
                t.length = r - 1;
              },
        };
      }
      (v = e.support = {}),
        (C = e.isXML =
          function (t) {
            var e = t && (t.ownerDocument || t).documentElement;
            return !!e && "HTML" !== e.nodeName;
          }),
        (D = e.setDocument =
          function (t) {
            var e,
              r,
              n = t ? t.ownerDocument || t : O;
            return n !== F && 9 === n.nodeType && n.documentElement
              ? ((F = n),
                (E = F.documentElement),
                (j = !C(F)),
                (r = F.defaultView) &&
                  r.top !== r &&
                  (r.addEventListener
                    ? r.addEventListener("unload", _t, !1)
                    : r.attachEvent && r.attachEvent("onunload", _t)),
                (v.attributes = i(function (t) {
                  return (t.className = "i"), !t.getAttribute("className");
                })),
                (v.getElementsByTagName = i(function (t) {
                  return (
                    t.appendChild(F.createComment("")),
                    !t.getElementsByTagName("*").length
                  );
                })),
                (v.getElementsByClassName = pt.test(F.getElementsByClassName)),
                (v.getById = i(function (t) {
                  return (
                    (E.appendChild(t).id = N),
                    !F.getElementsByName || !F.getElementsByName(N).length
                  );
                })),
                v.getById
                  ? ((_.find.ID = function (t, e) {
                      if (void 0 !== e.getElementById && j) {
                        var r = e.getElementById(t);
                        return r ? [r] : [];
                      }
                    }),
                    (_.filter.ID = function (t) {
                      var e = t.replace(bt, vt);
                      return function (t) {
                        return t.getAttribute("id") === e;
                      };
                    }))
                  : (delete _.find.ID,
                    (_.filter.ID = function (t) {
                      var e = t.replace(bt, vt);
                      return function (t) {
                        var r =
                          void 0 !== t.getAttributeNode &&
                          t.getAttributeNode("id");
                        return r && r.value === e;
                      };
                    })),
                (_.find.TAG = v.getElementsByTagName
                  ? function (t, e) {
                      return void 0 !== e.getElementsByTagName
                        ? e.getElementsByTagName(t)
                        : v.qsa
                        ? e.querySelectorAll(t)
                        : void 0;
                    }
                  : function (t, e) {
                      var r,
                        n = [],
                        i = 0,
                        o = e.getElementsByTagName(t);
                      if ("*" === t) {
                        for (; (r = o[i++]); ) 1 === r.nodeType && n.push(r);
                        return n;
                      }
                      return o;
                    }),
                (_.find.CLASS =
                  v.getElementsByClassName &&
                  function (t, e) {
                    if (void 0 !== e.getElementsByClassName && j)
                      return e.getElementsByClassName(t);
                  }),
                (R = []),
                (I = []),
                (v.qsa = pt.test(F.querySelectorAll)) &&
                  (i(function (t) {
                    (E.appendChild(t).innerHTML =
                      "<a id='" +
                      N +
                      "'></a><select id='" +
                      N +
                      "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                      t.querySelectorAll("[msallowcapture^='']").length &&
                        I.push("[*^$]=" + tt + "*(?:''|\"\")"),
                      t.querySelectorAll("[selected]").length ||
                        I.push("\\[" + tt + "*(?:value|" + Z + ")"),
                      t.querySelectorAll("[id~=" + N + "-]").length ||
                        I.push("~="),
                      t.querySelectorAll(":checked").length ||
                        I.push(":checked"),
                      t.querySelectorAll("a#" + N + "+*").length ||
                        I.push(".#.+[+~]");
                  }),
                  i(function (t) {
                    var e = F.createElement("input");
                    e.setAttribute("type", "hidden"),
                      t.appendChild(e).setAttribute("name", "D"),
                      t.querySelectorAll("[name=d]").length &&
                        I.push("name" + tt + "*[*^$|!~]?="),
                      t.querySelectorAll(":enabled").length ||
                        I.push(":enabled", ":disabled"),
                      t.querySelectorAll("*,:x"),
                      I.push(",.*:");
                  })),
                (v.matchesSelector = pt.test(
                  (M =
                    E.matches ||
                    E.webkitMatchesSelector ||
                    E.mozMatchesSelector ||
                    E.oMatchesSelector ||
                    E.msMatchesSelector)
                )) &&
                  i(function (t) {
                    (v.disconnectedMatch = M.call(t, "div")),
                      M.call(t, "[s!='']:x"),
                      R.push("!=", nt);
                  }),
                (I = I.length && new RegExp(I.join("|"))),
                (R = R.length && new RegExp(R.join("|"))),
                (e = pt.test(E.compareDocumentPosition)),
                (q =
                  e || pt.test(E.contains)
                    ? function (t, e) {
                        var r = 9 === t.nodeType ? t.documentElement : t,
                          n = e && e.parentNode;
                        return (
                          t === n ||
                          !(
                            !n ||
                            1 !== n.nodeType ||
                            !(r.contains
                              ? r.contains(n)
                              : t.compareDocumentPosition &&
                                16 & t.compareDocumentPosition(n))
                          )
                        );
                      }
                    : function (t, e) {
                        if (e)
                          for (; (e = e.parentNode); ) if (e === t) return !0;
                        return !1;
                      }),
                (W = e
                  ? function (t, e) {
                      if (t === e) return (T = !0), 0;
                      var r =
                        !t.compareDocumentPosition - !e.compareDocumentPosition;
                      return (
                        r ||
                        ((r =
                          (t.ownerDocument || t) === (e.ownerDocument || e)
                            ? t.compareDocumentPosition(e)
                            : 1),
                        1 & r ||
                        (!v.sortDetached && e.compareDocumentPosition(t) === r)
                          ? t === F || (t.ownerDocument === O && q(O, t))
                            ? -1
                            : e === F || (e.ownerDocument === O && q(O, e))
                            ? 1
                            : S
                            ? X(S, t) - X(S, e)
                            : 0
                          : 4 & r
                          ? -1
                          : 1)
                      );
                    }
                  : function (t, e) {
                      if (t === e) return (T = !0), 0;
                      var r,
                        n = 0,
                        i = t.parentNode,
                        o = e.parentNode,
                        c = [t],
                        s = [e];
                      if (!i || !o)
                        return t === F
                          ? -1
                          : e === F
                          ? 1
                          : i
                          ? -1
                          : o
                          ? 1
                          : S
                          ? X(S, t) - X(S, e)
                          : 0;
                      if (i === o) return a(t, e);
                      for (r = t; (r = r.parentNode); ) c.unshift(r);
                      for (r = e; (r = r.parentNode); ) s.unshift(r);
                      for (; c[n] === s[n]; ) n++;
                      return n
                        ? a(c[n], s[n])
                        : c[n] === O
                        ? -1
                        : s[n] === O
                        ? 1
                        : 0;
                    }),
                F)
              : F;
          }),
        (e.matches = function (t, r) {
          return e(t, null, null, r);
        }),
        (e.matchesSelector = function (t, r) {
          if (
            ((t.ownerDocument || t) !== F && D(t),
            (r = r.replace(st, "='$1']")),
            v.matchesSelector &&
              j &&
              !V[r + " "] &&
              (!R || !R.test(r)) &&
              (!I || !I.test(r)))
          )
            try {
              var n = M.call(t, r);
              if (
                n ||
                v.disconnectedMatch ||
                (t.document && 11 !== t.document.nodeType)
              )
                return n;
            } catch (t) {}
          return e(r, F, null, [t]).length > 0;
        }),
        (e.contains = function (t, e) {
          return (t.ownerDocument || t) !== F && D(t), q(t, e);
        }),
        (e.attr = function (t, e) {
          (t.ownerDocument || t) !== F && D(t);
          var r = _.attrHandle[e.toLowerCase()],
            n =
              r && G.call(_.attrHandle, e.toLowerCase()) ? r(t, e, !j) : void 0;
          return void 0 !== n
            ? n
            : v.attributes || !j
            ? t.getAttribute(e)
            : (n = t.getAttributeNode(e)) && n.specified
            ? n.value
            : null;
        }),
        (e.error = function (t) {
          throw new Error("Syntax error, unrecognized expression: " + t);
        }),
        (e.uniqueSort = function (t) {
          var e,
            r = [],
            n = 0,
            i = 0;
          if (
            ((T = !v.detectDuplicates),
            (S = !v.sortStable && t.slice(0)),
            t.sort(W),
            T)
          ) {
            for (; (e = t[i++]); ) e === t[i] && (n = r.push(i));
            for (; n--; ) t.splice(r[n], 1);
          }
          return (S = null), t;
        }),
        (w = e.getText =
          function (t) {
            var e,
              r = "",
              n = 0,
              i = t.nodeType;
            if (i) {
              if (1 === i || 9 === i || 11 === i) {
                if ("string" == typeof t.textContent) return t.textContent;
                for (t = t.firstChild; t; t = t.nextSibling) r += w(t);
              } else if (3 === i || 4 === i) return t.nodeValue;
            } else for (; (e = t[n++]); ) r += w(e);
            return r;
          }),
        (_ = e.selectors =
          {
            cacheLength: 50,
            createPseudo: n,
            match: dt,
            attrHandle: {},
            find: {},
            relative: {
              ">": { dir: "parentNode", first: !0 },
              " ": { dir: "parentNode" },
              "+": { dir: "previousSibling", first: !0 },
              "~": { dir: "previousSibling" },
            },
            preFilter: {
              ATTR: function (t) {
                return (
                  (t[1] = t[1].replace(bt, vt)),
                  (t[3] = (t[3] || t[4] || t[5] || "").replace(bt, vt)),
                  "~=" === t[2] && (t[3] = " " + t[3] + " "),
                  t.slice(0, 4)
                );
              },
              CHILD: function (t) {
                return (
                  (t[1] = t[1].toLowerCase()),
                  "nth" === t[1].slice(0, 3)
                    ? (t[3] || e.error(t[0]),
                      (t[4] = +(t[4]
                        ? t[5] + (t[6] || 1)
                        : 2 * ("even" === t[3] || "odd" === t[3]))),
                      (t[5] = +(t[7] + t[8] || "odd" === t[3])))
                    : t[3] && e.error(t[0]),
                  t
                );
              },
              PSEUDO: function (t) {
                var e,
                  r = !t[6] && t[2];
                return dt.CHILD.test(t[0])
                  ? null
                  : (t[3]
                      ? (t[2] = t[4] || t[5] || "")
                      : r &&
                        ut.test(r) &&
                        (e = x(r, !0)) &&
                        (e = r.indexOf(")", r.length - e) - r.length) &&
                        ((t[0] = t[0].slice(0, e)), (t[2] = r.slice(0, e))),
                    t.slice(0, 3));
              },
            },
            filter: {
              TAG: function (t) {
                var e = t.replace(bt, vt).toLowerCase();
                return "*" === t
                  ? function () {
                      return !0;
                    }
                  : function (t) {
                      return t.nodeName && t.nodeName.toLowerCase() === e;
                    };
              },
              CLASS: function (t) {
                var e = L[t + " "];
                return (
                  e ||
                  ((e = new RegExp("(^|" + tt + ")" + t + "(" + tt + "|$)")) &&
                    L(t, function (t) {
                      return e.test(
                        ("string" == typeof t.className && t.className) ||
                          (void 0 !== t.getAttribute &&
                            t.getAttribute("class")) ||
                          ""
                      );
                    }))
                );
              },
              ATTR: function (t, r, n) {
                return function (i) {
                  var o = e.attr(i, t);
                  return null == o
                    ? "!=" === r
                    : !r ||
                        ((o += ""),
                        "=" === r
                          ? o === n
                          : "!=" === r
                          ? o !== n
                          : "^=" === r
                          ? n && 0 === o.indexOf(n)
                          : "*=" === r
                          ? n && o.indexOf(n) > -1
                          : "$=" === r
                          ? n && o.slice(-n.length) === n
                          : "~=" === r
                          ? (" " + o.replace(it, " ") + " ").indexOf(n) > -1
                          : "|=" === r &&
                            (o === n || o.slice(0, n.length + 1) === n + "-"));
                };
              },
              CHILD: function (t, e, r, n, i) {
                var o = "nth" !== t.slice(0, 3),
                  a = "last" !== t.slice(-4),
                  c = "of-type" === e;
                return 1 === n && 0 === i
                  ? function (t) {
                      return !!t.parentNode;
                    }
                  : function (e, r, s) {
                      var u,
                        l,
                        d,
                        f,
                        h,
                        p,
                        m = o !== a ? "nextSibling" : "previousSibling",
                        g = e.parentNode,
                        y = c && e.nodeName.toLowerCase(),
                        b = !s && !c,
                        v = !1;
                      if (g) {
                        if (o) {
                          for (; m; ) {
                            for (f = e; (f = f[m]); )
                              if (
                                c
                                  ? f.nodeName.toLowerCase() === y
                                  : 1 === f.nodeType
                              )
                                return !1;
                            p = m = "only" === t && !p && "nextSibling";
                          }
                          return !0;
                        }
                        if (((p = [a ? g.firstChild : g.lastChild]), a && b)) {
                          for (
                            f = g,
                              d = f[N] || (f[N] = {}),
                              l = d[f.uniqueID] || (d[f.uniqueID] = {}),
                              u = l[t] || [],
                              h = u[0] === B && u[1],
                              v = h && u[2],
                              f = h && g.childNodes[h];
                            (f = (++h && f && f[m]) || (v = h = 0) || p.pop());

                          )
                            if (1 === f.nodeType && ++v && f === e) {
                              l[t] = [B, h, v];
                              break;
                            }
                        } else if (
                          (b &&
                            ((f = e),
                            (d = f[N] || (f[N] = {})),
                            (l = d[f.uniqueID] || (d[f.uniqueID] = {})),
                            (u = l[t] || []),
                            (h = u[0] === B && u[1]),
                            (v = h)),
                          !1 === v)
                        )
                          for (
                            ;
                            (f =
                              (++h && f && f[m]) || (v = h = 0) || p.pop()) &&
                            ((c
                              ? f.nodeName.toLowerCase() !== y
                              : 1 !== f.nodeType) ||
                              !++v ||
                              (b &&
                                ((d = f[N] || (f[N] = {})),
                                (l = d[f.uniqueID] || (d[f.uniqueID] = {})),
                                (l[t] = [B, v])),
                              f !== e));

                          );
                        return (v -= i) === n || (v % n == 0 && v / n >= 0);
                      }
                    };
              },
              PSEUDO: function (t, r) {
                var i,
                  o =
                    _.pseudos[t] ||
                    _.setFilters[t.toLowerCase()] ||
                    e.error("unsupported pseudo: " + t);
                return o[N]
                  ? o(r)
                  : o.length > 1
                  ? ((i = [t, t, "", r]),
                    _.setFilters.hasOwnProperty(t.toLowerCase())
                      ? n(function (t, e) {
                          for (var n, i = o(t, r), a = i.length; a--; )
                            (n = X(t, i[a])), (t[n] = !(e[n] = i[a]));
                        })
                      : function (t) {
                          return o(t, 0, i);
                        })
                  : o;
              },
            },
            pseudos: {
              not: n(function (t) {
                var e = [],
                  r = [],
                  i = P(t.replace(ot, "$1"));
                return i[N]
                  ? n(function (t, e, r, n) {
                      for (var o, a = i(t, null, n, []), c = t.length; c--; )
                        (o = a[c]) && (t[c] = !(e[c] = o));
                    })
                  : function (t, n, o) {
                      return (
                        (e[0] = t), i(e, null, o, r), (e[0] = null), !r.pop()
                      );
                    };
              }),
              has: n(function (t) {
                return function (r) {
                  return e(t, r).length > 0;
                };
              }),
              contains: n(function (t) {
                return (
                  (t = t.replace(bt, vt)),
                  function (e) {
                    return (
                      (e.textContent || e.innerText || w(e)).indexOf(t) > -1
                    );
                  }
                );
              }),
              lang: n(function (t) {
                return (
                  lt.test(t || "") || e.error("unsupported lang: " + t),
                  (t = t.replace(bt, vt).toLowerCase()),
                  function (e) {
                    var r;
                    do {
                      if (
                        (r = j
                          ? e.lang
                          : e.getAttribute("xml:lang") ||
                            e.getAttribute("lang"))
                      )
                        return (
                          (r = r.toLowerCase()) === t ||
                          0 === r.indexOf(t + "-")
                        );
                    } while ((e = e.parentNode) && 1 === e.nodeType);
                    return !1;
                  }
                );
              }),
              target: function (e) {
                var r = t.location && t.location.hash;
                return r && r.slice(1) === e.id;
              },
              root: function (t) {
                return t === E;
              },
              focus: function (t) {
                return (
                  t === F.activeElement &&
                  (!F.hasFocus || F.hasFocus()) &&
                  !!(t.type || t.href || ~t.tabIndex)
                );
              },
              enabled: function (t) {
                return !1 === t.disabled;
              },
              disabled: function (t) {
                return !0 === t.disabled;
              },
              checked: function (t) {
                var e = t.nodeName.toLowerCase();
                return (
                  ("input" === e && !!t.checked) ||
                  ("option" === e && !!t.selected)
                );
              },
              selected: function (t) {
                return (
                  t.parentNode && t.parentNode.selectedIndex, !0 === t.selected
                );
              },
              empty: function (t) {
                for (t = t.firstChild; t; t = t.nextSibling)
                  if (t.nodeType < 6) return !1;
                return !0;
              },
              parent: function (t) {
                return !_.pseudos.empty(t);
              },
              header: function (t) {
                return ht.test(t.nodeName);
              },
              input: function (t) {
                return ft.test(t.nodeName);
              },
              button: function (t) {
                var e = t.nodeName.toLowerCase();
                return ("input" === e && "button" === t.type) || "button" === e;
              },
              text: function (t) {
                var e;
                return (
                  "input" === t.nodeName.toLowerCase() &&
                  "text" === t.type &&
                  (null == (e = t.getAttribute("type")) ||
                    "text" === e.toLowerCase())
                );
              },
              first: c(function () {
                return [0];
              }),
              last: c(function (t, e) {
                return [e - 1];
              }),
              eq: c(function (t, e, r) {
                return [r < 0 ? r + e : r];
              }),
              even: c(function (t, e) {
                for (var r = 0; r < e; r += 2) t.push(r);
                return t;
              }),
              odd: c(function (t, e) {
                for (var r = 1; r < e; r += 2) t.push(r);
                return t;
              }),
              lt: c(function (t, e, r) {
                for (var n = r < 0 ? r + e : r; --n >= 0; ) t.push(n);
                return t;
              }),
              gt: c(function (t, e, r) {
                for (var n = r < 0 ? r + e : r; ++n < e; ) t.push(n);
                return t;
              }),
            },
          }),
        (_.pseudos.nth = _.pseudos.eq);
      for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        _.pseudos[b] = (function (t) {
          return function (e) {
            return "input" === e.nodeName.toLowerCase() && e.type === t;
          };
        })(b);
      for (b in { submit: !0, reset: !0 })
        _.pseudos[b] = (function (t) {
          return function (e) {
            var r = e.nodeName.toLowerCase();
            return ("input" === r || "button" === r) && e.type === t;
          };
        })(b);
      return (
        (u.prototype = _.filters = _.pseudos),
        (_.setFilters = new u()),
        (x = e.tokenize =
          function (t, r) {
            var n,
              i,
              o,
              a,
              c,
              s,
              u,
              l = $[t + " "];
            if (l) return r ? 0 : l.slice(0);
            for (c = t, s = [], u = _.preFilter; c; ) {
              (n && !(i = at.exec(c))) ||
                (i && (c = c.slice(i[0].length) || c), s.push((o = []))),
                (n = !1),
                (i = ct.exec(c)) &&
                  ((n = i.shift()),
                  o.push({ value: n, type: i[0].replace(ot, " ") }),
                  (c = c.slice(n.length)));
              for (a in _.filter)
                !(i = dt[a].exec(c)) ||
                  (u[a] && !(i = u[a](i))) ||
                  ((n = i.shift()),
                  o.push({ value: n, type: a, matches: i }),
                  (c = c.slice(n.length)));
              if (!n) break;
            }
            return r ? c.length : c ? e.error(t) : $(t, s).slice(0);
          }),
        (P = e.compile =
          function (t, e) {
            var r,
              n = [],
              i = [],
              o = V[t + " "];
            if (!o) {
              for (e || (e = x(t)), r = e.length; r--; )
                (o = g(e[r])), o[N] ? n.push(o) : i.push(o);
              (o = V(t, y(i, n))), (o.selector = t);
            }
            return o;
          }),
        (A = e.select =
          function (t, e, r, n) {
            var i,
              o,
              a,
              c,
              u,
              d = "function" == typeof t && t,
              f = !n && x((t = d.selector || t));
            if (((r = r || []), 1 === f.length)) {
              if (
                ((o = f[0] = f[0].slice(0)),
                o.length > 2 &&
                  "ID" === (a = o[0]).type &&
                  v.getById &&
                  9 === e.nodeType &&
                  j &&
                  _.relative[o[1].type])
              ) {
                if (
                  !(e = (_.find.ID(a.matches[0].replace(bt, vt), e) || [])[0])
                )
                  return r;
                d && (e = e.parentNode), (t = t.slice(o.shift().value.length));
              }
              for (
                i = dt.needsContext.test(t) ? 0 : o.length;
                i-- && ((a = o[i]), !_.relative[(c = a.type)]);

              )
                if (
                  (u = _.find[c]) &&
                  (n = u(
                    a.matches[0].replace(bt, vt),
                    (gt.test(o[0].type) && s(e.parentNode)) || e
                  ))
                ) {
                  if ((o.splice(i, 1), !(t = n.length && l(o))))
                    return Q.apply(r, n), r;
                  break;
                }
            }
            return (
              (d || P(t, f))(
                n,
                e,
                !j,
                r,
                !e || (gt.test(t) && s(e.parentNode)) || e
              ),
              r
            );
          }),
        (v.sortStable = N.split("").sort(W).join("") === N),
        (v.detectDuplicates = !!T),
        D(),
        (v.sortDetached = i(function (t) {
          return 1 & t.compareDocumentPosition(F.createElement("div"));
        })),
        i(function (t) {
          return (
            (t.innerHTML = "<a href='#'></a>"),
            "#" === t.firstChild.getAttribute("href")
          );
        }) ||
          o("type|href|height|width", function (t, e, r) {
            if (!r)
              return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2);
          }),
        (v.attributes &&
          i(function (t) {
            return (
              (t.innerHTML = "<input/>"),
              t.firstChild.setAttribute("value", ""),
              "" === t.firstChild.getAttribute("value")
            );
          })) ||
          o("value", function (t, e, r) {
            if (!r && "input" === t.nodeName.toLowerCase())
              return t.defaultValue;
          }),
        i(function (t) {
          return null == t.getAttribute("disabled");
        }) ||
          o(Z, function (t, e, r) {
            var n;
            if (!r)
              return !0 === t[e]
                ? e.toLowerCase()
                : (n = t.getAttributeNode(e)) && n.specified
                ? n.value
                : null;
          }),
        e
      );
    })(t);
    (ft.find = yt),
      (ft.expr = yt.selectors),
      (ft.expr[":"] = ft.expr.pseudos),
      (ft.uniqueSort = ft.unique = yt.uniqueSort),
      (ft.text = yt.getText),
      (ft.isXMLDoc = yt.isXML),
      (ft.contains = yt.contains);
    var bt = function (t, e, r) {
        for (var n = [], i = void 0 !== r; (t = t[e]) && 9 !== t.nodeType; )
          if (1 === t.nodeType) {
            if (i && ft(t).is(r)) break;
            n.push(t);
          }
        return n;
      },
      vt = function (t, e) {
        for (var r = []; t; t = t.nextSibling)
          1 === t.nodeType && t !== e && r.push(t);
        return r;
      },
      _t = ft.expr.match.needsContext,
      wt = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
      Ct = /^.[^:#\[\.,]*$/;
    (ft.filter = function (t, e, r) {
      var n = e[0];
      return (
        r && (t = ":not(" + t + ")"),
        1 === e.length && 1 === n.nodeType
          ? ft.find.matchesSelector(n, t)
            ? [n]
            : []
          : ft.find.matches(
              t,
              ft.grep(e, function (t) {
                return 1 === t.nodeType;
              })
            )
      );
    }),
      ft.fn.extend({
        find: function (t) {
          var e,
            r = [],
            n = this,
            i = n.length;
          if ("string" != typeof t)
            return this.pushStack(
              ft(t).filter(function () {
                for (e = 0; e < i; e++) if (ft.contains(n[e], this)) return !0;
              })
            );
          for (e = 0; e < i; e++) ft.find(t, n[e], r);
          return (
            (r = this.pushStack(i > 1 ? ft.unique(r) : r)),
            (r.selector = this.selector ? this.selector + " " + t : t),
            r
          );
        },
        filter: function (t) {
          return this.pushStack(n(this, t || [], !1));
        },
        not: function (t) {
          return this.pushStack(n(this, t || [], !0));
        },
        is: function (t) {
          return !!n(
            this,
            "string" == typeof t && _t.test(t) ? ft(t) : t || [],
            !1
          ).length;
        },
      });
    var xt,
      Pt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    ((ft.fn.init = function (t, e, r) {
      var n, i;
      if (!t) return this;
      if (((r = r || xt), "string" == typeof t)) {
        if (
          !(n =
            "<" === t.charAt(0) &&
            ">" === t.charAt(t.length - 1) &&
            t.length >= 3
              ? [null, t, null]
              : Pt.exec(t)) ||
          (!n[1] && e)
        )
          return !e || e.jquery
            ? (e || r).find(t)
            : this.constructor(e).find(t);
        if (n[1]) {
          if (
            ((e = e instanceof ft ? e[0] : e),
            ft.merge(
              this,
              ft.parseHTML(
                n[1],
                e && e.nodeType ? e.ownerDocument || e : nt,
                !0
              )
            ),
            wt.test(n[1]) && ft.isPlainObject(e))
          )
            for (n in e)
              ft.isFunction(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
          return this;
        }
        if ((i = nt.getElementById(n[2])) && i.parentNode) {
          if (i.id !== n[2]) return xt.find(t);
          (this.length = 1), (this[0] = i);
        }
        return (this.context = nt), (this.selector = t), this;
      }
      return t.nodeType
        ? ((this.context = this[0] = t), (this.length = 1), this)
        : ft.isFunction(t)
        ? void 0 !== r.ready
          ? r.ready(t)
          : t(ft)
        : (void 0 !== t.selector &&
            ((this.selector = t.selector), (this.context = t.context)),
          ft.makeArray(t, this));
    }).prototype = ft.fn),
      (xt = ft(nt));
    var At = /^(?:parents|prev(?:Until|All))/,
      kt = { children: !0, contents: !0, next: !0, prev: !0 };
    ft.fn.extend({
      has: function (t) {
        var e,
          r = ft(t, this),
          n = r.length;
        return this.filter(function () {
          for (e = 0; e < n; e++) if (ft.contains(this, r[e])) return !0;
        });
      },
      closest: function (t, e) {
        for (
          var r,
            n = 0,
            i = this.length,
            o = [],
            a =
              _t.test(t) || "string" != typeof t ? ft(t, e || this.context) : 0;
          n < i;
          n++
        )
          for (r = this[n]; r && r !== e; r = r.parentNode)
            if (
              r.nodeType < 11 &&
              (a
                ? a.index(r) > -1
                : 1 === r.nodeType && ft.find.matchesSelector(r, t))
            ) {
              o.push(r);
              break;
            }
        return this.pushStack(o.length > 1 ? ft.uniqueSort(o) : o);
      },
      index: function (t) {
        return t
          ? "string" == typeof t
            ? ft.inArray(this[0], ft(t))
            : ft.inArray(t.jquery ? t[0] : t, this)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (t, e) {
        return this.pushStack(ft.uniqueSort(ft.merge(this.get(), ft(t, e))));
      },
      addBack: function (t) {
        return this.add(
          null == t ? this.prevObject : this.prevObject.filter(t)
        );
      },
    }),
      ft.each(
        {
          parent: function (t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null;
          },
          parents: function (t) {
            return bt(t, "parentNode");
          },
          parentsUntil: function (t, e, r) {
            return bt(t, "parentNode", r);
          },
          next: function (t) {
            return i(t, "nextSibling");
          },
          prev: function (t) {
            return i(t, "previousSibling");
          },
          nextAll: function (t) {
            return bt(t, "nextSibling");
          },
          prevAll: function (t) {
            return bt(t, "previousSibling");
          },
          nextUntil: function (t, e, r) {
            return bt(t, "nextSibling", r);
          },
          prevUntil: function (t, e, r) {
            return bt(t, "previousSibling", r);
          },
          siblings: function (t) {
            return vt((t.parentNode || {}).firstChild, t);
          },
          children: function (t) {
            return vt(t.firstChild);
          },
          contents: function (t) {
            return ft.nodeName(t, "iframe")
              ? t.contentDocument || t.contentWindow.document
              : ft.merge([], t.childNodes);
          },
        },
        function (t, e) {
          ft.fn[t] = function (r, n) {
            var i = ft.map(this, e, r);
            return (
              "Until" !== t.slice(-5) && (n = r),
              n && "string" == typeof n && (i = ft.filter(n, i)),
              this.length > 1 &&
                (kt[t] || (i = ft.uniqueSort(i)),
                At.test(t) && (i = i.reverse())),
              this.pushStack(i)
            );
          };
        }
      );
    var St = /\S+/g;
    (ft.Callbacks = function (t) {
      t = "string" == typeof t ? o(t) : ft.extend({}, t);
      var e,
        r,
        n,
        i,
        a = [],
        c = [],
        s = -1,
        u = function () {
          for (i = t.once, n = e = !0; c.length; s = -1)
            for (r = c.shift(); ++s < a.length; )
              !1 === a[s].apply(r[0], r[1]) &&
                t.stopOnFalse &&
                ((s = a.length), (r = !1));
          t.memory || (r = !1), (e = !1), i && (a = r ? [] : "");
        },
        l = {
          add: function () {
            return (
              a &&
                (r && !e && ((s = a.length - 1), c.push(r)),
                (function e(r) {
                  ft.each(r, function (r, n) {
                    ft.isFunction(n)
                      ? (t.unique && l.has(n)) || a.push(n)
                      : n && n.length && "string" !== ft.type(n) && e(n);
                  });
                })(arguments),
                r && !e && u()),
              this
            );
          },
          remove: function () {
            return (
              ft.each(arguments, function (t, e) {
                for (var r; (r = ft.inArray(e, a, r)) > -1; )
                  a.splice(r, 1), r <= s && s--;
              }),
              this
            );
          },
          has: function (t) {
            return t ? ft.inArray(t, a) > -1 : a.length > 0;
          },
          empty: function () {
            return a && (a = []), this;
          },
          disable: function () {
            return (i = c = []), (a = r = ""), this;
          },
          disabled: function () {
            return !a;
          },
          lock: function () {
            return (i = !0), r || l.disable(), this;
          },
          locked: function () {
            return !!i;
          },
          fireWith: function (t, r) {
            return (
              i ||
                ((r = r || []),
                (r = [t, r.slice ? r.slice() : r]),
                c.push(r),
                e || u()),
              this
            );
          },
          fire: function () {
            return l.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!n;
          },
        };
      return l;
    }),
      ft.extend({
        Deferred: function (t) {
          var e = [
              ["resolve", "done", ft.Callbacks("once memory"), "resolved"],
              ["reject", "fail", ft.Callbacks("once memory"), "rejected"],
              ["notify", "progress", ft.Callbacks("memory")],
            ],
            r = "pending",
            n = {
              state: function () {
                return r;
              },
              always: function () {
                return i.done(arguments).fail(arguments), this;
              },
              then: function () {
                var t = arguments;
                return ft
                  .Deferred(function (r) {
                    ft.each(e, function (e, o) {
                      var a = ft.isFunction(t[e]) && t[e];
                      i[o[1]](function () {
                        var t = a && a.apply(this, arguments);
                        t && ft.isFunction(t.promise)
                          ? t
                              .promise()
                              .progress(r.notify)
                              .done(r.resolve)
                              .fail(r.reject)
                          : r[o[0] + "With"](
                              this === n ? r.promise() : this,
                              a ? [t] : arguments
                            );
                      });
                    }),
                      (t = null);
                  })
                  .promise();
              },
              promise: function (t) {
                return null != t ? ft.extend(t, n) : n;
              },
            },
            i = {};
          return (
            (n.pipe = n.then),
            ft.each(e, function (t, o) {
              var a = o[2],
                c = o[3];
              (n[o[1]] = a.add),
                c &&
                  a.add(
                    function () {
                      r = c;
                    },
                    e[1 ^ t][2].disable,
                    e[2][2].lock
                  ),
                (i[o[0]] = function () {
                  return (
                    i[o[0] + "With"](this === i ? n : this, arguments), this
                  );
                }),
                (i[o[0] + "With"] = a.fireWith);
            }),
            n.promise(i),
            t && t.call(i, i),
            i
          );
        },
        when: function (t) {
          var e,
            r,
            n,
            i = 0,
            o = it.call(arguments),
            a = o.length,
            c = 1 !== a || (t && ft.isFunction(t.promise)) ? a : 0,
            s = 1 === c ? t : ft.Deferred(),
            u = function (t, r, n) {
              return function (i) {
                (r[t] = this),
                  (n[t] = arguments.length > 1 ? it.call(arguments) : i),
                  n === e ? s.notifyWith(r, n) : --c || s.resolveWith(r, n);
              };
            };
          if (a > 1)
            for (
              e = new Array(a), r = new Array(a), n = new Array(a);
              i < a;
              i++
            )
              o[i] && ft.isFunction(o[i].promise)
                ? o[i]
                    .promise()
                    .progress(u(i, r, e))
                    .done(u(i, n, o))
                    .fail(s.reject)
                : --c;
          return c || s.resolveWith(n, o), s.promise();
        },
      });
    var Tt;
    (ft.fn.ready = function (t) {
      return ft.ready.promise().done(t), this;
    }),
      ft.extend({
        isReady: !1,
        readyWait: 1,
        holdReady: function (t) {
          t ? ft.readyWait++ : ft.ready(!0);
        },
        ready: function (t) {
          (!0 === t ? --ft.readyWait : ft.isReady) ||
            ((ft.isReady = !0),
            (!0 !== t && --ft.readyWait > 0) ||
              (Tt.resolveWith(nt, [ft]),
              ft.fn.triggerHandler &&
                (ft(nt).triggerHandler("ready"), ft(nt).off("ready"))));
        },
      }),
      (ft.ready.promise = function (e) {
        if (!Tt)
          if (
            ((Tt = ft.Deferred()),
            "complete" === nt.readyState ||
              ("loading" !== nt.readyState && !nt.documentElement.doScroll))
          )
            t.setTimeout(ft.ready);
          else if (nt.addEventListener)
            nt.addEventListener("DOMContentLoaded", c),
              t.addEventListener("load", c);
          else {
            nt.attachEvent("onreadystatechange", c), t.attachEvent("onload", c);
            var r = !1;
            try {
              r = null == t.frameElement && nt.documentElement;
            } catch (t) {}
            r &&
              r.doScroll &&
              (function e() {
                if (!ft.isReady) {
                  try {
                    r.doScroll("left");
                  } catch (r) {
                    return t.setTimeout(e, 50);
                  }
                  a(), ft.ready();
                }
              })();
          }
        return Tt.promise(e);
      }),
      ft.ready.promise();
    var Dt;
    for (Dt in ft(dt)) break;
    (dt.ownFirst = "0" === Dt),
      (dt.inlineBlockNeedsLayout = !1),
      ft(function () {
        var t, e, r, n;
        (r = nt.getElementsByTagName("body")[0]) &&
          r.style &&
          ((e = nt.createElement("div")),
          (n = nt.createElement("div")),
          (n.style.cssText =
            "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
          r.appendChild(n).appendChild(e),
          void 0 !== e.style.zoom &&
            ((e.style.cssText =
              "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1"),
            (dt.inlineBlockNeedsLayout = t = 3 === e.offsetWidth),
            t && (r.style.zoom = 1)),
          r.removeChild(n));
      }),
      (function () {
        var t = nt.createElement("div");
        dt.deleteExpando = !0;
        try {
          delete t.test;
        } catch (t) {
          dt.deleteExpando = !1;
        }
        t = null;
      })();
    var Ft = function (t) {
        var e = ft.noData[(t.nodeName + " ").toLowerCase()],
          r = +t.nodeType || 1;
        return (
          (1 === r || 9 === r) &&
          (!e || (!0 !== e && t.getAttribute("classid") === e))
        );
      },
      Et = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      jt = /([A-Z])/g;
    ft.extend({
      cache: {},
      noData: {
        "applet ": !0,
        "embed ": !0,
        "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
      },
      hasData: function (t) {
        return (
          !!(t = t.nodeType ? ft.cache[t[ft.expando]] : t[ft.expando]) && !u(t)
        );
      },
      data: function (t, e, r) {
        return l(t, e, r);
      },
      removeData: function (t, e) {
        return d(t, e);
      },
      _data: function (t, e, r) {
        return l(t, e, r, !0);
      },
      _removeData: function (t, e) {
        return d(t, e, !0);
      },
    }),
      ft.fn.extend({
        data: function (t, e) {
          var r,
            n,
            i,
            o = this[0],
            a = o && o.attributes;
          if (void 0 === t) {
            if (
              this.length &&
              ((i = ft.data(o)),
              1 === o.nodeType && !ft._data(o, "parsedAttrs"))
            ) {
              for (r = a.length; r--; )
                a[r] &&
                  ((n = a[r].name),
                  0 === n.indexOf("data-") &&
                    ((n = ft.camelCase(n.slice(5))), s(o, n, i[n])));
              ft._data(o, "parsedAttrs", !0);
            }
            return i;
          }
          return "object" == typeof t
            ? this.each(function () {
                ft.data(this, t);
              })
            : arguments.length > 1
            ? this.each(function () {
                ft.data(this, t, e);
              })
            : o
            ? s(o, t, ft.data(o, t))
            : void 0;
        },
        removeData: function (t) {
          return this.each(function () {
            ft.removeData(this, t);
          });
        },
      }),
      ft.extend({
        queue: function (t, e, r) {
          var n;
          if (t)
            return (
              (e = (e || "fx") + "queue"),
              (n = ft._data(t, e)),
              r &&
                (!n || ft.isArray(r)
                  ? (n = ft._data(t, e, ft.makeArray(r)))
                  : n.push(r)),
              n || []
            );
        },
        dequeue: function (t, e) {
          e = e || "fx";
          var r = ft.queue(t, e),
            n = r.length,
            i = r.shift(),
            o = ft._queueHooks(t, e),
            a = function () {
              ft.dequeue(t, e);
            };
          "inprogress" === i && ((i = r.shift()), n--),
            i &&
              ("fx" === e && r.unshift("inprogress"),
              delete o.stop,
              i.call(t, a, o)),
            !n && o && o.empty.fire();
        },
        _queueHooks: function (t, e) {
          var r = e + "queueHooks";
          return (
            ft._data(t, r) ||
            ft._data(t, r, {
              empty: ft.Callbacks("once memory").add(function () {
                ft._removeData(t, e + "queue"), ft._removeData(t, r);
              }),
            })
          );
        },
      }),
      ft.fn.extend({
        queue: function (t, e) {
          var r = 2;
          return (
            "string" != typeof t && ((e = t), (t = "fx"), r--),
            arguments.length < r
              ? ft.queue(this[0], t)
              : void 0 === e
              ? this
              : this.each(function () {
                  var r = ft.queue(this, t, e);
                  ft._queueHooks(this, t),
                    "fx" === t && "inprogress" !== r[0] && ft.dequeue(this, t);
                })
          );
        },
        dequeue: function (t) {
          return this.each(function () {
            ft.dequeue(this, t);
          });
        },
        clearQueue: function (t) {
          return this.queue(t || "fx", []);
        },
        promise: function (t, e) {
          var r,
            n = 1,
            i = ft.Deferred(),
            o = this,
            a = this.length,
            c = function () {
              --n || i.resolveWith(o, [o]);
            };
          for (
            "string" != typeof t && ((e = t), (t = void 0)), t = t || "fx";
            a--;

          )
            (r = ft._data(o[a], t + "queueHooks")) &&
              r.empty &&
              (n++, r.empty.add(c));
          return c(), i.promise(e);
        },
      }),
      (function () {
        var t;
        dt.shrinkWrapBlocks = function () {
          if (null != t) return t;
          t = !1;
          var e, r, n;
          return (r = nt.getElementsByTagName("body")[0]) && r.style
            ? ((e = nt.createElement("div")),
              (n = nt.createElement("div")),
              (n.style.cssText =
                "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
              r.appendChild(n).appendChild(e),
              void 0 !== e.style.zoom &&
                ((e.style.cssText =
                  "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1"),
                (e.appendChild(nt.createElement("div")).style.width = "5px"),
                (t = 3 !== e.offsetWidth)),
              r.removeChild(n),
              t)
            : void 0;
        };
      })();
    var It = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Rt = new RegExp("^(?:([+-])=|)(" + It + ")([a-z%]*)$", "i"),
      Mt = ["Top", "Right", "Bottom", "Left"],
      qt = function (t, e) {
        return (
          (t = e || t),
          "none" === ft.css(t, "display") || !ft.contains(t.ownerDocument, t)
        );
      },
      Nt = function (t, e, r, n, i, o, a) {
        var c = 0,
          s = t.length,
          u = null == r;
        if ("object" === ft.type(r)) {
          i = !0;
          for (c in r) Nt(t, e, c, r[c], !0, o, a);
        } else if (
          void 0 !== n &&
          ((i = !0),
          ft.isFunction(n) || (a = !0),
          u &&
            (a
              ? (e.call(t, n), (e = null))
              : ((u = e),
                (e = function (t, e, r) {
                  return u.call(ft(t), r);
                }))),
          e)
        )
          for (; c < s; c++) e(t[c], r, a ? n : n.call(t[c], c, e(t[c], r)));
        return i ? t : u ? e.call(t) : s ? e(t[0], r) : o;
      },
      Ot = /^(?:checkbox|radio)$/i,
      Bt = /<([\w:-]+)/,
      Ut = /^$|\/(?:java|ecma)script/i,
      Lt = /^\s+/,
      $t =
        "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
    !(function () {
      var t = nt.createElement("div"),
        e = nt.createDocumentFragment(),
        r = nt.createElement("input");
      (t.innerHTML =
        "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
        (dt.leadingWhitespace = 3 === t.firstChild.nodeType),
        (dt.tbody = !t.getElementsByTagName("tbody").length),
        (dt.htmlSerialize = !!t.getElementsByTagName("link").length),
        (dt.html5Clone =
          "<:nav></:nav>" !== nt.createElement("nav").cloneNode(!0).outerHTML),
        (r.type = "checkbox"),
        (r.checked = !0),
        e.appendChild(r),
        (dt.appendChecked = r.checked),
        (t.innerHTML = "<textarea>x</textarea>"),
        (dt.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue),
        e.appendChild(t),
        (r = nt.createElement("input")),
        r.setAttribute("type", "radio"),
        r.setAttribute("checked", "checked"),
        r.setAttribute("name", "t"),
        t.appendChild(r),
        (dt.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (dt.noCloneEvent = !!t.addEventListener),
        (t[ft.expando] = 1),
        (dt.attributes = !t.getAttribute(ft.expando));
    })();
    var Vt = {
      option: [1, "<select multiple='multiple'>", "</select>"],
      legend: [1, "<fieldset>", "</fieldset>"],
      area: [1, "<map>", "</map>"],
      param: [1, "<object>", "</object>"],
      thead: [1, "<table>", "</table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: dt.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"],
    };
    (Vt.optgroup = Vt.option),
      (Vt.tbody = Vt.tfoot = Vt.colgroup = Vt.caption = Vt.thead),
      (Vt.th = Vt.td);
    var Wt = /<|&#?\w+;/,
      Ht = /<tbody/i;
    !(function () {
      var e,
        r,
        n = nt.createElement("div");
      for (e in { submit: !0, change: !0, focusin: !0 })
        (r = "on" + e),
          (dt[e] = r in t) ||
            (n.setAttribute(r, "t"), (dt[e] = !1 === n.attributes[r].expando));
      n = null;
    })();
    var Gt = /^(?:input|select|textarea)$/i,
      zt = /^key/,
      Jt = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Kt = /^(?:focusinfocus|focusoutblur)$/,
      Qt = /^([^.]*)(?:\.(.+)|)/;
    (ft.event = {
      global: {},
      add: function (t, e, r, n, i) {
        var o,
          a,
          c,
          s,
          u,
          l,
          d,
          f,
          h,
          p,
          m,
          g = ft._data(t);
        if (g) {
          for (
            r.handler && ((s = r), (r = s.handler), (i = s.selector)),
              r.guid || (r.guid = ft.guid++),
              (a = g.events) || (a = g.events = {}),
              (l = g.handle) ||
                ((l = g.handle =
                  function (t) {
                    return void 0 === ft || (t && ft.event.triggered === t.type)
                      ? void 0
                      : ft.event.dispatch.apply(l.elem, arguments);
                  }),
                (l.elem = t)),
              e = (e || "").match(St) || [""],
              c = e.length;
            c--;

          )
            (o = Qt.exec(e[c]) || []),
              (h = m = o[1]),
              (p = (o[2] || "").split(".").sort()),
              h &&
                ((u = ft.event.special[h] || {}),
                (h = (i ? u.delegateType : u.bindType) || h),
                (u = ft.event.special[h] || {}),
                (d = ft.extend(
                  {
                    type: h,
                    origType: m,
                    data: n,
                    handler: r,
                    guid: r.guid,
                    selector: i,
                    needsContext: i && ft.expr.match.needsContext.test(i),
                    namespace: p.join("."),
                  },
                  s
                )),
                (f = a[h]) ||
                  ((f = a[h] = []),
                  (f.delegateCount = 0),
                  (u.setup && !1 !== u.setup.call(t, n, p, l)) ||
                    (t.addEventListener
                      ? t.addEventListener(h, l, !1)
                      : t.attachEvent && t.attachEvent("on" + h, l))),
                u.add &&
                  (u.add.call(t, d),
                  d.handler.guid || (d.handler.guid = r.guid)),
                i ? f.splice(f.delegateCount++, 0, d) : f.push(d),
                (ft.event.global[h] = !0));
          t = null;
        }
      },
      remove: function (t, e, r, n, i) {
        var o,
          a,
          c,
          s,
          u,
          l,
          d,
          f,
          h,
          p,
          m,
          g = ft.hasData(t) && ft._data(t);
        if (g && (l = g.events)) {
          for (e = (e || "").match(St) || [""], u = e.length; u--; )
            if (
              ((c = Qt.exec(e[u]) || []),
              (h = m = c[1]),
              (p = (c[2] || "").split(".").sort()),
              h)
            ) {
              for (
                d = ft.event.special[h] || {},
                  h = (n ? d.delegateType : d.bindType) || h,
                  f = l[h] || [],
                  c =
                    c[2] &&
                    new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  s = o = f.length;
                o--;

              )
                (a = f[o]),
                  (!i && m !== a.origType) ||
                    (r && r.guid !== a.guid) ||
                    (c && !c.test(a.namespace)) ||
                    (n && n !== a.selector && ("**" !== n || !a.selector)) ||
                    (f.splice(o, 1),
                    a.selector && f.delegateCount--,
                    d.remove && d.remove.call(t, a));
              s &&
                !f.length &&
                ((d.teardown && !1 !== d.teardown.call(t, p, g.handle)) ||
                  ft.removeEvent(t, h, g.handle),
                delete l[h]);
            } else for (h in l) ft.event.remove(t, h + e[u], r, n, !0);
          ft.isEmptyObject(l) && (delete g.handle, ft._removeData(t, "events"));
        }
      },
      trigger: function (e, r, n, i) {
        var o,
          a,
          c,
          s,
          u,
          l,
          d,
          f = [n || nt],
          h = lt.call(e, "type") ? e.type : e,
          p = lt.call(e, "namespace") ? e.namespace.split(".") : [];
        if (
          ((c = l = n = n || nt),
          3 !== n.nodeType &&
            8 !== n.nodeType &&
            !Kt.test(h + ft.event.triggered) &&
            (h.indexOf(".") > -1 &&
              ((p = h.split(".")), (h = p.shift()), p.sort()),
            (a = h.indexOf(":") < 0 && "on" + h),
            (e = e[ft.expando]
              ? e
              : new ft.Event(h, "object" == typeof e && e)),
            (e.isTrigger = i ? 2 : 3),
            (e.namespace = p.join(".")),
            (e.rnamespace = e.namespace
              ? new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (e.result = void 0),
            e.target || (e.target = n),
            (r = null == r ? [e] : ft.makeArray(r, [e])),
            (u = ft.event.special[h] || {}),
            i || !u.trigger || !1 !== u.trigger.apply(n, r)))
        ) {
          if (!i && !u.noBubble && !ft.isWindow(n)) {
            for (
              s = u.delegateType || h, Kt.test(s + h) || (c = c.parentNode);
              c;
              c = c.parentNode
            )
              f.push(c), (l = c);
            l === (n.ownerDocument || nt) &&
              f.push(l.defaultView || l.parentWindow || t);
          }
          for (d = 0; (c = f[d++]) && !e.isPropagationStopped(); )
            (e.type = d > 1 ? s : u.bindType || h),
              (o =
                (ft._data(c, "events") || {})[e.type] && ft._data(c, "handle")),
              o && o.apply(c, r),
              (o = a && c[a]) &&
                o.apply &&
                Ft(c) &&
                ((e.result = o.apply(c, r)),
                !1 === e.result && e.preventDefault());
          if (
            ((e.type = h),
            !i &&
              !e.isDefaultPrevented() &&
              (!u._default || !1 === u._default.apply(f.pop(), r)) &&
              Ft(n) &&
              a &&
              n[h] &&
              !ft.isWindow(n))
          ) {
            (l = n[a]), l && (n[a] = null), (ft.event.triggered = h);
            try {
              n[h]();
            } catch (t) {}
            (ft.event.triggered = void 0), l && (n[a] = l);
          }
          return e.result;
        }
      },
      dispatch: function (t) {
        t = ft.event.fix(t);
        var e,
          r,
          n,
          i,
          o,
          a = [],
          c = it.call(arguments),
          s = (ft._data(this, "events") || {})[t.type] || [],
          u = ft.event.special[t.type] || {};
        if (
          ((c[0] = t),
          (t.delegateTarget = this),
          !u.preDispatch || !1 !== u.preDispatch.call(this, t))
        ) {
          for (
            a = ft.event.handlers.call(this, t, s), e = 0;
            (i = a[e++]) && !t.isPropagationStopped();

          )
            for (
              t.currentTarget = i.elem, r = 0;
              (o = i.handlers[r++]) && !t.isImmediatePropagationStopped();

            )
              (t.rnamespace && !t.rnamespace.test(o.namespace)) ||
                ((t.handleObj = o),
                (t.data = o.data),
                void 0 !==
                  (n = (
                    (ft.event.special[o.origType] || {}).handle || o.handler
                  ).apply(i.elem, c)) &&
                  !1 === (t.result = n) &&
                  (t.preventDefault(), t.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, t), t.result;
        }
      },
      handlers: function (t, e) {
        var r,
          n,
          i,
          o,
          a = [],
          c = e.delegateCount,
          s = t.target;
        if (
          c &&
          s.nodeType &&
          ("click" !== t.type || isNaN(t.button) || t.button < 1)
        )
          for (; s != this; s = s.parentNode || this)
            if (1 === s.nodeType && (!0 !== s.disabled || "click" !== t.type)) {
              for (n = [], r = 0; r < c; r++)
                (o = e[r]),
                  (i = o.selector + " "),
                  void 0 === n[i] &&
                    (n[i] = o.needsContext
                      ? ft(i, this).index(s) > -1
                      : ft.find(i, this, null, [s]).length),
                  n[i] && n.push(o);
              n.length && a.push({ elem: s, handlers: n });
            }
        return c < e.length && a.push({ elem: this, handlers: e.slice(c) }), a;
      },
      fix: function (t) {
        if (t[ft.expando]) return t;
        var e,
          r,
          n,
          i = t.type,
          o = t,
          a = this.fixHooks[i];
        for (
          a ||
            (this.fixHooks[i] = a =
              Jt.test(i) ? this.mouseHooks : zt.test(i) ? this.keyHooks : {}),
            n = a.props ? this.props.concat(a.props) : this.props,
            t = new ft.Event(o),
            e = n.length;
          e--;

        )
          (r = n[e]), (t[r] = o[r]);
        return (
          t.target || (t.target = o.srcElement || nt),
          3 === t.target.nodeType && (t.target = t.target.parentNode),
          (t.metaKey = !!t.metaKey),
          a.filter ? a.filter(t, o) : t
        );
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (t, e) {
          return (
            null == t.which &&
              (t.which = null != e.charCode ? e.charCode : e.keyCode),
            t
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (t, e) {
          var r,
            n,
            i,
            o = e.button,
            a = e.fromElement;
          return (
            null == t.pageX &&
              null != e.clientX &&
              ((n = t.target.ownerDocument || nt),
              (i = n.documentElement),
              (r = n.body),
              (t.pageX =
                e.clientX +
                ((i && i.scrollLeft) || (r && r.scrollLeft) || 0) -
                ((i && i.clientLeft) || (r && r.clientLeft) || 0)),
              (t.pageY =
                e.clientY +
                ((i && i.scrollTop) || (r && r.scrollTop) || 0) -
                ((i && i.clientTop) || (r && r.clientTop) || 0))),
            !t.relatedTarget &&
              a &&
              (t.relatedTarget = a === t.target ? e.toElement : a),
            t.which ||
              void 0 === o ||
              (t.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0),
            t
          );
        },
      },
      special: {
        load: { noBubble: !0 },
        focus: {
          trigger: function () {
            if (this !== _() && this.focus)
              try {
                return this.focus(), !1;
              } catch (t) {}
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            if (this === _() && this.blur) return this.blur(), !1;
          },
          delegateType: "focusout",
        },
        click: {
          trigger: function () {
            if (
              ft.nodeName(this, "input") &&
              "checkbox" === this.type &&
              this.click
            )
              return this.click(), !1;
          },
          _default: function (t) {
            return ft.nodeName(t.target, "a");
          },
        },
        beforeunload: {
          postDispatch: function (t) {
            void 0 !== t.result &&
              t.originalEvent &&
              (t.originalEvent.returnValue = t.result);
          },
        },
      },
      simulate: function (t, e, r) {
        var n = ft.extend(new ft.Event(), r, { type: t, isSimulated: !0 });
        ft.event.trigger(n, null, e),
          n.isDefaultPrevented() && r.preventDefault();
      },
    }),
      (ft.removeEvent = nt.removeEventListener
        ? function (t, e, r) {
            t.removeEventListener && t.removeEventListener(e, r);
          }
        : function (t, e, r) {
            var n = "on" + e;
            t.detachEvent &&
              (void 0 === t[n] && (t[n] = null), t.detachEvent(n, r));
          }),
      (ft.Event = function (t, e) {
        if (!(this instanceof ft.Event)) return new ft.Event(t, e);
        t && t.type
          ? ((this.originalEvent = t),
            (this.type = t.type),
            (this.isDefaultPrevented =
              t.defaultPrevented ||
              (void 0 === t.defaultPrevented && !1 === t.returnValue)
                ? b
                : v))
          : (this.type = t),
          e && ft.extend(this, e),
          (this.timeStamp = (t && t.timeStamp) || ft.now()),
          (this[ft.expando] = !0);
      }),
      (ft.Event.prototype = {
        constructor: ft.Event,
        isDefaultPrevented: v,
        isPropagationStopped: v,
        isImmediatePropagationStopped: v,
        preventDefault: function () {
          var t = this.originalEvent;
          (this.isDefaultPrevented = b),
            t && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1));
        },
        stopPropagation: function () {
          var t = this.originalEvent;
          (this.isPropagationStopped = b),
            t &&
              !this.isSimulated &&
              (t.stopPropagation && t.stopPropagation(), (t.cancelBubble = !0));
        },
        stopImmediatePropagation: function () {
          var t = this.originalEvent;
          (this.isImmediatePropagationStopped = b),
            t && t.stopImmediatePropagation && t.stopImmediatePropagation(),
            this.stopPropagation();
        },
      }),
      ft.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
          pointerenter: "pointerover",
          pointerleave: "pointerout",
        },
        function (t, e) {
          ft.event.special[t] = {
            delegateType: e,
            bindType: e,
            handle: function (t) {
              var r,
                n = this,
                i = t.relatedTarget,
                o = t.handleObj;
              return (
                (i && (i === n || ft.contains(n, i))) ||
                  ((t.type = o.origType),
                  (r = o.handler.apply(this, arguments)),
                  (t.type = e)),
                r
              );
            },
          };
        }
      ),
      dt.submit ||
        (ft.event.special.submit = {
          setup: function () {
            if (ft.nodeName(this, "form")) return !1;
            ft.event.add(this, "click._submit keypress._submit", function (t) {
              var e = t.target,
                r =
                  ft.nodeName(e, "input") || ft.nodeName(e, "button")
                    ? ft.prop(e, "form")
                    : void 0;
              r &&
                !ft._data(r, "submit") &&
                (ft.event.add(r, "submit._submit", function (t) {
                  t._submitBubble = !0;
                }),
                ft._data(r, "submit", !0));
            });
          },
          postDispatch: function (t) {
            t._submitBubble &&
              (delete t._submitBubble,
              this.parentNode &&
                !t.isTrigger &&
                ft.event.simulate("submit", this.parentNode, t));
          },
          teardown: function () {
            if (ft.nodeName(this, "form")) return !1;
            ft.event.remove(this, "._submit");
          },
        }),
      dt.change ||
        (ft.event.special.change = {
          setup: function () {
            if (Gt.test(this.nodeName))
              return (
                ("checkbox" !== this.type && "radio" !== this.type) ||
                  (ft.event.add(this, "propertychange._change", function (t) {
                    "checked" === t.originalEvent.propertyName &&
                      (this._justChanged = !0);
                  }),
                  ft.event.add(this, "click._change", function (t) {
                    this._justChanged &&
                      !t.isTrigger &&
                      (this._justChanged = !1),
                      ft.event.simulate("change", this, t);
                  })),
                !1
              );
            ft.event.add(this, "beforeactivate._change", function (t) {
              var e = t.target;
              Gt.test(e.nodeName) &&
                !ft._data(e, "change") &&
                (ft.event.add(e, "change._change", function (t) {
                  !this.parentNode ||
                    t.isSimulated ||
                    t.isTrigger ||
                    ft.event.simulate("change", this.parentNode, t);
                }),
                ft._data(e, "change", !0));
            });
          },
          handle: function (t) {
            var e = t.target;
            if (
              this !== e ||
              t.isSimulated ||
              t.isTrigger ||
              ("radio" !== e.type && "checkbox" !== e.type)
            )
              return t.handleObj.handler.apply(this, arguments);
          },
          teardown: function () {
            return ft.event.remove(this, "._change"), !Gt.test(this.nodeName);
          },
        }),
      dt.focusin ||
        ft.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
          var r = function (t) {
            ft.event.simulate(e, t.target, ft.event.fix(t));
          };
          ft.event.special[e] = {
            setup: function () {
              var n = this.ownerDocument || this,
                i = ft._data(n, e);
              i || n.addEventListener(t, r, !0), ft._data(n, e, (i || 0) + 1);
            },
            teardown: function () {
              var n = this.ownerDocument || this,
                i = ft._data(n, e) - 1;
              i
                ? ft._data(n, e, i)
                : (n.removeEventListener(t, r, !0), ft._removeData(n, e));
            },
          };
        }),
      ft.fn.extend({
        on: function (t, e, r, n) {
          return w(this, t, e, r, n);
        },
        one: function (t, e, r, n) {
          return w(this, t, e, r, n, 1);
        },
        off: function (t, e, r) {
          var n, i;
          if (t && t.preventDefault && t.handleObj)
            return (
              (n = t.handleObj),
              ft(t.delegateTarget).off(
                n.namespace ? n.origType + "." + n.namespace : n.origType,
                n.selector,
                n.handler
              ),
              this
            );
          if ("object" == typeof t) {
            for (i in t) this.off(i, e, t[i]);
            return this;
          }
          return (
            (!1 !== e && "function" != typeof e) || ((r = e), (e = void 0)),
            !1 === r && (r = v),
            this.each(function () {
              ft.event.remove(this, t, r, e);
            })
          );
        },
        trigger: function (t, e) {
          return this.each(function () {
            ft.event.trigger(t, e, this);
          });
        },
        triggerHandler: function (t, e) {
          var r = this[0];
          if (r) return ft.event.trigger(t, e, r, !0);
        },
      });
    var Yt = / cbbJQuery\d+="(?:null|\d+)"/g,
      Xt = new RegExp("<(?:" + $t + ")[\\s/>]", "i"),
      Zt =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
      te = /<script|<style|<link/i,
      ee = /checked\s*(?:[^=]|=\s*.checked.)/i,
      re = /^true\/(.*)/,
      ne = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
      ie = h(nt),
      oe = ie.appendChild(nt.createElement("div"));
    ft.extend({
      htmlPrefilter: function (t) {
        return t.replace(Zt, "<$1></$2>");
      },
      clone: function (t, e, r) {
        var n,
          i,
          o,
          a,
          c,
          s = ft.contains(t.ownerDocument, t);
        if (
          (dt.html5Clone || ft.isXMLDoc(t) || !Xt.test("<" + t.nodeName + ">")
            ? (o = t.cloneNode(!0))
            : ((oe.innerHTML = t.outerHTML),
              oe.removeChild((o = oe.firstChild))),
          !(
            (dt.noCloneEvent && dt.noCloneChecked) ||
            (1 !== t.nodeType && 11 !== t.nodeType) ||
            ft.isXMLDoc(t)
          ))
        )
          for (n = p(o), c = p(t), a = 0; null != (i = c[a]); ++a)
            n[a] && k(i, n[a]);
        if (e)
          if (r)
            for (c = c || p(t), n = n || p(o), a = 0; null != (i = c[a]); a++)
              A(i, n[a]);
          else A(t, o);
        return (
          (n = p(o, "script")),
          n.length > 0 && m(n, !s && p(t, "script")),
          (n = c = i = null),
          o
        );
      },
      cleanData: function (t, e) {
        for (
          var r,
            n,
            i,
            o,
            a = 0,
            c = ft.expando,
            s = ft.cache,
            u = dt.attributes,
            l = ft.event.special;
          null != (r = t[a]);
          a++
        )
          if ((e || Ft(r)) && ((i = r[c]), (o = i && s[i]))) {
            if (o.events)
              for (n in o.events)
                l[n] ? ft.event.remove(r, n) : ft.removeEvent(r, n, o.handle);
            s[i] &&
              (delete s[i],
              u || void 0 === r.removeAttribute
                ? (r[c] = void 0)
                : r.removeAttribute(c),
              rt.push(i));
          }
      },
    }),
      ft.fn.extend({
        domManip: S,
        detach: function (t) {
          return T(this, t, !0);
        },
        remove: function (t) {
          return T(this, t);
        },
        text: function (t) {
          return Nt(
            this,
            function (t) {
              return void 0 === t
                ? ft.text(this)
                : this.empty().append(
                    ((this[0] && this[0].ownerDocument) || nt).createTextNode(t)
                  );
            },
            null,
            t,
            arguments.length
          );
        },
        append: function () {
          return S(this, arguments, function (t) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              C(this, t).appendChild(t);
            }
          });
        },
        prepend: function () {
          return S(this, arguments, function (t) {
            if (
              1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType
            ) {
              var e = C(this, t);
              e.insertBefore(t, e.firstChild);
            }
          });
        },
        before: function () {
          return S(this, arguments, function (t) {
            this.parentNode && this.parentNode.insertBefore(t, this);
          });
        },
        after: function () {
          return S(this, arguments, function (t) {
            this.parentNode &&
              this.parentNode.insertBefore(t, this.nextSibling);
          });
        },
        empty: function () {
          for (var t, e = 0; null != (t = this[e]); e++) {
            for (1 === t.nodeType && ft.cleanData(p(t, !1)); t.firstChild; )
              t.removeChild(t.firstChild);
            t.options && ft.nodeName(t, "select") && (t.options.length = 0);
          }
          return this;
        },
        clone: function (t, e) {
          return (
            (t = null != t && t),
            (e = null == e ? t : e),
            this.map(function () {
              return ft.clone(this, t, e);
            })
          );
        },
        html: function (t) {
          return Nt(
            this,
            function (t) {
              var e = this[0] || {},
                r = 0,
                n = this.length;
              if (void 0 === t)
                return 1 === e.nodeType ? e.innerHTML.replace(Yt, "") : void 0;
              if (
                "string" == typeof t &&
                !te.test(t) &&
                (dt.htmlSerialize || !Xt.test(t)) &&
                (dt.leadingWhitespace || !Lt.test(t)) &&
                !Vt[(Bt.exec(t) || ["", ""])[1].toLowerCase()]
              ) {
                t = ft.htmlPrefilter(t);
                try {
                  for (; r < n; r++)
                    (e = this[r] || {}),
                      1 === e.nodeType &&
                        (ft.cleanData(p(e, !1)), (e.innerHTML = t));
                  e = 0;
                } catch (t) {}
              }
              e && this.empty().append(t);
            },
            null,
            t,
            arguments.length
          );
        },
        replaceWith: function () {
          var t = [];
          return S(
            this,
            arguments,
            function (e) {
              var r = this.parentNode;
              ft.inArray(this, t) < 0 &&
                (ft.cleanData(p(this)), r && r.replaceChild(e, this));
            },
            t
          );
        },
      }),
      ft.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (t, e) {
          ft.fn[t] = function (t) {
            for (var r, n = 0, i = [], o = ft(t), a = o.length - 1; n <= a; n++)
              (r = n === a ? this : this.clone(!0)),
                ft(o[n])[e](r),
                at.apply(i, r.get());
            return this.pushStack(i);
          };
        }
      );
    var ae,
      ce = { HTML: "block", BODY: "block" },
      se = /^margin/,
      ue = new RegExp("^(" + It + ")(?!px)[a-z%]+$", "i"),
      le = function (t, e, r, n) {
        var i,
          o,
          a = {};
        for (o in e) (a[o] = t.style[o]), (t.style[o] = e[o]);
        i = r.apply(t, n || []);
        for (o in e) t.style[o] = a[o];
        return i;
      },
      de = nt.documentElement;
    !(function () {
      function e() {
        var e,
          l,
          d = nt.documentElement;
        d.appendChild(s),
          (u.style.cssText =
            "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (r = i = c = !1),
          (n = a = !0),
          t.getComputedStyle &&
            ((l = t.getComputedStyle(u)),
            (r = "1%" !== (l || {}).top),
            (c = "2px" === (l || {}).marginLeft),
            (i = "4px" === (l || { width: "4px" }).width),
            (u.style.marginRight = "50%"),
            (n = "4px" === (l || { marginRight: "4px" }).marginRight),
            (e = u.appendChild(nt.createElement("div"))),
            (e.style.cssText = u.style.cssText =
              "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
            (e.style.marginRight = e.style.width = "0"),
            (u.style.width = "1px"),
            (a = !parseFloat((t.getComputedStyle(e) || {}).marginRight)),
            u.removeChild(e)),
          (u.style.display = "none"),
          (o = 0 === u.getClientRects().length),
          o &&
            ((u.style.display = ""),
            (u.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
            (u.childNodes[0].style.borderCollapse = "separate"),
            (e = u.getElementsByTagName("td")),
            (e[0].style.cssText = "margin:0;border:0;padding:0;display:none"),
            (o = 0 === e[0].offsetHeight) &&
              ((e[0].style.display = ""),
              (e[1].style.display = "none"),
              (o = 0 === e[0].offsetHeight))),
          d.removeChild(s);
      }
      var r,
        n,
        i,
        o,
        a,
        c,
        s = nt.createElement("div"),
        u = nt.createElement("div");
      u.style &&
        ((u.style.cssText = "float:left;opacity:.5"),
        (dt.opacity = "0.5" === u.style.opacity),
        (dt.cssFloat = !!u.style.cssFloat),
        (u.style.backgroundClip = "content-box"),
        (u.cloneNode(!0).style.backgroundClip = ""),
        (dt.clearCloneStyle = "content-box" === u.style.backgroundClip),
        (s = nt.createElement("div")),
        (s.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        (u.innerHTML = ""),
        s.appendChild(u),
        (dt.boxSizing =
          "" === u.style.boxSizing ||
          "" === u.style.MozBoxSizing ||
          "" === u.style.WebkitBoxSizing),
        ft.extend(dt, {
          reliableHiddenOffsets: function () {
            return null == r && e(), o;
          },
          boxSizingReliable: function () {
            return null == r && e(), i;
          },
          pixelMarginRight: function () {
            return null == r && e(), n;
          },
          pixelPosition: function () {
            return null == r && e(), r;
          },
          reliableMarginRight: function () {
            return null == r && e(), a;
          },
          reliableMarginLeft: function () {
            return null == r && e(), c;
          },
        }));
    })();
    var fe,
      he,
      pe = /^(top|right|bottom|left)$/;
    t.getComputedStyle
      ? ((fe = function (e) {
          var r = e.ownerDocument.defaultView;
          return (r && r.opener) || (r = t), r.getComputedStyle(e);
        }),
        (he = function (t, e, r) {
          var n,
            i,
            o,
            a,
            c = t.style;
          return (
            (r = r || fe(t)),
            (a = r ? r.getPropertyValue(e) || r[e] : void 0),
            ("" !== a && void 0 !== a) ||
              ft.contains(t.ownerDocument, t) ||
              (a = ft.style(t, e)),
            r &&
              !dt.pixelMarginRight() &&
              ue.test(a) &&
              se.test(e) &&
              ((n = c.width),
              (i = c.minWidth),
              (o = c.maxWidth),
              (c.minWidth = c.maxWidth = c.width = a),
              (a = r.width),
              (c.width = n),
              (c.minWidth = i),
              (c.maxWidth = o)),
            void 0 === a ? a : a + ""
          );
        }))
      : de.currentStyle &&
        ((fe = function (t) {
          return t.currentStyle;
        }),
        (he = function (t, e, r) {
          var n,
            i,
            o,
            a,
            c = t.style;
          return (
            (r = r || fe(t)),
            (a = r ? r[e] : void 0),
            null == a && c && c[e] && (a = c[e]),
            ue.test(a) &&
              !pe.test(e) &&
              ((n = c.left),
              (i = t.runtimeStyle),
              (o = i && i.left),
              o && (i.left = t.currentStyle.left),
              (c.left = "fontSize" === e ? "1em" : a),
              (a = c.pixelLeft + "px"),
              (c.left = n),
              o && (i.left = o)),
            void 0 === a ? a : a + "" || "auto"
          );
        }));
    var me = /alpha\([^)]*\)/i,
      ge = /opacity\s*=\s*([^)]*)/i,
      ye = /^(none|table(?!-c[ea]).+)/,
      be = new RegExp("^(" + It + ")(.*)$", "i"),
      ve = { position: "absolute", visibility: "hidden", display: "block" },
      _e = { letterSpacing: "0", fontWeight: "400" },
      we = ["Webkit", "O", "Moz", "ms"],
      Ce = nt.createElement("div").style;
    ft.extend({
      cssHooks: {
        opacity: {
          get: function (t, e) {
            if (e) {
              var r = he(t, "opacity");
              return "" === r ? "1" : r;
            }
          },
        },
      },
      cssNumber: {
        animationIterationCount: !0,
        columnCount: !0,
        fillOpacity: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
      },
      cssProps: { float: dt.cssFloat ? "cssFloat" : "styleFloat" },
      style: function (t, e, r, n) {
        if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
          var i,
            o,
            a,
            c = ft.camelCase(e),
            s = t.style;
          if (
            ((e = ft.cssProps[c] || (ft.cssProps[c] = j(c) || c)),
            (a = ft.cssHooks[e] || ft.cssHooks[c]),
            void 0 === r)
          )
            return a && "get" in a && void 0 !== (i = a.get(t, !1, n))
              ? i
              : s[e];
          if (
            ((o = typeof r),
            "string" === o &&
              (i = Rt.exec(r)) &&
              i[1] &&
              ((r = f(t, e, i)), (o = "number")),
            null != r &&
              r === r &&
              ("number" === o &&
                (r += (i && i[3]) || (ft.cssNumber[c] ? "" : "px")),
              dt.clearCloneStyle ||
                "" !== r ||
                0 !== e.indexOf("background") ||
                (s[e] = "inherit"),
              !(a && "set" in a && void 0 === (r = a.set(t, r, n)))))
          )
            try {
              s[e] = r;
            } catch (t) {}
        }
      },
      css: function (t, e, r, n) {
        var i,
          o,
          a,
          c = ft.camelCase(e);
        return (
          (e = ft.cssProps[c] || (ft.cssProps[c] = j(c) || c)),
          (a = ft.cssHooks[e] || ft.cssHooks[c]),
          a && "get" in a && (o = a.get(t, !0, r)),
          void 0 === o && (o = he(t, e, n)),
          "normal" === o && e in _e && (o = _e[e]),
          "" === r || r
            ? ((i = parseFloat(o)), !0 === r || isFinite(i) ? i || 0 : o)
            : o
        );
      },
    }),
      ft.each(["height", "width"], function (t, e) {
        ft.cssHooks[e] = {
          get: function (t, r, n) {
            if (r)
              return ye.test(ft.css(t, "display")) && 0 === t.offsetWidth
                ? le(t, ve, function () {
                    return q(t, e, n);
                  })
                : q(t, e, n);
          },
          set: function (t, r, n) {
            var i = n && fe(t);
            return R(
              t,
              r,
              n
                ? M(
                    t,
                    e,
                    n,
                    dt.boxSizing &&
                      "border-box" === ft.css(t, "boxSizing", !1, i),
                    i
                  )
                : 0
            );
          },
        };
      }),
      dt.opacity ||
        (ft.cssHooks.opacity = {
          get: function (t, e) {
            return ge.test(
              (e && t.currentStyle ? t.currentStyle.filter : t.style.filter) ||
                ""
            )
              ? 0.01 * parseFloat(RegExp.$1) + ""
              : e
              ? "1"
              : "";
          },
          set: function (t, e) {
            var r = t.style,
              n = t.currentStyle,
              i = ft.isNumeric(e) ? "alpha(opacity=" + 100 * e + ")" : "",
              o = (n && n.filter) || r.filter || "";
            (r.zoom = 1),
              ((e >= 1 || "" === e) &&
                "" === ft.trim(o.replace(me, "")) &&
                r.removeAttribute &&
                (r.removeAttribute("filter"), "" === e || (n && !n.filter))) ||
                (r.filter = me.test(o) ? o.replace(me, i) : o + " " + i);
          },
        }),
      (ft.cssHooks.marginRight = E(dt.reliableMarginRight, function (t, e) {
        if (e)
          return le(t, { display: "inline-block" }, he, [t, "marginRight"]);
      })),
      (ft.cssHooks.marginLeft = E(dt.reliableMarginLeft, function (t, e) {
        if (e)
          return (
            (parseFloat(he(t, "marginLeft")) ||
              (ft.contains(t.ownerDocument, t)
                ? t.getBoundingClientRect().left -
                  le(t, { marginLeft: 0 }, function () {
                    return t.getBoundingClientRect().left;
                  })
                : 0)) + "px"
          );
      })),
      ft.each({ margin: "", padding: "", border: "Width" }, function (t, e) {
        (ft.cssHooks[t + e] = {
          expand: function (r) {
            for (
              var n = 0, i = {}, o = "string" == typeof r ? r.split(" ") : [r];
              n < 4;
              n++
            )
              i[t + Mt[n] + e] = o[n] || o[n - 2] || o[0];
            return i;
          },
        }),
          se.test(t) || (ft.cssHooks[t + e].set = R);
      }),
      ft.fn.extend({
        css: function (t, e) {
          return Nt(
            this,
            function (t, e, r) {
              var n,
                i,
                o = {},
                a = 0;
              if (ft.isArray(e)) {
                for (n = fe(t), i = e.length; a < i; a++)
                  o[e[a]] = ft.css(t, e[a], !1, n);
                return o;
              }
              return void 0 !== r ? ft.style(t, e, r) : ft.css(t, e);
            },
            t,
            e,
            arguments.length > 1
          );
        },
        show: function () {
          return I(this, !0);
        },
        hide: function () {
          return I(this);
        },
        toggle: function (t) {
          return "boolean" == typeof t
            ? t
              ? this.show()
              : this.hide()
            : this.each(function () {
                qt(this) ? ft(this).show() : ft(this).hide();
              });
        },
      }),
      (ft.Tween = N),
      (N.prototype = {
        constructor: N,
        init: function (t, e, r, n, i, o) {
          (this.elem = t),
            (this.prop = r),
            (this.easing = i || ft.easing._default),
            (this.options = e),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = o || (ft.cssNumber[r] ? "" : "px"));
        },
        cur: function () {
          var t = N.propHooks[this.prop];
          return t && t.get ? t.get(this) : N.propHooks._default.get(this);
        },
        run: function (t) {
          var e,
            r = N.propHooks[this.prop];
          return (
            this.options.duration
              ? (this.pos = e =
                  ft.easing[this.easing](
                    t,
                    this.options.duration * t,
                    0,
                    1,
                    this.options.duration
                  ))
              : (this.pos = e = t),
            (this.now = (this.end - this.start) * e + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            r && r.set ? r.set(this) : N.propHooks._default.set(this),
            this
          );
        },
      }),
      (N.prototype.init.prototype = N.prototype),
      (N.propHooks = {
        _default: {
          get: function (t) {
            var e;
            return 1 !== t.elem.nodeType ||
              (null != t.elem[t.prop] && null == t.elem.style[t.prop])
              ? t.elem[t.prop]
              : ((e = ft.css(t.elem, t.prop, "")), e && "auto" !== e ? e : 0);
          },
          set: function (t) {
            ft.fx.step[t.prop]
              ? ft.fx.step[t.prop](t)
              : 1 !== t.elem.nodeType ||
                (null == t.elem.style[ft.cssProps[t.prop]] &&
                  !ft.cssHooks[t.prop])
              ? (t.elem[t.prop] = t.now)
              : ft.style(t.elem, t.prop, t.now + t.unit);
          },
        },
      }),
      (N.propHooks.scrollTop = N.propHooks.scrollLeft =
        {
          set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
          },
        }),
      (ft.easing = {
        linear: function (t) {
          return t;
        },
        swing: function (t) {
          return 0.5 - Math.cos(t * Math.PI) / 2;
        },
        _default: "swing",
      }),
      (ft.fx = N.prototype.init),
      (ft.fx.step = {});
    var xe,
      Pe,
      Ae = /^(?:toggle|show|hide)$/,
      ke = /queueHooks$/;
    (ft.Animation = ft.extend(V, {
      tweeners: {
        "*": [
          function (t, e) {
            var r = this.createTween(t, e);
            return f(r.elem, t, Rt.exec(e), r), r;
          },
        ],
      },
      tweener: function (t, e) {
        ft.isFunction(t) ? ((e = t), (t = ["*"])) : (t = t.match(St));
        for (var r, n = 0, i = t.length; n < i; n++)
          (r = t[n]),
            (V.tweeners[r] = V.tweeners[r] || []),
            V.tweeners[r].unshift(e);
      },
      prefilters: [L],
      prefilter: function (t, e) {
        e ? V.prefilters.unshift(t) : V.prefilters.push(t);
      },
    })),
      (ft.speed = function (t, e, r) {
        var n =
          t && "object" == typeof t
            ? ft.extend({}, t)
            : {
                complete: r || (!r && e) || (ft.isFunction(t) && t),
                duration: t,
                easing: (r && e) || (e && !ft.isFunction(e) && e),
              };
        return (
          (n.duration = ft.fx.off
            ? 0
            : "number" == typeof n.duration
            ? n.duration
            : n.duration in ft.fx.speeds
            ? ft.fx.speeds[n.duration]
            : ft.fx.speeds._default),
          (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            ft.isFunction(n.old) && n.old.call(this),
              n.queue && ft.dequeue(this, n.queue);
          }),
          n
        );
      }),
      ft.fn.extend({
        fadeTo: function (t, e, r, n) {
          return this.filter(qt)
            .css("opacity", 0)
            .show()
            .end()
            .animate({ opacity: e }, t, r, n);
        },
        animate: function (t, e, r, n) {
          var i = ft.isEmptyObject(t),
            o = ft.speed(e, r, n),
            a = function () {
              var e = V(this, ft.extend({}, t), o);
              (i || ft._data(this, "finish")) && e.stop(!0);
            };
          return (
            (a.finish = a),
            i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
          );
        },
        stop: function (t, e, r) {
          var n = function (t) {
            var e = t.stop;
            delete t.stop, e(r);
          };
          return (
            "string" != typeof t && ((r = e), (e = t), (t = void 0)),
            e && !1 !== t && this.queue(t || "fx", []),
            this.each(function () {
              var e = !0,
                i = null != t && t + "queueHooks",
                o = ft.timers,
                a = ft._data(this);
              if (i) a[i] && a[i].stop && n(a[i]);
              else for (i in a) a[i] && a[i].stop && ke.test(i) && n(a[i]);
              for (i = o.length; i--; )
                o[i].elem !== this ||
                  (null != t && o[i].queue !== t) ||
                  (o[i].anim.stop(r), (e = !1), o.splice(i, 1));
              (!e && r) || ft.dequeue(this, t);
            })
          );
        },
        finish: function (t) {
          return (
            !1 !== t && (t = t || "fx"),
            this.each(function () {
              var e,
                r = ft._data(this),
                n = r[t + "queue"],
                i = r[t + "queueHooks"],
                o = ft.timers,
                a = n ? n.length : 0;
              for (
                r.finish = !0,
                  ft.queue(this, t, []),
                  i && i.stop && i.stop.call(this, !0),
                  e = o.length;
                e--;

              )
                o[e].elem === this &&
                  o[e].queue === t &&
                  (o[e].anim.stop(!0), o.splice(e, 1));
              for (e = 0; e < a; e++)
                n[e] && n[e].finish && n[e].finish.call(this);
              delete r.finish;
            })
          );
        },
      }),
      ft.each(["toggle", "show", "hide"], function (t, e) {
        var r = ft.fn[e];
        ft.fn[e] = function (t, n, i) {
          return null == t || "boolean" == typeof t
            ? r.apply(this, arguments)
            : this.animate(B(e, !0), t, n, i);
        };
      }),
      ft.each(
        {
          slideDown: B("show"),
          slideUp: B("hide"),
          slideToggle: B("toggle"),
          fadeIn: { opacity: "show" },
          fadeOut: { opacity: "hide" },
          fadeToggle: { opacity: "toggle" },
        },
        function (t, e) {
          ft.fn[t] = function (t, r, n) {
            return this.animate(e, t, r, n);
          };
        }
      ),
      (ft.timers = []),
      (ft.fx.tick = function () {
        var t,
          e = ft.timers,
          r = 0;
        for (xe = ft.now(); r < e.length; r++)
          (t = e[r])() || e[r] !== t || e.splice(r--, 1);
        e.length || ft.fx.stop(), (xe = void 0);
      }),
      (ft.fx.timer = function (t) {
        ft.timers.push(t), t() ? ft.fx.start() : ft.timers.pop();
      }),
      (ft.fx.interval = 13),
      (ft.fx.start = function () {
        Pe || (Pe = t.setInterval(ft.fx.tick, ft.fx.interval));
      }),
      (ft.fx.stop = function () {
        t.clearInterval(Pe), (Pe = null);
      }),
      (ft.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
      (ft.fn.delay = function (e, r) {
        return (
          (e = ft.fx ? ft.fx.speeds[e] || e : e),
          (r = r || "fx"),
          this.queue(r, function (r, n) {
            var i = t.setTimeout(r, e);
            n.stop = function () {
              t.clearTimeout(i);
            };
          })
        );
      }),
      (function () {
        var t,
          e = nt.createElement("input"),
          r = nt.createElement("div"),
          n = nt.createElement("select"),
          i = n.appendChild(nt.createElement("option"));
        (r = nt.createElement("div")),
          r.setAttribute("className", "t"),
          (r.innerHTML =
            "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
          (t = r.getElementsByTagName("a")[0]),
          e.setAttribute("type", "checkbox"),
          r.appendChild(e),
          (t = r.getElementsByTagName("a")[0]),
          (t.style.cssText = "top:1px"),
          (dt.getSetAttribute = "t" !== r.className),
          (dt.style = /top/.test(t.getAttribute("style"))),
          (dt.hrefNormalized = "/a" === t.getAttribute("href")),
          (dt.checkOn = !!e.value),
          (dt.optSelected = i.selected),
          (dt.enctype = !!nt.createElement("form").enctype),
          (n.disabled = !0),
          (dt.optDisabled = !i.disabled),
          (e = nt.createElement("input")),
          e.setAttribute("value", ""),
          (dt.input = "" === e.getAttribute("value")),
          (e.value = "t"),
          e.setAttribute("type", "radio"),
          (dt.radioValue = "t" === e.value);
      })();
    var Se = /\r/g,
      Te = /[\x20\t\r\n\f]+/g;
    ft.fn.extend({
      val: function (t) {
        var e,
          r,
          n,
          i = this[0];
        {
          if (arguments.length)
            return (
              (n = ft.isFunction(t)),
              this.each(function (r) {
                var i;
                1 === this.nodeType &&
                  ((i = n ? t.call(this, r, ft(this).val()) : t),
                  null == i
                    ? (i = "")
                    : "number" == typeof i
                    ? (i += "")
                    : ft.isArray(i) &&
                      (i = ft.map(i, function (t) {
                        return null == t ? "" : t + "";
                      })),
                  ((e =
                    ft.valHooks[this.type] ||
                    ft.valHooks[this.nodeName.toLowerCase()]) &&
                    "set" in e &&
                    void 0 !== e.set(this, i, "value")) ||
                    (this.value = i));
              })
            );
          if (i)
            return (e =
              ft.valHooks[i.type] || ft.valHooks[i.nodeName.toLowerCase()]) &&
              "get" in e &&
              void 0 !== (r = e.get(i, "value"))
              ? r
              : ((r = i.value),
                "string" == typeof r ? r.replace(Se, "") : null == r ? "" : r);
        }
      },
    }),
      ft.extend({
        valHooks: {
          option: {
            get: function (t) {
              var e = ft.find.attr(t, "value");
              return null != e ? e : ft.trim(ft.text(t)).replace(Te, " ");
            },
          },
          select: {
            get: function (t) {
              for (
                var e,
                  r,
                  n = t.options,
                  i = t.selectedIndex,
                  o = "select-one" === t.type || i < 0,
                  a = o ? null : [],
                  c = o ? i + 1 : n.length,
                  s = i < 0 ? c : o ? i : 0;
                s < c;
                s++
              )
                if (
                  ((r = n[s]),
                  (r.selected || s === i) &&
                    (dt.optDisabled
                      ? !r.disabled
                      : null === r.getAttribute("disabled")) &&
                    (!r.parentNode.disabled ||
                      !ft.nodeName(r.parentNode, "optgroup")))
                ) {
                  if (((e = ft(r).val()), o)) return e;
                  a.push(e);
                }
              return a;
            },
            set: function (t, e) {
              for (
                var r, n, i = t.options, o = ft.makeArray(e), a = i.length;
                a--;

              )
                if (((n = i[a]), ft.inArray(ft.valHooks.option.get(n), o) > -1))
                  try {
                    n.selected = r = !0;
                  } catch (t) {
                    n.scrollHeight;
                  }
                else n.selected = !1;
              return r || (t.selectedIndex = -1), i;
            },
          },
        },
      }),
      ft.each(["radio", "checkbox"], function () {
        (ft.valHooks[this] = {
          set: function (t, e) {
            if (ft.isArray(e))
              return (t.checked = ft.inArray(ft(t).val(), e) > -1);
          },
        }),
          dt.checkOn ||
            (ft.valHooks[this].get = function (t) {
              return null === t.getAttribute("value") ? "on" : t.value;
            });
      });
    var De,
      Fe,
      Ee = ft.expr.attrHandle,
      je = /^(?:checked|selected)$/i,
      Ie = dt.getSetAttribute,
      Re = dt.input;
    ft.fn.extend({
      attr: function (t, e) {
        return Nt(this, ft.attr, t, e, arguments.length > 1);
      },
      removeAttr: function (t) {
        return this.each(function () {
          ft.removeAttr(this, t);
        });
      },
    }),
      ft.extend({
        attr: function (t, e, r) {
          var n,
            i,
            o = t.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return void 0 === t.getAttribute
              ? ft.prop(t, e, r)
              : ((1 === o && ft.isXMLDoc(t)) ||
                  ((e = e.toLowerCase()),
                  (i =
                    ft.attrHooks[e] || (ft.expr.match.bool.test(e) ? Fe : De))),
                void 0 !== r
                  ? null === r
                    ? void ft.removeAttr(t, e)
                    : i && "set" in i && void 0 !== (n = i.set(t, r, e))
                    ? n
                    : (t.setAttribute(e, r + ""), r)
                  : i && "get" in i && null !== (n = i.get(t, e))
                  ? n
                  : ((n = ft.find.attr(t, e)), null == n ? void 0 : n));
        },
        attrHooks: {
          type: {
            set: function (t, e) {
              if (!dt.radioValue && "radio" === e && ft.nodeName(t, "input")) {
                var r = t.value;
                return t.setAttribute("type", e), r && (t.value = r), e;
              }
            },
          },
        },
        removeAttr: function (t, e) {
          var r,
            n,
            i = 0,
            o = e && e.match(St);
          if (o && 1 === t.nodeType)
            for (; (r = o[i++]); )
              (n = ft.propFix[r] || r),
                ft.expr.match.bool.test(r)
                  ? (Re && Ie) || !je.test(r)
                    ? (t[n] = !1)
                    : (t[ft.camelCase("default-" + r)] = t[n] = !1)
                  : ft.attr(t, r, ""),
                t.removeAttribute(Ie ? r : n);
        },
      }),
      (Fe = {
        set: function (t, e, r) {
          return (
            !1 === e
              ? ft.removeAttr(t, r)
              : (Re && Ie) || !je.test(r)
              ? t.setAttribute((!Ie && ft.propFix[r]) || r, r)
              : (t[ft.camelCase("default-" + r)] = t[r] = !0),
            r
          );
        },
      }),
      ft.each(ft.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var r = Ee[e] || ft.find.attr;
        (Re && Ie) || !je.test(e)
          ? (Ee[e] = function (t, e, n) {
              var i, o;
              return (
                n ||
                  ((o = Ee[e]),
                  (Ee[e] = i),
                  (i = null != r(t, e, n) ? e.toLowerCase() : null),
                  (Ee[e] = o)),
                i
              );
            })
          : (Ee[e] = function (t, e, r) {
              if (!r)
                return t[ft.camelCase("default-" + e)] ? e.toLowerCase() : null;
            });
      }),
      (Re && Ie) ||
        (ft.attrHooks.value = {
          set: function (t, e, r) {
            if (!ft.nodeName(t, "input")) return De && De.set(t, e, r);
            t.defaultValue = e;
          },
        }),
      Ie ||
        ((De = {
          set: function (t, e, r) {
            var n = t.getAttributeNode(r);
            if (
              (n ||
                t.setAttributeNode((n = t.ownerDocument.createAttribute(r))),
              (n.value = e += ""),
              "value" === r || e === t.getAttribute(r))
            )
              return e;
          },
        }),
        (Ee.id =
          Ee.name =
          Ee.coords =
            function (t, e, r) {
              var n;
              if (!r)
                return (n = t.getAttributeNode(e)) && "" !== n.value
                  ? n.value
                  : null;
            }),
        (ft.valHooks.button = {
          get: function (t, e) {
            var r = t.getAttributeNode(e);
            if (r && r.specified) return r.value;
          },
          set: De.set,
        }),
        (ft.attrHooks.contenteditable = {
          set: function (t, e, r) {
            De.set(t, "" !== e && e, r);
          },
        }),
        ft.each(["width", "height"], function (t, e) {
          ft.attrHooks[e] = {
            set: function (t, r) {
              if ("" === r) return t.setAttribute(e, "auto"), r;
            },
          };
        })),
      dt.style ||
        (ft.attrHooks.style = {
          get: function (t) {
            return t.style.cssText || void 0;
          },
          set: function (t, e) {
            return (t.style.cssText = e + "");
          },
        });
    var Me = /^(?:input|select|textarea|button|object)$/i,
      qe = /^(?:a|area)$/i;
    ft.fn.extend({
      prop: function (t, e) {
        return Nt(this, ft.prop, t, e, arguments.length > 1);
      },
      removeProp: function (t) {
        return (
          (t = ft.propFix[t] || t),
          this.each(function () {
            try {
              (this[t] = void 0), delete this[t];
            } catch (t) {}
          })
        );
      },
    }),
      ft.extend({
        prop: function (t, e, r) {
          var n,
            i,
            o = t.nodeType;
          if (3 !== o && 8 !== o && 2 !== o)
            return (
              (1 === o && ft.isXMLDoc(t)) ||
                ((e = ft.propFix[e] || e), (i = ft.propHooks[e])),
              void 0 !== r
                ? i && "set" in i && void 0 !== (n = i.set(t, r, e))
                  ? n
                  : (t[e] = r)
                : i && "get" in i && null !== (n = i.get(t, e))
                ? n
                : t[e]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (t) {
              var e = ft.find.attr(t, "tabindex");
              return e
                ? parseInt(e, 10)
                : Me.test(t.nodeName) || (qe.test(t.nodeName) && t.href)
                ? 0
                : -1;
            },
          },
        },
        propFix: { for: "htmlFor", class: "className" },
      }),
      dt.hrefNormalized ||
        ft.each(["href", "src"], function (t, e) {
          ft.propHooks[e] = {
            get: function (t) {
              return t.getAttribute(e, 4);
            },
          };
        }),
      dt.optSelected ||
        (ft.propHooks.selected = {
          get: function (t) {
            var e = t.parentNode;
            return (
              e &&
                (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex),
              null
            );
          },
          set: function (t) {
            var e = t.parentNode;
            e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
          },
        }),
      ft.each(
        [
          "tabIndex",
          "readOnly",
          "maxLength",
          "cellSpacing",
          "cellPadding",
          "rowSpan",
          "colSpan",
          "useMap",
          "frameBorder",
          "contentEditable",
        ],
        function () {
          ft.propFix[this.toLowerCase()] = this;
        }
      ),
      dt.enctype || (ft.propFix.enctype = "encoding");
    var Ne = /[\t\r\n\f]/g;
    ft.fn.extend({
      addClass: function (t) {
        var e,
          r,
          n,
          i,
          o,
          a,
          c,
          s = 0;
        if (ft.isFunction(t))
          return this.each(function (e) {
            ft(this).addClass(t.call(this, e, W(this)));
          });
        if ("string" == typeof t && t)
          for (e = t.match(St) || []; (r = this[s++]); )
            if (
              ((i = W(r)),
              (n = 1 === r.nodeType && (" " + i + " ").replace(Ne, " ")))
            ) {
              for (a = 0; (o = e[a++]); )
                n.indexOf(" " + o + " ") < 0 && (n += o + " ");
              (c = ft.trim(n)), i !== c && ft.attr(r, "class", c);
            }
        return this;
      },
      removeClass: function (t) {
        var e,
          r,
          n,
          i,
          o,
          a,
          c,
          s = 0;
        if (ft.isFunction(t))
          return this.each(function (e) {
            ft(this).removeClass(t.call(this, e, W(this)));
          });
        if (!arguments.length) return this.attr("class", "");
        if ("string" == typeof t && t)
          for (e = t.match(St) || []; (r = this[s++]); )
            if (
              ((i = W(r)),
              (n = 1 === r.nodeType && (" " + i + " ").replace(Ne, " ")))
            ) {
              for (a = 0; (o = e[a++]); )
                for (; n.indexOf(" " + o + " ") > -1; )
                  n = n.replace(" " + o + " ", " ");
              (c = ft.trim(n)), i !== c && ft.attr(r, "class", c);
            }
        return this;
      },
      toggleClass: function (t, e) {
        var r = typeof t;
        return "boolean" == typeof e && "string" === r
          ? e
            ? this.addClass(t)
            : this.removeClass(t)
          : ft.isFunction(t)
          ? this.each(function (r) {
              ft(this).toggleClass(t.call(this, r, W(this), e), e);
            })
          : this.each(function () {
              var e, n, i, o;
              if ("string" === r)
                for (n = 0, i = ft(this), o = t.match(St) || []; (e = o[n++]); )
                  i.hasClass(e) ? i.removeClass(e) : i.addClass(e);
              else
                (void 0 !== t && "boolean" !== r) ||
                  ((e = W(this)),
                  e && ft._data(this, "__className__", e),
                  ft.attr(
                    this,
                    "class",
                    e || !1 === t ? "" : ft._data(this, "__className__") || ""
                  ));
            });
      },
      hasClass: function (t) {
        var e,
          r,
          n = 0;
        for (e = " " + t + " "; (r = this[n++]); )
          if (
            1 === r.nodeType &&
            (" " + W(r) + " ").replace(Ne, " ").indexOf(e) > -1
          )
            return !0;
        return !1;
      },
    }),
      ft.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (t, e) {
          ft.fn[e] = function (t, r) {
            return arguments.length > 0
              ? this.on(e, null, t, r)
              : this.trigger(e);
          };
        }
      ),
      ft.fn.extend({
        hover: function (t, e) {
          return this.mouseenter(t).mouseleave(e || t);
        },
      });
    var Oe = t.location,
      Be = ft.now(),
      Ue = /\?/,
      Le =
        /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
    (ft.parseJSON = function (e) {
      if (t.JSON && t.JSON.parse) return t.JSON.parse(e + "");
      var r,
        n = null,
        i = ft.trim(e + "");
      return i &&
        !ft.trim(
          i.replace(Le, function (t, e, i, o) {
            return (
              r && e && (n = 0),
              0 === n ? t : ((r = i || e), (n += !o - !i), "")
            );
          })
        )
        ? Function("return " + i)()
        : ft.error("Invalid JSON: " + e);
    }),
      (ft.parseXML = function (e) {
        var r, n;
        if (!e || "string" != typeof e) return null;
        try {
          t.DOMParser
            ? ((n = new t.DOMParser()), (r = n.parseFromString(e, "text/xml")))
            : ((r = new t.ActiveXObject("Microsoft.XMLDOM")),
              (r.async = "false"),
              r.loadXML(e));
        } catch (t) {
          r = void 0;
        }
        return (
          (r &&
            r.documentElement &&
            !r.getElementsByTagName("parsererror").length) ||
            ft.error("Invalid XML: " + e),
          r
        );
      });
    var $e = /#.*$/,
      Ve = /([?&])_=[^&]*/,
      We = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      He = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Ge = /^(?:GET|HEAD)$/,
      ze = /^\/\//,
      Je = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
      Ke = {},
      Qe = {},
      Ye = "*/".concat("*"),
      Xe = Oe.href,
      Ze = Je.exec(Xe.toLowerCase()) || [];
    ft.extend({
      active: 0,
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Xe,
        type: "GET",
        isLocal: He.test(Ze[1]),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        accepts: {
          "*": Ye,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript",
        },
        contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON",
        },
        converters: {
          "* text": String,
          "text html": !0,
          "text json": ft.parseJSON,
          "text xml": ft.parseXML,
        },
        flatOptions: { url: !0, context: !0 },
      },
      ajaxSetup: function (t, e) {
        return e ? z(z(t, ft.ajaxSettings), e) : z(ft.ajaxSettings, t);
      },
      ajaxPrefilter: H(Ke),
      ajaxTransport: H(Qe),
      ajax: function (e, r) {
        function n(e, r, n, i) {
          var o,
            d,
            b,
            v,
            w,
            x = r;
          2 !== _ &&
            ((_ = 2),
            s && t.clearTimeout(s),
            (l = void 0),
            (c = i || ""),
            (C.readyState = e > 0 ? 4 : 0),
            (o = (e >= 200 && e < 300) || 304 === e),
            n && (v = J(f, C, n)),
            (v = K(f, v, C, o)),
            o
              ? (f.ifModified &&
                  ((w = C.getResponseHeader("Last-Modified")),
                  w && (ft.lastModified[a] = w),
                  (w = C.getResponseHeader("etag")) && (ft.etag[a] = w)),
                204 === e || "HEAD" === f.type
                  ? (x = "nocontent")
                  : 304 === e
                  ? (x = "notmodified")
                  : ((x = v.state), (d = v.data), (b = v.error), (o = !b)))
              : ((b = x), (!e && x) || ((x = "error"), e < 0 && (e = 0))),
            (C.status = e),
            (C.statusText = (r || x) + ""),
            o ? m.resolveWith(h, [d, x, C]) : m.rejectWith(h, [C, x, b]),
            C.statusCode(y),
            (y = void 0),
            u && p.trigger(o ? "ajaxSuccess" : "ajaxError", [C, f, o ? d : b]),
            g.fireWith(h, [C, x]),
            u &&
              (p.trigger("ajaxComplete", [C, f]),
              --ft.active || ft.event.trigger("ajaxStop")));
        }
        "object" == typeof e && ((r = e), (e = void 0)), (r = r || {});
        var i,
          o,
          a,
          c,
          s,
          u,
          l,
          d,
          f = ft.ajaxSetup({}, r),
          h = f.context || f,
          p = f.context && (h.nodeType || h.jquery) ? ft(h) : ft.event,
          m = ft.Deferred(),
          g = ft.Callbacks("once memory"),
          y = f.statusCode || {},
          b = {},
          v = {},
          _ = 0,
          w = "canceled",
          C = {
            readyState: 0,
            getResponseHeader: function (t) {
              var e;
              if (2 === _) {
                if (!d)
                  for (d = {}; (e = We.exec(c)); ) d[e[1].toLowerCase()] = e[2];
                e = d[t.toLowerCase()];
              }
              return null == e ? null : e;
            },
            getAllResponseHeaders: function () {
              return 2 === _ ? c : null;
            },
            setRequestHeader: function (t, e) {
              var r = t.toLowerCase();
              return _ || ((t = v[r] = v[r] || t), (b[t] = e)), this;
            },
            overrideMimeType: function (t) {
              return _ || (f.mimeType = t), this;
            },
            statusCode: function (t) {
              var e;
              if (t)
                if (_ < 2) for (e in t) y[e] = [y[e], t[e]];
                else C.always(t[C.status]);
              return this;
            },
            abort: function (t) {
              var e = t || w;
              return l && l.abort(e), n(0, e), this;
            },
          };
        if (
          ((m.promise(C).complete = g.add),
          (C.success = C.done),
          (C.error = C.fail),
          (f.url = ((e || f.url || Xe) + "")
            .replace($e, "")
            .replace(ze, Ze[1] + "//")),
          (f.type = r.method || r.type || f.method || f.type),
          (f.dataTypes = ft
            .trim(f.dataType || "*")
            .toLowerCase()
            .match(St) || [""]),
          null == f.crossDomain &&
            ((i = Je.exec(f.url.toLowerCase())),
            (f.crossDomain = !(
              !i ||
              (i[1] === Ze[1] &&
                i[2] === Ze[2] &&
                (i[3] || ("http:" === i[1] ? "80" : "443")) ===
                  (Ze[3] || ("http:" === Ze[1] ? "80" : "443")))
            ))),
          f.data &&
            f.processData &&
            "string" != typeof f.data &&
            (f.data = ft.param(f.data, f.traditional)),
          G(Ke, f, r, C),
          2 === _)
        )
          return C;
        (u = ft.event && f.global),
          u && 0 == ft.active++ && ft.event.trigger("ajaxStart"),
          (f.type = f.type.toUpperCase()),
          (f.hasContent = !Ge.test(f.type)),
          (a = f.url),
          f.hasContent ||
            (f.data &&
              ((a = f.url += (Ue.test(a) ? "&" : "?") + f.data), delete f.data),
            !1 === f.cache &&
              (f.url = Ve.test(a)
                ? a.replace(Ve, "$1_=" + Be++)
                : a + (Ue.test(a) ? "&" : "?") + "_=" + Be++)),
          f.ifModified &&
            (ft.lastModified[a] &&
              C.setRequestHeader("If-Modified-Since", ft.lastModified[a]),
            ft.etag[a] && C.setRequestHeader("If-None-Match", ft.etag[a])),
          ((f.data && f.hasContent && !1 !== f.contentType) || r.contentType) &&
            C.setRequestHeader("Content-Type", f.contentType),
          C.setRequestHeader(
            "Accept",
            f.dataTypes[0] && f.accepts[f.dataTypes[0]]
              ? f.accepts[f.dataTypes[0]] +
                  ("*" !== f.dataTypes[0] ? ", " + Ye + "; q=0.01" : "")
              : f.accepts["*"]
          );
        for (o in f.headers) C.setRequestHeader(o, f.headers[o]);
        if (f.beforeSend && (!1 === f.beforeSend.call(h, C, f) || 2 === _))
          return C.abort();
        w = "abort";
        for (o in { success: 1, error: 1, complete: 1 }) C[o](f[o]);
        if ((l = G(Qe, f, r, C))) {
          if (((C.readyState = 1), u && p.trigger("ajaxSend", [C, f]), 2 === _))
            return C;
          f.async &&
            f.timeout > 0 &&
            (s = t.setTimeout(function () {
              C.abort("timeout");
            }, f.timeout));
          try {
            (_ = 1), l.send(b, n);
          } catch (t) {
            if (!(_ < 2)) throw t;
            n(-1, t);
          }
        } else n(-1, "No Transport");
        return C;
      },
      getJSON: function (t, e, r) {
        return ft.get(t, e, r, "json");
      },
      getScript: function (t, e) {
        return ft.get(t, void 0, e, "script");
      },
    }),
      ft.each(["get", "post"], function (t, e) {
        ft[e] = function (t, r, n, i) {
          return (
            ft.isFunction(r) && ((i = i || n), (n = r), (r = void 0)),
            ft.ajax(
              ft.extend(
                { url: t, type: e, dataType: i, data: r, success: n },
                ft.isPlainObject(t) && t
              )
            )
          );
        };
      }),
      (ft._evalUrl = function (t) {
        return ft.ajax({
          url: t,
          type: "GET",
          dataType: "script",
          cache: !0,
          async: !1,
          global: !1,
          throws: !0,
        });
      }),
      ft.fn.extend({
        wrapAll: function (t) {
          if (ft.isFunction(t))
            return this.each(function (e) {
              ft(this).wrapAll(t.call(this, e));
            });
          if (this[0]) {
            var e = ft(t, this[0].ownerDocument).eq(0).clone(!0);
            this[0].parentNode && e.insertBefore(this[0]),
              e
                .map(function () {
                  for (
                    var t = this;
                    t.firstChild && 1 === t.firstChild.nodeType;

                  )
                    t = t.firstChild;
                  return t;
                })
                .append(this);
          }
          return this;
        },
        wrapInner: function (t) {
          return ft.isFunction(t)
            ? this.each(function (e) {
                ft(this).wrapInner(t.call(this, e));
              })
            : this.each(function () {
                var e = ft(this),
                  r = e.contents();
                r.length ? r.wrapAll(t) : e.append(t);
              });
        },
        wrap: function (t) {
          var e = ft.isFunction(t);
          return this.each(function (r) {
            ft(this).wrapAll(e ? t.call(this, r) : t);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              ft.nodeName(this, "body") ||
                ft(this).replaceWith(this.childNodes);
            })
            .end();
        },
      }),
      (ft.expr.filters.hidden = function (t) {
        return dt.reliableHiddenOffsets()
          ? t.offsetWidth <= 0 &&
              t.offsetHeight <= 0 &&
              !t.getClientRects().length
          : Y(t);
      }),
      (ft.expr.filters.visible = function (t) {
        return !ft.expr.filters.hidden(t);
      });
    var tr = /%20/g,
      er = /\[\]$/,
      rr = /\r?\n/g,
      nr = /^(?:submit|button|image|reset|file)$/i,
      ir = /^(?:input|select|textarea|keygen)/i;
    (ft.param = function (t, e) {
      var r,
        n = [],
        i = function (t, e) {
          (e = ft.isFunction(e) ? e() : null == e ? "" : e),
            (n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e));
        };
      if (
        (void 0 === e && (e = ft.ajaxSettings && ft.ajaxSettings.traditional),
        ft.isArray(t) || (t.jquery && !ft.isPlainObject(t)))
      )
        ft.each(t, function () {
          i(this.name, this.value);
        });
      else for (r in t) X(r, t[r], e, i);
      return n.join("&").replace(tr, "+");
    }),
      ft.fn.extend({
        serialize: function () {
          return ft.param(this.serializeArray());
        },
        serializeArray: function () {
          return this.map(function () {
            var t = ft.prop(this, "elements");
            return t ? ft.makeArray(t) : this;
          })
            .filter(function () {
              var t = this.type;
              return (
                this.name &&
                !ft(this).is(":disabled") &&
                ir.test(this.nodeName) &&
                !nr.test(t) &&
                (this.checked || !Ot.test(t))
              );
            })
            .map(function (t, e) {
              var r = ft(this).val();
              return null == r
                ? null
                : ft.isArray(r)
                ? ft.map(r, function (t) {
                    return { name: e.name, value: t.replace(rr, "\r\n") };
                  })
                : { name: e.name, value: r.replace(rr, "\r\n") };
            })
            .get();
        },
      }),
      (ft.ajaxSettings.xhr =
        void 0 !== t.ActiveXObject
          ? function () {
              return this.isLocal
                ? tt()
                : nt.documentMode > 8
                ? Z()
                : (/^(get|post|head|put|delete|options)$/i.test(this.type) &&
                    Z()) ||
                  tt();
            }
          : Z);
    var or = 0,
      ar = {},
      cr = ft.ajaxSettings.xhr();
    t.attachEvent &&
      t.attachEvent("onunload", function () {
        for (var t in ar) ar[t](void 0, !0);
      }),
      (dt.cors = !!cr && "withCredentials" in cr),
      (cr = dt.ajax = !!cr),
      cr &&
        ft.ajaxTransport(function (e) {
          if (!e.crossDomain || dt.cors) {
            var r;
            return {
              send: function (n, i) {
                var o,
                  a = e.xhr(),
                  c = ++or;
                if (
                  (a.open(e.type, e.url, e.async, e.username, e.password),
                  e.xhrFields)
                )
                  for (o in e.xhrFields) a[o] = e.xhrFields[o];
                e.mimeType &&
                  a.overrideMimeType &&
                  a.overrideMimeType(e.mimeType),
                  e.crossDomain ||
                    n["X-Requested-With"] ||
                    (n["X-Requested-With"] = "XMLHttpRequest");
                for (o in n)
                  void 0 !== n[o] && a.setRequestHeader(o, n[o] + "");
                a.send((e.hasContent && e.data) || null),
                  (r = function (t, n) {
                    var o, s, u;
                    if (r && (n || 4 === a.readyState))
                      if (
                        (delete ar[c],
                        (r = void 0),
                        (a.onreadystatechange = ft.noop),
                        n)
                      )
                        4 !== a.readyState && a.abort();
                      else {
                        (u = {}),
                          (o = a.status),
                          "string" == typeof a.responseText &&
                            (u.text = a.responseText);
                        try {
                          s = a.statusText;
                        } catch (t) {
                          s = "";
                        }
                        o || !e.isLocal || e.crossDomain
                          ? 1223 === o && (o = 204)
                          : (o = u.text ? 200 : 404);
                      }
                    u && i(o, s, u, a.getAllResponseHeaders());
                  }),
                  e.async
                    ? 4 === a.readyState
                      ? t.setTimeout(r)
                      : (a.onreadystatechange = ar[c] = r)
                    : r();
              },
              abort: function () {
                r && r(void 0, !0);
              },
            };
          }
        }),
      ft.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: { script: /\b(?:java|ecma)script\b/ },
        converters: {
          "text script": function (t) {
            return ft.globalEval(t), t;
          },
        },
      }),
      ft.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1),
          t.crossDomain && ((t.type = "GET"), (t.global = !1));
      }),
      ft.ajaxTransport("script", function (t) {
        if (t.crossDomain) {
          var e,
            r = nt.head || ft("head")[0] || nt.documentElement;
          return {
            send: function (n, i) {
              (e = nt.createElement("script")),
                (e.async = !0),
                t.scriptCharset && (e.charset = t.scriptCharset),
                (e.src = t.url),
                (e.onload = e.onreadystatechange =
                  function (t, r) {
                    (r ||
                      !e.readyState ||
                      /loaded|complete/.test(e.readyState)) &&
                      ((e.onload = e.onreadystatechange = null),
                      e.parentNode && e.parentNode.removeChild(e),
                      (e = null),
                      r || i(200, "success"));
                  }),
                r.insertBefore(e, r.firstChild);
            },
            abort: function () {
              e && e.onload(void 0, !0);
            },
          };
        }
      });
    var sr = [],
      ur = /(=)\?(?=&|$)|\?\?/;
    ft.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var t = sr.pop() || ft.expando + "_" + Be++;
        return (this[t] = !0), t;
      },
    }),
      ft.ajaxPrefilter("json jsonp", function (e, r, n) {
        var i,
          o,
          a,
          c =
            !1 !== e.jsonp &&
            (ur.test(e.url)
              ? "url"
              : "string" == typeof e.data &&
                0 ===
                  (e.contentType || "").indexOf(
                    "application/x-www-form-urlencoded"
                  ) &&
                ur.test(e.data) &&
                "data");
        if (c || "jsonp" === e.dataTypes[0])
          return (
            (i = e.jsonpCallback =
              ft.isFunction(e.jsonpCallback)
                ? e.jsonpCallback()
                : e.jsonpCallback),
            c
              ? (e[c] = e[c].replace(ur, "$1" + i))
              : !1 !== e.jsonp &&
                (e.url += (Ue.test(e.url) ? "&" : "?") + e.jsonp + "=" + i),
            (e.converters["script json"] = function () {
              return a || ft.error(i + " was not called"), a[0];
            }),
            (e.dataTypes[0] = "json"),
            (o = t[i]),
            (t[i] = function () {
              a = arguments;
            }),
            n.always(function () {
              void 0 === o ? ft(t).removeProp(i) : (t[i] = o),
                e[i] && ((e.jsonpCallback = r.jsonpCallback), sr.push(i)),
                a && ft.isFunction(o) && o(a[0]),
                (a = o = void 0);
            }),
            "script"
          );
      }),
      (ft.parseHTML = function (t, e, r) {
        if (!t || "string" != typeof t) return null;
        "boolean" == typeof e && ((r = e), (e = !1)), (e = e || nt);
        var n = wt.exec(t),
          i = !r && [];
        return n
          ? [e.createElement(n[1])]
          : ((n = y([t], e, i)),
            i && i.length && ft(i).remove(),
            ft.merge([], n.childNodes));
      });
    var lr = ft.fn.load;
    (ft.fn.load = function (t, e, r) {
      if ("string" != typeof t && lr) return lr.apply(this, arguments);
      var n,
        i,
        o,
        a = this,
        c = t.indexOf(" ");
      return (
        c > -1 && ((n = ft.trim(t.slice(c, t.length))), (t = t.slice(0, c))),
        ft.isFunction(e)
          ? ((r = e), (e = void 0))
          : e && "object" == typeof e && (i = "POST"),
        a.length > 0 &&
          ft
            .ajax({ url: t, type: i || "GET", dataType: "html", data: e })
            .done(function (t) {
              (o = arguments),
                a.html(n ? ft("<div>").append(ft.parseHTML(t)).find(n) : t);
            })
            .always(
              r &&
                function (t, e) {
                  a.each(function () {
                    r.apply(this, o || [t.responseText, e, t]);
                  });
                }
            ),
        this
      );
    }),
      ft.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (t, e) {
          ft.fn[e] = function (t) {
            return this.on(e, t);
          };
        }
      ),
      (ft.expr.filters.animated = function (t) {
        return ft.grep(ft.timers, function (e) {
          return t === e.elem;
        }).length;
      }),
      (ft.offset = {
        setOffset: function (t, e, r) {
          var n,
            i,
            o,
            a,
            c,
            s,
            u,
            l = ft.css(t, "position"),
            d = ft(t),
            f = {};
          "static" === l && (t.style.position = "relative"),
            (c = d.offset()),
            (o = ft.css(t, "top")),
            (s = ft.css(t, "left")),
            (u =
              ("absolute" === l || "fixed" === l) &&
              ft.inArray("auto", [o, s]) > -1),
            u
              ? ((n = d.position()), (a = n.top), (i = n.left))
              : ((a = parseFloat(o) || 0), (i = parseFloat(s) || 0)),
            ft.isFunction(e) && (e = e.call(t, r, ft.extend({}, c))),
            null != e.top && (f.top = e.top - c.top + a),
            null != e.left && (f.left = e.left - c.left + i),
            "using" in e ? e.using.call(t, f) : d.css(f);
        },
      }),
      ft.fn.extend({
        offset: function (t) {
          if (arguments.length)
            return void 0 === t
              ? this
              : this.each(function (e) {
                  ft.offset.setOffset(this, t, e);
                });
          var e,
            r,
            n = { top: 0, left: 0 },
            i = this[0],
            o = i && i.ownerDocument;
          if (o)
            return (
              (e = o.documentElement),
              ft.contains(e, i)
                ? (void 0 !== i.getBoundingClientRect &&
                    (n = i.getBoundingClientRect()),
                  (r = et(o)),
                  {
                    top:
                      n.top +
                      (r.pageYOffset || e.scrollTop) -
                      (e.clientTop || 0),
                    left:
                      n.left +
                      (r.pageXOffset || e.scrollLeft) -
                      (e.clientLeft || 0),
                  })
                : n
            );
        },
        position: function () {
          if (this[0]) {
            var t,
              e,
              r = { top: 0, left: 0 },
              n = this[0];
            return (
              "fixed" === ft.css(n, "position")
                ? (e = n.getBoundingClientRect())
                : ((t = this.offsetParent()),
                  (e = this.offset()),
                  ft.nodeName(t[0], "html") || (r = t.offset()),
                  (r.top += ft.css(t[0], "borderTopWidth", !0)),
                  (r.left += ft.css(t[0], "borderLeftWidth", !0))),
              {
                top: e.top - r.top - ft.css(n, "marginTop", !0),
                left: e.left - r.left - ft.css(n, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var t = this.offsetParent;
              t &&
              !ft.nodeName(t, "html") &&
              "static" === ft.css(t, "position");

            )
              t = t.offsetParent;
            return t || de;
          });
        },
      }),
      ft.each(
        { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
        function (t, e) {
          var r = /Y/.test(e);
          ft.fn[t] = function (n) {
            return Nt(
              this,
              function (t, n, i) {
                var o = et(t);
                if (void 0 === i)
                  return o
                    ? e in o
                      ? o[e]
                      : o.document.documentElement[n]
                    : t[n];
                o
                  ? o.scrollTo(
                      r ? ft(o).scrollLeft() : i,
                      r ? i : ft(o).scrollTop()
                    )
                  : (t[n] = i);
              },
              t,
              n,
              arguments.length,
              null
            );
          };
        }
      ),
      ft.each(["top", "left"], function (t, e) {
        ft.cssHooks[e] = E(dt.pixelPosition, function (t, r) {
          if (r)
            return (r = he(t, e)), ue.test(r) ? ft(t).position()[e] + "px" : r;
        });
      }),
      ft.each({ Height: "height", Width: "width" }, function (t, e) {
        ft.each(
          { padding: "inner" + t, content: e, "": "outer" + t },
          function (r, n) {
            ft.fn[n] = function (n, i) {
              var o = arguments.length && (r || "boolean" != typeof n),
                a = r || (!0 === n || !0 === i ? "margin" : "border");
              return Nt(
                this,
                function (e, r, n) {
                  var i;
                  return ft.isWindow(e)
                    ? e.document.documentElement["client" + t]
                    : 9 === e.nodeType
                    ? ((i = e.documentElement),
                      Math.max(
                        e.body["scroll" + t],
                        i["scroll" + t],
                        e.body["offset" + t],
                        i["offset" + t],
                        i["client" + t]
                      ))
                    : void 0 === n
                    ? ft.css(e, r, a)
                    : ft.style(e, r, n, a);
                },
                e,
                o ? n : void 0,
                o,
                null
              );
            };
          }
        );
      }),
      ft.fn.extend({
        bind: function (t, e, r) {
          return this.on(t, null, e, r);
        },
        unbind: function (t, e) {
          return this.off(t, null, e);
        },
        delegate: function (t, e, r, n) {
          return this.on(e, t, r, n);
        },
        undelegate: function (t, e, r) {
          return 1 === arguments.length
            ? this.off(t, "**")
            : this.off(e, t || "**", r);
        },
      }),
      (ft.fn.size = function () {
        return this.length;
      }),
      (ft.fn.andSelf = ft.fn.addBack),
      "function" == typeof codeblackbelt.define &&
        codeblackbelt.define.amd &&
        codeblackbelt.define("jquery", [], function () {
          return ft;
        });
    var dr = t.cbbJQuery,
      fr = t.cbb$;
    return (
      (ft.noConflict = function (e) {
        return (
          t.cbb$ === ft && (t.cbb$ = fr),
          e && t.cbbJQuery === ft && (t.cbbJQuery = dr),
          ft
        );
      }),
      e || (t.cbbJQuery = t.cbb$ = ft),
      ft
    );
  }),
  codeblackbelt.define("lib/jquery-renamed-1.12.4", function () {}),
  codeblackbelt.define(
    "lib/jquery-private",
    ["lib/jquery-renamed-1.12.4"],
    function () {
      return cbbJQuery.noConflict(!0);
    }
  ),
  codeblackbelt.define(
    "core/util/StringUtil",
    ["lib/jquery-private"],
    function (t) {
      function e() {}
      return (
        (t.fn.exists = function () {
          return this.length > 0;
        }),
        (e.isString = function (t) {
          return "string" == typeof t;
        }),
        (e.isNotString = function (t) {
          return !e.isString(t);
        }),
        (e.removeWhiteSpaces = function (e) {
          if (null == e) return e;
          var r = e.replace(/&nbsp;/g, " ");
          return t.trim(r);
        }),
        (e.replaceHyphens = function (t) {
          return t.replace(/-/g, "_");
        }),
        (e.isNotEmpty = function (t) {
          return !e.isEmpty(t);
        }),
        (e.isEmpty = function (t) {
          return (
            null == t || "null" === t || 0 === e.removeWhiteSpaces(t).length
          );
        }),
        (e.contains = function (t, r) {
          return !e.isEmpty(t) && !e.isEmpty(r) && t.indexOf(r) >= 0;
        }),
        (e.startsWith = function (t, r) {
          return !e.isEmpty(t) && !e.isEmpty(r) && 0 === t.indexOf(r);
        }),
        (e.endsWith = function (t, r) {
          return (
            !e.isEmpty(t) &&
            !e.isEmpty(r) &&
            -1 !== t.indexOf(r, t.length - r.length)
          );
        }),
        (e.replaceLast = function (t, r, n) {
          if (e.isEmpty(t) || e.isEmpty(r)) return t;
          var i = t.lastIndexOf(r);
          return -1 !== i ? t.substring(0, i) + n : t;
        }),
        (e.reverse = function (t) {
          for (var e = "", r = t.length - 1; r >= 0; r--) e += t[r];
          return e;
        }),
        (e.removeAccents = function (t) {
          return e.isEmpty(t)
            ? t
            : t
                .replace(/[áàäâã]/g, "a")
                .replace(/[ÁÀÄÂÃ]/g, "A")
                .replace(/[éèëê]/g, "e")
                .replace(/[ÉÈËÊ]/g, "E")
                .replace(/[íìïî]/g, "i")
                .replace(/[ÍÌÏÎ]/g, "I")
                .replace(/[óòöôõ]/g, "o")
                .replace(/[ÓÒÖÔÕ]/g, "O")
                .replace(/[úùüû]/g, "u")
                .replace(/[ÚÙÜÛ]/g, "U")
                .replace("ñ", "n")
                .replace("Ñ", "N")
                .replace("ç", "c")
                .replace("Ç", "C");
        }),
        (e.fixCommaSeparatedList = function (r) {
          if (e.isEmpty(r)) return "";
          var n = r
            .replace(/[\r\n\t]/g, ",")
            .replace(/\s/g, "")
            .replace(/,+/g, ",")
            .replace(/^,/, "")
            .replace(/,$/, "");
          return t.trim(n);
        }),
        (e.padEnd = function (t, e, r) {
          if (t.length >= e) return t;
          for (var n = t; n.length < e; ) n += r;
          return n;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define("core/util/ShopifyUtil", [], function () {
    function t() {}
    return (
      (t.isEmbedParameter = function () {
        return document.location.href.indexOf("embed=true") > 0;
      }),
      (t.isInsideThemeEditor = function () {
        return window.Shopify && window.Shopify.designMode;
      }),
      (t.hasAdminBar = function () {
        return document.getElementById("admin-bar-iframe");
      }),
      (t.isShopPresent = function () {
        return (
          t._isShopGlobalAvailable() ||
          t._isDocumentDomainAvailable() ||
          t._isDocumentLocationAvailable()
        );
      }),
      (t.getShop = function () {
        if (t._isShopGlobalAvailable()) return t._shopGlobal();
        if (t._isDocumentDomainAvailable()) return t._documentDomain();
        if (t._isDocumentLocationAvailable()) return t._documentLocation();
        throw new Error("Shop domain matching *.myshopify.com not found");
      }),
      (t.isStagingShop = function () {
        if (t.isShopPresent()) {
          var e = t.getShop();
          return e && 0 === e.indexOf("cbb-staging-");
        }
        return !1;
      }),
      (t.getPresentmentCurrency = function () {
        return window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active
          ? window.Shopify.currency.active
          : "";
      }),
      (t.getCountry = function () {
        return window.Shopify && window.Shopify.country
          ? window.Shopify.country
          : "US";
      }),
      (t.isPresentmentCurrencyActive = function () {
        return 1 !== t.getPresentmentCurrencyRate();
      }),
      (t.isDefaultCurrencyActive = function () {
        return 1 == t.getPresentmentCurrencyRate();
      }),
      (t.getPresentmentCurrencyRate = function () {
        return window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.rate
          ? Number(window.Shopify.currency.rate)
          : 1;
      }),
      (t.getRoute = function () {
        return window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "";
      }),
      (t._isShopGlobalAvailable = function () {
        return window.Shopify && window.Shopify.shop;
      }),
      (t._isDocumentDomainAvailable = function () {
        return (
          document.domain && -1 !== document.domain.indexOf(".myshopify.com")
        );
      }),
      (t._isDocumentLocationAvailable = function () {
        return (
          document.location.host &&
          -1 !== document.domain.indexOf(".myshopify.com")
        );
      }),
      (t._shopGlobal = function () {
        return window.Shopify.shop;
      }),
      (t._documentDomain = function () {
        return document.domain;
      }),
      (t._documentLocation = function () {
        return document.location.href;
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/InternationalContextParser",
    ["core/util/ShopifyUtil", "core/util/StringUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.getInternationalContext = function (t) {
          return e.isNotEmpty(t) ? r._removeTrailingSlash(t) : "";
        }),
        (r._removeTrailingSlash = function (t) {
          return e.replaceLast(t, "/", "");
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/InternationalContextRemover",
    ["core/util/InternationalContextParser", "core/util/StringUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.removeLocalizedContext = function (r, n) {
          var i = t.getInternationalContext(n);
          return e.isNotEmpty(i) ? r.replace(i, "") : r;
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ShopifyUrlUtil",
    [
      "core/util/InternationalContextParser",
      "core/util/InternationalContextRemover",
    ],
    function (t, e) {
      function r() {}
      return (
        (r.isDemoPage = function (t) {
          var r = e.removeLocalizedContext(t, "/");
          return (
            null !== r.match(/^\/.*\/test.html/) ||
            null !== r.match(/^\/.*\/demo\//)
          );
        }),
        (r.isHomePage = function (t, r) {
          var n = e.removeLocalizedContext(t, r);
          return (
            n.length <= 1 ||
            null !== n.match(/^\/index/) ||
            null !== n.match(/^\/pages\/home/)
          );
        }),
        (r.isProductPage = function (t, r) {
          var n = e.removeLocalizedContext(t, r);
          return (
            null !== n.match(/^\/products\/.*/) ||
            null !== n.match(/^\/.*\/products\/.*/) ||
            null !== n.match(/^\/products_preview.*/)
          );
        }),
        (r.isCartPage = function (t, r) {
          return null !== e.removeLocalizedContext(t, r).match(/^\/cart/);
        }),
        (r.isCheckoutEndPage = function (t) {
          return (
            null !== t.match(/\/\/checkout\.shopify\.com/) ||
            null !== t.match(/\/checkouts\//)
          );
        }),
        (r.isTicnologic = function (t) {
          return null !== t.match(/\/\/ticnologic/);
        }),
        (r.isSandboxStore = function (t) {
          return null !== t.match(/\/\/cbb-sandbox/);
        }),
        (r.isStagingStore = function (t) {
          return null !== t.match(/\/\/cbb-staging/);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/UrlUtil",
    [
      "core/util/StringUtil",
      "core/util/ShopifyUtil",
      "core/util/ShopifyUrlUtil",
      "core/util/InternationalContextParser",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        (i.isHomePage = function () {
          var t = i._shopifyServletPath(),
            n = e.getRoute();
          return r.isHomePage(t, n);
        }),
        (i.isProductPage = function () {
          var t = i._shopifyServletPath(),
            n = e.getRoute();
          return r.isProductPage(t, n);
        }),
        (i.isCartPage = function () {
          var t = i._shopifyServletPath(),
            n = e.getRoute();
          return r.isCartPage(t, n);
        }),
        (i.isDemoPage = function () {
          var t = location.pathname;
          return r.isDemoPage(t);
        }),
        (i.isCheckoutEndPage = function () {
          var t = location.href;
          return r.isCheckoutEndPage(t);
        }),
        (i.isTicnologic = function () {
          var t = location.href;
          return r.isTicnologic(t);
        }),
        (i.isSandboxStore = function () {
          var t = location.href;
          return r.isSandboxStore(t);
        }),
        (i.isStagingStore = function () {
          var t = location.href;
          return r.isStagingStore(t);
        }),
        (i.getInternationalContext = function () {
          var t = e.getRoute();
          return n.getInternationalContext(t);
        }),
        (i.servletPath = function (e) {
          if (t.isEmpty(e)) return "";
          var r = e.indexOf("/");
          if (-1 == r) return "/";
          var n = e.indexOf("?");
          return -1 == n && (n = e.length), e.substring(r, n);
        }),
        (i.isAbsolute = function (t) {
          return null !== t.match(/^http.*/);
        }),
        (i.removeProtocol = function (t) {
          var e = t.indexOf("://");
          return e > 0 ? t.substr(e + 1) : t;
        }),
        (i.hasParameterInUrl = function (t) {
          return document.location.href.indexOf(t) > 0;
        }),
        (i.getParameterFromUrl = function (t) {
          var e = document.location.href;
          return i.getParameter(e, t);
        }),
        (i.getParameter = function (t, e) {
          return (t.split(e + "=")[1] || "").split("&")[0];
        }),
        (i._shopifyServletPath = function () {
          return null == window.__st || null == window.__st.pageurl
            ? location.pathname
            : i.servletPath(window.__st.pageurl);
        }),
        i
      );
    }
  ),
  codeblackbelt.define("core/util/JQueryObjectChecker", [], function () {
    function t() {}
    return (
      (t.exists = function (t) {
        if (!t.jquery)
          throw new Error("This function only works for jQuery objects");
        return t && t[0];
      }),
      (t.existsVisible = function (e) {
        return t.exists(e) && e.is(":visible");
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define("core/util/BrowserUtil", [], function () {
    function t() {}
    var e =
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
      r =
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
      n = /android|ipad|playbook|silk/i;
    return (
      (t.isWindowsPhone7 = function () {
        return /Windows Phone OS 7/i.test(navigator.userAgent);
      }),
      (t.isChrome = function () {
        return (
          /Chrome\/\d/.test(navigator.userAgent) &&
          !/Edg\/\d/.test(navigator.userAgent)
        );
      }),
      (t.isFirefox = function () {
        return /Firefox/.test(navigator.userAgent);
      }),
      (t.isSafari = function () {
        return (
          /Safari/.test(navigator.userAgent) &&
          /AppleWebKit/.test(navigator.userAgent) &&
          !/Edg\/\d/.test(navigator.userAgent)
        );
      }),
      (t.isSafariMobile = function () {
        return (
          (/iPhone/.test(navigator.userAgent) ||
            /iPad/.test(navigator.userAgent)) &&
          /AppleWebKit/.test(navigator.userAgent)
        );
      }),
      (t.isAndroidBrowser = function () {
        return (
          /Android/.test(navigator.userAgent) &&
          /Chrome\/3/.test(navigator.userAgent) &&
          /Mobile/.test(navigator.userAgent)
        );
      }),
      (t.isMobile = function () {
        var t = navigator.userAgent || navigator.vendor || window.opera;
        return e.test(t) || r.test(t.substr(0, 4));
      }),
      (t.isMobileOrTablet = function () {
        return t.isMobile() || t.isTablet();
      }),
      (t.isMobileOrTabletPortrait = function () {
        return t.isMobile() || (t.isTablet() && t.isPortrait());
      }),
      (t.isTablet = function () {
        return t.isGenericTablet() || t.isRecentIosTablet();
      }),
      (t.isGenericTablet = function () {
        var t = navigator.userAgent || navigator.vendor || window.opera;
        return n.test(t);
      }),
      (t.isRecentIosTablet = function () {
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }),
      (t.isDesktop = function () {
        return !t.isMobileOrTablet();
      }),
      (t.isIEBefore9 = function () {
        return document.all && !document.addEventListener;
      }),
      (t.isIE9 = function () {
        return (
          navigator.appVersion && navigator.appVersion.indexOf("MSIE 9.") > 0
        );
      }),
      (t.isIEorEdge = function () {
        return (
          navigator.appVersion &&
          (navigator.appVersion.indexOf("MSIE") > 0 ||
            navigator.appVersion.indexOf("Trident") > 0 ||
            navigator.appVersion.indexOf("Edge") > 0)
        );
      }),
      (t.isPortrait = function () {
        return window.matchMedia("(orientation: portrait)").matches;
      }),
      (t.isLandscape = function () {
        return window.matchMedia("(orientation: landscape)").matches;
      }),
      (t.getLanguage = function () {
        return window.navigator.language;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/dom/DomPlacer",
    [
      "core/util/StringUtil",
      "core/util/BrowserUtil",
      "core/util/JQueryObjectChecker",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i(t) {
        this.preferences = t;
      }
      return (
        (i.prototype = {
          doesTargetExist: function () {
            var t = this.findTarget();
            return r.exists(t);
          },
          placeElement: function (t) {
            var e = this.findTarget(),
              r = this._placement();
            "BEFORE" === r
              ? t.insertBefore(e)
              : "FIRST_CHILD" === r
              ? t.prependTo(e)
              : "LAST_CHILD" === r
              ? t.appendTo(e)
              : t.insertAfter(e);
          },
          findTarget: function () {
            var t = n(this.targetSelector()),
              e = t.filter(":visible").filter(":first");
            return e.length > 0 ? e : t.filter(":first");
          },
          targetSelector: function () {
            return this._useMobileTarget()
              ? this.preferences.mobileTarget
              : this.preferences.target;
          },
          _placement: function () {
            return this._useMobileTarget()
              ? this.preferences.mobileTargetPlacement
              : this.preferences.targetPlacement;
          },
          _useMobileTarget: function () {
            return (
              e.isMobileOrTabletPortrait() &&
              t.isNotEmpty(this.preferences.mobileTarget)
            );
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/util/FrequentlyBoughtWidgetAppender",
    [
      "core/util/UrlUtil",
      "core/util/JQueryObjectChecker",
      "core/util/dom/DomPlacer",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i() {}
      var o = [
        ".product-single",
        ".section.product_section",
        ".product-single__content",
        "#productHead",
        "#ProductSection--product-template",
        "#shopify-section-product-template",
      ];
      return (
        (i.append = function (t, e) {
          var n = new r(e);
          n.doesTargetExist() ? n.placeElement(t) : i._tryToAppendToPage(t);
        }),
        (i._tryToAppendToPage = function (t) {
          var e = i._findBestTargetOnPage();
          null !== e ? i._appendElementAfterTarget(t, e) : i._appendToBody(t);
        }),
        (i._findBestTargetOnPage = function () {
          for (var t = 0; t < o.length; t++) {
            var r = n(o[t]);
            if (e.exists(r)) return r;
          }
          return null;
        }),
        (i._appendToBody = function (t) {
          var r = n("footer");
          e.exists(r)
            ? i._appendElementBeforeTarget(t, r)
            : i._appendElementToTarget(t, n("body"));
        }),
        (i._appendElementToTarget = function (t, e) {
          var r = i._firstMatchingTarget(e);
          t.appendTo(r);
        }),
        (i._appendElementAfterTarget = function (t, e) {
          var r = i._firstMatchingTarget(e);
          t.insertAfter(r);
        }),
        (i._appendElementBeforeTarget = function (t, e) {
          var r = i._firstMatchingTarget(e);
          t.insertBefore(r);
        }),
        (i._firstMatchingTarget = function (t) {
          return t.filter(":first");
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/DomainUtil",
    ["core/util/ShopifyUtil"],
    function (t) {
      function e() {}
      return (
        (e.baseUrl = function () {
          return t.isStagingShop()
            ? "https://staging.codeblackbelt.com"
            : e.isLocalhost()
            ? "http://localhost:8080/shopify-js-apps"
            : "https://cdn.codeblackbelt.com";
        }),
        (e.cdnUrl = function () {
          return t.isStagingShop()
            ? "https://staging.codeblackbelt.com"
            : e.isLocalhost()
            ? "http://localhost:8080/shopify-js-apps"
            : "https://cdn.codeblackbelt.com";
        }),
        (e.isLocalhost = function () {
          var t = location.href;
          return (
            null !== t.match(/\/\/localhost/) ||
            null !== t.match(/\/\/bs-local.com/) ||
            null !== t.match(/\/\/192.168.*/)
          );
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/Logger",
    ["core/util/ShopifyUtil", "core/util/DomainUtil"],
    function (t, e) {
      function r() {}
      var n = !1;
      return (
        (r.debug = function (t) {
          r._shouldLogDebug() && r.log(t);
        }),
        (r.debugGroup = function (t, e) {
          r._shouldLogDebug() &&
            (r.group(t),
            e.forEach(function (t) {
              r.debug(t);
            }),
            r.groupEnd());
        }),
        (r.group = function (t) {
          console.group(t);
        }),
        (r.groupEnd = function () {
          console.groupEnd();
        }),
        (r.log = function (t) {
          try {
            console.log(t);
          } catch (t) {}
        }),
        (r.enableDebug = function () {
          n = !0;
        }),
        (r.disableDebug = function () {
          n = !1;
        }),
        (r._shouldLogDebug = function () {
          return n || t.isStagingShop() || e.isLocalhost();
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/JsonCss",
    ["core/util/StringUtil", "core/util/Logger", "lib/jquery-private"],
    function (t, e, r) {
      function n() {}
      return (
        (n.apply = function (t, r) {
          try {
            n._applySafe(t, r);
          } catch (o) {
            var i = n._elementRef(t);
            e.log(
              "Syntax error: could not apply to the element " +
                i +
                " the additional styles: " +
                r
            );
          }
        }),
        (n._applySafe = function (e, n) {
          if (!t.isEmpty(n) && ((n = t.removeWhiteSpaces(n)), !t.isEmpty(n))) {
            var i = r.parseJSON(n);
            e.css(i);
          }
        }),
        (n._elementRef = function (e) {
          var r = e.attr("id");
          return t.isNotEmpty(r)
            ? "with id " + r
            : ((r = e.attr("class")),
              t.isNotEmpty(r) ? "with class " + r : (r = e[0].tagName));
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/TitleUI",
    ["core/util/JsonCss", "lib/jquery-private"],
    function (t, e) {
      function r(t) {
        this.$title, this._create(t);
      }
      return (
        (r.prototype = {
          _create: function (r) {
            (this.$title = e("<h2></h2>")),
              this.$title.addClass("cbb-frequently-bought-title"),
              this.$title.addClass("translatable"),
              this.$title.text(r.text),
              this.$title.css({
                "text-align": "left",
                "font-size": r.size + "rem",
                color: r.color,
                "font-weight": r.isBold ? "600" : "400",
                "margin-bottom": "1rem",
              }),
              t.apply(this.$title, r.additionalStyles);
          },
          getTitle: function () {
            return this.$title;
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define("core/util/NumberUtil", [], function () {
    function t() {}
    return (
      (t.random = function (t, e) {
        return Math.floor(t + Math.random() * (e - t));
      }),
      (t.unbalancedRandom = function (t, e) {
        var r = Math.random(),
          n = Math.pow(r, 0.3);
        return Math.floor(t + n * (e - t));
      }),
      (t.percent = function (t, e) {
        return Math.floor(e * (t / 100));
      }),
      (t.interpolatedValue = function (t, e, r) {
        return t + this.percent(100 * r, e - t);
      }),
      (t.pxToNumber = function (t) {
        return Number(t.substring(0, t.length - 2));
      }),
      (t.proportionalRectangle = function (t, e, r) {
        return t / r < e
          ? {
              width: Math.ceil(e * r),
              height: e,
              offsetX: -Math.ceil((e * r - t) / 2),
              offsetY: 0,
            }
          : {
              width: t,
              height: Math.ceil(t / r),
              offsetX: 0,
              offsetY: -Math.ceil((t / r - e) / 2),
            };
      }),
      (t.isNotZero = function (t) {
        return null != t && 0 != t;
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/DeviceCssClassAdder",
    ["core/util/BrowserUtil"],
    function (t) {
      function e() {}
      return (
        (e.addDeviceClasses = function (e) {
          t.isDesktop() && e.addClass("cbb-desktop-view"),
            t.isMobile() && e.addClass("cbb-mobile-view"),
            t.isTablet() && e.addClass("cbb-tablet-view");
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/MobileMarginsAdjuster",
    ["core/util/BrowserUtil"],
    function (t) {
      function e() {}
      return (
        (e.defaultMargin = function () {
          return 15;
        }),
        (e.addHorizontalMargins = function (r) {
          t.isMobile() && e._isUpAgainstTheLeftBoundary(r) && e._setMargins(r);
        }),
        (e._isUpAgainstTheLeftBoundary = function (t) {
          var e = t.offset();
          return !!e && e.left <= 0;
        }),
        (e._setMargins = function (t) {
          var e = t.offset(),
            r = 15 - e.left;
          t.css({
            "margin-left": r + "px",
            "margin-right": r + "px",
            width: "auto",
          });
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/BoxUI",
    [
      "core/frequently-bought/util/FrequentlyBoughtWidgetAppender",
      "core/frequently-bought/TitleUI",
      "core/util/StringUtil",
      "core/util/NumberUtil",
      "core/util/BrowserUtil",
      "core/util/DeviceCssClassAdder",
      "core/util/JsonCss",
      "core/util/MobileMarginsAdjuster",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a, c, s) {
      function u(t, e, r, n, i, o, a, c) {
        (this.boxPreferences = t),
          (this.titleUI = e),
          (this.discountMessageUI = r),
          (this.productsUI = n),
          (this.selectorsUI = i),
          (this.totalPriceUI = o),
          (this.addToCartButtonUI = a),
          (this.errorUI = c),
          this._build(),
          this._append();
      }
      return (
        (u.prototype = {
          _build: function () {
            (this.$mainBox = this._buildMainBox()),
              this.$mainBox.append(this.titleUI.getTitle()),
              this.$mainBox.append(this.discountMessageUI.getMessage()),
              this.$mainBox.append(this._buildRecommendationsBox()),
              this.$mainBox.append(this.selectorsUI.getSelectorBoxes());
          },
          _buildMainBox: function () {
            var t = s("<div></div>");
            return (
              t.addClass("cbb-frequently-bought-container"),
              o.addDeviceClasses(t),
              t.css({
                width: "100%",
                height: "100%",
                clear: "both",
                "text-align": "left",
                margin: this.boxPreferences.padding + "px auto",
                "background-color": this.boxPreferences.backgroundColor,
              }),
              this.boxPreferences.showBorder &&
                t.css({
                  border: "solid 1px " + this.boxPreferences.borderColor,
                  "border-radius": "4px",
                  padding: "20px",
                }),
              this._preservePaddingAroundContent() && t.css("padding", "20px"),
              n.isNotZero(this.boxPreferences.maxWidth) &&
                t.css("max-width", this.boxPreferences.maxWidth + "px"),
              a.apply(t, this.boxPreferences.additionalPreferences),
              t
            );
          },
          _buildRecommendationsBox: function () {
            var t = s("<div></div>");
            return (
              t.addClass("cbb-frequently-bought-recommendations-container"),
              t.append(this.productsUI.getProducts()),
              t.append(
                this._buildAddToCartBox(
                  this.totalPriceUI,
                  this.addToCartButtonUI,
                  this.errorUI
                )
              ),
              t
            );
          },
          _buildAddToCartBox: function (t, e, r) {
            var n = s("<div></div>");
            return (
              n.addClass("cbb-frequently-bought-form"),
              n.css({ display: "inline-block", "margin-bottom": "12px" }),
              i.isMobile() && n.css({ width: "100%" }),
              n.append(t.getPrice()),
              n.append(r.getErrorBox()),
              n.append(e.getButton()),
              n
            );
          },
          _append: function () {
            t.append(this.$mainBox, this.boxPreferences),
              c.addHorizontalMargins(this.$mainBox);
          },
          _preservePaddingAroundContent: function () {
            return (
              this.boxPreferences.showBorder ||
              this.boxPreferences.backgroundColor
            );
          },
          width: function () {
            return Math.floor(this.$mainBox.width());
          },
        }),
        u
      );
    }
  ),
  codeblackbelt.define("core/util/dom/Watcher", [], function () {
    function t(t) {
      this.condition = t;
    }
    return (
      (t._removeInterval = function (t) {
        t && clearInterval(t);
      }),
      (t.checkIf = function (e) {
        return new t(e);
      }),
      (t.checkIndefinitelyIf = function (e) {
        return new t(e).during(0);
      }),
      (t.prototype = {
        nowAndEvery: function (t) {
          return (this.checkInitially = !0), (this.intervalMillis = t), this;
        },
        every: function (t) {
          return (this.checkInitially = !1), (this.intervalMillis = t), this;
        },
        during: function (t) {
          return (this.timeoutMillis = t), this;
        },
        then: function (t) {
          return (this.okCallback = t), this;
        },
        otherwise: function (t) {
          return (this.failCallback = t), this;
        },
        watch: function () {
          var e = this;
          if (this.checkInitially && this.condition()) this.okCallback();
          else {
            var r = setInterval(function () {
              e.condition() && (t._removeInterval(r), e.okCallback());
            }, this.intervalMillis);
            this.timeoutMillis
              ? setTimeout(function () {
                  t._removeInterval(r), e._executeFailCallbackSafely();
                }, this.timeoutMillis)
              : this._executeFailCallbackSafely();
          }
        },
        _executeFailCallbackSafely: function () {
          !this.condition() && this.failCallback && this.failCallback();
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/ViewportUtil",
    ["core/util/dom/Watcher", "core/util/Logger"],
    function (t, e) {
      function r() {}
      return (
        (r.viewable = function (e, n) {
          t.checkIndefinitelyIf(function () {
            return r._isInsideViewport(e);
          })
            .every(2500)
            .then(n)
            .watch();
        }),
        (r._isInsideViewport = function (t) {
          try {
            var r = window.innerHeight || document.documentElement.clientHeight,
              n = window.innerWidth || document.documentElement.clientWidth,
              i = t.getBoundingClientRect();
            return (
              i.top >= 0 &&
              i.left >= 0 &&
              i.bottom <= r &&
              i.right <= n &&
              i.left < i.right &&
              i.top < i.bottom
            );
          } catch (t) {
            return e.log("Error getting the element coordinates: " + t), !1;
          }
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/AjaxGet",
    ["core/util/StringUtil", "core/util/Logger", "lib/jquery-private"],
    function (t, e, r) {
      function n() {}
      var i = "www.codeblackbelt.com",
        o = { withCredentials: !0, requestVendor: i },
        a = { requestVendor: i };
      return (
        (n.jsonpGet = function (e, r, i, a, c) {
          var s = "cbbJsonpCallback" + t.replaceHyphens(e),
            u = {
              dataType: "jsonp",
              xhrFields: o,
              url: r,
              cache: !0,
              traditional: !0,
              jsonpCallback: s,
              data: i || {},
              success: function (t) {
                a && a(t);
              },
              error: function (t) {
                c && c(t);
              },
            };
          n._retryGet(u, 1);
        }),
        (n.jsonGet = function (t, e, r, i) {
          var o = {
            dataType: "json",
            xhrFields: a,
            url: t,
            cache: !0,
            data: e || {},
            success: function (t) {
              r && r(t);
            },
            error: function (t) {
              i && i(t);
            },
          };
          n._retryGet(o, 1);
        }),
        (n.jsonGetNoCache = function (t, e, r, i) {
          var o = {
            dataType: "json",
            xhrFields: a,
            url: t,
            cache: !1,
            data: e || {},
            success: function (t) {
              r && r(t);
            },
            error: function (t) {
              i && i(t);
            },
          };
          n._retryGet(o, 1);
        }),
        (n.getNoCache = function (t, e, r, i) {
          var o = {
            dataType: "html",
            xhrFields: a,
            url: t,
            cache: !1,
            data: e || {},
            success: function (t) {
              r && r(t);
            },
            error: function (t) {
              i && i(t);
            },
          };
          n._retryGet(o, 1);
        }),
        (n._retryGet = function (t, i) {
          var o = r.extend({}, t);
          (o.timeout = 3e4),
            (o.error = function (r) {
              n._mustRetry(r.status, i)
                ? (e.log(
                    "Failed call to " +
                      o.url +
                      " : " +
                      r.statusText +
                      ". Retrying..."
                  ),
                  setTimeout(function () {
                    n._retryGet(t, i - 1);
                  }, 500))
                : (e.log(
                    "Failed call to " +
                      o.url +
                      " : " +
                      r.statusText +
                      ". Will not try again. "
                  ),
                  t.error(r));
            }),
            r.ajax(o);
        }),
        (n._mustRetry = function (t, e) {
          return e > 1 && (403 != t || 500 != t);
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define("core/util/LocalStorage", [], function () {
    function t() {}
    return (
      (t.setItem = function (t, e) {
        try {
          localStorage.setItem(t, e);
        } catch (t) {}
      }),
      (t.hasItem = function (e) {
        var r = t.getItem(e);
        return r && void 0 !== r && null !== r;
      }),
      (t.getItem = function (t) {
        try {
          return localStorage.getItem(t);
        } catch (t) {
          return null;
        }
      }),
      (t.removeItem = function (t) {
        try {
          return localStorage.removeItem(t);
        } catch (t) {}
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define("core/util/DateUtil", [], function () {
    function t() {}
    return (
      (t.getTimestamp = function () {
        return new Date().getTime();
      }),
      (t.isAfterNow = function (e) {
        var r = new Date();
        return t.isAfterDate(e, r);
      }),
      (t.isAfterDate = function (t, e) {
        return new Date(t) > e;
      }),
      (t.nowPlusMilliseconds = function (e) {
        var r = new Date();
        return t.datePlusMilliseconds(r, e);
      }),
      (t.datePlusMilliseconds = function (t, e) {
        return t.getTime() + e;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/ExpiringLocalStorage",
    ["core/util/LocalStorage", "core/util/DateUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.save = function (r, n) {
          if (n) {
            var i = e.nowPlusMilliseconds(2592e6),
              o = { value: n, expirationTimeMillis: i };
            t.setItem(r, JSON.stringify(o));
          }
        }),
        (r.load = function (e) {
          var n = JSON.parse(t.getItem(e));
          return r.isDataAlive(n) ? n.value : null;
        }),
        (r.remove = function (e) {
          t.removeItem(e);
        }),
        (r.isDataAlive = function (t) {
          if (t) {
            var r = t.expirationTimeMillis;
            return r && e.isAfterNow(r);
          }
          return !1;
        }),
        (r.hasItem = function (t) {
          var e = r.load(t);
          return e && void 0 !== e && null !== e;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/StatLocalStorage",
    ["core/util/ExpiringLocalStorage"],
    function (t) {
      function e() {}
      return (
        (e.saveProductAsClicked = function (t, r, n) {
          e._saveProduct(t, "-clicked-", r, n);
        }),
        (e.saveProductAsDirectlyAdded = function (t, r, n) {
          e._saveProduct(t, "-directly-added-", r, n);
        }),
        (e.wasProductClicked = function (t, r, n) {
          return e._hasProduct(t, "-clicked-", r, n);
        }),
        (e.wasProductDirectlyAdded = function (t, r, n) {
          return e._hasProduct(t, "-directly-added-", r, n);
        }),
        (e.removeClickedProduct = function (t, r, n) {
          return e._removeProduct(t, "-clicked-", r, n);
        }),
        (e.removeDirectlyAddedProduct = function (t, r, n) {
          return e._removeProduct(t, "-directly-added-", r, n);
        }),
        (e._saveProduct = function (r, n, i, o) {
          var a = e._key(r, n, i, o);
          t.save(a, !0);
        }),
        (e._hasProduct = function (r, n, i, o) {
          var a = e._key(r, n, i, o);
          return !0 === t.load(a);
        }),
        (e._removeProduct = function (r, n, i, o) {
          var a = e._key(r, n, i, o);
          return t.remove(a);
        }),
        (e._key = function (t, e, r, n) {
          return t + e + r + n;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/AddedStatLocalStorage",
    ["core/util/StatLocalStorage"],
    function (t) {
      function e() {}
      var r = "-for-added-check";
      return (
        (e.saveProductAsClicked = function (e, n) {
          t.saveProductAsClicked(e, n, r);
        }),
        (e.saveProductAsDirectlyAdded = function (e, n) {
          t.saveProductAsDirectlyAdded(e, n, r);
        }),
        (e.wasProductClicked = function (e, n) {
          return t.wasProductClicked(e, n, r);
        }),
        (e.wasProductDirectlyAdded = function (e, n) {
          return t.wasProductDirectlyAdded(e, n, r);
        }),
        (e.removeClickedProduct = function (e, n) {
          return t.removeClickedProduct(e, n, r);
        }),
        (e.removeDirectlyAddedProduct = function (e, n) {
          return t.removeDirectlyAddedProduct(e, n, r);
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ConvertedStatLocalStorage",
    ["core/util/StatLocalStorage"],
    function (t) {
      function e() {}
      var r = "-for-converted-check";
      return (
        (e.saveProductAsClicked = function (e, n) {
          t.saveProductAsClicked(e, n, r);
        }),
        (e.saveProductAsDirectlyAdded = function (e, n) {
          t.saveProductAsDirectlyAdded(e, n, r);
        }),
        (e.wasProductClicked = function (e, n) {
          return t.wasProductClicked(e, n, r);
        }),
        (e.wasProductDirectlyAdded = function (e, n) {
          return t.wasProductDirectlyAdded(e, n, r);
        }),
        (e.removeClickedProduct = function (e, n) {
          return t.removeClickedProduct(e, n, r);
        }),
        (e.removeDirectlyAddedProduct = function (e, n) {
          return t.removeDirectlyAddedProduct(e, n, r);
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/CheckoutPresentmentCurrencyUtil",
    [],
    function () {
      function t() {}
      return (
        (t.isPresentmentCurrencyActive = function () {
          return (
            window.Shopify &&
            window.Shopify.checkout &&
            window.Shopify.checkout.currency &&
            window.Shopify.checkout.presentment_currency &&
            window.Shopify.checkout.currency !==
              window.Shopify.checkout.presentment_currency
          );
        }),
        (t.getPresentmentCurrencyInverseRate = function () {
          try {
            var t = Number(
                window.Shopify.checkout.total_price_set.shop_money.amount
              ),
              e = Number(
                window.Shopify.checkout.total_price_set.presentment_money.amount
              ),
              r = t / e;
            return isNaN(r) ? 1 : r;
          } catch (t) {
            return 1;
          }
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/StatUtil",
    [
      "core/util/AjaxGet",
      "core/util/DomainUtil",
      "core/util/AddedStatLocalStorage",
      "core/util/ConvertedStatLocalStorage",
      "core/util/ShopifyUtil",
      "core/util/CheckoutPresentmentCurrencyUtil",
    ],
    function (t, e, r, n, i, o) {
      function a() {}
      return (
        (a.rendered = function (t, e) {
          a._stats(t, "rendered", { value: e });
        }),
        (a.viewed = function (t, e) {
          a._stats(t, "viewed", { value: e });
        }),
        (a.clickedAndRedirect = function (t, e, r) {
          r.stopPropagation(),
            r.preventDefault(),
            (r.target.style.cursor = "wait"),
            (r.currentTarget.style.cursor = "wait");
          var n = a._href(r.currentTarget);
          a._clicked(t, e, function () {
            window.location.href = n;
          });
        }),
        (a._href = function (t) {
          return t.getAttribute("href")
            ? t.getAttribute("href")
            : t.getAttribute("data-href")
            ? t.getAttribute("data-href")
            : "#";
        }),
        (a._clicked = function (t, e, i) {
          a._stats(t, "clicked", {}, i),
            r.saveProductAsClicked(t, e),
            n.saveProductAsClicked(t, e);
        }),
        (a.productsDirectlyAdded = function (t, e) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r];
            a.productDirectlyAdded(t, n);
          }
        }),
        (a.productDirectlyAdded = function (t, e) {
          r.saveProductAsDirectlyAdded(t, e),
            n.saveProductAsDirectlyAdded(t, e),
            r.removeClickedProduct(t, e),
            n.removeClickedProduct(t, e);
        }),
        (a.checkCartProducts = function (t, e) {
          if (0 !== e.length) {
            for (var n = 0, i = 0, o = 0; o < e.length; o++) {
              var c = e[o].getId(),
                s = e[o].getQuantity();
              r.wasProductClicked(t, c) &&
                ((n += s), r.removeClickedProduct(t, c)),
                r.wasProductDirectlyAdded(t, c) &&
                  ((i += s), r.removeDirectlyAddedProduct(t, c));
            }
            (n > 0 || i > 0) && a._added(t, n, i);
          }
        }),
        (a._added = function (t, e, r) {
          a._stats(t, "added", { added: e, directlyAdded: r });
        }),
        (a.checkThankYouProducts = function (t, e, r) {
          for (
            var i = 0, c = 0, s = 0, u = 0, l = 0, d = 0;
            d < e.length;
            d++
          ) {
            var f = e[d],
              h = f.getId();
            n.wasProductClicked(t, h) &&
              ((i += f.getQuantity()),
              (s += f.getQuantity() * f.getPrice()),
              n.removeClickedProduct(t, h)),
              n.wasProductDirectlyAdded(t, h) &&
                ((c += f.getQuantity()),
                (u += f.getPrice()),
                n.removeDirectlyAddedProduct(t, h)),
              (l += f.getQuantity() * f.getPrice());
          }
          if (o.isPresentmentCurrencyActive()) {
            var p = o.getPresentmentCurrencyInverseRate();
            (s = Math.round(s * p)),
              (u = Math.round(u * p)),
              (l = Math.round(l * p));
          }
          a._converted(t, i, c, s, u, l, r);
        }),
        (a._converted = function (t, e, r, n, i, o, c) {
          a._stats(
            t,
            "converted",
            {
              converted: e,
              directlyConverted: r,
              convertedAmount: Math.round(n),
              directlyConvertedAmount: Math.round(i),
              purchasedAmount: Math.round(o),
            },
            c
          );
        }),
        (a._stats = function (r, n, o, a) {
          var c = e.baseUrl() + "/" + r + "/stats/" + n + ".json";
          o.shop = i.getShop();
          var s = a;
          t.jsonGetNoCache(c, o, a, s);
        }),
        (a.prototype = {}),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/ProductsUI",
    [
      "core/util/BrowserUtil",
      "core/util/ViewportUtil",
      "core/util/StatUtil",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i(t) {
        (this.numberOfBundleProducts = t), this._create();
      }
      return (
        (i.prototype = {
          _create: function () {
            (this.$products = n("<ul></ul>")),
              this.$products.addClass("cbb-frequently-bought-products"),
              this.$products.attr("aria-hidden", "true"),
              this.$products.attr("role", "none"),
              this.$products.css({
                display: "inline-block",
                float: "left",
                "vertical-align": "middle",
                "list-style": "none",
                padding: "0",
                margin: "0 15px 15px 0",
              }),
              t.isMobile() &&
                (this.$products.css({
                  "max-width": "100%",
                  width: "100%",
                  margin: "0",
                }),
                this.numberOfBundleProducts <= 3 &&
                  this.$products.css("text-align", "center")),
              this._prepareViewStats();
          },
          getProducts: function () {
            return this.$products;
          },
          addProduct: function (t) {
            var e = t.getProduct();
            this.$products.append(e);
          },
          _prepareViewStats: function () {
            var t = this;
            e.viewable(this.$products[0], function () {
              var e = t.$products.children().length;
              r.viewed("frequently-bought-together", e);
            });
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/SelectorsUI",
    ["lib/jquery-private"],
    function (t) {
      function e() {
        this.$selectorBoxes,
          (this.selectors = []),
          (this.ratingBoxes = []),
          this._create();
      }
      return (
        (e.prototype = {
          _create: function () {
            (this.$selectorBoxes = t("<ul></ul>")),
              this.$selectorBoxes.addClass(
                "cbb-frequently-bought-selector-list"
              ),
              this.$selectorBoxes.css({
                "list-style": "none",
                display: "block",
                clear: "left",
                "padding-left": "0",
                "margin-left": "0",
              });
          },
          getSelectorBoxes: function () {
            return this.$selectorBoxes;
          },
          getRatingBoxes: function () {
            return this.ratingBoxes;
          },
          getSelectors: function () {
            return this.selectors;
          },
          addSelector: function (t) {
            this.ratingBoxes.push(t.getRatingBox()),
              this.$selectorBoxes.append(t.getSelector()),
              this.selectors.push(t);
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/util/ProductImageUtil",
    ["core/util/BrowserUtil"],
    function (t) {
      function e() {}
      return (
        (e.plusIconWidthPx = function () {
          return 19;
        }),
        (e.productPaddingPx = function () {
          return 5;
        }),
        (e.totalProductPaddingPx = function () {
          return 10;
        }),
        (e.deviceAwareWidth = function (r, n, i) {
          return t.isMobile() ? e._mobileWidth(r, i) : n;
        }),
        (e._mobileWidth = function (t, r) {
          var n = e._worstCasePlusIconPadding(r),
            i = e._fixWidthRoundingError(t),
            o = Math.floor(i - n),
            a = e._maxProductsPerRow(r);
          return Math.floor(o / a);
        }),
        (e._fixWidthRoundingError = function (t) {
          return t - 1;
        }),
        (e._maxProductsPerRow = function (t) {
          return 1 === t ? 1 : t % 2 == 0 ? 2 : 3;
        }),
        (e._worstCasePlusIconPadding = function (t) {
          return t > 3 ? 87 : 29 * (t - 1) + 10;
        }),
        (e.deviceAwareHeight = function (r, n, i, o) {
          if (t.isMobile()) {
            var a = e._mobileWidth(r, o),
              c = i / n;
            return Math.round(a * c);
          }
          return i;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define("core/util/CssUtil", [], function () {
    function t() {}
    return (
      (t.isHidden = function (t) {
        return "none" === t.css("display");
      }),
      (t.isVisible = function (e) {
        return !t.isHidden(e);
      }),
      (t.isTextDecorationLineThrough = function (t) {
        var e = t.css("text-decoration");
        if (e && e.indexOf("line-through") >= 0) return !0;
        var r = t.attr("style");
        return !!(r && r.indexOf("line-through") >= 0);
      }),
      (t.hide = function (t) {
        t.hide();
      }),
      (t.show = function (t) {
        t.show();
      }),
      (t.margin = function (e) {
        return {
          top: t.pixelsToInteger(e.css("margin-top")),
          right: t.pixelsToInteger(e.css("margin-right")),
          bottom: t.pixelsToInteger(e.css("margin-bottom")),
          left: t.pixelsToInteger(e.css("margin-left")),
        };
      }),
      (t.offset = function (e) {
        return {
          top: t.pixelsToInteger(e.css("top")),
          right: t.pixelsToInteger(e.css("right")),
          bottom: t.pixelsToInteger(e.css("bottom")),
          left: t.pixelsToInteger(e.css("left")),
        };
      }),
      (t.addImportantCssToElement = function (t, e, r) {
        var n = t.attr("style"),
          i = n + " " + e + ": " + r + " !important;";
        t.attr("style", i);
      }),
      (t.pixelsToInteger = function (t) {
        var e = parseInt(t, 10);
        return isNaN(e) ? 0 : e;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/currency/price/PriceElementUtil",
    ["core/util/CssUtil", "core/util/StringUtil", "lib/jquery-private"],
    function (t, e, r) {
      function n() {}
      var i =
        ".currency-converter-wrapper-amount-box,.currency-converter-amount-box,.cbb-currency-flag,.currency-converter-amount,.cbb-price-symbol,.cbb-price-digits,.cbb-price-code,.cbb-currency-updown-icon,.currency-converter-chooser,.currency-converter-chooser-item";
      return (
        (n.hasCbbClass = function (t) {
          return t.is(i) || t.parents(i).length > 0;
        }),
        (n.isDiscountPrice = function (e, r) {
          return (
            n._isDiscountPriceTag(e, r) ||
            n._isDiscountPriceClass(e, r) ||
            t.isTextDecorationLineThrough(e)
          );
        }),
        (n._isDiscountPriceTag = function (t, e) {
          var r = "del,s,strike" + (e ? "," + e : "");
          return t.is(r) || t.parents(r).length > 0;
        }),
        (n._isDiscountPriceClass = function (t, e) {
          var r =
            ".cbb-discount-price,.was,.was_price,.old-price,.pmo_strike,.compare-price,.compare-at-price,.compare_at_price,.price-compare-at,.sale-tag,.ls-original-price,.grid-link__sale_price,.product-single__price--compare-at,.product_compare_price,.grid-product__price--original,.product__price--compare,.Price--compareAt,#so-compare-at-label-wrap,.card__price--regular-strike" +
            (e ? "," + e : "");
          return t.is(r) || t.parents(r).length > 0;
        }),
        (n.isSimplifiedPrice = function (t, e) {
          var r =
            ".info-bar,.announcement-bar,.announcement-bar--mobile,.announcement,.shopify-policy__container,.bannertop,.promo_banner,.notification-bar,.promo-bar,#fsb_bar,#revy-motivator-bar,#qab_background,.pxs-announcement-bar,.siteAlert,.site-header--text-links,.header-bar__left,.header-bar__message,.__seguno-banner-container,.cart-toggle,.header-cart_preview,#CartDropdown,.top-cart,.header-cart-btn,#cart_block,#shopify-section-hero,.hero__text-content,.afterpay-paragraph,.btn--add-to-cart,.ProductForm__AddToCart,#CartButton,#addToCart-product-template,.prod_label,.save-badge2,.tdf_ribbon,.customer-links,.save_amount_two,#store-return-amp-exchange,.price--compare-at,.grid-product__on-sale,.STP-tiers,#refund-policy,#htusb_container_html_prod_generic_pricing,.so-field-wrap,.so-btn-add-to-cart,.product-description,.product-single__description,#satcb_checkout_btn,.saso-summary,.shipsell-calculator,.testimonial,#productPhoto,.hulkapps-volumes,#bold-modal__content,.selectric-wrapper,.tt-services-block,.quantity-breaks-now-discount-table,.shappify-qty-msg,.shappify_qb_grid,.htusb-ui-cart-text,.cart__product-name,.cart-item--total,.cart-item--sale-price,.cart-item--content-price,#booster-summary-item,.rte,.price-comment,.sro-message,.header__cart-price-bubble,.grid-product__tag--sale" +
            (e ? "," + e : "");
          return t.is(r) || t.parents(r).length > 0;
        }),
        (n.isValidElement = function (t) {
          return !t.is(
            "option, sup, script, style, noscript, link, header, footer, meta, title, iframe, head, img, select"
          );
        }),
        (n.containsSuperScriptPrice = function (t) {
          var e = t.children("sup");
          if (1 === e.length) {
            var n = e.first().text();
            return r.isNumeric(n);
          }
          return !1;
        }),
        (n.extractPlainSuperScriptPrice = function (t, r) {
          var n = t.html(),
            i = n
              .replace(/[,.]/, "")
              .replace(/\s*\n*<sup>\s*\n*/, r)
              .replace(/\s*\n*<\/sup>/, "");
          return e.removeWhiteSpaces(i);
        }),
        (n.isAProductPrice = function (t, e) {
          return !n._ignoreElement(t, e);
        }),
        (n.isAShoppingCartPrice = function (t, e) {
          return !n._ignoreElement(t, e) && !n._isNotAChildOfAForm(t);
        }),
        (n._ignoreElement = function (t, e) {
          var r =
            ".cbb-ignored-price,.cbb-frequently-bought-selector-label-name,.cbb-frequently-bought-selector-label-description,.cbb-also-bought-product-name,.cbb-also-bought-product-description,#CartCount,#productDescription,#bk-coupon-box,#top-bar,.spr-review-content-body,.product-single__title,.message,.currency-converter-currency-button,.grid-link__title,.grid-product__title,.ajaxcart__product-name--wrapper,.breadcrumb--truncate,.visually-hidden,.bcpo,.df-card__title,.df-card__description,.s_um_dropdowndiv,.product-aside .product-title,.box.product a.title,.cart-preview .product-title,.cart-item-product .cart-item-title,nav.breadcrumb,.pagination,#judgeme_product_reviews,.jdgm-carousel-wrapper,.faq-main-wrap,.site-nav__link,.product-card__name,.site-nav__dropdown-link,.site-nav__dropdown-container .meganav__link,.cart-img" +
            (e ? "," + e : "");
          return t.is(r) || t.parents(r).length > 0;
        }),
        (n._isNotAChildOfAForm = function (t) {
          return 0 === t.parents("form").length;
        }),
        (n._isACheckoutForm = function (t) {
          return -1 !== t.parents("form").attr("action").indexOf("/checkout");
        }),
        (n._isACartActionForm = function (t) {
          return -1 !== t.parents("form").attr("action").indexOf("/cart/");
        }),
        (n.markAsProcessed = function (t) {
          t.attr("data-cbb-price-processed", "true");
        }),
        (n.markAsUnprocessed = function (t) {
          t.attr("data-cbb-price-processed", "false");
        }),
        (n.isUnProcessed = function (t) {
          return !n.isProcessed(t);
        }),
        (n.isProcessed = function (t) {
          return "true" === t.attr("data-cbb-price-processed");
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp("\\{\\{\\s?amount\\s?\\}\\}").test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(\\d+[,]{0,1})+([.](\\d+))?\\s?)";
          },
          getDecimalSymbol: function () {
            return ".";
          },
          hasDecimals: function () {
            return !0;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountNoDecimalsFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp("\\{\\{\\s?amount_no_decimals\\s?\\}\\}").test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_no_decimals}}";
          },
          getDigitsRegex: function (t) {
            return "CLP" === t
              ? "(\\s?(((\\d+[.|,]){1,}\\d+)|(\\d+))\\s?)"
              : "(\\s?(((\\d+[,]){1,}\\d+)|(\\d+))\\s?)";
          },
          getDecimalSymbol: function () {
            return null;
          },
          hasDecimals: function () {
            return !1;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountWithCommaSeparatorFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp(
            "\\{\\{\\s?amount_with_comma_separator\\s?\\}\\}"
          ).test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_with_comma_separator}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(\\d+[.]{0,1})+([,](\\d+))?\\s?)";
          },
          getDecimalSymbol: function () {
            return ",";
          },
          hasDecimals: function () {
            return !0;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountNoDecimalsWithCommaSeparatorFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp(
            "\\{\\{\\s?amount_no_decimals_with_comma_separator\\s?\\}\\}"
          ).test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_no_decimals_with_comma_separator}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(((\\d+[.]){1,}\\d+)|(\\d+))\\s?)";
          },
          getDecimalSymbol: function () {
            return null;
          },
          hasDecimals: function () {
            return !1;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountNoDecimalsWithSpaceSeparatorFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp(
            "\\{\\{\\s?amount_no_decimals_with_space_separator\\s?\\}\\}"
          ).test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_no_decimals_with_space_separator}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(((\\d{1,3}\\s{1}){1,})|(\\d{1,3}))\\s?)";
          },
          getDecimalSymbol: function () {
            return null;
          },
          hasDecimals: function () {
            return !1;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountWithSpaceSeparatorFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp(
            "\\{\\{\\s?amount_with_space_separator\\s?\\}\\}"
          ).test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_with_space_separator}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(\\d{1,3}\\s{1})*(\\d{1,3}[,]\\d{2})\\s?)";
          },
          getDecimalSymbol: function () {
            return ",";
          },
          hasDecimals: function () {
            return !0;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/formats/AmountWithApostropheSeparatorFormat",
    [],
    function () {
      function t(t) {
        this.moneyFormat = t;
      }
      return (
        (t.matchesExpression = function (t) {
          return new RegExp(
            "\\{\\{\\s?amount_with_apostrophe_separator\\s?\\}\\}"
          ).test(t);
        }),
        (t.prototype = {
          setMoneyFormat: function (t) {
            this.moneyFormat = t;
          },
          getMoneyFormat: function () {
            return this.moneyFormat;
          },
          getExpression: function () {
            return "{{amount_with_apostrophe_separator}}";
          },
          getDigitsRegex: function () {
            return "(\\s?(\\d{1,3}'{1})*(\\d{1,3}[.]\\d{2})\\s?)";
          },
          getDecimalSymbol: function () {
            return ".";
          },
          hasDecimals: function () {
            return !0;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/AmountFormatFactory",
    [
      "core/currency/price/formats/AmountFormat",
      "core/currency/price/formats/AmountNoDecimalsFormat",
      "core/currency/price/formats/AmountWithCommaSeparatorFormat",
      "core/currency/price/formats/AmountNoDecimalsWithCommaSeparatorFormat",
      "core/currency/price/formats/AmountNoDecimalsWithSpaceSeparatorFormat",
      "core/currency/price/formats/AmountWithSpaceSeparatorFormat",
      "core/currency/price/formats/AmountWithApostropheSeparatorFormat",
      "core/util/Logger",
    ],
    function (t, e, r, n, i, o, a, c) {
      function s() {}
      return (
        (s.amountFormatFor = function (s) {
          return t.matchesExpression(s)
            ? new t(s)
            : e.matchesExpression(s)
            ? new e(s)
            : r.matchesExpression(s)
            ? new r(s)
            : n.matchesExpression(s)
            ? new n(s)
            : i.matchesExpression(s)
            ? new i(s)
            : o.matchesExpression(s)
            ? new o(s)
            : a.matchesExpression(s)
            ? new a(s)
            : (c.log("Unsupported money format: " + s), null);
        }),
        (s.prototype = {}),
        s
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceRegex",
    ["core/currency/price/AmountFormatFactory", "core/util/StringUtil"],
    function (t, e) {
      function r(e, r) {
        var a = t.amountFormatFor(e),
          c = "("
            .concat(e)
            .replace(a.getExpression(), a.getDigitsRegex(r))
            .replace(/\s/g, n)
            .replace("$", i)
            .replace(o, "")
            .concat(")");
        this.priceRegex = new RegExp(c);
      }
      var n = "\\s?",
        i = "\\$",
        o = /[\u200B-\u200D\uFEFF]/g;
      return (
        (r.prototype = {
          isPrice: function (t) {
            return (this.priceRegex.lastIndex = 0), this.priceRegex.test(t);
          },
          price: function (t) {
            return this._extractPrice(t, 2);
          },
          rawPrice: function (t) {
            return this._extractPrice(t, 1);
          },
          _extractPrice: function (t, r) {
            this.priceRegex.lastIndex = 0;
            var n = this.priceRegex.exec(t);
            return null !== n ? e.removeWhiteSpaces(n[r]) : null;
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceFormatResolver",
    [
      "core/currency/util/PriceRegex",
      "core/currency/price/AmountFormatFactory",
    ],
    function (t, e) {
      function r(e, r, n) {
        (this.moneyFormat = this._trimMoneyFormat(e)),
          (this.moneyFormatWithCurrency = this._trimMoneyFormat(r)),
          (this.moneyFormatRegex = new t(this.moneyFormat, n)),
          (this.moneyFormatWithCurrencyRegex = new t(
            this.moneyFormatWithCurrency,
            n
          ));
      }
      return (
        (r.prototype = {
          matchesAnyPriceFormat: function (t) {
            return null !== this._moneyFormatForPrice(t);
          },
          amountFormatForPrice: function (t) {
            var r = this._moneyFormatForPrice(t);
            return e.amountFormatFor(r);
          },
          _moneyFormatForPrice: function (t) {
            return this.moneyFormatWithCurrencyRegex.isPrice(t)
              ? this.moneyFormatWithCurrency
              : this.moneyFormatRegex.isPrice(t)
              ? this.moneyFormat
              : null;
          },
          _trimMoneyFormat: function (t) {
            return t.replace(/\{\{\s?/, "{{").replace(/\s?\}\}/, "}}");
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceExtractor",
    ["core/currency/util/PriceRegex"],
    function (t) {
      function e() {}
      return (
        (e.rawPrice = function (e, r, n) {
          return new t(r.getMoneyFormat(), n).rawPrice(e);
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define("core/currency/util/PriceConverter", [], function () {
    function t() {}
    return (
      (t.convertedPrice = function (e, r, n, i) {
        var o = t._convertPrice(e, r);
        return t._round(o, r, n, i);
      }),
      (t._convertPrice = function (t, e) {
        return t * e;
      }),
      (t._round = function (e, r, n, i) {
        if (t._roundingApplicable(e, r, i)) {
          var o = Math.round(e);
          return i.roundTo99 && (o = t._roundTo99(o, n)), o;
        }
        return e;
      }),
      (t._roundingApplicable = function (t, e, r) {
        return !(t < 1) && (!(1 === e) || !r.roundOnlyConverted) && r.rounding;
      }),
      (t._roundTo99 = function (e, r) {
        return e - t._roundAmount(r);
      }),
      (t._roundAmount = function (t) {
        if (0 === t) return 0;
        for (var e = 1, r = 0; r < t; r++) e /= 10;
        return e;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/currency/util/PricePatternAnalyzer",
    [],
    function () {
      function t() {}
      return (
        (t.patternMetadata = function (e, r) {
          return {
            decimalSeparator: t._decimalSeparator(e),
            symbol: r,
            symbolFirst: t._symbolFirst(e, r),
            symbolSpaced: t._symbolSpaced(e, r),
          };
        }),
        (t.decimalPrecision = function (t) {
          var e = t.indexOf("#") + 1,
            r = t.lastIndexOf("#");
          return r < e ? 0 : r - e;
        }),
        (t._decimalSeparator = function (t) {
          var e = new RegExp("(#){1}(,|.){1}(#*)"),
            r = e.exec(t);
          return null !== r ? r[2] : ".";
        }),
        (t._symbolFirst = function (t, e) {
          return t.indexOf(e) < t.indexOf("#");
        }),
        (t._symbolSpaced = function (t, e) {
          var r = e.replace("$", "\\$");
          return new RegExp("(\\s" + r + "|" + r + "\\s)").test(t);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define("core/currency/util/PriceMetadata", [], function () {
    function t(t, e) {
      (this.integerPart = t), (this.decimalPart = e);
    }
    return (
      (t.prototype = {
        getIntegerPart: function () {
          return this.integerPart;
        },
        getDecimalPart: function () {
          return this.decimalPart;
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/currency/util/PriceAnalyzer",
    ["core/currency/util/PriceMetadata"],
    function (t) {
      function e(t) {
        this.price = t;
      }
      return (
        (e.prototype = {
          priceMetadata: function (e) {
            var r = this._integerPart(e),
              n = this._decimalPart(e);
            return new t(r, n);
          },
          _integerPart: function (t) {
            if (null != this.price) {
              var e = this.price.toFixed(t);
              return String(Math.floor(e));
            }
            return "0";
          },
          _decimalPart: function (t) {
            if (null != this.price) {
              var e = this._requiredPrecision(t),
                r = this.price.toFixed(e);
              (r %= 1),
                (r = 1 + r),
                (r = r.toFixed(e + 1)),
                (r *= Math.pow(10, e)),
                (r = Math.round(r));
              var n = String(r);
              return (n = n.substr(1));
            }
            return "0";
          },
          _requiredPrecision: function (t) {
            var e = this._extractRequiredPrecision(t);
            return e > t ? Math.min(8, e) : t;
          },
          _extractRequiredPrecision: function (t) {
            if (this._integerPart() > 0) return t;
            var e = String(this.price).split(".");
            if (e.length > 1) {
              var r = e[1],
                n = this._countLeadingZeros(r);
              return n >= t ? n + 1 : t;
            }
            return t;
          },
          _countLeadingZeros: function (t) {
            for (var e = 0; "0" === t.charAt(e) && e < t.length; ) e++;
            return e;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceFormatter",
    [
      "core/currency/util/PricePatternAnalyzer",
      "core/currency/util/PriceAnalyzer",
    ],
    function (t, e) {
      function r() {}
      return (
        (r.format = function (n, i, o, a, c) {
          var s = t.decimalPrecision(o),
            u = new e(n).priceMetadata(s),
            l = t.patternMetadata(o, a),
            d = r._mustFormatWithDecimals(n, i, s);
          return r._formatMetadata(u, l, d, c);
        }),
        (r._formatMetadata = function (t, e, n, i) {
          var o = t.getIntegerPart(),
            a = e.decimalSeparator,
            c = r._formatIntegerPart(o, i);
          return n ? c + a + t.getDecimalPart() : c;
        }),
        (r._mustFormatWithDecimals = function (t, e, r) {
          return (t > 0 && t < 1) || (e.hasDecimals() && r > 0);
        }),
        (r._formatIntegerPart = function (t, e) {
          return t.replace(/\B(?=(\d{3})+(?!\d))/g, e);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceNormalizer",
    [
      "core/currency/util/PriceRegex",
      "core/util/StringUtil",
      "core/util/Logger",
    ],
    function (t, e, r) {
      function n(t, e, r) {
        (this.priceText = t), (this.amountFormat = e), (this.currency = r);
      }
      return (
        (n.normalize = function (t, e, r) {
          return new n(t, e, r)._normalizeFromPattern();
        }),
        (n.prototype = {
          _normalizeFromPattern: function () {
            var t = this._plainPrice();
            r.debug("Plain price: " + t);
            var e = this._integerPart(t);
            r.debug("Integer part: " + e);
            var n = this._decimalPart(t);
            return (
              r.debug("Decimal part: " + n), this._fullNormalizedPrice(e, n)
            );
          },
          _plainPrice: function () {
            return new t(
              this.amountFormat.getMoneyFormat(),
              this.currency
            ).price(this.priceText);
          },
          _integerPart: function (t) {
            var r;
            if (null !== this.amountFormat.getDecimalSymbol()) {
              r = t.split(this.amountFormat.getDecimalSymbol())[0];
            } else r = t;
            return (
              (r = r.replace(/\,/g, "")),
              (r = r.replace(/\./g, "")),
              (r = r.replace(/\s/g, "")),
              (r = r.replace(/\'/g, "")),
              (r = e.removeWhiteSpaces(r))
            );
          },
          _decimalPart: function (t) {
            if (null !== this.amountFormat.getDecimalSymbol()) {
              var r,
                n = t.split(this.amountFormat.getDecimalSymbol());
              return (
                n.length > 1 && ((r = n[1]), (r = e.removeWhiteSpaces(r))), r
              );
            }
            return null;
          },
          _fullNormalizedPrice: function (t, e) {
            var n;
            return (
              (n = null != e ? t + "." + e : t),
              r.debug("Normalized price: " + n),
              Number(n)
            );
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/util/PriceBoilerplateTextAnalyzer",
    [],
    function () {
      function t() {}
      return (
        (t.priceTextMetadata = function (e, r) {
          return {
            leadingText: t._findLeadingText(e, r),
            trailingText: t._findTrailingText(e, r),
          };
        }),
        (t._findLeadingText = function (t, e) {
          return 0 !== t.indexOf(e) ? t.substr(0, t.indexOf(e)) : null;
        }),
        (t._findTrailingText = function (t, e) {
          var r = t.indexOf(e) + e.length;
          return r < t.length ? t.substr(r, t.length - 1) : null;
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/currency/price/Price",
    [
      "core/currency/price/PriceElementUtil",
      "core/currency/price/AmountFormatFactory",
      "core/currency/util/PriceFormatResolver",
      "core/currency/util/PriceExtractor",
      "core/currency/util/PriceConverter",
      "core/currency/util/PriceFormatter",
      "core/currency/util/PriceNormalizer",
      "core/currency/util/PriceBoilerplateTextAnalyzer",
      "core/currency/util/PricePatternAnalyzer",
      "core/util/CssUtil",
      "core/util/StringUtil",
      "core/util/Logger",
    ],
    function (t, e, r, n, i, o, a, c, s, u, l, d) {
      function f(t, e) {
        (this.$element = t), this._build(e);
      }
      return (
        (f.GOOGLE_TRANSLATE_INHIBIT_CLASS = "skiptranslate notranslate"),
        (f.prototype = {
          _build: function (t) {
            this._readConfiguration(t), this._initialize();
          },
          _readConfiguration: function (t) {
            t &&
              ((this.priceConfiguration = t),
              (this.ratio = t.ratio),
              (this.roundingPreferences = t.roundingPreferences),
              (this.pattern = t.pattern),
              (this.symbol = t.symbol),
              (this.thousandSymbol = t.thousandSymbol),
              (this.code = t.code),
              (this.decimalPrecision = s.decimalPrecision(this.pattern)),
              (this.moneyFormat = t.priceFormat),
              (this.moneyFormatWithCurrency = t.priceFormatWithCurrency),
              (this.shopCurrencyCode = t.shopCurrencyCode),
              (this.amountBoxIsEmpty = t.isAmountBoxEmpty()),
              (this.amountFormat = e.amountFormatFor(t.priceFormat)),
              (this.customDiscountedPriceSelectors =
                t.customDiscountedPriceSelectors),
              (this.customSimplifiedPriceSelectors =
                t.customSimplifiedPriceSelectors));
          },
          _initialize: function () {
            if (
              (this.$element.addClass(f.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              (this.originalElementText = this.$element.html()),
              (this.priceFormatResolver = new r(
                this.moneyFormat,
                this.moneyFormatWithCurrency,
                this.shopCurrencyCode
              )),
              (this.patchedText = this._extractPriceText()),
              (this.amountFormat =
                this.priceFormatResolver.amountFormatForPrice(
                  this.patchedText
                )),
              null == this.amountFormat)
            )
              return void d.log(
                "Price conversion aborted for " + this.originalElementText
              );
            (this.priceText = n.rawPrice(
              this.patchedText,
              this.amountFormat,
              this.shopCurrencyCode
            )),
              (this.priceNumber = a.normalize(
                this.priceText,
                this.amountFormat,
                this.shopCurrencyCode
              )),
              (this.convertedPrice = i.convertedPrice(
                this.priceNumber,
                this.ratio,
                this.decimalPrecision,
                this.roundingPreferences
              )),
              (this.formattedPrice = o.format(
                this.convertedPrice,
                this.amountFormat,
                this.pattern,
                this.symbol,
                this.thousandSymbol
              )),
              (this.boilerplateTextMetadata = c.priceTextMetadata(
                this.patchedText,
                this.priceText
              ));
          },
          _extractPriceText: function () {
            return l.removeWhiteSpaces(this.$element.text());
          },
          setElement: function (t) {
            (this.$element = t), this._build();
          },
          getElement: function () {
            return this.$element;
          },
          isAmountBoxEmpty: function () {
            return this.amountBoxIsEmpty;
          },
          isRegularPrice: function () {
            return !0;
          },
          isNotDiscountPrice: function () {
            return !this.isDiscountPrice();
          },
          isDiscountPrice: function () {
            return t.isDiscountPrice(
              this.$element,
              this.customDiscountedPriceSelectors
            );
          },
          isNotSimplifiedPrice: function () {
            return !this.isSimplifiedPrice();
          },
          isSimplifiedPrice: function () {
            return t.isSimplifiedPrice(
              this.$element,
              this.customSimplifiedPriceSelectors
            );
          },
          isDeletedPrice: function () {
            return 0 === this.$element.parent().length;
          },
          isEmptyPrice: function () {
            return l.isEmpty(this._extractPriceText());
          },
          getText: function () {
            return this.originalElementText;
          },
          getPrice: function () {
            return this.priceNumber;
          },
          getRawPrice: function () {
            return this.priceText;
          },
          getFormattedPrice: function () {
            return this.formattedPrice;
          },
          markAsProcessed: function () {
            t.markAsProcessed(this.$element);
          },
          markAsUnprocessed: function () {
            t.markAsUnprocessed(this.$element);
          },
          isProcessed: function () {
            return t.isProcessed(this.$element);
          },
          replaceWithAmountBox: function (t) {
            this.appendAmountBox(t), this.hide();
          },
          appendAmountBox: function (t) {
            (this.amountBox = t),
              this.$element.after(this.amountBox.boxElement()),
              this.markAsProcessed();
          },
          updateReplacedAmountBox: function (t) {
            this.updateAmountBox(t), this.hide();
          },
          updateAmountBox: function (t) {
            t && this._readConfiguration(t),
              (this.convertedPrice = i.convertedPrice(
                this.priceNumber,
                this.ratio,
                this.decimalPrecision,
                this.roundingPreferences
              )),
              (this.formattedPrice = o.format(
                this.convertedPrice,
                this.amountFormat,
                this.pattern,
                this.symbol,
                this.thousandSymbol
              )),
              this.amountBox && this.amountBox.update();
          },
          removeAmountBox: function () {
            this.amountBox && this.amountBox.remove(),
              this.show(),
              this.markAsUnprocessed();
          },
          getAmountBox: function () {
            return this.amountBox;
          },
          rebuildPriceChanged: function () {
            this._build();
          },
          hasChanged: function () {
            return this.patchedText !== this._extractPriceText();
          },
          hide: function () {
            this.$element.hide();
          },
          show: function () {
            this.$element.show();
          },
          html: function () {
            return this.$element.html();
          },
          getFontFamily: function () {
            return this.$element.css("font-family");
          },
          getFontSize: function () {
            return this.$element.css("font-size");
          },
          getFontWeight: function () {
            return this.$element.css("font-weight");
          },
          getFontColor: function () {
            return this.$element.css("color");
          },
          getAttribute: function (t) {
            return this.$element.attr(t);
          },
          isHidden: function () {
            return u.isHidden(this.$element);
          },
          isTableDataElement: function () {
            return this.$element.is("td");
          },
          isNotLabelElement: function () {
            return !this.isLabelElement();
          },
          isLabelElement: function () {
            return this.$element.is("label");
          },
        }),
        f
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ShopifyMasterImageBuilder",
    ["core/util/StringUtil"],
    function (t) {
      function e(t) {
        for (var e = [], r = 0; r < t.length; r++)
          for (var n = 0; n < a.length; n++) {
            var i = a[n],
              o = t[r] + i;
            e.push({ pattern: o, replacement: i });
          }
        return e;
      }
      function r() {}
      var n = /_\d+x\d*(\.\w+)$/i,
        i = /_x\d+(\.\w+)$/i,
        o = [
          "_1x1.gif",
          "_1x1.jpeg",
          "_1x1.jpg",
          "_1x1.png",
          "_1x1.GIF",
          "_1x1.JPEG",
          "_1x1.JPG",
          "_1x1.PNG",
        ],
        a = [".gif", ".jpeg", ".jpg", ".png", ".GIF", ".JPEG", ".JPG", ".PNG"],
        c = [
          { pattern: ".progressive.jpg", replacement: ".jpg" },
          { pattern: ".progressive.JPG", replacement: ".JPG" },
          { pattern: ".progressive.png", replacement: ".png" },
          { pattern: ".progressive.PNG", replacement: ".PNG" },
          { pattern: ".progressive.gif.jpg", replacement: ".gif" },
          { pattern: ".progressive.jpeg.jpg", replacement: ".jpeg" },
          { pattern: ".progressive.png.jpg", replacement: ".png" },
          { pattern: ".progressive.GIF.jpg", replacement: ".GIF" },
          { pattern: ".progressive.JPEG.jpg", replacement: ".JPEG" },
          { pattern: ".progressive.PNG.jpg", replacement: ".PNG" },
          { pattern: ".gif.jpg", replacement: ".gif" },
          { pattern: ".jpeg.jpg", replacement: ".jpeg" },
          { pattern: ".png.jpg", replacement: ".png" },
          { pattern: ".GIF.jpg", replacement: ".GIF" },
          { pattern: ".JPEG.jpg", replacement: ".JPEG" },
          { pattern: ".PNG.jpg", replacement: ".PNG" },
        ],
        s = e(["_{width}x", "_{width}X"]),
        u = e(["@2x", "@3x", "@2X", "@3X"]),
        l = e([
          "_crop_top",
          "_crop_center",
          "_crop_bottom",
          "_crop_left",
          "_crop_right",
        ]),
        d = e([
          "_pico",
          "_icon",
          "_thumb",
          "_small",
          "_compact",
          "_medium",
          "_large",
          "_grande",
          "_original",
          "_master",
        ]);
      return (
        (r.masterImageSrc = function (t) {
          var e = t,
            n = r._urlParameters(e);
          return (
            (e = r._removeUrlParameters(e)),
            (e = r._removeParameter(e, c)),
            (e = r._removeParameter(e, s)),
            (e = r._removeParameter(e, u)),
            (e = r._removeParameter(e, l)),
            (e = r._removeSizeParameter(e)),
            (e = r._addUrlParameters(e, n))
          );
        }),
        (r._urlParameters = function (t) {
          var e = t.indexOf("?");
          return -1 !== e ? t.substring(e) : "";
        }),
        (r._removeUrlParameters = function (t) {
          var e = t.indexOf("?");
          return -1 !== e ? t.substring(0, e) : t;
        }),
        (r._removeParameter = function (e, r) {
          for (var n = 0; n < r.length; n++) {
            var i = r[n];
            if (t.endsWith(e, i.pattern))
              return t.replaceLast(e, i.pattern, i.replacement);
          }
          return e;
        }),
        (r._removeSizeParameter = function (e) {
          for (var a = 0; a < o.length; a++) {
            var c = o[a];
            if (t.endsWith(e, c)) return e;
          }
          return e.match(n)
            ? e.replace(n, "$1")
            : e.match(i)
            ? e.replace(i, "$1")
            : r._removeParameter(e, d);
        }),
        (r._addUrlParameters = function (t, e) {
          return t + e;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ImageSizedSrcBuilder",
    ["core/util/ShopifyMasterImageBuilder", "core/util/StringUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.imageSrcForSize = function (e, n) {
          var i = t.masterImageSrc(e);
          return r._addSizeParameter(i, n);
        }),
        (r.bestImageSrcWithSizeForContainer = function (t, n, i, o) {
          if (e.isEmpty(t)) return "";
          var a = o ? 2 : 3,
            c = Math.max(n, i);
          (c *= a), (c = Math.max(c, 100));
          var s = c + "x" + c;
          return r._addSizeParameter(t, s);
        }),
        (r._addSizeParameter = function (t, r) {
          if (e.isEmpty(r)) return t;
          var n = t.lastIndexOf(".");
          return t.substring(0, n) + "_" + r + t.substring(n, t.length);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/ProductUI",
    [
      "core/frequently-bought/util/ProductImageUtil",
      "core/util/BrowserUtil",
      "core/util/StatUtil",
      "core/util/JsonCss",
      "core/currency/price/Price",
      "core/util/ImageSizedSrcBuilder",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a) {
      function c(e, r, n, i) {
        (this.product = e),
          (this.preferences = r),
          (this.isMainProduct = this.product.isMainProduct()),
          (this.isLastProduct = this.product.isLastProduct()),
          (this.imageWidth = t.deviceAwareWidth(
            i,
            this.preferences.imageWidth,
            n
          )),
          (this.imageHeight = t.deviceAwareHeight(
            i,
            this.preferences.imageWidth,
            this.preferences.imageHeight,
            n
          )),
          this._create();
      }
      var s = "cbb-frequently-bought-plus-icon";
      return (
        (c.prototype = {
          _create: function () {
            this._createProduct(),
              this._createThumbnail(),
              this.isLastProduct || this._createPlus();
          },
          _createProduct: function () {
            (this.$product = a("<li></li>")),
              this.$product.addClass("cbb-frequently-bought-product"),
              this.$product.css({
                display: "inline-block",
                "margin-top": "10px",
                "margin-bottom": "10px",
                "vertical-align": "middle",
              }),
              e.isMobile() &&
                this.$product.css({
                  width: this.isLastProduct
                    ? Number(this.imageWidth) + t.totalProductPaddingPx() + "px"
                    : Number(this.imageWidth) +
                      t.totalProductPaddingPx() +
                      t.plusIconWidthPx() +
                      "px",
                  height: this.imageHeight + "px",
                  "padding-left": "0",
                  "box-sizing": "content-box",
                });
          },
          _createThumbnail: function () {
            this.isMainProduct
              ? this._createMainProductThumbnail()
              : this._createRecommendationThumbnail();
          },
          _createMainProductThumbnail: function () {
            var r = this._productImage();
            r.css({
              float: "left",
              margin: e.isMobile()
                ? "0 " + t.productPaddingPx() + "px"
                : "0 " + this.preferences.imageMargins + "px",
            }),
              this.$product.append(r);
          },
          _createRecommendationThumbnail: function () {
            (this.$link = a("<a></a>")),
              this.$link.addClass("cbb-frequently-bought-product-image-link"),
              this.$link.attr("tabindex", "0"),
              this.$link.css({
                float: "left",
                cursor: "pointer",
                width: this.imageWidth + "px",
                height: this.imageHeight + "px",
                margin: e.isMobile()
                  ? "0 " + t.productPaddingPx() + "px"
                  : "0 " + this.preferences.imageMargins + "px",
              }),
              this.$link.append(this._productImage()),
              this.$product.append(this.$link);
          },
          _productImage: function () {
            return (
              (this.$image = a("<div></div>")),
              this.$image.addClass("cbb-frequently-bought-product-image"),
              this.$image.text(" "),
              this.$image.css({
                width: this.imageWidth + "px",
                height: this.imageHeight + "px",
                overflow: "hidden",
                "background-image":
                  "url(" +
                  this._bestImageUrl(this.product.firstVariant()) +
                  ")",
                "background-position": "center",
                "background-size": this.preferences.isFitted
                  ? "contain"
                  : "cover",
                "background-repeat": "no-repeat",
              }),
              n.apply(this.$image, this.preferences.imageAdditionalStyles),
              this.$image
            );
          },
          _createPlus: function () {
            (this.$plus = a("<div></div>")),
              this.$plus.addClass(s),
              this.$plus.addClass(i.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              this.$plus.css({
                "user-select": "none",
                "font-size": "18px",
                "font-weight": "200",
                "font-family": "monospace",
                height: this.imageHeight + "px",
                width: t.plusIconWidthPx() + "px",
                "line-height": this.imageHeight + "px",
                color: this.preferences.whitePlusIcon ? "#ffffff" : "#000000",
                "text-shadow": this.preferences.whitePlusIcon
                  ? "-1px 0 rgba(0, 0, 0, 0.4), 0 1px rgba(0, 0, 0, 0.4), 1px 0 rgba(0, 0, 0, 0.4), 0 -1px rgba(0, 0, 0, 0.4)"
                  : "-1px 0 rgba(255, 255, 255, 0.4), 0 1px rgba(255, 255, 255, 0.4), 1px 0 rgba(255, 255, 255, 0.4), 0 -1px rgba(255, 255, 255, 0.4)",
                "text-align": "center",
                float: "right",
              }),
              this.$plus.append("&#65291;"),
              this.$product.append(this.$plus);
          },
          updateWithVariant: function (t) {
            this._changeThumbnail(t), this.isMainProduct || this._setLink(t);
          },
          _changeThumbnail: function (t) {
            this.$image.css(
              "background-image",
              "url(" + this._bestImageUrl(t) + ")"
            );
          },
          _setLink: function (t) {
            this.$link.attr("data-href", t.getVariantUrl()), this.$link.off();
            var e = this.product.getId();
            this.$link.click(function (t) {
              r.clickedAndRedirect("frequently-bought-together", e, t);
            });
          },
          show: function () {
            var t = this;
            this.$product.fadeIn(800), t._hideFirstPlusIcon();
          },
          hide: function () {
            var t = this;
            this.$product.fadeOut(function () {
              t._hideFirstPlusIcon();
            });
          },
          _hideFirstPlusIcon: function () {
            var t = this.$product.parent();
            t.find("li>div." + s).show(),
              t
                .find("li:visible")
                .last()
                .find(">div." + s)
                .hide();
          },
          getProduct: function () {
            return this.$product;
          },
          _bestImageUrl: function (t) {
            return o.bestImageSrcWithSizeForContainer(
              t.getImageUrl(),
              this.imageWidth,
              this.imageHeight,
              this.preferences.isFitted
            );
          },
        }),
        c
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/PriceStyleUtil",
    ["core/util/JsonCss"],
    function (t) {
      function e() {}
      return (
        (e.applyRegularPriceStylePreferences = function (t, r) {
          var n = {
            color: r.regularPriceColor,
            bold: r.regularPriceBold,
            additionalStyles: r.regularPriceAdditionalStyles,
          };
          e._applyPriceStylePreferences(t, n);
        }),
        (e.applySalePriceStylePreferences = function (t, r) {
          var n = {
            color: r.salePriceColor,
            bold: r.salePriceBold,
            additionalStyles: r.salePriceAdditionalStyles,
          };
          e._applyPriceStylePreferences(t, n);
        }),
        (e.applyCompareAtPriceStylePreferences = function (t, r) {
          var n = {
            color: r.compareAtPriceColor,
            bold: r.compareAtPriceBold,
            additionalStyles: r.compareAtPriceAdditionalStyles,
          };
          e._applyPriceStylePreferences(t, n);
        }),
        (e._applyPriceStylePreferences = function (e, r) {
          e.css("color", r.color),
            e.css("font-weight", r.bold ? "600" : "400"),
            t.apply(e, r.additionalStyles);
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/shopify-product-reviews/ShopifyProductReviewsGatherer",
    [
      "core/util/ShopifyUtil",
      "core/util/AjaxGet",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        (i.gatherRating = function (n, o, a, c, s) {
          var u = t.getShop(),
            l = "productreviews" + n + o;
          e.jsonpGet(
            l,
            "//productreviews.shopifycdn.com/proxy/v4/reviews/product?version=v4",
            { product_id: o, shop: u },
            function (t) {
              var e = i._readRatingAverage(t),
                r = i._readReviewCount(t);
              s(e, r, a, c);
            },
            function (t) {
              r.log("Could not load product reviews: " + t.statusText);
            }
          );
        }),
        (i._readRatingAverage = function (t) {
          var e = i._parseReviewJson(t);
          if (e) return parseFloat(e.ratingValue).toFixed(1);
        }),
        (i._readReviewCount = function (t) {
          var e = i._parseReviewJson(t);
          if (e) return parseInt(e.reviewCount);
        }),
        (i._parseReviewJson = function (t) {
          try {
            var e = n(t.aggregate_rating),
              r = e.text();
            r = n.trim(r);
            return JSON.parse(r);
          } catch (t) {
            return null;
          }
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ImageUtil",
    ["core/util/DomainUtil"],
    function (t) {
      function e() {}
      var r = t.cdnUrl() + "/images";
      return (
        (e.baseUrl = function () {
          return r;
        }),
        (e.imagePath = function (t) {
          return r + "/" + t;
        }),
        (e.loadImage = function (t, e, r) {
          var n = new Image();
          (n.onload = function () {
            t(r, n);
          }),
            (n.src = e);
        }),
        (e.mimeType = function (t) {
          return t.split(".")[1];
        }),
        (e.filenameWithoutMimeType = function (t) {
          return t.split(".")[0];
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/shopify-product-reviews/ShopifyRatingUtil",
    [
      "core/util/shopify-product-reviews/ShopifyProductReviewsGatherer",
      "core/util/ImageUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i() {}
      i.GOOGLE_TRANSLATE_INHIBIT_CLASS = "skiptranslate notranslate";
      return (
        (i.showAllRating = function (e, r, o, a) {
          n.each(r, function (n) {
            var c = r[n],
              s = o[n];
            t.gatherRating(e, c.getId(), s, a, i._showProductRating);
          });
        }),
        (i._showProductRating = function (t, e, r, o) {
          if (t && t > 0) {
            var a = i.getNumberOfFullStars(t),
              c = i.widthHalfStar(t),
              s = 5 - a - (c > 0 ? 1 : 0),
              u = n('<span class="cbb-star-rating-class"></span>');
            u.addClass(i.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              u.addClass("cbb-reviews-app-shopify");
            for (var l = 0; l < a; l++)
              u.append(
                i._createFullStar(
                  "E800",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            c > 0 &&
              u.append(
                i._createHalfStar(
                  "E803",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            for (var d = 0; d < s; d++)
              u.append(
                i._createEmptyStar(
                  "E801",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            r.append(u),
              o.showReviewCount &&
                u.append(
                  i._createReviewCount(
                    e,
                    o.reviewCountColor,
                    o.reviewCountAdditionalStyles
                  )
                );
          } else
            r.append(
              i._createNoStar(o.starRatingColor, o.starRatingAdditionalStyles)
            );
        }),
        (i.getNumberOfFullStars = function (t) {
          return i.decimalPart(t) <= 0.5 ? Math.floor(t) : Math.round(t);
        }),
        (i.widthHalfStar = function (t) {
          var e = i.decimalPart(t);
          return e > 0 && e <= 0.5 ? 50 : 0;
        }),
        (i.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (i._createFullStar = function (t, e, o) {
          var a = n('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return a.css(i._starCssStyles(e)), r.apply(a, o), a;
        }),
        (i._createHalfStar = function (t, e, o) {
          var a = n('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          return a.css(i._starCssStyles(e)), r.apply(a, o), a;
        }),
        (i._createEmptyStar = function (t, e, o) {
          var a = n('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return a.css(i._starCssStyles(e)), r.apply(a, o), a;
        }),
        (i._createNoStar = function (t, e) {
          var o = n('<i class="cbb-icon-no-star">&nbsp;</i>');
          return o.css(i._starCssStyles(t)), r.apply(o, e), o;
        }),
        (i._starCssStyles = function (t) {
          return {
            "font-family": "font-awesome-stars",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "15px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (i._createReviewCount = function (t, e, i) {
          var o = n('<span class="cbb-review-count"> (' + t + ")</span>");
          return o.css({ "font-size": "15px", color: e }), r.apply(o, i), o;
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/AjaxPost",
    ["core/util/DomainUtil", "core/util/StringUtil", "lib/jquery-private"],
    function (t, e, r) {
      function n() {}
      return (
        (n.post = function (t, e, n, i) {
          var o = {
            type: "POST",
            url: t,
            data: e || {},
            success: function (t) {
              n && n(t);
            },
            error: function (t) {
              i && i(t);
            },
          };
          r.ajax(o);
        }),
        (n.jsonPost = function (t, e, n, i) {
          var o = {
            type: "POST",
            url: t,
            data: e || {},
            dataType: "json",
            success: function (t) {
              n && n(t);
            },
            error: function (t) {
              i && i(t);
            },
          };
          r.ajax(o);
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/stamped-reviews/StampedReviewsGatherer",
    [
      "core/util/ShopifyUtil",
      "core/util/AjaxPost",
      "core/util/StringUtil",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.gatherAllRating = function (n, a, c, s, u) {
          var l = t.getShop();
          if (r.isNotEmpty(a)) {
            var d = new Array(),
              f = new Array();
            i.each(n, function (t) {
              var e = n[t];
              d.push({ productId: e.getId(), productSKU: e.getVariantSku() }),
                f.push({ productId: e.getId(), element: c[t] });
            });
            var h = { productIds: d, apiKey: a, storeUrl: l };
            e.post("https://stamped.io/api/widget/badges", h, function (t) {
              i.each(t, function (e) {
                var r = o._readRatingAverage(t, e),
                  n = o._readReviewCount(t, e),
                  i = parseInt(t[e].productId),
                  a = o._findElement(f, i);
                u(r, n, a, s);
              });
            });
          }
        }),
        (o._findElement = function (t, e) {
          for (index = 0; index < t.length; index++)
            if (t[index].productId === e) return t[index].element;
        }),
        (o._readRatingAverage = function (t, e) {
          return t[e] ? t[e].rating : 0;
        }),
        (o._readReviewCount = function (t, e) {
          return t[e] ? t[e].count : 0;
        }),
        (o.prototype = {}),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/util/stamped-reviews/StampedRatingUtil",
    [
      "core/util/stamped-reviews/StampedReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
      "core/util/ShopifyUtil",
    ],
    function (t, e, r, n, i, o) {
      function a() {}
      return (
        (a.showAllRating = function (e, r, n, i) {
          var o = i.stampedApiKey;
          t.gatherAllRating(r, o, n, i, a._showProductRating);
        }),
        (a._showProductRating = function (t, r, n, o) {
          if (t && t > 0) {
            var c = a.getNumberOfFullStars(t),
              s = a.widthHalfStar(t),
              u = 5 - c - (s > 0 ? 1 : 0),
              l = i('<span class="cbb-star-rating-class"></span>');
            l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              l.addClass("cbb-reviews-app-stamped");
            for (var d = 0; d < c; d++)
              l.append(
                a._createFullStar(
                  "F005",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            s > 0 &&
              l.append(
                a._createHalfStar(
                  "F123",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            for (var f = 0; f < u; f++)
              l.append(
                a._createEmptyStar(
                  "F006",
                  o.starRatingColor,
                  o.starRatingAdditionalStyles
                )
              );
            n.append(l),
              o.showReviewCount &&
                l.append(
                  a._createReviewCount(
                    r,
                    o.reviewCountColor,
                    o.reviewCountAdditionalStyles
                  )
                );
          } else
            n.append(
              a._createNoStar(o.starRatingColor, o.starRatingAdditionalStyles)
            );
        }),
        (a.getNumberOfFullStars = function (t) {
          return a.decimalPart(t) <= 0.5 ? Math.floor(t) : Math.round(t);
        }),
        (a.widthHalfStar = function (t) {
          var e = a.decimalPart(t);
          return e > 0 && e <= 0.5 ? 50 : 0;
        }),
        (a.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (a._createFullStar = function (t, e, r) {
          var o = i('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return o.css(a._starCssStyles(e)), n.apply(o, r), o;
        }),
        (a._createHalfStar = function (t, e, r) {
          var o = i('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          return o.css(a._starCssStyles(e)), n.apply(o, r), o;
        }),
        (a._createEmptyStar = function (t, e, r) {
          var o = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return o.css(a._starCssStyles(e)), n.apply(o, r), o;
        }),
        (a._createNoStar = function (t, e) {
          var r = i('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(a._starCssStyles(t)), n.apply(r, e), r;
        }),
        (a._starCssStyles = function (t) {
          return {
            "font-family": "stamped-font,FontAwesome",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "15px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (a._createReviewCount = function (t, e, r) {
          var o = i('<span class="cbb-review-count"> (' + t + ")</span>");
          return o.css({ "font-size": "15px", color: e }), n.apply(o, r), o;
        }),
        (a.prototype = {}),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/util/yotpo-reviews/YotpoReviewsGatherer",
    [
      "core/util/AjaxGet",
      "core/util/StringUtil",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        (i.gatherRating = function (n, o, a, c, s) {
          if (e.isNotEmpty(o)) {
            var u =
              "https://api.yotpo.com/products/" + o + "/" + n + "/bottomline";
            t.jsonGet(
              u,
              {},
              function (t) {
                var e = i._readRatingAverage(t),
                  r = i._readReviewCount(t);
                s(e, r, a, c);
              },
              function (t) {
                r.log("Could not load product reviews: " + t.statusText);
              }
            );
          }
        }),
        (i._readRatingAverage = function (t) {
          return t.response.bottomline.average_score;
        }),
        (i._readReviewCount = function (t) {
          return t.response.bottomline.total_reviews;
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/yotpo-reviews/YotpoRatingUtil",
    [
      "core/util/yotpo-reviews/YotpoReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.showAllRating = function (e, r, n, a) {
          var c = a.yotpoAppKey;
          i.each(r, function (e) {
            var i = r[e],
              s = n[e];
            t.gatherRating(i.getId(), c, s, a, o._showProductRating);
          });
        }),
        (o._showProductRating = function (t, r, n, a) {
          if (t && t > 0) {
            var c = o.getNumberOfFullStars(t),
              s = o.widthHalfStar(t),
              u = 5 - c - (s > 0 ? 1 : 0),
              l = i('<span class="cbb-star-rating-class"></span>');
            l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              l.addClass("cbb-reviews-app-yotpo");
            for (var d = 0; d < c; d++)
              l.append(
                o._createFullStar(
                  "E60E",
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            s > 0 &&
              l.append(
                o._createHalfStar(
                  "E61A",
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            for (var f = 0; f < u; f++)
              l.append(
                o._createEmptyStar(
                  "E61B",
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            n.append(l),
              a.showReviewCount &&
                l.append(
                  o._createReviewCount(
                    r,
                    a.reviewCountColor,
                    a.reviewCountAdditionalStyles
                  )
                );
          } else
            n.append(
              o._createNoStar(a.starRatingColor, a.starRatingAdditionalStyles)
            );
        }),
        (o.getNumberOfFullStars = function (t) {
          return o.decimalPart(t) <= 0.5 ? Math.floor(t) : Math.round(t);
        }),
        (o.widthHalfStar = function (t) {
          return 0.5 === o.decimalPart(t) ? 50 : 0;
        }),
        (o.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (o._createFullStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createHalfStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createEmptyStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createNoStar = function (t, e) {
          var r = i('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(o._starCssStyles(t)), n.apply(r, e), r;
        }),
        (o._starCssStyles = function (t) {
          return {
            "font-family": "yotpo-widget-font",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "15px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (o._createReviewCount = function (t, e, r) {
          var o = i('<span class="cbb-review-count"> (' + t + ")</span>");
          return o.css({ "font-size": "15px", color: e }), n.apply(o, r), o;
        }),
        (o.prototype = {}),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/util/loox-reviews/LooxReviewsGatherer",
    [
      "core/util/AjaxGet",
      "core/util/StringUtil",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        (i.gatherAllRating = function (o, a, c, s, u, l) {
          if (e.isNotEmpty(c)) {
            var d = "https://loox.io/widget/" + c + "/ratings",
              f = new Array(),
              h = new Array();
            n.each(a, function (t) {
              var e = a[t];
              f.push(e.getId()),
                h.push({ productId: e.getId(), element: s[t] });
            });
            var p = { products_ids: f.join(",") };
            o && (p.h = o),
              t.jsonGet(
                d,
                p,
                function (t) {
                  n.each(t.ratings, function (e) {
                    var r = i._readRatingAverage(t.ratings, e),
                      n = i._readReviewCount(t.ratings, e),
                      o = parseInt(i._readProductId(t.ratings, e)),
                      a = i._findElement(h, o);
                    l(r, n, a, u);
                  });
                },
                function (t) {
                  r.log("Could not load product reviews: " + t.statusText);
                }
              );
          }
        }),
        (i._findElement = function (t, e) {
          for (index = 0; index < t.length; index++)
            if (t[index].productId === e) return t[index].element;
        }),
        (i._readRatingAverage = function (t, e) {
          return t[e] ? t[e].rating : 0;
        }),
        (i._readReviewCount = function (t, e) {
          return t[e] ? t[e].raters : 0;
        }),
        (i._readProductId = function (t, e) {
          return t[e] ? t[e].pid : 0;
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/loox-reviews/LooxRatingUtil",
    [
      "core/util/loox-reviews/LooxReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/dom/Watcher",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o) {
      function a() {}
      return (
        (a.showAllRating = function (e, r, i, o) {
          n.checkIf(a._isStoreIdEnabled)
            .every(250)
            .during(3e4)
            .then(function () {
              var e = window.LOOX.clientId,
                n = window.loox_global_hash ? window.loox_global_hash : null;
              t.gatherAllRating(n, r, e, i, o, a._showProductRating);
            })
            .watch();
        }),
        (a._isStoreIdEnabled = function () {
          return window.LOOX && window.LOOX.clientId;
        }),
        (a._showProductRating = function (t, r, n, i) {
          if (t && t > 0) {
            var c = a.getNumberOfFullStars(t),
              s = a.widthHalfStar(t),
              u = 5 - c - (s > 0 ? 1 : 0),
              l = o('<span class="cbb-star-rating-class"></span>');
            l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              l.addClass("cbb-reviews-app-loox");
            for (var d = 0; d < c; d++)
              l.append(
                a._createFullStar(
                  "E800",
                  i.starRatingColor,
                  i.starRatingAdditionalStyles
                )
              );
            s > 0 &&
              l.append(
                a._createHalfStar(
                  "F123",
                  i.starRatingColor,
                  i.starRatingAdditionalStyles
                )
              );
            for (var f = 0; f < u; f++)
              l.append(
                a._createEmptyStar(
                  "E801",
                  i.starRatingColor,
                  i.starRatingAdditionalStyles
                )
              );
            n.append(l),
              i.showReviewCount &&
                l.append(
                  a._createReviewCount(
                    r,
                    i.reviewCountColor,
                    i.reviewCountAdditionalStyles
                  )
                );
          } else
            n.append(
              a._createNoStar(i.starRatingColor, i.starRatingAdditionalStyles)
            );
        }),
        (a.getNumberOfFullStars = function (t) {
          return a.decimalPart(t) <= 0.5 ? Math.floor(t) : Math.round(t);
        }),
        (a.widthHalfStar = function (t) {
          var e = a.decimalPart(t);
          return e > 0 && e <= 0.5 ? 50 : 0;
        }),
        (a.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (a._createFullStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createHalfStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createEmptyStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createNoStar = function (t, e) {
          var r = o('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(a._starCssStyles(t)), i.apply(r, e), r;
        }),
        (a._starCssStyles = function (t) {
          return {
            "font-family": "LooxIcons",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "15px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (a._createReviewCount = function (t, e, r) {
          var n = o('<span class="cbb-review-count"> (' + t + ")</span>");
          return n.css({ "font-size": "15px", color: e }), i.apply(n, r), n;
        }),
        (a.prototype = {}),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/util/judge-product-reviews/JudgeProductReviewsGatherer",
    ["core/util/Logger", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        (r.gatherRating = function (t, r, n, i, o) {
          var a = [{ productHandle: r, badgePlaceholder: n.get() }];
          window.jdgm.batchRenderBadgesWithCallback(a, function (t, r, n, a) {
            var c = e(n);
            o(t, r, c, i);
          });
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/judge-product-reviews/JudgeRatingUtil",
    [
      "core/util/judge-product-reviews/JudgeProductReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/dom/Watcher",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o) {
      function a() {}
      return (
        (a.showAllRating = function (e, r, i, c) {
          n.checkIf(a._isJdgmCallbackEnabled)
            .every(250)
            .during(3e4)
            .then(function () {
              o.each(r, function (e) {
                var n = r[e],
                  o = i[e];
                t.gatherRating(
                  n.getId(),
                  n.getHandle(),
                  o,
                  c,
                  a._showProductRating
                );
              });
            })
            .watch();
        }),
        (a._isJdgmCallbackEnabled = function () {
          return window.jdgm && window.jdgm.batchRenderBadgesWithCallback;
        }),
        (a._showProductRating = function (t, r, n, i) {
          if (!a._isNotValidContainer(n))
            if (a._hasValidRating(t)) {
              var c = a.getNumberOfFullStars(t),
                s = a.widthHalfStar(t),
                u = 5 - c - (s > 0 ? 1 : 0),
                l = o('<span class="cbb-star-rating-class"></span>');
              l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
                l.addClass("cbb-reviews-app-judge");
              for (var d = 0; d < c; d++)
                l.append(
                  a._createFullStar(
                    "E000",
                    i.starRatingColor,
                    i.starRatingAdditionalStyles
                  )
                );
              s > 0 &&
                l.append(
                  a._createHalfStar(
                    "E002",
                    i.starRatingColor,
                    i.starRatingAdditionalStyles
                  )
                );
              for (var f = 0; f < u; f++)
                l.append(
                  a._createEmptyStar(
                    "E001",
                    i.starRatingColor,
                    i.starRatingAdditionalStyles
                  )
                );
              n.append(l),
                i.showReviewCount &&
                  l.append(
                    a._createReviewCount(
                      r,
                      i.reviewCountColor,
                      i.reviewCountAdditionalStyles
                    )
                  );
            } else
              n.append(
                a._createNoStar(i.starRatingColor, i.starRatingAdditionalStyles)
              );
        }),
        (a._hasValidRating = function (t) {
          return t && t > 0;
        }),
        (a._isNotValidContainer = function (t) {
          return !(
            t.hasClass("cbb-frequently-bought-rating-box") ||
            t.hasClass("cbb-also-bought-product-rating-box")
          );
        }),
        (a.getNumberOfFullStars = function (t) {
          return a.decimalPart(t) <= 0.75 ? Math.floor(t) : Math.round(t);
        }),
        (a.widthHalfStar = function (t) {
          var e = a.decimalPart(t);
          return e > 0.25 && e <= 0.75 ? 50 : 0;
        }),
        (a.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (a._createFullStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createHalfStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createEmptyStar = function (t, e, r) {
          var n = o('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return n.css(a._starCssStyles(e)), i.apply(n, r), n;
        }),
        (a._createNoStar = function (t, e) {
          var r = o('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(a._starCssStyles(t)), i.apply(r, e), r;
        }),
        (a._starCssStyles = function (t) {
          return {
            "font-family": "JudgemeStar",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "15px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (a._createReviewCount = function (t, e, r) {
          var n = o('<span class="cbb-review-count"> (' + t + ")</span>");
          return n.css({ "font-size": "15px", color: e }), i.apply(n, r), n;
        }),
        (a.prototype = {}),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/util/alireviews-product-reviews/AlireviewsProductReviewsGatherer",
    ["core/util/AjaxGet", "core/util/Logger", "lib/jquery-private"],
    function (t, e, r) {
      function n() {}
      return (
        (n.gatherRating = function (r, i, o, a, c) {
          t.jsonGet(
            "https://alireviews.fireapps.io/comment/get_review",
            { product_id: r, shop_id: i },
            function (t) {
              !0 === t.status
                ? n._parseRating(t, c, o, a)
                : n.gatherRatingFromV2(r, i, o, a, c);
            },
            function (t) {
              e.log(
                "Could not load product reviews from V1 API: " + t.statusText
              );
            }
          );
        }),
        (n.gatherRatingFromV2 = function (r, i, o, a, c) {
          t.jsonGet(
            "https://new-alireviews.fireapps.io/comment/get_review",
            { product_id: r, shop_id: i },
            function (t) {
              !0 === t.status
                ? n._parseRating(t, c, o, a)
                : e.log(
                    "Could not load product reviews from V2 API: " +
                      JSON.stringify(t)
                  );
            },
            function (t) {
              e.log(
                "Could not load product reviews from V2 API: " + t.statusText
              );
            }
          );
        }),
        (n._parseRating = function (t, e, r, i) {
          e(n._readRatingAverage(t), n._readReviewCount(t), r, i);
        }),
        (n._readRatingAverage = function (t) {
          return t.avg;
        }),
        (n._readReviewCount = function (t) {
          return t.total_review;
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/alireviews-product-reviews/AlireviewsRatingUtil",
    [
      "core/util/alireviews-product-reviews/AlireviewsProductReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.showAllRating = function (e, r, n, a) {
          var c = a.shopId;
          i.each(r, function (e) {
            var i = r[e],
              s = n[e];
            t.gatherRating(i.getId(), c, s, a, o._showProductRating);
          });
        }),
        (o._showProductRating = function (t, r, n, a) {
          if (t && t > 0) {
            var c = o.getNumberOfFullStars(t),
              s = o.widthHalfStar(t),
              u = 5 - c - (s > 0 ? 1 : 0),
              l = i('<span class="cbb-star-rating-class"></span>');
            l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              l.addClass("cbb-reviews-app-alireviews");
            for (var d = 0; d < c; d++)
              l.append(
                o._createFullStar(
                  a.alireviewsRatingCharacter,
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            s > 0 &&
              l.append(
                o._createHalfStar(
                  a.alireviewsRatingCharacter,
                  a.starRatingColor,
                  s,
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            for (var f = 0; f < u; f++)
              l.append(
                o._createEmptyStar(
                  a.alireviewsRatingCharacter,
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            n.append(l),
              a.showReviewCount &&
                l.append(
                  o._createReviewCount(
                    r,
                    a.reviewCountColor,
                    a.reviewCountAdditionalStyles
                  )
                );
          } else
            n.append(
              o._createNoStar(a.starRatingColor, a.starRatingAdditionalStyles)
            );
        }),
        (o.getNumberOfFullStars = function (t) {
          return Math.floor(t);
        }),
        (o.widthHalfStar = function (t) {
          return 100 * o.decimalPart(t);
        }),
        (o.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (o._createFullStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return a.css(o._opaqueStarCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createHalfStar = function (t, e, r, a, c) {
          var s = i("<div></div>"),
            u = i('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          u.css(o._opaqueStarCssStyles(e)),
            n.apply(u, c),
            u.css({
              display: "inline-block",
              position: "absolute",
              overflow: "hidden",
              left: "0px",
              bottom: "0px",
              width: r + "%",
            });
          var l = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return (
            l.css(o._starCssStyles(a)),
            n.apply(l, c),
            s.append(l),
            s.append(u),
            s.css({ display: "inline-block", position: "relative" }),
            s
          );
        }),
        (o._createEmptyStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createNoStar = function (t, e) {
          var r = i('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(o._starCssStyles(t)), n.apply(r, e), r;
        }),
        (o._starCssStyles = function (t) {
          return {
            "font-family": "Font Awesome\\ 5 Pro",
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "18px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (o._opaqueStarCssStyles = function (t) {
          var e = o._starCssStyles(t);
          return i.extend({}, e, { "font-weight": "900" });
        }),
        (o._createReviewCount = function (t, e, r) {
          var o = i('<span class="cbb-review-count"> (' + t + ")</span>");
          return (
            o.css({
              "font-size": "15px",
              color: e,
              "vertical-align": "text-bottom",
            }),
            n.apply(o, r),
            o
          );
        }),
        (o.prototype = {}),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/util/demo-reviews/DemoReviewsGatherer",
    ["core/util/Logger", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        (r.gatherRating = function (t, e, r, n) {
          n(5 * Math.random(), 1 + Math.round(15 * Math.random()), e, r);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/demo-reviews/DemoRatingUtil",
    [
      "core/util/demo-reviews/DemoReviewsGatherer",
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/ImageUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.showAllRating = function (e, r, n, a) {
          i.each(r, function (e) {
            var c = r[e],
              s = i(n[e]);
            t.gatherRating(c.getId(), s, a, o._showProductRating);
          });
        }),
        (o._showProductRating = function (t, r, n, a) {
          if (t && t > 0) {
            var c = o.getNumberOfFullStars(t),
              s = o.widthHalfStar(t),
              u = 5 - c - (s > 0 ? 1 : 0),
              l = i('<span class="cbb-star-rating-class"></span>');
            l.addClass(e.GOOGLE_TRANSLATE_INHIBIT_CLASS),
              l.addClass("cbb-reviews-app-demo");
            for (var d = 0; d < c; d++)
              l.append(
                o._createFullStar(
                  "2605",
                  a.starRatingColor,
                  a.starRatingAdditionalStyles
                )
              );
            s > 0 &&
              l.append(
                o._createHalfStar(
                  "2605",
                  a.starRatingColor,
                  s,
                  "#A4AFB7ed",
                  a.starRatingAdditionalStyles
                )
              );
            for (var f = 0; f < u; f++)
              l.append(
                o._createEmptyStar(
                  "2605",
                  "#A4AFB7ed",
                  a.starRatingAdditionalStyles
                )
              );
            n.append(l),
              a.showReviewCount &&
                l.append(
                  o._createReviewCount(
                    r,
                    a.reviewCountColor,
                    a.reviewCountAdditionalStyles
                  )
                );
          } else
            n.append(
              o._createNoStar(a.starRatingColor, a.starRatingAdditionalStyles)
            );
        }),
        (o.getNumberOfFullStars = function (t) {
          return Math.floor(t);
        }),
        (o.widthHalfStar = function (t) {
          return 100 * o.decimalPart(t);
        }),
        (o.decimalPart = function (t) {
          return Number((t - Math.floor(t)).toFixed(1));
        }),
        (o._createFullStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-full-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createHalfStar = function (t, e, r, a, c) {
          var s = i("<div></div>"),
            u = i('<i class="cbb-icon-half-star">&#x' + t + ";</i>");
          u.css(o._starCssStyles(e)),
            n.apply(u, c),
            u.css({
              display: "inline-block",
              position: "absolute",
              overflow: "hidden",
              left: "0px",
              right: "0px",
              width: r + "%",
            });
          var l = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return (
            l.css(o._starCssStyles(a)),
            n.apply(l, c),
            s.append(l),
            s.append(u),
            s.css({ display: "inline-block", position: "relative" }),
            s
          );
        }),
        (o._createEmptyStar = function (t, e, r) {
          var a = i('<i class="cbb-icon-empty-star">&#x' + t + ";</i>");
          return a.css(o._starCssStyles(e)), n.apply(a, r), a;
        }),
        (o._createNoStar = function (t, e) {
          var r = i('<i class="cbb-icon-no-star">&nbsp;</i>');
          return r.css(o._starCssStyles(t)), n.apply(r, e), r;
        }),
        (o._starCssStyles = function (t) {
          return {
            "font-style": "normal",
            "font-weight": "normal",
            "font-size": "20px",
            "text-align": "center",
            "letter-spacing": "1px",
            color: t,
          };
        }),
        (o._createReviewCount = function (t, e, r) {
          var o = i('<span class="cbb-review-count"> (' + t + ")</span>");
          return o.css({ "font-size": "15px", color: e }), n.apply(o, r), o;
        }),
        (o.prototype = {}),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/util/RatingUtil",
    [
      "core/util/shopify-product-reviews/ShopifyRatingUtil",
      "core/util/stamped-reviews/StampedRatingUtil",
      "core/util/yotpo-reviews/YotpoRatingUtil",
      "core/util/loox-reviews/LooxRatingUtil",
      "core/util/judge-product-reviews/JudgeRatingUtil",
      "core/util/alireviews-product-reviews/AlireviewsRatingUtil",
      "core/util/demo-reviews/DemoRatingUtil",
      "core/util/UrlUtil",
      "core/util/Logger",
    ],
    function (t, e, r, n, i, o, a, c, s) {
      function u() {}
      return (
        (u.showAllRating = function (u, l, d, f) {
          if (c.isDemoPage()) a.showAllRating(u, l, d, f);
          else
            try {
              "SHOPIFY_PRODUCT_REVIEWS" === f.reviewsApp
                ? t.showAllRating(u, l, d, f)
                : "STAMPED_REVIEWS" === f.reviewsApp
                ? e.showAllRating(u, l, d, f)
                : "YOTPO_REVIEWS" === f.reviewsApp
                ? r.showAllRating(u, l, d, f)
                : "LOOX_REVIEWS" === f.reviewsApp
                ? n.showAllRating(u, l, d, f)
                : "JUDGE_PRODUCT_REVIEWS" === f.reviewsApp
                ? i.showAllRating(u, l, d, f)
                : "ALI_REVIEWS_PRODUCT_REVIEWS" === f.reviewsApp &&
                  o.showAllRating(u, l, d, f);
            } catch (t) {
              s.log(
                "Failed showing products rating in " +
                  u +
                  " widget. (Error: " +
                  t.message +
                  ")"
              );
            }
        }),
        (u.prototype = {}),
        u
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/RatingUI",
    ["core/util/RatingUtil", "lib/jquery-private"],
    function (t, e) {
      function r(t, e) {
        (this.product = t), (this.ratingPreferences = e);
      }
      return (
        (r.prototype = {
          createRating: function () {
            return (
              (this.$rating = e(
                "<span id=cbb-frequently-bought-rating-box-" +
                  this.product.getId() +
                  "></span>"
              )),
              this.$rating.addClass("cbb-frequently-bought-rating-box"),
              this.$rating.css("display", "inline-block"),
              this.$rating.css("margin-left", "5px"),
              this.$rating
            );
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define("core/util/ScreenUtil", [], function () {
    function t() {}
    return (
      (t.getHiddenProperty = function () {
        var t = ["webkit", "moz", "ms", "o"];
        if ("hidden" in document) return "hidden";
        for (var e = 0; e < t.length; e++)
          if (t[e] + "Hidden" in document) return t[e] + "Hidden";
        return null;
      }),
      (t.getVisibilityChangeEventName = function () {
        return (
          t.getHiddenProperty().replace(/[H|h]idden/, "") + "visibilitychange"
        );
      }),
      (t.isHidden = function () {
        var e = t.getHiddenProperty();
        return !!e && document[e];
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define("core/util/Objects", [], function () {
    function t() {}
    return (
      (t.isNull = function (t) {
        return null == t || void 0 == t;
      }),
      (t.nonNull = function (t) {
        return null != t && void 0 != t;
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/EventUtil",
    ["core/util/ScreenUtil", "core/util/Objects"],
    function (t, e) {
      function r() {}
      return (
        (r.LEFT_KEY = 37),
        (r.RIGHT_KEY = 39),
        (r.UP_KEY = 38),
        (r.DOWN_KEY = 40),
        (r.ESCAPE_KEY = 27),
        (r.trigger = function (t, e) {
          var r = new CustomEvent(t, { detail: e });
          document.dispatchEvent(r);
        }),
        (r.onScroll = function (t) {
          r.addEvent(window, "scroll", t);
        }),
        (r.offScroll = function (t) {
          r.removeEvent(window, "scroll", t);
        }),
        (r.onKeydown = function (t) {
          r.addEvent(document.body, "keydown", t);
        }),
        (r.offKeydown = function (t) {
          r.removeEvent(document.body, "keydown", t);
        }),
        (r.onKeypress = function (t) {
          r.addEvent(document.body, "keypress", t);
        }),
        (r.offKeypress = function (t) {
          r.removeEvent(document.body, "keypress", t);
        }),
        (r.onMousedown = function (t) {
          r.addEvent(document.body, "mousedown", t);
        }),
        (r.offMousedown = function (t) {
          r.removeEvent(document.body, "mousedown", t);
        }),
        (r.onMousemove = function (t) {
          r.addEvent(document.body, "mousemove", t);
        }),
        (r.offMousemove = function (t) {
          r.removeEvent(document.body, "mousemove", t);
        }),
        (r.onTouchstart = function (t) {
          r.addEvent(document.body, "touchstart", t);
        }),
        (r.offTouchstart = function (t) {
          r.removeEvent(document.body, "touchstart", t);
        }),
        (r.onWindowResize = function (t) {
          r.addEvent(window, "resize", t);
        }),
        (r.onOrientationChange = function (t) {
          r.addEvent(window, "orientationchange", t);
        }),
        (r.onVisibilityChange = function (e) {
          if (t.getHiddenProperty()) {
            var n = t.getVisibilityChangeEventName();
            r.addEvent(document, n, e);
          }
        }),
        (r.onKey = function (t, e) {
          r.onKeydown(function (r) {
            (r = r || window.event), Number(r.which || r.keyCode) === t && e();
          });
        }),
        (r.addEventToAll = function (t, n, i) {
          if (!e.isNull(t))
            for (var o = 0; o < t.length; o++) {
              var a = t[o];
              r.addEvent(a, n, i);
            }
        }),
        (r.addEvent = function (t, e, r) {
          t.addEventListener
            ? t.addEventListener(e, r)
            : t.attachEvent && t.attachEvent("on" + e, r);
        }),
        (r.removeEvent = function (t, e, r) {
          t.removeEventListener
            ? t.removeEventListener(e, r)
            : t.detachEvent && t.detachEvent("on" + e, r);
        }),
        (r.addThemeJQueryEvent = function (t, e, r) {
          var n = window.$ || window.jQuery;
          n && n(t) && n(t).on && n(t).on(e, r);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/events/Events",
    ["core/util/EventUtil"],
    function (t) {
      function e() {}
      return (
        (e.triggerAddedEvent = function (e) {
          t.trigger("codeblackbelt:frequently-bought-together:added", e);
        }),
        (e.triggerRenderedEvent = function (e) {
          t.trigger("codeblackbelt:frequently-bought-together:rendered", e);
        }),
        (e.triggerProductCheckEvent = function (e) {
          t.trigger(
            "codeblackbelt:frequently-bought-together:product-check",
            e
          );
        }),
        (e.triggerProductUncheckEvent = function (e) {
          t.trigger(
            "codeblackbelt:frequently-bought-together:product-uncheck",
            e
          );
        }),
        (e.triggerVariantChangeEvent = function (e) {
          t.trigger(
            "codeblackbelt:frequently-bought-together:variant-change",
            e
          );
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/events/EventDataFactory",
    [],
    function () {
      function t() {}
      return (
        (t.buildAddedEventData = function (t, e) {
          return {
            productIdList: t,
            variantIdList: e,
            productId: t[0],
            variantId: e[0],
            quantity: t.length,
          };
        }),
        (t.buildRenderedEventData = function (t, e) {
          return { preferences: t, products: e };
        }),
        (t.buildProductCheckEventData = function (t) {
          return { productId: t };
        }),
        (t.buildVariantChangeEventData = function (t, e) {
          return { productId: t, variantId: e };
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/RegularPriceVisibilityChecker",
    [],
    function () {
      function t(t) {
        this.variant = t;
      }
      return (
        (t.forVariant = function (e) {
          return new t(e);
        }),
        (t.prototype = {
          inMarket: function (t) {
            return (this.market = t), this;
          },
          withPriceVisiblePreference: function (t) {
            return (this.showPricePreference = t), this;
          },
          andDiscountOffered: function (t) {
            return (this.offerDiscount = t), this;
          },
          isRegularPriceVisible: function () {
            return (
              !this.variant.isOnSale(this.market) &&
              (this.showPricePreference || this._isDiscountOffered())
            );
          },
          _isDiscountOffered: function () {
            return null != this.offerDiscount && 1 == this.offerDiscount;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/SalePriceVisibilityChecker",
    [],
    function () {
      function t(t) {
        this.variant = t;
      }
      return (
        (t.forVariant = function (e) {
          return new t(e);
        }),
        (t.prototype = {
          inMarket: function (t) {
            return (this.market = t), this;
          },
          withPriceVisiblePreference: function (t) {
            return (this.showPricePreference = t), this;
          },
          andDiscountOffered: function (t) {
            return (this.offerDiscount = t), this;
          },
          isSalePriceVisible: function () {
            return (
              !!this.variant.isOnSale(this.market) &&
              (this.showPricePreference || this._isDiscountOffered())
            );
          },
          _isDiscountOffered: function () {
            return null != this.offerDiscount && 1 == this.offerDiscount;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/CompareAtPriceVisibilityChecker",
    [],
    function () {
      function t(t) {
        this.variant = t;
      }
      return (
        (t.forVariant = function (e) {
          return new t(e);
        }),
        (t.prototype = {
          inMarket: function (t) {
            return (this.market = t), this;
          },
          withCompareAtPriceVisiblePreference: function (t) {
            return (this.showCompareAtPricePreference = t), this;
          },
          andDiscountOffered: function (t) {
            return (this.offerDiscount = t), this;
          },
          isCompareAtPriceVisible: function () {
            return this.market.isDefaultMarket()
              ? this._isCompareAtPriceVisibleInDefaultMarket()
              : this._isCompareAtPriceVisibleInSecondaryMarket();
          },
          _isCompareAtPriceVisibleInDefaultMarket: function () {
            if (
              this.showCompareAtPricePreference ||
              this._isDiscountOffered()
            ) {
              var t = this.market.defaultMarket();
              return (
                this.variant.getNumericPrice(t) <
                this.variant.getNumericCompareAtPrice(t)
              );
            }
            return !1;
          },
          _isCompareAtPriceVisibleInSecondaryMarket: function () {
            return null == this.variant.getPrice(this.market)
              ? this._isCompareAtPriceVisibleInDefaultMarket()
              : null != this.variant.getCompareAtPrice(this.market) &&
                  !(
                    !this.showCompareAtPricePreference &&
                    !this._isDiscountOffered()
                  ) &&
                  this.variant.isOnSale(this.market);
          },
          _isDiscountOffered: function () {
            return null != this.offerDiscount && 1 == this.offerDiscount;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/VariantSelector",
    ["core/util/JsonCss", "core/util/BrowserUtil", "lib/jquery-private"],
    function (t, e, r) {
      function n(t, e, r) {
        (this.product = t),
          (this.styles = e),
          (this.color = r.color),
          (this.backgroundColor = r.backgroundColor),
          (this.borderColor = r.borderColor),
          (this.additionalStyles = r.additionalStyles),
          (this.variants = t.getVariants());
      }
      return (
        (n.prototype = {
          createSelect: function (t) {
            this._createSelect(), this._populateSelect();
            var e = this;
            return (
              this.$select.change(function () {
                t(e.getSelectedVariant());
              }),
              this.$select
            );
          },
          getSelectedVariant: function () {
            var t = this.$select ? this.$select.val() : 0;
            return this.variants[t];
          },
          getSelect: function () {
            return this.$select;
          },
          _createSelect: function () {
            (this.$select = r("<select />")),
              this.$select.addClass("cbb-recommendations-variant-select"),
              this.$select.attr("aria-label", "Variant selector"),
              this.$select.css({
                display: "inline-block",
                appearance: "menulist",
                "background-image": "none",
                width: "auto",
                "max-width": "100%",
                "font-size": ".9em",
                "font-weight": "normal",
                border: "solid 1px #e0e0e0",
                color: "#212121",
                "background-color": "#ffffff",
                "text-align": "left",
                "vertical-align": "baseline",
              }),
              this.styles && this.$select.css(this.styles),
              this.color && this.$select.css("color", this.color),
              this.backgroundColor &&
                this.$select.css("background-color", this.backgroundColor),
              this.borderColor &&
                this.$select.css("border-color", this.borderColor),
              e.isSafariMobile() &&
                this.$select.css("border", "solid 0.1px #555555"),
              t.apply(this.$select, this.additionalStyles);
          },
          _populateSelect: function () {
            for (var t = 0; t < this.variants.length; t++) {
              var e = this.variants[t],
                n = r("<option />");
              n.val(t),
                n.text(e.getLabel()),
                n.attr("data-variant-id", e.getId()),
                this.$select.append(n);
            }
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/CurrencyConverterPlus",
    ["core/util/GlobalProperties"],
    function (t) {
      function e() {}
      return (
        (e.isInstalled = function () {
          return t.hasProperty("currency-converter-plusApi");
        }),
        (e.triggerConversion = function () {
          try {
            t.getProperty("currency-converter-plusApi").convertPrices();
          } catch (t) {}
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/Doubly",
    ["lib/jquery-private"],
    function (t) {
      function e() {}
      return (
        (e.isInstalled = function () {
          return null != window.DoublyGlobalCurrency;
        }),
        (e.triggerConversion = function () {
          try {
            e._triggerConversion();
          } catch (t) {}
        }),
        (e._triggerConversion = function () {
          var t = e.doublyCurrency();
          null != t && window.DoublyGlobalCurrency.convertAll(t);
        }),
        (e.doublyCurrency = function () {
          return t("[name=doubly-currencies]").length > 0
            ? t("[name=doubly-currencies]").val()
            : t(".currency-switcher-btn").length > 0
            ? t(".currency-switcher-btn.selected").attr("doubly-currency")
            : null;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define("core/third-party/MultiCurrency", [], function () {
    function t() {}
    return (
      (t.isInstalled = function () {
        return (
          null != window.BOLDCURRENCY && null != window.BOLDCURRENCY.converter
        );
      }),
      (t.triggerConversion = function () {
        try {
          t._triggerStandardConversion(),
            t._usesEventEmitter() && t._emitEvent();
        } catch (t) {}
      }),
      (t._triggerStandardConversion = function () {
        var t = window.BOLDCURRENCY.rateInfo,
          e = window.BOLDCURRENCY.converter.moneyElements,
          r = window.BOLDCURRENCY.defaultShopCurrency,
          n = window.BOLDCURRENCY.currentCurrency;
        window.BOLDCURRENCY.converter.convertAll(t, e, r, n);
      }),
      (t._usesEventEmitter = function () {
        return (
          window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter
        );
      }),
      (t._emitEvent = function () {
        window.BOLD.common.eventEmitter.emit("BOLD_CURRENCY_double_check");
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/third-party/AutoCurrencySwitcher",
    [],
    function () {
      function t() {}
      return (
        (t.isInstalled = function () {
          return null != window.mlvedaload;
        }),
        (t.triggerConversion = function () {
          try {
            window.mlvedaload();
          } catch (t) {}
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/JQueryCurrenciesCurrencyConverter",
    ["lib/jquery-private", "core/util/ShopifyUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.isInstalled = function () {
          return (
            this._isInstalled() &&
            this._findShopCurrency() &&
            this._findSelectedCurrency()
          );
        }),
        (r.triggerConversion = function () {
          try {
            this._triggerConversion();
          } catch (t) {}
        }),
        (r._isInstalled = function () {
          return (
            window.Currency &&
            window.Currency.convertAll &&
            "function" == typeof window.Currency.convertAll
          );
        }),
        (r._findSelectedCurrency = function () {
          var e = t(".currency-picker:eq(1)");
          if (e.length > 0) return e.find("option:selected").val();
          var r = t("[name=currencies]");
          return r.length > 0
            ? r.val()
            : window.Currency && window.Currency.currentCurrency
            ? window.Currency.currentCurrency
            : null;
        }),
        (r._findShopCurrency = function () {
          var t = e.getPresentmentCurrency();
          return t || (window.shopCurrency ? window.shopCurrency : null);
        }),
        (r._triggerConversion = function () {
          var t = this._findShopCurrency(),
            e = this._findSelectedCurrency();
          t != e && window.Currency.convertAll(t, e);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ThemeUtil",
    ["core/util/StringUtil"],
    function (t) {
      function e() {}
      return (
        (e.isShowTimeTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "showtime");
        }),
        (e.isPrestigeTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "prestige");
        }),
        (e.isWarehouseTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "warehouse");
        }),
        (e.isMotionTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "motion");
        }),
        (e.isImpulseTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "impulse");
        }),
        (e.isCraveTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "crave");
        }),
        (e.isExpressTheme = function (e) {
          return (
            !t.isEmpty(e) &&
            t.contains(e.toLowerCase(), "express") &&
            !t.contains(e.toLowerCase(), "expression")
          );
        }),
        (e.isDebutTheme = function (r) {
          return (
            !t.isEmpty(r) &&
            t.startsWith(r.toLowerCase(), "debut") &&
            !e.isDebutifyTheme(r)
          );
        }),
        (e.isDebutifyTheme = function (e) {
          return !t.isEmpty(e) && t.contains(e.toLowerCase(), "debutify");
        }),
        (e.isEnvyTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "envy");
        }),
        (e.isExpanseTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "expanse");
        }),
        (e.isStreamlineTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "streamline");
        }),
        (e.isKallesTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "kalles");
        }),
        (e.isGeckoTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "gecko");
        }),
        (e.isEcomSolidTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "ecomsolid");
        }),
        (e.isBoosterTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "booster");
        }),
        (e.isTurboTheme = function (e) {
          return !t.isEmpty(e) && t.startsWith(e.toLowerCase(), "turbo");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/ArchetypeCurrencyConverter",
    ["core/util/ThemeUtil"],
    function (t) {
      function e() {}
      return (
        (e.isInstalled = function () {
          var e = "";
          if (
            (window.Shopify &&
              window.Shopify.theme &&
              window.Shopify.theme.name &&
              (e = window.Shopify.theme.name),
            !(t.isMotionTheme(e) || t.isImpulseTheme(e)))
          )
            return !1;
          var r = !1;
          return (
            window.theme &&
              window.theme.settings &&
              window.theme.settings.currenciesEnabled &&
              "boolean" == typeof window.theme.settings.currenciesEnabled &&
              window.theme.currencySwitcher &&
              window.theme.currencySwitcher.ajaxrefresh &&
              "function" == typeof window.theme.currencySwitcher.ajaxrefresh &&
              (r = window.theme.settings.currenciesEnabled),
            r
          );
        }),
        (e.triggerConversion = function () {
          try {
            e._triggerConversion();
          } catch (t) {}
        }),
        (e._triggerConversion = function () {
          window.theme.currencySwitcher.ajaxrefresh();
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/ConversionBearCurrencyConverter",
    ["lib/jquery-private"],
    function (t) {
      function e() {}
      return (
        (e.isInstalled = function () {
          return null != window.conversionBearAutoCurrencyConverter;
        }),
        (e.triggerConversion = function () {
          try {
            e._addConversionBearClass(), e._triggerConversion();
          } catch (t) {}
        }),
        (e._addConversionBearClass = function () {
          t(
            ".cbb-also-bought-container .money, .cbb-frequently-bought-container .money"
          ).addClass("conversion-bear-money");
        }),
        (e._triggerConversion = function () {
          window.conversionBearAutoCurrencyConverter.convertPricesOnPage();
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/BoosterAppsCurrencyConverter",
    [],
    function () {
      function t() {}
      return (
        (t.isInstalled = function () {
          return (
            window.baCurr &&
            window.baCurr.config &&
            window.baCurr.config.enabled
          );
        }),
        (t.triggerConversion = function () {
          try {
            window.baCurr.rePeat();
          } catch (t) {}
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/BucksCurrencyConverter",
    [],
    function () {
      function t() {}
      return (
        (t.isInstalled = function () {
          return (
            window.bucksCC &&
            window.bucksCC.config &&
            window.bucksCC.config.active
          );
        }),
        (t.triggerConversion = function () {
          try {
            window.bucksCC.reConvert();
          } catch (t) {}
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/third-party/CurrencyConverterFacade",
    [
      "core/util/ShopifyUtil",
      "core/third-party/CurrencyConverterPlus",
      "core/third-party/Doubly",
      "core/third-party/MultiCurrency",
      "core/third-party/AutoCurrencySwitcher",
      "core/third-party/JQueryCurrenciesCurrencyConverter",
      "core/third-party/ArchetypeCurrencyConverter",
      "core/third-party/ConversionBearCurrencyConverter",
      "core/third-party/BoosterAppsCurrencyConverter",
      "core/third-party/BucksCurrencyConverter",
    ],
    function (t, e, r, n, i, o, a, c, s, u) {
      function l() {}
      return (
        (l.triggerConversion = function () {
          l._triggerConversion(), setTimeout(l._triggerConversion, 5e3);
        }),
        (l._triggerConversion = function () {
          e.isInstalled() && e.triggerConversion(),
            t.isPresentmentCurrencyActive() ||
              (r.isInstalled()
                ? r.triggerConversion()
                : n.isInstalled()
                ? n.triggerConversion()
                : i.isInstalled()
                ? i.triggerConversion()
                : c.isInstalled()
                ? c.triggerConversion()
                : s.isInstalled()
                ? s.triggerConversion()
                : u.isInstalled()
                ? u.triggerConversion()
                : a.isInstalled()
                ? a.triggerConversion()
                : o.isInstalled() && o.triggerConversion());
        }),
        (l.prototype = {}),
        l
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/SelectorUI",
    [
      "core/util/price/PriceStyleUtil",
      "core/frequently-bought/RatingUI",
      "core/frequently-bought/events/Events",
      "core/frequently-bought/events/EventDataFactory",
      "core/util/price/RegularPriceVisibilityChecker",
      "core/util/price/SalePriceVisibilityChecker",
      "core/util/price/CompareAtPriceVisibilityChecker",
      "core/util/VariantSelector",
      "core/util/StatUtil",
      "core/util/JsonCss",
      "core/util/StringUtil",
      "core/util/BrowserUtil",
      "core/util/Logger",
      "core/third-party/CurrencyConverterFacade",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a, c, s, u, l, d, f, h, p) {
      function m(t, e, r, n, i) {
        (this.product = t),
          (this.preferences = e),
          (this.productUI = r),
          (this.errorUI = n),
          (this.isMainProduct = t.isMainProduct()),
          (this.isFreeProduct = !1),
          (this.discountCalculator = i),
          this._create();
      }
      var g = "cbb-frequently-bought-selector-label-name";
      m.THIS_ITEM_SELECT_CLASS =
        "cbb-frequently-bought-this-item-variant-select";
      return (
        (m.prototype = {
          isSelected: function () {
            return this.$selector.is(":checked");
          },
          getProduct: function () {
            return this.product;
          },
          getSelector: function () {
            return this.$selectorBox;
          },
          getSelectedVariant: function () {
            return this.product.hasVariants()
              ? this.variantSelector.getSelectedVariant()
              : this.product.getSingleVariant();
          },
          getRatingBox: function () {
            return this.$ratingBox;
          },
          setFreeVariant: function () {
            (this.isFreeProduct = !0),
              this._updateWithVariant(this.getSelectedVariant());
          },
          setPaidVariant: function () {
            (this.isFreeProduct = !1),
              this._updateWithVariant(this.getSelectedVariant());
          },
          _updateWithVariant: function (t) {
            this._setLink(t),
              this._setRegularPrice(t),
              this._setSalePrice(t),
              this._setCompareAtPrice(t),
              this.productUI.updateWithVariant(t);
          },
          _create: function () {
            (this.$selectorBox = p("<li></li>")),
              this.$selectorBox.css({ "list-style-type": "none" }),
              this._createCheckbox(),
              this.isMainProduct ? this._createLabel() : this._createLink(),
              this.product.hasVariants() && this._createVariantSelector(),
              this._createProductPrices(),
              this.preferences.ratingPreferences.showRating &&
                this._createRating();
          },
          _createProductPrices: function () {
            this._showComparePriceAtFirst()
              ? this._createComparePriceBeforeCurrentPrice()
              : this._createComparePriceAfterCurrentPrice();
          },
          _createComparePriceBeforeCurrentPrice: function () {
            this._createCompareAtPrice(),
              this._createRegularPrice(),
              this._createSalePrice();
          },
          _createComparePriceAfterCurrentPrice: function () {
            this._createRegularPrice(),
              this._createSalePrice(),
              this._createCompareAtPrice();
          },
          _createCheckbox: function () {
            (this.$selector = p('<input type="checkbox" />')),
              this.$selector.addClass("cbb-frequently-bought-selector-input"),
              this.$selector.attr("id", this.product.getVariantId()),
              this.$selector.attr("name", "product_" + this.product.getId()),
              this.$selector.attr(
                "aria-label",
                "Selection of " + this.product.getNameFormatted()
              ),
              this.$selector.attr("checked", "checked"),
              this.$selector.css({
                "-webkit-appearance": "checkbox",
                display: "inline",
                float: "none",
                width: "auto",
                "min-width": "unset",
                height: "auto",
                "min-height": "unset",
                "margin-top": "0",
                "vertical-align": "baseline",
              }),
              d.isSafariMobile() &&
                this.$selector.css({
                  border: "1px solid #222222",
                  "border-radius": "2px",
                  "background-color": "#222222",
                }),
              this.$selectorBox.append(this.$selector),
              this._configureOnCheckEvent(),
              this._configureOnUnCheckEvent();
          },
          _configureOnCheckEvent: function () {
            var t = this;
            this.$selector.change(function () {
              if ((t.errorUI.hide(), p(this).is(":checked"))) {
                t.$selectorBox.animate({ opacity: "1" }, 500),
                  t.productUI.show(),
                  t.discountCalculator.recalculatePricesAndDiscountRequirements(),
                  h.triggerConversion();
                var e = n.buildProductCheckEventData(t.product.getId());
                r.triggerProductCheckEvent(e);
              }
            });
          },
          _configureOnUnCheckEvent: function () {
            var t = this;
            this.$selector.change(function () {
              if (!p(this).is(":checked")) {
                t.$selectorBox.animate({ opacity: "0.5" }, 500),
                  t.productUI.hide(),
                  t.discountCalculator.recalculatePricesAndDiscountRequirements(),
                  h.triggerConversion();
                var e = n.buildProductCheckEventData(t.product.getId());
                r.triggerProductUncheckEvent(e);
              }
            });
          },
          _createLabel: function () {
            (this.$label = p("<span></span>")),
              this.$label.addClass("translatable"),
              this.$label.attr("for", this.product.getVariantId()),
              this.$label.css({ display: "inline", "margin-left": "5px" }),
              this._createLabelContent(),
              this.$selectorBox.append(this.$label);
          },
          _createLabelContent: function () {
            var t = p("<h3></h3>");
            if ((t.addClass(g), l.isNotEmpty(this.preferences.thisItemLabel))) {
              var e = p("<span></span>");
              e.addClass("cbb-frequently-bought-this-item-label"),
                e.addClass("translatable"),
                e.text(this.preferences.thisItemLabel + " "),
                t.append(e);
            }
            var r = p("<span></span>");
            r.text(this.product.getNameFormatted()),
              t.append(r),
              t.css({
                display: "inline",
                color: this.preferences.nameColor,
                "font-weight": "bold",
                "font-size": "1em",
                "line-height": "2em",
              }),
              u.apply(t, this.preferences.nameAdditionalStyles),
              this.$label.append(t),
              this.preferences.showDescription &&
                this.$label.append(this._createDescription());
          },
          _createLink: function () {
            (this.$link = p("<a></a>")),
              this.$link.attr("tabindex", "0"),
              this.$link.attr("role", "link"),
              this.$link.addClass("cbb-frequently-bought-selector-link"),
              this.$link.css({
                color: this.preferences.nameColor,
                "font-weight": this.preferences.nameBold ? "600" : "400",
                display: "inline",
              }),
              (this.$linkText = p("<h3></h3>")),
              this.$linkText.text(this.product.getNameFormatted()),
              this.$linkText.addClass(g),
              this.$linkText.addClass(g),
              this.$linkText.css({
                display: "inline",
                "margin-left": "5px",
                "line-height": "2em",
                color: this.preferences.nameColor,
                "font-weight": this.preferences.nameBold ? "600" : "400",
                "font-size": "1em",
              }),
              u.apply(this.$link, this.preferences.nameAdditionalStyles),
              u.apply(this.$linkText, this.preferences.nameAdditionalStyles),
              this.$link.append(this.$linkText),
              this.$selectorBox.append(this.$link),
              this.preferences.showDescription &&
                this.$selectorBox.append(this._createDescription());
          },
          _createDescription: function () {
            var t = p("<span></span>");
            return (
              t.addClass("cbb-frequently-bought-selector-label-description"),
              t.html(this.product.getDescriptionFormatted()),
              t.css({
                "margin-left": "5px",
                "font-weight": this.preferences.descriptionBold ? "600" : "400",
                color: this.preferences.descriptionColor,
              }),
              u.apply(t, this.preferences.descriptionAdditionalStyles),
              t
            );
          },
          _createVariantSelector: function () {
            var t = {
              margin: "2px 2px 2px 5px",
              padding: "2px",
              "max-width": "220px",
              height: "2em",
              "min-height": "2em",
              "max-height": "2em",
            };
            this.variantSelector = new c(
              this.product,
              t,
              this.preferences.variantSelectorPreferences
            );
            var e = this,
              i = this.variantSelector.createSelect(function (t) {
                e._updateWithVariant(t),
                  e.discountCalculator.recalculatePricesAndDiscountRequirements(),
                  h.triggerConversion();
                var i = n.buildVariantChangeEventData(
                  e.product.getId(),
                  t.getId()
                );
                r.triggerVariantChangeEvent(i);
              });
            this.isMainProduct && i.addClass(m.THIS_ITEM_SELECT_CLASS),
              this.$selectorBox.append(i);
          },
          _setLink: function (t) {
            if (this.$link) {
              this.$link.attr("href", t.getVariantUrl()), this.$link.off();
              var e = this.product.getId();
              this.$link.click(function (t) {
                s.clickedAndRedirect("frequently-bought-together", e, t);
              });
            }
          },
          _createRegularPrice: function () {
            (this.$regularPrice = p("<span></span>")),
              this.$regularPrice.addClass(
                "cbb-frequently-bought-selector-label-regular-price"
              ),
              this.$regularPrice.css({
                "margin-left": ".5em",
                "white-space": "nowrap",
              }),
              t.applyRegularPriceStylePreferences(
                this.$regularPrice,
                this.preferences
              ),
              this.$regularPrice.hide(),
              this.$selectorBox.append(this.$regularPrice);
          },
          _createSalePrice: function () {
            (this.$salePrice = p("<span></span>")),
              this.$salePrice.addClass(
                "cbb-frequently-bought-selector-label-sale-price"
              ),
              this.$salePrice.css({
                "margin-left": ".5em",
                "white-space": "nowrap",
              }),
              t.applySalePriceStylePreferences(
                this.$salePrice,
                this.preferences
              ),
              this.$salePrice.hide(),
              this.$selectorBox.append(this.$salePrice);
          },
          _createCompareAtPrice: function () {
            (this.$compareAtPrice = p("<s></s>")),
              this.$compareAtPrice.addClass(
                "cbb-frequently-bought-selector-label-compare-at-price"
              ),
              this.$compareAtPrice.css({
                "margin-left": "0.5em",
                "white-space": "nowrap",
              }),
              t.applyCompareAtPriceStylePreferences(
                this.$compareAtPrice,
                this.preferences
              ),
              this.$compareAtPrice.hide(),
              this.$selectorBox.append(this.$compareAtPrice);
          },
          _setRegularPrice: function (t) {
            if (this._shouldShowRegularPriceProduct(t)) {
              var e = t.getPriceFormatted(this.preferences.market);
              this.$regularPrice.html(e), this.$regularPrice.show();
            } else this.$regularPrice.empty(), this.$regularPrice.hide();
          },
          _setSalePrice: function (t) {
            if (this._shouldShowSalePriceProduct(t)) {
              var e = this.isFreeProduct
                ? t.getForFreePriceFormatted()
                : t.getPriceFormatted(this.preferences.market);
              this.$salePrice.html(e), this.$salePrice.show();
            } else this.$salePrice.empty(), this.$salePrice.hide();
          },
          _setCompareAtPrice: function (t) {
            a
              .forVariant(t)
              .inMarket(this.preferences.market)
              .withCompareAtPriceVisiblePreference(
                this.preferences.showCompareAtPrice
              )
              .andDiscountOffered(this.preferences.offerDiscount)
              .isCompareAtPriceVisible()
              ? (this.$compareAtPrice.html(
                  t.getCompareAtPriceFormatted(this.preferences.market)
                ),
                this.$compareAtPrice.show())
              : this._shouldShowCompareAtPriceForFreeProduct()
              ? (this.$compareAtPrice.html(
                  t.getPriceFormatted(this.preferences.market)
                ),
                this.$compareAtPrice.show())
              : (this.$compareAtPrice.empty(), this.$compareAtPrice.hide());
          },
          _createRating: function () {
            var t = new e(this.product, this.preferences.ratingPreferences);
            (this.$ratingBox = t.createRating()),
              this.$selectorBox.append(this.$ratingBox);
          },
          _showComparePriceAtFirst: function () {
            return this.preferences.showCompareAtPriceFirst;
          },
          _shouldShowRegularPriceProduct: function (t) {
            return (
              !this.isFreeProduct &&
              i
                .forVariant(t)
                .inMarket(this.preferences.market)
                .withPriceVisiblePreference(this.preferences.showPrice)
                .andDiscountOffered(this.preferences.offerDiscount)
                .isRegularPriceVisible()
            );
          },
          _shouldShowSalePriceProduct: function (t) {
            return this.isFreeProduct
              ? this.preferences.showPrice || this.preferences.offerDiscount
              : o
                  .forVariant(t)
                  .inMarket(this.preferences.market)
                  .withPriceVisiblePreference(this.preferences.showPrice)
                  .andDiscountOffered(this.preferences.offerDiscount)
                  .isSalePriceVisible();
          },
          _shouldShowCompareAtPriceForFreeProduct: function () {
            return (
              !!this.isFreeProduct &&
              (this.preferences.showPrice || this.preferences.offerDiscount)
            );
          },
        }),
        m
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ButtonFinder",
    ["lib/jquery-private"],
    function (t) {
      function e() {}
      return (
        (e.prototype = {
          findSubmitButtonInForm: function (t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r],
                i = this._findVisibleButtonMatchingSelector(t, n);
              if (this._exists(i)) return this._isRegularSubmitButton(i);
            }
            return null;
          },
          _findVisibleButtonMatchingSelector: function (e, r) {
            var n = e.find(r).filter(":visible");
            return this._exists(n) ? t(n[0]) : null;
          },
          _isRegularSubmitButton: function (t) {
            return (
              !this._isPayPalExpressButton(t) &&
              !this._isDynamicCheckoutButton(t) &&
              t
            );
          },
          _isPayPalExpressButton: function (t) {
            var e = t.attr("id");
            return null !== e && "paypal-express-button" === e;
          },
          _isDynamicCheckoutButton: function (t) {
            return t.hasClass("shopify-payment-button__button");
          },
          _exists: function (t) {
            return t && t.length > 0;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/AddToCartButtonFinder",
    ["core/util/ButtonFinder", "core/util/UrlUtil", "lib/jquery-private"],
    function (t, e, r) {
      function n() {
        this.buttonFinder = new t();
      }
      var i = [
        "#AddToCart",
        ".product-form__cart-submit, #AddToCart-product-template",
        "#addToCart-product-template",
        "#AddToCart--product-template",
        '.product__add-to-cart-button, button[type="submit"][name="add"]',
        'input[type="submit"][name="add"]',
        'button[type="button"][name="add"]',
        ".ProductForm__AddToCart",
      ];
      return (
        (n.prototype = {
          findButton: function () {
            var t = this._findAddToCartForm();
            return this._exists(t)
              ? this.buttonFinder.findSubmitButtonInForm(t, i)
              : null;
          },
          _findAddToCartForm: function () {
            return this._findCart('form[action*="/cart/aadd"]');
          },
          _findCart: function (t) {
            var e = r(t);
            return this._exists(e) ? e : null;
          },
          _exists: function (t) {
            return t && t.length > 0;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/CheckoutButtonFinder",
    ["core/util/ButtonFinder", "core/util/UrlUtil", "lib/jquery-private"],
    function (t, e, r) {
      function n() {
        this.buttonFinder = new t();
      }
      var i = [
        'button[id="checkout"]',
        'input[type="submit"][name="checkout"]',
        'button[type="submit"][name="checkout"]',
        'button[type="submit"]',
        'input[type="submit"]',
        'button[type="button"]',
      ];
      return (
        (n.prototype = {
          findButton: function () {
            var t = this._findDawnButton();
            return this._exists(t) ? t : this._findCheckoutButtonInForm();
          },
          _findDawnButton: function () {
            var t = r("button.cart__checkout-button");
            return this._exists(t) ? r(t[0]) : {};
          },
          _findCheckoutForm: function () {
            return this._findCart(
              'form[action="/checkout"], form[action*="/cart"]'
            );
          },
          _findCheckoutButtonInForm: function () {
            var t = this._findCheckoutForm();
            return this._exists(t)
              ? this.buttonFinder.findSubmitButtonInForm(t, i)
              : null;
          },
          _findCart: function (t) {
            var e = r(t);
            return this._exists(e) ? e : {};
          },
          _exists: function (t) {
            return t && t.length > 0;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/FormButtonFinder",
    [
      "core/util/AddToCartButtonFinder",
      "core/util/CheckoutButtonFinder",
      "core/util/UrlUtil",
    ],
    function (t, e, r) {
      function n() {
        (this.checkoutButtonFinder = new e()),
          (this.addToCartButtonFinder = new t());
      }
      return (
        (n.prototype = {
          findButton: function () {
            return r.isCartPage()
              ? this._findCheckoutButton()
              : r.isProductPage()
              ? this._findAddToCartButton()
              : this._findCheckoutButton() || this._findAddToCartButton();
          },
          _findCheckoutButton: function () {
            return this.checkoutButtonFinder.findButton();
          },
          _findAddToCartButton: function () {
            return this.addToCartButtonFinder.findButton();
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/CartFormButtonStylesReader",
    [
      "core/util/FormButtonFinder",
      "core/util/StringUtil",
      "core/util/NumberUtil",
    ],
    function (t, e, r) {
      function n() {
        (this.formButtonFinder = new t()), (this.$button = null);
      }
      return (
        (n.jsonStyles = function () {
          return new n()._jsonStyles();
        }),
        (n.prototype = {
          _jsonStyles: function () {
            return (
              (this.$button = this.formButtonFinder.findButton()),
              this._formButtonExists()
                ? this._buttonStyles()
                : this._emptyStyles()
            );
          },
          _formButtonExists: function () {
            return this.$button && this.$button.length > 0;
          },
          _buttonStyles: function () {
            return {
              "font-family": this.$button.css("font-family"),
              "font-size": this._safeFontSize(),
              "font-weight": this.$button.css("font-weight"),
              "text-transform": this.$button.css("text-transform"),
              "text-decoration": this.$button.css("text-decoration"),
              "text-align": this.$button.css("text-align"),
              "vertical-align": this.$button.css("vertical-align"),
              "max-height": "70px",
              "letter-spacing": this.$button.css("letter-spacing"),
              "white-space": this.$button.css("white-space"),
              "line-height": "normal",
              color: this.$button.css("color"),
              background: this.$button.css("background"),
              "background-color": this.$button.css("background-color"),
              "box-shadow": this.$button.css("box-shadow"),
              "border-top-width": this._pxValueOrZero("border-top-width"),
              "border-right-width": this._pxValueOrZero("border-right-width"),
              "border-bottom-width": this._pxValueOrZero("border-bottom-width"),
              "border-left-width": this._pxValueOrZero("border-left-width"),
              "border-top-left-radius": this._pxValueOrZero(
                "border-top-left-radius"
              ),
              "border-top-right-radius": this._pxValueOrZero(
                "border-top-right-radius"
              ),
              "border-bottom-right-radius": this._pxValueOrZero(
                "border-bottom-right-radius"
              ),
              "border-bottom-left-radius": this._pxValueOrZero(
                "border-bottom-left-radius"
              ),
              "border-top-color": this._valueOrDefault("border-top-color"),
              "border-right-color": this._valueOrDefault("border-right-color"),
              "border-bottom-color": this._valueOrDefault(
                "border-bottom-color"
              ),
              "border-left-color": this._valueOrDefault("border-left-color"),
              "padding-top": this._safePadding("padding-top"),
              "padding-bottom": this._safePadding("padding-bottom"),
              "padding-left": this._safePadding("padding-left"),
              "padding-right": this._safePadding("padding-right"),
            };
          },
          _emptyStyles: function () {
            return {};
          },
          _safeFontSize: function () {
            var t = this.$button.css("font-size");
            return e.isEmpty(t) ? "18px" : r.pxToNumber(t) > 18 ? "18px" : t;
          },
          _pxValueOrZero: function (t) {
            var r = this.$button.css(t);
            return e.isEmpty(r) ? "0px" : r;
          },
          _valueOrDefault: function (t) {
            var r = this.$button.css(t);
            return e.isEmpty(r) ? "initial" : r;
          },
          _safePadding: function (t) {
            var n = this.$button.css(t),
              i = r.pxToNumber(n);
            return e.isEmpty(n) || i < 10 ? "10px" : n;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/AddToCartButtonUI",
    [
      "core/util/CartFormButtonStylesReader",
      "core/util/BrowserUtil",
      "core/util/JsonCss",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i(t) {
        (this.preferences = t), this._create();
      }
      return (
        (i.prototype = {
          onClick: function (t) {
            this.$button.click(function (e) {
              e.preventDefault(), e.stopPropagation(), t();
            });
          },
          _create: function () {
            (this.$button = n("<button></button>")),
              this.$button.addClass("cbb-frequently-bought-add-button"),
              (this.$buttonText = this._buttonText()),
              this.$button.append(this.$buttonText),
              this._setStyles(),
              this._setHoverStyles();
          },
          _buttonText: function () {
            return (
              (this.$text = n("<span></span>")),
              this.$text.addClass("translatable"),
              this.preferences.hasAddToCartColor() &&
                this.$text.css("color", this.preferences.color),
              this.$text.text(this.preferences.label),
              this.$text
            );
          },
          _setStyles: function () {
            this.$button.css(t.jsonStyles()),
              this.$button.css({
                position: "relative",
                display: "inline-block",
                width: "auto",
                "margin-top": "0",
                "margin-left": "0",
                "text-align": "center",
                cursor: "pointer",
                "white-space": "no-wrap",
                "border-style": "none",
              }),
              e.isMobile() &&
                this.$button.css({
                  width: "100%",
                  "padding-left": "0",
                  "padding-right": "0",
                  "margin-bottom": ".5em",
                }),
              this.preferences.hasAddToCartBackgroundColor() &&
                this.$button.css(
                  "background-color",
                  this.preferences.backgroundColor
                ),
              r.apply(this.$button, this.preferences.additionalStyles);
          },
          _setHoverStyles: function () {
            var t = this,
              e = this.$text.css("color"),
              r = this.$button.css("background-color");
            this.preferences.mustSetStylesOnHover() &&
              this.$button.hover(
                function () {
                  t.preferences.hasAddToCartHoverColor() &&
                    t.$text.css("color", t.preferences.hoverColor),
                    t.preferences.hasAddToCartHoverBackgroundColor() &&
                      t.$button.css(
                        "background-color",
                        t.preferences.hoverBackgroundColor
                      );
                },
                function () {
                  t.$text.css("color", e), t.$button.css("background-color", r);
                }
              );
          },
          getButton: function () {
            return this.$button;
          },
          showDisabledButton: function () {
            this._disable(),
              this._waitCursor(),
              this.$button.css("min-width", this.$button.outerWidth()),
              this._waitText();
          },
          showEnabledButton: function () {
            this.$buttonText.text(this.preferences.label), this._enable();
          },
          showDisabledAddedAndEnabledButton: function () {
            var t = this;
            this.showDisabledAddedButton(),
              setTimeout(function () {
                t.showEnabledButton();
              }, 5e3);
          },
          showDisabledAddedButton: function () {
            this._disable(), this._regularCursor(), this._addedText();
          },
          _disable: function () {
            this.$button.prop("disabled", !0);
          },
          _enable: function () {
            this.$button.prop("disabled", !1), this._clickCursor();
          },
          _waitCursor: function () {
            this.$button.css("cursor", "wait");
          },
          _regularCursor: function () {
            this.$button.css("cursor", "default");
          },
          _clickCursor: function () {
            this.$button.css("cursor", "pointer");
            var t = e.isMobile() ? "100%" : "auto";
            this.$button.css("width", t);
          },
          _waitText: function () {
            this.$buttonText.text("•••");
          },
          _addedText: function () {
            this.preferences.addedLabel.length > 0
              ? this.$buttonText.text(this.preferences.addedLabel)
              : this.$buttonText.text("✔");
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/SalePriceChecker",
    ["core/util/Objects"],
    function (t) {
      function e() {}
      return (
        (e.isOnSale = function (e, r) {
          return !t.isNull(e) && !t.isNull(r) && r > e;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/TotalPriceUI",
    [
      "core/util/price/SalePriceChecker",
      "core/util/price/PriceStyleUtil",
      "core/util/CssUtil",
      "core/util/BrowserUtil",
      "core/util/Logger",
      "core/util/Objects",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a) {
      function c(t, e) {
        (this.totalPricePreferences = t),
          (this.priceFormatter = e),
          this._create();
      }
      return (
        (c.prototype = {
          getPrice: function () {
            return this.$priceBox;
          },
          setTotalPrice: function (e, r) {
            var n = t.isOnSale(e, r);
            this._setRegularPrice(e, r, n),
              this._setSalePrice(e, r, n),
              this._setCompareAtPrice(e, r, n),
              this._showIfAnyPriceIsShown();
          },
          _create: function () {
            (this.$priceBox = a("<div></div>")),
              this.$priceBox.addClass("cbb-frequently-bought-total-price-box"),
              this.$priceBox.css({
                "margin-bottom": "10px",
                "margin-right": ".5em",
              }),
              n.isMobile() &&
                this.$priceBox.css({
                  width: "100%",
                  "text-align": "center",
                  "font-size": "1.25em",
                }),
              this.$priceBox.append(this._text()),
              this.$priceBox.hide(),
              this._createProductPrices();
          },
          _createProductPrices: function () {
            this._showComparePriceAtFirst()
              ? this._createComparePriceBeforeCurrentPrice()
              : this._createComparePriceAfterCurrentPrice();
          },
          _createComparePriceBeforeCurrentPrice: function () {
            this.$priceBox.append(this._compareAtPrice()),
              this.$priceBox.append(this._regularPrice()),
              this.$priceBox.append(this._salePrice());
          },
          _createComparePriceAfterCurrentPrice: function () {
            this.$priceBox.append(this._regularPrice()),
              this.$priceBox.append(this._salePrice()),
              this.$priceBox.append(this._compareAtPrice());
          },
          _text: function () {
            return (
              (this.$text = a("<span></span>")),
              this.$text.addClass("cbb-frequently-bought-total-price-text"),
              this.$text.addClass("translatable"),
              this.$text.text(this.totalPricePreferences.label),
              this.$text.css({
                color: this.totalPricePreferences.labelColor,
                "font-weight": this.totalPricePreferences.labelBold
                  ? "600"
                  : "400",
                "white-space": "nowrap",
              }),
              this.$text
            );
          },
          _regularPrice: function () {
            return (
              (this.$regularPrice = a("<span></span>")),
              this.$regularPrice.addClass(
                "cbb-frequently-bought-total-price-regular-price"
              ),
              this.$regularPrice.css({
                "margin-left": "0.25em",
                "margin-right": "0.25em",
              }),
              e.applyRegularPriceStylePreferences(
                this.$regularPrice,
                this.totalPricePreferences
              ),
              this.$regularPrice
            );
          },
          _salePrice: function () {
            return (
              (this.$salePrice = a("<span></span>")),
              this.$salePrice.addClass(
                "cbb-frequently-bought-total-price-sale-price"
              ),
              this.$salePrice.css({
                "margin-left": "0.25em",
                "margin-right": "0.25em",
              }),
              e.applySalePriceStylePreferences(
                this.$salePrice,
                this.totalPricePreferences
              ),
              this.$salePrice
            );
          },
          _compareAtPrice: function () {
            return (
              (this.$compareAtPrice = a("<s></s>")),
              this.$compareAtPrice.addClass(
                "cbb-frequently-bought-total-price-was-price"
              ),
              this.$compareAtPrice.css({
                "white-space": "nowrap",
                "margin-left": "0.25em",
                "margin-right": "0.25em",
              }),
              e.applyCompareAtPriceStylePreferences(
                this.$compareAtPrice,
                this.totalPricePreferences
              ),
              this.$compareAtPrice
            );
          },
          _setRegularPrice: function (t, e, r) {
            this._showFinalPrice() && !r
              ? (this.$regularPrice.html(this._priceFormatted(t)),
                this.$regularPrice.show())
              : (this.$regularPrice.empty(), this.$regularPrice.hide());
          },
          _setSalePrice: function (t, e, r) {
            this._showFinalPrice() && r
              ? (this.$salePrice.html(this._priceFormatted(t)),
                this.$salePrice.show())
              : (this.$salePrice.empty(), this.$salePrice.hide());
          },
          _setCompareAtPrice: function (t, e, r) {
            this._showComparePrice() && r
              ? (this.$compareAtPrice.html(this._priceFormatted(e)),
                this.$compareAtPrice.show())
              : (this.$compareAtPrice.empty(), this.$compareAtPrice.hide());
          },
          _showFinalPrice: function () {
            return (
              this.totalPricePreferences.showPrice ||
              this.totalPricePreferences.offerDiscount
            );
          },
          _showComparePrice: function () {
            return (
              this.totalPricePreferences.showCompareAtPrice ||
              this.totalPricePreferences.offerDiscount
            );
          },
          _showIfAnyPriceIsShown: function () {
            r.isHidden(this.$regularPrice) &&
            r.isHidden(this.$salePrice) &&
            r.isHidden(this.$compareAtPrice)
              ? this.$priceBox.hide()
              : this.$priceBox.show();
          },
          _priceFormatted: function (t) {
            if (o.isNull(t) || isNaN(t)) return "";
            var e = String(t);
            return this.priceFormatter.formattedPrice(e);
          },
          _showComparePriceAtFirst: function () {
            return this.totalPricePreferences.showCompareAtPriceFirst;
          },
        }),
        c
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/ErrorUI",
    ["lib/jquery-private"],
    function (t) {
      function e() {
        this._create();
      }
      return (
        (e.prototype = {
          _create: function () {
            (this.$error = t("<div></div>")),
              this.$error.addClass("cbb-frequently-bought-error"),
              this.$error.css({
                display: "none",
                "background-color": "#ffb6c1",
                "border-radius": "4px",
                padding: "1em",
                "margin-bottom": "10px",
              });
          },
          getErrorBox: function () {
            return this.$error;
          },
          hide: function () {
            this.$error.hide();
          },
          show: function (t) {
            this.$error.html(t), this.$error.show();
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define("core/util/Arrays", ["core/util/Objects"], function (t) {
    function e() {}
    return (
      (e.isArray = function (t) {
        return Array.isArray(t);
      }),
      (e.isEmpty = function (e) {
        if (t.isNull(e)) return !0;
        if (Array.isArray(e)) return 0 === e.length;
        throw new Error("Illegal argument exception: " + typeof e);
      }),
      (e.hasOneElement = function (t) {
        return !e.isEmpty(t) && 1 == t.length;
      }),
      e
    );
  }),
  codeblackbelt.define(
    "core/frequently-bought/util/ProductViewUtil",
    ["core/util/Objects", "core/util/Arrays"],
    function (t, e) {
      function r() {}
      return (
        (r.isProductChecked = function (r, n) {
          if (t.isNull(r))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          if (t.isNull(n))
            throw new Error("Illegal argument exception: null product id");
          var i = r.filter(function (t) {
            return n == t.getId();
          });
          return e.hasOneElement(i);
        }),
        (r.checkedProducts = function (e) {
          if (t.isNull(e))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          return e.filter(function (t) {
            return t.isSelected();
          });
        }),
        (r.productIds = function (e) {
          if (t.isNull(e))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          return e.map(function (t) {
            return t.getId();
          });
        }),
        (r.variantIds = function (e) {
          if (t.isNull(e))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          return e.map(function (t) {
            return t.getVariantId();
          });
        }),
        (r.productNames = function (r) {
          if (t.isNull(r))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          return e.isEmpty(r)
            ? ""
            : r
                .map(function (t) {
                  return t.getNameFormatted();
                })
                .reduce(function (t, e) {
                  return t + ", " + e;
                });
        }),
        (r.totalAmount = function (e, r) {
          if (t.isNull(e))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          if (t.isNull(r))
            throw new Error("Illegal argument exception: null market");
          var n = e
            .map(function (t) {
              return t.getVariant().getNumericPrice(r);
            })
            .reduce(function (t, e) {
              return t + e;
            }, 0);
          return Number(n.toFixed(2));
        }),
        (r.totalCompareAtAmount = function (e, r) {
          if (t.isNull(e))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          if (t.isNull(r))
            throw new Error("Illegal argument exception: null market");
          var n = e
            .map(function (t) {
              return t.getVariant().getNumericCompareAtPriceOrPrice(r);
            })
            .reduce(function (t, e) {
              return t + e;
            }, 0);
          return Number(n.toFixed(2));
        }),
        (r.cheapestVariant = function (n, i) {
          if (t.isNull(n))
            throw new Error(
              "Illegal argument exception: null product view array"
            );
          if (e.isEmpty(n))
            throw new Error(
              "Illegal argument exception: empty product view array"
            );
          if (t.isNull(i))
            throw new Error("Illegal argument exception: null market");
          return n
            .map(function (t) {
              return t.getVariant();
            })
            .reduce(function (t, e) {
              return r._cheapest(e, t, i);
            });
        }),
        (r._cheapest = function (e, r, n) {
          return t.isNull(r)
            ? e
            : e.getNumericPrice(n) < r.getNumericPrice(n)
            ? e
            : r;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountCalculator",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/util/Logger",
      "core/util/Arrays",
    ],
    function (t, e, r) {
      function n(t, e, r, n, i) {
        (this.productViews = t),
          (this.totalPriceUI = e),
          (this.selectorsUI = r),
          (this.discountMessageUI = n),
          (this.preferences = i),
          (this.discountApplicable = !1),
          (this.checkedProducts = []),
          (this.selectedProductIdList = []),
          (this.selectedVariantIdList = []);
      }
      return (
        (n.prototype = {
          recalculatePricesAndDiscountRequirements: function () {
            this._reloadCheckedProducts(),
              this._checkDiscountRequirements(),
              this._showDiscountMessage(),
              this._applyBxGetOneIfNeeded(),
              this._recalculateTotalPrice();
          },
          getSelectedProductIdList: function () {
            return this.selectedProductIdList;
          },
          getSelectedVariantIdList: function () {
            return this.selectedVariantIdList;
          },
          isDiscountApplicable: function () {
            return this.discountApplicable;
          },
          _reloadCheckedProducts: function () {
            (this.checkedProducts = t.checkedProducts(this.productViews)),
              (this.selectedProductIdList = t.productIds(this.checkedProducts)),
              (this.selectedVariantIdList = t.variantIds(this.checkedProducts)),
              e.debugGroup("Reloaded checked products", [
                this.checkedProducts,
                this.selectedProductIdList,
                this.selectedVariantIdList,
              ]);
          },
          _checkDiscountRequirements: function () {
            var t = this.preferences.offerDiscount;
            this.discountApplicable =
              !!t &&
              this.preferences.discount.isApplicable(
                this.checkedProducts,
                this.preferences.currentProduct
              );
          },
          _showDiscountMessage: function () {
            this.discountApplicable &&
            this.preferences.notEmptyDiscountMessage()
              ? (e.debug("Showing discount applicable message"),
                this.discountMessageUI.show())
              : (e.debug("Hiding discount applicable message"),
                this.discountMessageUI.hide());
          },
          _applyBxGetOneIfNeeded: function () {
            this._isBxGetOneApplicable()
              ? this._applyBxGetOneDiscount()
              : this._showBundle();
          },
          _isBxGetOneApplicable: function () {
            return (
              !r.isEmpty(this.checkedProducts) &&
              this.preferences.offerDiscount &&
              this.preferences.discountPreferences.isCheapestItemForFreeDiscount() &&
              this.discountApplicable
            );
          },
          _applyBxGetOneDiscount: function () {
            var e = t.cheapestVariant(
                this.checkedProducts,
                this.preferences.market.defaultMarket()
              ),
              r = this;
            this.selectorsUI.getSelectors().forEach(function (t) {
              r._selectedMatchesCheapest(t.getSelectedVariant(), e)
                ? t.setFreeVariant()
                : t.setPaidVariant();
            });
          },
          _showBundle: function () {
            this.selectorsUI.getSelectors().forEach(function (t) {
              t.setPaidVariant();
            });
          },
          _selectedMatchesCheapest: function (t, e) {
            return t.getId() == e.getId();
          },
          _recalculateTotalPrice: function () {
            var r = this._calculateBundleTotal(),
              n = t.totalCompareAtAmount(
                this.checkedProducts,
                this.preferences.market
              );
            e.debug("Bundle total: " + r),
              e.debug("Bundle total compare at price: " + n),
              this.totalPriceUI.setTotalPrice(r, n);
          },
          _calculateBundleTotal: function () {
            return this.discountApplicable
              ? (e.debug(
                  "The configured discount will be applied to this bundle"
                ),
                this.preferences.discount.calculateDiscountedTotal(
                  this.checkedProducts
                ))
              : (e.debug("There is no discount applicable to this bundle"),
                t.totalAmount(this.checkedProducts, this.preferences.market));
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/LocalStorageDiscountParameters",
    ["core/util/LocalStorage"],
    function (t) {
      function e() {}
      return (
        (e.exists = function () {
          return t.hasItem("cbb-fbt-discount-parameters");
        }),
        (e.get = function () {
          return JSON.parse(t.getItem("cbb-fbt-discount-parameters"));
        }),
        (e.store = function (e) {
          t.setItem("cbb-fbt-discount-parameters", JSON.stringify(e));
        }),
        (e.remove = function () {
          t.removeItem("cbb-fbt-discount-parameters");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountDeactivator",
    ["core/util/ShopifyUtil", "core/util/AjaxPost", "core/util/DomainUtil"],
    function (t, e, r) {
      function n() {}
      return (
        (n.deactivateShopifyDiscountPriceRule = function (n) {
          var i =
              r.baseUrl() + "/frequently-bought-together/deactivate-discount",
            o = {
              shop: t.getShop(),
              hmac: n.hmac,
              timestamp: n.timestamp,
              priceRuleId: n.priceRuleId,
            };
          e.post(i, o);
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountCreator",
    [
      "core/frequently-bought/discount/LocalStorageDiscountParameters",
      "core/frequently-bought/discount/DiscountDeactivator",
      "core/util/AjaxGet",
      "core/util/AjaxPost",
      "core/util/ShopifyUtil",
      "core/util/DomainUtil",
    ],
    function (t, e, r, n, i, o) {
      function a(t, e, r) {
        (this.preferences = t),
          (this.addToCartButtonUI = e),
          (this.errorUI = r);
      }
      return (
        (a.prototype = {
          createAndApplyDiscountCode: function (t, e, r, n, i) {
            var o = this;
            this._createDiscountCode(t, e, r, n, function (t) {
              o._applyDiscountCode(t, i);
            });
          },
          _createDiscountCode: function (t, e, r, a, c) {
            for (
              var s = this,
                u = o.baseUrl() + "/frequently-bought-together/discount.json",
                l = {
                  shop: i.getShop(),
                  marketCountry: i.getCountry(),
                  marketCurrency: i.getPresentmentCurrency(),
                  currentProductId: t,
                  hmac: this.preferences.discountHmac,
                  timestamp: this.preferences.discountTimestamp,
                },
                d = 0;
              d < e.length;
              d++
            ) {
              var f = "productIds[" + d + "]";
              l[f] = e[d];
            }
            for (var d = 0; d < r.length; d++) {
              var f = "selectedProductIds[" + d + "]";
              l[f] = r[d];
            }
            for (var d = 0; d < a.length; d++) {
              var f = "selectedVariantIds[" + d + "]";
              l[f] = a[d];
            }
            var h = function (t) {
                (t.selectedVariantIds = a), c(t);
              },
              p = function () {
                s.addToCartButtonUI.showEnabledButton(),
                  s.errorUI.show(
                    "Could not create discount. Please refresh the page and try again"
                  );
              };
            n.post(u, l, h, p);
          },
          _applyDiscountCode: function (e, n) {
            var i = this,
              a = "/discount/" + e.discountCode;
            o.isLocalhost() && (a = o.baseUrl() + a);
            var c = function () {
                i._deactivatePreviousShopifyDiscountIfPresent(),
                  t.store(e),
                  n();
              },
              s = function () {
                i.addToCartButtonUI.showEnabledButton(),
                  i.errorUI.show(
                    "Could not apply discount. Please refresh the page and try again"
                  );
              };
            r.getNoCache(a, {}, c, s);
          },
          _deactivatePreviousShopifyDiscountIfPresent: function () {
            if (t.exists()) {
              var r = t.get();
              setTimeout(function () {
                e.deactivateShopifyDiscountPriceRule(r);
              }, 10);
            }
          },
        }),
        a
      );
    }
  ),
  codeblackbelt.define("core/util/CookieUtil", [], function () {
    function t() {}
    return (
      (t.getCookie = function (t) {
        for (
          var e = t + "=",
            r = decodeURIComponent(document.cookie),
            n = r.split(";"),
            i = 0;
          i < n.length;
          i++
        ) {
          for (var o = n[i]; " " === o.charAt(0); ) o = o.substring(1);
          if (0 === o.indexOf(e)) return o.substring(e.length, o.length);
        }
        return null;
      }),
      (t.deleteCookie = function (t) {
        document.cookie =
          t + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountRemover",
    [
      "core/frequently-bought/discount/LocalStorageDiscountParameters",
      "core/frequently-bought/discount/DiscountDeactivator",
      "core/util/AjaxGet",
      "core/util/CookieUtil",
      "core/util/DomainUtil",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.removeDiscount = function () {
          if (t.exists()) {
            var r = t.get();
            e.deactivateShopifyDiscountPriceRule(r),
              o._removeDiscountCookie(),
              o._forceShopifyToIgnoreDiscount(),
              o._removeStoredDiscountParameters();
          }
        }),
        (o._removeDiscountCookie = function () {
          n.deleteCookie("discount_code");
        }),
        (o._forceShopifyToIgnoreDiscount = function () {
          var t = "/checkout?discount=%20";
          i.isLocalhost() && (t = i.baseUrl() + t), r.getNoCache(t);
        }),
        (o._removeStoredDiscountParameters = function () {
          t.remove();
        }),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountMessageUI",
    [
      "core/util/JsonCss",
      "core/util/BrowserUtil",
      "core/util/DeviceCssClassAdder",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i) {
      function o(t) {
        (this.discountMessagePreferences = t), this._build();
      }
      return (
        (o.prototype = {
          _build: function () {
            (this.$discountMessageBox = i("<div></div>")),
              this.$discountMessageBox.append(this._buildDiscountMessage()),
              this.$discountMessageBox.addClass(
                "cbb-frequently-bought-discount-message-container"
              ),
              r.addDeviceClasses(this.$discountMessageBox),
              this.$discountMessageBox.css({
                display: "none",
                "text-align": e.isMobile() ? "center" : "left",
                "padding-top": "0",
                "padding-bottom": "0",
                "padding-left": "0",
                "padding-right": "0",
                margin: "0",
              });
          },
          _buildDiscountMessage: function () {
            var e = i("<span></span>");
            return (
              e.html(this.discountMessagePreferences.discountMessage),
              e.addClass("cbb-frequently-bought-discount-message"),
              e.addClass("translatable"),
              e.css({
                display: "inline-block",
                color: this.discountMessagePreferences.color,
                "background-color":
                  this.discountMessagePreferences.backgroundColor,
                border: this.discountMessagePreferences.border
                  ? "1px solid"
                  : "none",
                "border-radius": "4px",
                "border-color": this.discountMessagePreferences.borderColor,
                "font-size": this.discountMessagePreferences.size + "px",
                "font-weight": this.discountMessagePreferences.bold
                  ? "bold"
                  : "normal",
                "padding-top":
                  this.discountMessagePreferences.verticalPadding + "px",
                "padding-bottom":
                  this.discountMessagePreferences.verticalPadding + "px",
                "padding-left":
                  this.discountMessagePreferences.horizontalPadding + "px",
                "padding-right":
                  this.discountMessagePreferences.horizontalPadding + "px",
                "text-decoration": "none",
                "text-transform": "none",
              }),
              t.apply(e, this.discountMessagePreferences.additionalStyles),
              e
            );
          },
          getMessage: function () {
            return this.$discountMessageBox;
          },
          show: function () {
            try {
              return this.$discountMessageBox.show();
            } catch (t) {
              n.log(
                "Discount message could not be displayed due to jQuery error"
              );
            }
          },
          hide: function () {
            return this.$discountMessageBox.hide();
          },
        }),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountAppliedMessageFormatter",
    ["core/util/StringUtil", "lib/jquery-private"],
    function (t, e) {
      function r(t, e, r, n, i, o) {
        (this.text = t),
          (this.discountAmount = e),
          (this.discountCode = r),
          (this.cheapestProductName = n),
          (this.cartAmount = i),
          (this.priceFormatter = o);
      }
      var n = /{discount-amount}/g,
        i = /{cart-amount}/g,
        o = /{checkout-amount}/g,
        a = /{discount-code}/g,
        c = /{cheapest-product-name}/g;
      return (
        (r.prototype = {
          formattedText: function () {
            return (
              (this.textFormatted = this.text),
              this._replaceDiscountAmount(),
              this._replaceCartAmount(),
              this._replaceCheckoutAmount(),
              this._replaceDiscountCode(),
              this._replaceCheapestProductName(),
              this.textFormatted
            );
          },
          _replaceDiscountAmount: function () {
            this._containsDiscountAmountPattern() &&
              (this.textFormatted = this.textFormatted.replace(
                n,
                this._getDiscountAmountFormatted()
              ));
          },
          _replaceCartAmount: function () {
            this._containsCartAmountPattern() &&
              (this.textFormatted = this.textFormatted.replace(
                i,
                this._getCartAmountFormatted()
              ));
          },
          _replaceCheckoutAmount: function () {
            this._containsCheckoutAmountPattern() &&
              (this.textFormatted = this.textFormatted.replace(
                o,
                this._getCheckoutAmountFormatted()
              ));
          },
          _replaceDiscountCode: function () {
            this._containsDiscountCode() &&
              (this.textFormatted = this.textFormatted.replace(
                a,
                this.discountCode
              ));
          },
          _replaceCheapestProductName: function () {
            this._containsCheapestProductName() &&
              (this.textFormatted = this.textFormatted.replace(
                c,
                this.cheapestProductName
              ));
          },
          _containsDiscountAmountPattern: function () {
            return n.test(this.textFormatted);
          },
          _containsCartAmountPattern: function () {
            return i.test(this.textFormatted);
          },
          _containsCheckoutAmountPattern: function () {
            return o.test(this.textFormatted);
          },
          _containsDiscountCode: function () {
            return a.test(this.textFormatted);
          },
          _containsCheapestProductName: function () {
            return c.test(this.textFormatted);
          },
          _getDiscountAmountFormatted: function () {
            var t = this._formatPrice(this.discountAmount);
            return this._getHtmlElementContent(t);
          },
          _getCartAmountFormatted: function () {
            var t = this._formatPrice(this.cartAmount);
            return this._getHtmlElementContent(t);
          },
          _getCheckoutAmountFormatted: function () {
            var t = String(this.cartAmount - this.discountAmount),
              e = this._formatPrice(t);
            return this._getHtmlElementContent(e);
          },
          _formatPrice: function (e) {
            return t.isEmpty(e) ? "" : this.priceFormatter.formattedPrice(e);
          },
          _getHtmlElementContent: function (t) {
            return e("<p></p>").html(t).html();
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountAppliedMessageUI",
    [
      "core/util/JsonCss",
      "core/util/DeviceCssClassAdder",
      "core/frequently-bought/discount/DiscountAppliedMessageFormatter",
      "lib/jquery-private",
    ],
    function (t, e, r, n) {
      function i(t, e) {
        (this.discountAppliedMessagePreferences = t), (this.priceFormatter = e);
      }
      return (
        (i.prototype = {
          message: function (r, i, o, a, c) {
            var s = n("<div></div>");
            return (
              s.addClass("cbb-frequently-bought-discount-applied-message"),
              s.addClass("translatable"),
              e.addDeviceClasses(s),
              s.html(this._discountAppliedMessageFormatted(r, i, o, a, c)),
              t.apply(
                s,
                this.discountAppliedMessagePreferences.additionalStyles
              ),
              s
            );
          },
          _discountAppliedMessageFormatted: function (t, e, n, i, o) {
            return new r(t, e, n, i, o, this.priceFormatter).formattedText();
          },
          selector: function () {
            return ".cbb-frequently-bought-discount-applied-message";
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/DelayedExecutor",
    ["core/util/Logger", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        (r.runAfterPageLoading = function (t, e) {
          "complete" === document.readyState
            ? r._runDelayed(t, e)
            : r._runOnLoad(t, e);
        }),
        (r._runOnLoad = function (e, n) {
          try {
            r._runOnLoadSafely(e, n);
          } catch (e) {
            t.log("Caught error on DelayedExecutor.runAfterPageLoading: " + e);
          }
        }),
        (r._runOnLoadSafely = function (t, n) {
          e(window).load(function () {
            r._runDelayed(t, n);
          });
        }),
        (r._runDelayed = function (t, e) {
          e
            ? setTimeout(function () {
                t();
              }, e)
            : t();
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/MutationBasedDomObserver",
    ["core/util/DelayedExecutor", "core/util/DateUtil"],
    function (t, e) {
      function r(t, e) {
        (this.callback = t),
          (this.listenToAttributeChanges = e),
          (this.dynamicMinCallingPeriod = n),
          (this.lastCall = 0),
          this._armInterval();
      }
      var n = 150;
      return (
        (r.prototype = {
          updateParameters: function (t) {
            this.callbackParameterObject = t;
          },
          _armInterval: function () {
            var e = this;
            t.runAfterPageLoading(function () {
              e._addObserver();
            }),
              e._nodeChanged();
          },
          _addObserver: function () {
            var t = this,
              e = new MutationObserver(function () {
                t._nodeChanged();
              }),
              r = {
                attributes: this.listenToAttributeChanges,
                childList: !0,
                characterData: !0,
                subtree: !0,
              },
              n = document.body;
            e.observe(n, r);
          },
          _nodeChanged: function () {
            this._notCalledThisInterval() && this._invokeCallback();
          },
          _notCalledThisInterval: function () {
            var t = e.getTimestamp();
            return (
              t - this.lastCall > this.dynamicMinCallingPeriod &&
              ((this.lastCall = t), !0)
            );
          },
          _invokeCallback: function () {
            var t = e.getTimestamp();
            this.callback(this.callbackParameterObject);
            var r = e.getTimestamp(),
              n = r - t;
            this._updateMinCallingPeriod(n);
          },
          _updateMinCallingPeriod: function (t) {
            var e = 3 * t;
            this.dynamicMinCallingPeriod = Math.max(n, e);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ShopifyCart",
    [
      "core/util/AjaxGet",
      "core/util/AjaxPost",
      "core/util/UrlUtil",
      "core/util/DomainUtil",
      "core/util/CookieUtil",
      "core/util/Objects",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a) {
      function c() {}
      var s = n.baseUrl() + "/shopify/cart",
        u = n.baseUrl() + "/shopify/cartAdd",
        l = r.getInternationalContext() + "/caart.js",
        d = r.getInternationalContext() + "/cart/adad.js";
      return (
        (c.getCart = function (e) {
          var r = c._demoOrContextualizedUrl(s, l);
          t.jsonGetNoCache(
            r,
            null,
            function (t) {
              e(t);
            },
            function (t) {}
          );
        }),
        (c.getCartId = function () {
          return i.getCookie("cart");
        }),
        (c.getProductIdList = function (t) {
          return c.isNotEmpty(t) ? c._productIdList(t.items) : [];
        }),
        (c.getVariantIdList = function (t) {
          return c.isNotEmpty(t) ? c._variantIdList(t.items) : [];
        }),
        (c.findProduct = function (t, e, r) {
          for (var n = 0; n < t.items.length; n++) {
            var i = t.items[n];
            if (c._isValidProduct(i) && i.product_id === e && i.id === r)
              return i;
          }
          return null;
        }),
        (c.findLastAddedProduct = function (t, e) {
          var r = e.productId,
            n = e.variantId,
            i = c.findProduct(t, r, n);
          return i || t.items[0];
        }),
        (c.isEmpty = function (t) {
          return o.isNull(t) || 0 === t.item_count;
        }),
        (c.isNotEmpty = function (t) {
          return !c.isEmpty(t);
        }),
        (c._demoOrContextualizedUrl = function (t, e) {
          return r.isDemoPage() ? t : e;
        }),
        (c._productIdList = function (t) {
          for (var e = [], r = 0; r < t.length; r++) {
            var n = t[r];
            c._isValidProduct(n) && (e[r] = n.product_id);
          }
          return e;
        }),
        (c._variantIdList = function (t) {
          for (var e = [], r = 0; r < t.length; r++) {
            var n = t[r];
            c._isValidProduct(n) && (e[r] = n.variant_id);
          }
          return e;
        }),
        (c._isValidProduct = function (t) {
          return o.nonNull(t) && o.nonNull(t.product_id);
        }),
        (c.prototype = {
          addSingleVariant: function (t, e, r, n) {
            var i = [t];
            this.addVariants(i, e, r, n);
          },
          addVariants: function (t, r, n, i) {
            if (0 === t.length)
              return void i(
                "Please, select at least one product to be added to the shopping cart"
              );
            var o = c._demoOrContextualizedUrl(u, d),
              a = this._reverseVariants(t),
              s = this._variantsData(a, r),
              l = this,
              f = function (t) {
                l._handleSuccess(n, t);
              },
              h = function (t) {
                l._handleError(t.responseJSON, i);
              };
            e.jsonPost(o, s, f, h);
          },
          _reverseVariants: function (t) {
            if (t.length > 1) {
              return Array.from(t).reverse();
            }
            return t;
          },
          _variantsData: function (t, e) {
            var r = { items: [] };
            return (
              a.each(t, function () {
                var t = { id: this, quantity: 1 };
                e && (t.properties = e.toJson()), r.items.push(t);
              }),
              r
            );
          },
          _handleSuccess: function (t, e) {
            t && t(e);
          },
          _handleError: function (t, e) {
            e(
              t && t.status
                ? t.description
                : "An error happened while adding products to the shopping cart"
            );
          },
        }),
        c
      );
    }
  ),
  codeblackbelt.define("core/util/ArrayUtil", [], function () {
    function t() {}
    return (
      (t.isArray = function (t) {
        return t instanceof Array;
      }),
      (t.doesNotContainValue = function (e, r) {
        return !t.containsValue(e, r);
      }),
      (t.containsValue = function (t, e) {
        for (var r = 0; r < t.length; r++) if (t[r] === e) return !0;
        return !1;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountChecker",
    [
      "core/frequently-bought/discount/LocalStorageDiscountParameters",
      "core/util/ShopifyCart",
      "core/util/ArrayUtil",
    ],
    function (t, e, r) {
      function n(t) {
        this.okCallback = t;
      }
      return (
        (n.ifThereIsAValidDiscountApplied = function (t) {
          return new n(t);
        }),
        (n.prototype = {
          orElse: function (t) {
            (this.koCallback = t), this._checkDiscountAgainstCartContents();
          },
          _checkDiscountAgainstCartContents: function () {
            if (this._notDiscountRegistered()) this.koCallback();
            else {
              var r = this;
              e.getCart(function (e) {
                var n = t.get();
                r._areAllVariantsInCart(e, n.selectedVariantIds)
                  ? r.okCallback(e)
                  : r.koCallback();
              });
            }
          },
          _notDiscountRegistered: function () {
            return !t.exists();
          },
          _areAllVariantsInCart: function (t, n) {
            if (null == n) return !1;
            for (var i = e.getVariantIdList(t), o = 0; o < n.length; o++) {
              var a = Number(n[o]);
              if (r.doesNotContainValue(i, a)) return !1;
            }
            return !0;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/PageCssClassAdder",
    ["lib/jquery-private", "core/util/UrlUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.addPageClassToBody = function () {
          e.isCartPage()
            ? this.addClassToBody("cbb-cart-page")
            : e.isProductPage() && this.addClassToBody("cbb-product-page");
        }),
        (r.addClassToBody = function (e) {
          t("body").addClass(e);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountAppliedMessageUtil",
    [
      "core/util/StringUtil",
      "core/util/dom/DomPlacer",
      "core/util/ShopifyUtil",
      "core/util/PageCssClassAdder",
      "core/frequently-bought/discount/LocalStorageDiscountParameters",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o) {
      function a() {}
      var c = [
        ".cart__shipping em",
        ".cart__shipping",
        ".cart__taxes",
        ".cart__subtotal-shipping",
        ".cart__footer .txt--emphasis",
        ".cart__footer .text-small",
        ".cart__subtotal__note em",
        ".order_notes",
        ".cart-totals--wrapper",
        ".cart__policies",
        ".checkout-misc-container .layout-column-half-left",
        ".cart__footer__text em",
        "#basket-right > p:eq(0)",
        ".shipping-at-checkout > em:eq(0)",
        ".template-cart .cart__row--table-large > .grid__item > small",
        ".cartitems .cart-total .cart-shipping",
        "#basket-right > h4:eq(0)",
        ".cart__row > .text-right > p > em",
        ".under-cart > p.comment",
        "#shopify-section-cart-template .add-comments",
        "#cart_form .subtotal_amount",
        ".cart-subtotal__note",
        "#cart_form .cart_savings",
        ".ajaxcart > .ajaxcart__footer > .ajaxcart__note",
        ".ajaxcart > .drawer__footer > .ajaxcart__note",
        "#cart.mm-opened ul.mm-listview li:last",
        ".cart-item-price-text",
        ".ajaxifyCart--products",
        ".cart-preview .cart-preview-total",
        ".ajaxcart__footer > p.text-center",
        ".js-cart_content__form .js-cart_subtotal",
        'form[action$="/cart"]',
        'form[action*="/cart?"]',
      ];
      return (
        (a.hideAppliedDiscountMessage = function (t) {
          o(t.selector()).remove(), a._removeBodyClass();
        }),
        (a.showAppliedDiscountMessage = function (t, e) {
          var r = i.get();
          if (a._isDiscountAppliedMessageDisplayable(r)) {
            n.addPageClassToBody();
            var o = a._getDiscountAppliedMessageFormatted(t, r, e);
            a._appendMessage(t, o), a._addBodyClass();
          }
        }),
        (a._addBodyClass = function () {
          n.addClassToBody("cbb-fbt-discount-applied");
        }),
        (a._removeBodyClass = function () {
          o("body").removeClass("cbb-fbt-discount-applied");
        }),
        (a._isDiscountAppliedMessageDisplayable = function (e) {
          var r = e.discountAppliedMessage;
          return t.isNotEmpty(r);
        }),
        (a._getDiscountAppliedMessageFormatted = function (t, e, r) {
          var n = e.discountAppliedMessage,
            i = a._getSafeDiscountAmount(e.discountAmount),
            o = e.discountCode,
            c = e.cheapestProductName,
            s = a._getCartAmount(r);
          return t.message(n, i, o, c, s);
        }),
        (a._getSafeDiscountAmount = function (t) {
          return 0 === t ? "" : a._estimatedDiscountAmount(t);
        }),
        (a._estimatedDiscountAmount = function (t) {
          return (Number(t) * Number(r.getPresentmentCurrencyRate())).toFixed(
            2
          );
        }),
        (a._getCartAmount = function (t) {
          var e = t.total_price / 100;
          return String(e);
        }),
        (a._appendMessage = function (t, r) {
          var n =
              t.discountAppliedMessagePreferences.getDiscountAppliedMessageTargetPreferences(),
            i = new e(n);
          i.doesTargetExist()
            ? a._placeWithSelector(i, t, r)
            : a._appendToAllExistingElements(t, r);
        }),
        (a._placeWithSelector = function (t, e, r) {
          if (a._messageIsNotPresentYet(e)) {
            var n = r;
            t.placeElement(n);
          }
        }),
        (a._messageIsNotPresentYet = function (t) {
          var e = o(t.selector());
          return null === e || 0 === e.length;
        }),
        (a._appendToAllExistingElements = function (t, e) {
          o.each(c, function (r) {
            o(c[r]).each(function () {
              var r = o(this);
              a._doesNotContainMessage(r, t) && r.append(e);
            });
          });
        }),
        (a._doesNotContainMessage = function (t, e) {
          var r = t.find(e.selector());
          return null === r || 0 === r.length;
        }),
        (a.prototype = {}),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountStatusUpdater",
    [
      "core/frequently-bought/discount/DiscountChecker",
      "core/frequently-bought/discount/DiscountRemover",
      "core/frequently-bought/discount/DiscountAppliedMessageUtil",
    ],
    function (t, e, r) {
      function n(t) {
        this.discountAppliedMessageUI = t;
      }
      return (
        (n.prototype = {
          refreshStatus: function () {
            var n = this;
            t.ifThereIsAValidDiscountApplied(function (t) {
              r.showAppliedDiscountMessage(n.discountAppliedMessageUI, t);
            }).orElse(function () {
              e.removeDiscount(),
                r.hideAppliedDiscountMessage(n.discountAppliedMessageUI);
            });
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/AppliedDiscountObserver",
    [
      "core/util/MutationBasedDomObserver",
      "core/frequently-bought/discount/DiscountStatusUpdater",
    ],
    function (t, e) {
      function r(t) {
        this.discountStatusUpdater = new e(t);
      }
      return (
        (r.prototype = {
          startChecking: function () {
            this._updateNow();
            var t = this;
            setTimeout(function () {
              t._updateAfterDomChanges();
            }, 1e3);
          },
          _updateNow: function () {
            this.discountStatusUpdater.refreshStatus();
          },
          _updateAfterDomChanges: function () {
            var e = this;
            new t(function () {
              e.discountStatusUpdater.refreshStatus();
            }, !1);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountApplicabilityManager",
    [
      "core/frequently-bought/discount/LocalStorageDiscountParameters",
      "core/frequently-bought/discount/DiscountAppliedMessageUI",
      "core/frequently-bought/discount/AppliedDiscountObserver",
    ],
    function (t, e, r) {
      function n(t) {
        (this.preferences = t), (this.checkingStarted = !1);
      }
      return (
        (n.prototype = {
          startCheckingOnPageLoad: function () {
            this._isDiscountRegistered() && this._manageDiscountApplicability();
          },
          startCheckingAfterAddingToTheCart: function () {
            this._notCheckingStarted() &&
              this._isDiscountRegistered() &&
              this._remainInTheSamePageAfterAddingToTheCart() &&
              this._manageDiscountApplicability();
          },
          _isDiscountRegistered: function () {
            return t.exists();
          },
          _notCheckingStarted: function () {
            return !this.checkingStarted;
          },
          _remainInTheSamePageAfterAddingToTheCart: function () {
            return (
              this.preferences.dontRedirectPolicy ||
              this.preferences.themeDefaultPolicy
            );
          },
          _manageDiscountApplicability: function () {
            var t = new e(
              this.preferences.discountAppliedMessagePreferences,
              this.preferences.priceFormatter
            );
            new r(t).startChecking(), (this.checkingStarted = !0);
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define("core/frequently-bought/ProductView", [], function () {
    function t(t, e, r) {
      (this.product = t), (this.productUI = e), (this.selectorUI = r);
    }
    return (
      (t.prototype = {
        getId: function () {
          return this.product.getId();
        },
        getVariant: function () {
          return this.product.hasVariants()
            ? this.selectorUI.getSelectedVariant()
            : this.product.getSingleVariant();
        },
        getVariantId: function () {
          return this.getVariant().getId();
        },
        getNameFormatted: function () {
          return this.product.getNameFormatted();
        },
        isSelected: function () {
          return this.selectorUI.isSelected();
        },
        getProductUI: function () {
          return this.productUI;
        },
        getSelectorUI: function () {
          return this.selectorUI;
        },
      }),
      t
    );
  }),
  codeblackbelt.define("core/util/JQueryChecker", [], function () {
    function t() {}
    return (
      (t.existsJQuery = function () {
        var t = window.$ || window.jQuery;
        return (
          t &&
          "function" == typeof t &&
          "object" == typeof t() &&
          t().jquery &&
          "string" == typeof t().jquery
        );
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/variant/UrlVariantExtractor",
    ["core/util/UrlUtil", "core/util/Logger"],
    function (t, e) {
      function r() {}
      return (
        (r.extractVariantId = function () {
          var r = t.getParameterFromUrl("variant");
          return e.debug("Variant from URL: " + r), r;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/variant/EventVariantObserver",
    [
      "core/util/EventUtil",
      "core/util/JQueryChecker",
      "core/util/variant/UrlVariantExtractor",
      "core/util/Logger",
    ],
    function (t, e, r, n) {
      function i() {}
      var o =
          'select.single-option-selector, input.single-option-selector__radio, variant-selects, variant-radios, [data-product-option], .options-selection__input-select, .options-selection__option-value-input, select.original-selector, .option-selectors, .disclosure--input, .radios--input, .product__selectors input, .variant-wrapper--dropdown select, .js-swatches-wrapper input, [data-variant-input], .form__selectors input, .tt-swatches-container-js select, .selector-wrapper select, .product-option-select select, .materialize-select select, .swatch-element input, .wetheme-dropdown__select, [data-product-swatch-input], [data-name="product-option-radio"], [data-name="product-option-select"], .swatches__form--input, [data-pf-type="ProductVariantSwatches"], select.pf-variant-select, .pf-variant-radio input, .gf_variants, .globo-swatch-list input, #bcpo .selector-wrapper input',
        a =
          ".swatches-select > .nt-swatch, .gecko-swatch, .gt_swatches--select, .product-form__input label, .product-options__value, .product__swatches .swatches__holder > span, .tt-swatches-container-js a, [data-option-type], .gf_swatch, .swatch-selector, .so-variant-change";
      return (
        (i.observeVariant = function (t) {
          new i()._addVariantChangeListeners(t);
        }),
        (i.prototype = {
          _addVariantChangeListeners: function (t) {
            e.existsJQuery()
              ? this._addJQueryVariantChangeListeners(t)
              : this._addVanillaJsVariantChangeListeners(t);
          },
          _addJQueryVariantChangeListeners: function (e) {
            var r = this;
            t.addThemeJQueryEvent(
              window,
              "variantChange variantPriceChange variant_change variant:changed shopify-variants:switch-variant product-variant-switch",
              function () {
                r._callbackWithVariantFromUrl(e);
              }
            ),
              t.addThemeJQueryEvent(document, "variant:change", function () {
                r._callbackWithVariantFromUrl(e);
              }),
              t.addThemeJQueryEvent(o, "change", function () {
                r._callbackWithVariantFromUrl(e);
              }),
              t.addThemeJQueryEvent(a, "click", function () {
                r._callbackWithVariantFromUrl(e);
              }),
              n.debug("Added jQuery variant change events");
          },
          _addVanillaJsVariantChangeListeners: function (e) {
            var r = this;
            t.addEvent(window, "variant:changed", function () {
              r._callbackWithVariantFromUrl(e);
            }),
              t.addEvent(document, "variant:change", function () {
                r._callbackWithVariantFromUrl(e);
              });
            var i = document.querySelectorAll(o);
            t.addEventToAll(i, "change", function () {
              r._callbackWithVariantFromUrl(e);
            });
            var c = document.querySelectorAll(a);
            t.addEventToAll(c, "click", function () {
              r._callbackWithVariantFromUrl(e);
            }),
              n.debug("Added vanilla JS variant change events");
          },
          _callbackWithVariantFromUrl: function (t) {
            setTimeout(function () {
              t(r.extractVariantId());
            }, 250);
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/variant/ExpressVariantObserver",
    ["core/util/EventUtil", "core/util/Logger"],
    function (t, e) {
      function r() {}
      return (
        (r.observeVariant = function (t) {
          new r()._addExpressListener(t);
        }),
        (r.prototype = {
          _addExpressListener: function (r) {
            var n = this._expressVariantSelectors();
            t.addEventToAll(n, "change", function (t) {
              var n = t.dataset.variant.id;
              e.debug("Express main variant changed to " + n), r(n);
            });
          },
          _expressVariantSelectors: function () {
            return this._isExpressProductPage()
              ? this._expressProductPageVariantSelectors()
              : this._isExpressProductPopup()
              ? this._expressProductPopupVariantSelectors()
              : (e.debug("Variant selectors not found in Express"), null);
          },
          _isExpressProductPage: function () {
            var t = window.Shopify.theme.sections.getInstanceById("product");
            return (
              t &&
              t.product &&
              t.product.productForm &&
              t.product.productForm.productForm &&
              t.product.productForm.productForm.optionInputs
            );
          },
          _expressProductPageVariantSelectors: function () {
            return window.Shopify.theme.sections.getInstanceById("product")
              .product.productForm.productForm.optionInputs;
          },
          _isExpressProductPopup: function () {
            var t = document.querySelector(
              ".product-modal__content form.product-form"
            );
            return t && t.querySelectorAll(".form__input--select");
          },
          _expressProductPopupVariantSelectors: function () {
            return document
              .querySelector(".product-modal__content form.product-form")
              .querySelectorAll(".form__input--select");
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/variant/DebutifyVariantObserver",
    ["core/util/Logger", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        (r.observeVariant = function (r) {
          var n = e(
              ".js-single-option-selector, .single-option-selector__radio, .input-color_swatches"
            ),
            i = e("select.product-single__variants");
          n.change(function () {
            var e = i.val();
            t.debug("Debutify main variant changed to " + e), r(e);
          });
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/variant/TurboVariantObserver",
    [
      "core/util/variant/UrlVariantExtractor",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r) {
      function n() {}
      return (
        (n.observeVariant = function (t) {
          0 === r(".swatch-element").length
            ? n._observeVariantSingleSelector(t)
            : n._observeVariantSwatches(t);
        }),
        (n._observeVariantSingleSelector = function (t) {
          var n = r(".single-option-selector"),
            i = r(".shopify-product-form .multi_select");
          n.change(function () {
            var r = i.val();
            e.debug("Turbo main variant changed to " + r), t(r);
          });
        }),
        (n._observeVariantSwatches = function (e) {
          r(".swatch-element").click(function () {
            setTimeout(function () {
              e(t.extractVariantId());
            }, 250);
          });
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/variant/VariantObserver",
    [
      "core/util/ThemeUtil",
      "core/util/variant/EventVariantObserver",
      "core/util/variant/ExpressVariantObserver",
      "core/util/variant/DebutifyVariantObserver",
      "core/util/variant/TurboVariantObserver",
    ],
    function (t, e, r, n, i) {
      function o(t) {
        this.theme = t;
      }
      return (
        (o.onThemeVariantChange = function (t, e) {
          new o(t)._addVariantChangeListener(e);
        }),
        (o.prototype = {
          _addVariantChangeListener: function (o) {
            t.isDebutifyTheme(this.theme)
              ? n.observeVariant(o)
              : t.isTurboTheme(this.theme)
              ? i.observeVariant(o)
              : t.isExpressTheme(this.theme)
              ? r.observeVariant(o)
              : e.observeVariant(o);
          },
        }),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/variant/ThisItemVariantSelector",
    [
      "core/frequently-bought/SelectorUI",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r) {
      function n() {}
      return (
        (n.selectVariant = function (n) {
          var i = "." + t.THIS_ITEM_SELECT_CLASS,
            o = r(i);
          if (0 !== o.length) {
            var a = o.find("option:selected").data("variantId");
            "" !== n &&
              n != a &&
              1 === o.find("option[data-variant-id='" + n + "']").length &&
              (e.debug("Variant selected: " + n),
              o.val(o.find("option[data-variant-id='" + n + "']").val()),
              o.trigger("change"));
          }
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/variant/UrlVariantSelector",
    [
      "core/util/UrlUtil",
      "core/util/variant/UrlVariantExtractor",
      "core/frequently-bought/variant/ThisItemVariantSelector",
    ],
    function (t, e, r) {
      function n() {}
      return (
        (n.selectVariantFromUrl = function () {
          setTimeout(n._safeSelectVariantFromUrl, 250);
        }),
        (n._safeSelectVariantFromUrl = function () {
          var t = e.extractVariantId();
          r.selectVariant(t);
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/variant/VariantObserver",
    [
      "core/util/ThemeUtil",
      "core/util/variant/VariantObserver",
      "core/frequently-bought/variant/UrlVariantSelector",
      "core/frequently-bought/variant/ThisItemVariantSelector",
    ],
    function (t, e, r, n) {
      function i(t) {
        this.theme = t;
      }
      return (
        (i.updateVariantFromTheme = function (t) {
          r.selectVariantFromUrl(),
            e.onThemeVariantChange(t, function (t) {
              n.selectVariant(t);
            });
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ProductPromise",
    ["core/util/AjaxGet"],
    function (t) {
      function e(t) {
        (this.promise = null), (this.product = t), (this.productJson = null);
      }
      return (
        (e.prototype = {
          start: function () {
            var e = this;
            this.promise = new Promise(function (r, n) {
              t.jsonGet(
                e.product.getUrl(),
                {},
                function (t) {
                  (e.productJson = t), r(e);
                },
                function () {
                  n();
                }
              );
            });
          },
          getPromise: function () {
            return this.promise;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ProductPriceMerger",
    ["core/util/Logger"],
    function (t) {
      function e(t) {
        this.productJson = t;
      }
      return (
        (e.merge = function (t) {
          return new e(t);
        }),
        (e.prototype = {
          into: function (t) {
            (this.product = t), this._mergePrices();
          },
          _mergePrices: function () {
            var t = this.productJson.variants;
            this._mergeVariantsPrice(t);
          },
          _mergeVariantsPrice: function (t) {
            t.forEach(this._mergeVariantPrice, this);
          },
          _mergeVariantPrice: function (t) {
            var e = this._findVariant(t.id);
            e && (e.setPrice(t.price), e.setCompareAtPrice(t.compare_at_price));
          },
          _findVariant: function (t) {
            return this.product.getVariants().find(function (e) {
              return e.variantData.id == t;
            });
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define("core/util/dom/ScriptUtil", [], function () {
    function t() {}
    return (
      (t.addScript = function (t, e) {
        var r = document.createElement("script");
        (r.type = "text/javascript"),
          (r.src = t),
          (r.onload = function () {
            e && e();
          }),
          document.getElementsByTagName("head")[0].appendChild(r);
      }),
      (t.addScriptCode = function (t) {
        var e = document.createElement("script");
        (e.type = "text/javascript"),
          (e.innerHTML = t),
          document.getElementsByTagName("head")[0].appendChild(e);
      }),
      t
    );
  }),
  codeblackbelt.define("core/util/dom/StyleUtil", [], function () {
    function t() {}
    return (
      (t.addStyleSheet = function (t) {
        var e = document.createElement("link");
        (e.rel = "stylesheet"),
          (e.type = "text/css"),
          (e.href = t),
          document.getElementsByTagName("head")[0].appendChild(e);
      }),
      (t.addStyles = function (t) {
        var e = document.createElement("style");
        (e.type = "text/css"),
          (e.innerHTML = t),
          document.getElementsByTagName("head")[0].appendChild(e);
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/CustomScripts",
    [
      "core/util/StringUtil",
      "core/util/dom/ScriptUtil",
      "core/util/dom/StyleUtil",
    ],
    function (t, e, r) {
      function n() {}
      return (
        (n.addScripts = function (n, i) {
          t.isNotEmpty(n) && r.addStyles(n),
            t.isNotEmpty(i) && e.addScriptCode(i);
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/util/MarketManager",
    [
      "core/frequently-bought/events/Events",
      "core/frequently-bought/events/EventDataFactory",
      "core/frequently-bought/variant/VariantObserver",
      "core/util/ProductPromise",
      "core/util/ProductPriceMerger",
      "core/util/CustomScripts",
      "core/util/StatUtil",
      "core/util/Logger",
      "core/util/Objects",
      "core/third-party/CurrencyConverterFacade",
    ],
    function (t, e, r, n, i, o, a, c, s, u) {
      function l(t, e, r) {
        (this.products = t),
          (this.discountCalculator = e),
          (this.preferences = r),
          (this.market = r.market),
          (this.theme = r.theme),
          (this.customCss = r.customCss),
          (this.customJs = r.customJs),
          (this.numberOfBundleProducts = r.numberOfBundleProducts()),
          (this.productPromises = []),
          (this.promiseResult = null);
      }
      return (
        (l.prototype = {
          applyActiveMarket: function () {
            var t = [
              { "Active market country": this.market.country() },
              { "Active market currency": this.market.currency() },
              { "Active market currency rate": this.market.currencyRate() },
              { "Is default market?": this.market.isDefaultMarket() },
              { "Is twin market?": this.market.isTwinMarket() },
              { "Is secondary market?": this.market.isSecondaryMarket() },
            ];
            c.debugGroup("Market", t),
              this.market.isDefaultMarket()
                ? (c.debug(
                    "Default market, displaying prices in the shop currency"
                  ),
                  this._runOnDefaultMarket())
                : (c.debug(
                    "International prices enabled...displaying prices in the active market"
                  ),
                  this._runOnActiveMarket());
          },
          _runOnDefaultMarket: function () {
            this._selectDefaultVariant(),
              this._applyDiscount(),
              this._addCustomScripts(),
              this._triggerCompletionEvents();
          },
          _runOnActiveMarket: function () {
            this._buildProductPromises(),
              this._awaitProductPromisesToComplete(),
              this._checkProductPromises();
          },
          _selectDefaultVariant: function () {
            r.updateVariantFromTheme(this.theme),
              c.debug("Default variant selected");
          },
          _buildProductPromises: function () {
            this.products.forEach(this._buildProductPromise, this);
          },
          _awaitProductPromisesToComplete: function () {
            this.promiseResult = Promise.all(this._promises());
          },
          _checkProductPromises: function () {
            var t = this;
            this.promiseResult
              .then(function (e) {
                c.debug(
                  "Product data successfully retrieved...displaying the international prices"
                ),
                  t._processProductsWithInternationalPrice(e);
              })
              .catch(function () {
                c.debug(
                  "Failed to retrieve the product data...switching to the default market"
                ),
                  t._processProductsInDefaultMarket();
              })
              .finally(function () {
                t._addCustomScripts(), t._triggerCompletionEvents();
              });
          },
          _processProductsWithInternationalPrice: function (t) {
            this._updateProductsWithInternationalPrice(t),
              this._selectDefaultVariant(),
              this._applyDiscount();
          },
          _processProductsInDefaultMarket: function () {
            this._switchToDefaultMarket(),
              this._selectDefaultVariant(),
              this._applyDiscount();
          },
          _addCustomScripts: function () {
            o.addScripts(this.customCss, this.customJs),
              c.debug("Custom scripts successfully added");
          },
          _triggerCompletionEvents: function () {
            u.triggerConversion(),
              t.triggerRenderedEvent(
                e.buildRenderedEventData(this.preferences, this.products)
              ),
              a.rendered(
                "frequently-bought-together",
                this.numberOfBundleProducts
              ),
              c.debug("Application events successfully triggered");
          },
          _updateProductsWithInternationalPrice: function (t) {
            t.forEach(this._updateProductPrice, this);
          },
          _applyDiscount: function () {
            this.discountCalculator.recalculatePricesAndDiscountRequirements();
          },
          _updateProductPrice: function (t) {
            i.merge(t.productJson.product).into(t.product);
          },
          _switchToDefaultMarket: function () {
            this.market.switchToDefaultMarket();
            var t = [
              { "Active market country": this.market.country() },
              { "Active market currency": this.market.currency() },
              { "Active market currency rate": this.market.currencyRate() },
              { "Is default market?": this.market.isDefaultMarket() },
              { "Is twin market?": this.market.isTwinMarket() },
              { "Is secondary market?": this.market.isSecondaryMarket() },
            ];
            c.debugGroup("Switch to the default market", t);
          },
          _promises: function () {
            var t = [];
            return (
              this.productPromises.forEach(function (e) {
                e.start(), t.push(e.getPromise());
              }),
              t
            );
          },
          _buildProductPromise: function (t) {
            this.productPromises.push(new n(t));
          },
        }),
        l
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ThemeAjaxCart",
    ["core/util/Logger", "core/util/ShopifyCart"],
    function (t, e) {
      function r() {}
      return (
        (r.safeLoadAjaxCart = function (t, e) {
          try {
            this.loadAjaxCart(t, e);
          } catch (t) {
            this._processError(t, e);
          }
        }),
        (r.loadAjaxCart = function (t, e) {}),
        (r.updateCartInfo = function () {}),
        (r.isAjaxCart = function () {
          return !1;
        }),
        (r.isCartPage = function () {
          return !1;
        }),
        (r.isCheckoutPage = function () {
          return !1;
        }),
        (r.isRefresh = function () {
          return !1;
        }),
        (r._getCart = function (t, r) {
          var n = this;
          e.getCart(function (e) {
            try {
              t(e);
            } catch (t) {
              n._processError(t, r);
            }
          });
        }),
        (r._processError = function (e, r) {
          t.log(
            "Failed to display the " +
              this.name +
              " (Error: " +
              e.message +
              ")."
          ),
            r && r();
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/BrooklynAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, e) {
          window.ajaxCart && (window.ajaxCart.load(), e());
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            e._updateCartBubble(t);
          });
        }),
        (e.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "drawer" === window.theme.settings.cartType
          );
        }),
        (e.isCartPage = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "page" === window.theme.settings.cartType
          );
        }),
        (e._updateCartBubble = function (t) {
          var e = window.theme.cache.$cartBuggle,
            r = t.item_count;
          0 == r
            ? e.removeClass("cart-link__bubble--visible")
            : e.addClass("cart-link__bubble--visible");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/BoundlessAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, e) {
          window.ajaxCart && (window.ajaxCart.load(), e());
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            e._updateCartBubble(t);
          });
        }),
        (e.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "drawer" === window.theme.settings.cartType
          );
        }),
        (e.isCartPage = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "page" === window.theme.settings.cartType
          );
        }),
        (e._updateCartBubble = function (t) {
          var e = window.theme.cache.$siteHeaderCart,
            r = t.item_count;
          0 == r
            ? e.removeClass("cart-bubble--visible")
            : e.addClass("cart-bubble--visible");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/EnvyAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._isNewVersionDrawerCart()
            ? e._loadNewDrawerCart(r)
            : e._isOldVersionDrawerCart() && e._loadOldDrawerCart(r);
        }),
        (e.isAjaxCart = function () {
          return e._isNewVersionDrawerCart() || e._isOldVersionDrawerCart();
        }),
        (e._isNewVersionDrawerCart = function () {
          return (
            "object" == typeof window.wetheme &&
            "object" == typeof window.wetheme.cartDrawer &&
            "function" == typeof window.wetheme.updateCartDrawer
          );
        }),
        (e._isOldVersionDrawerCart = function () {
          return (
            "function" == typeof window.Product &&
            null !== document.querySelector("#product-box")
          );
        }),
        (e._loadNewDrawerCart = function (t) {
          e._getCart(function (e) {
            window.wetheme.updateCartDrawer(e),
              window.wetheme.cartDrawer.element.dispatchEvent(
                new CustomEvent("cart:open")
              ),
              t();
          }, t);
        }),
        (e._loadOldDrawerCart = function (t) {
          new window.Product(
            document.querySelector("#product-box")
          ).update_cart(),
            t();
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/FastlaneAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "core/util/ShopifyCart"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._updateDrawer(t, e);
        }),
        (r.isAjaxCart = function () {
          var t = r._isNoRedirect(),
            e =
              window.headerCartBuildProduct &&
              "function" == typeof window.headerCartBuildProduct;
          return t && e;
        }),
        (r.isCartPage = function () {
          return (
            window.product_cart_redirect &&
            "cart" === window.product_cart_redirect
          );
        }),
        (r._isNoRedirect = function () {
          return (
            !window.product_cart_redirect ||
            "same" === window.product_cart_redirect
          );
        }),
        (r._updateDrawer = function (t, e) {
          r._getCart(function (n) {
            t.productIdList
              ? r._updateDrawerAddedProducts(n, t)
              : r._updateDrawerAddedProduct(n, t.productId, t.variantId),
              e();
          }, e);
        }),
        (r._updateDrawerAddedProducts = function (t, e) {
          for (var n = 0; n < e.productIdList.length; n++) {
            var i = e.productIdList[n],
              o = e.variantIdList[n];
            r._updateDrawerAddedProduct(t, i, o);
          }
        }),
        (r._updateDrawerAddedProduct = function (t, r, n) {
          var i = e.findProduct(t, r, n),
            o =
              null !==
              document.querySelector('[data-header-cart-item="' + i.id + '"]');
          window.headerCartBuildProduct(t, o, i, i.quantity);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/VentureAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      Object.assign(e, t);
      return (
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e.updateCartInfo(), e._showNotification(), r();
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            e._updateCartBubble(t);
          });
        }),
        (e.isAjaxCart = function () {
          var t = document.querySelector("#ProductSection-product-template");
          return t && "true" === t.getAttribute("data-ajax");
        }),
        (e.isCartPage = function () {
          return !e.isAjaxCart();
        }),
        (e._showNotification = function () {
          window.theme &&
            window.theme.Notify &&
            window.theme.Notify.open("success", !1, !0);
        }),
        (e._updateCartBubble = function (t) {
          var e = document.querySelectorAll(".site-header__cart-indicator"),
            r = t.item_count;
          0 === r
            ? e.forEach(function (t) {
                t.classList.add("hide");
              })
            : e.forEach(function (t) {
                t.classList.remove("hide");
              });
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/SimpleAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r.updateCartInfo();
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartCount(t);
          });
        }),
        (r.isAjaxCart = function () {
          var t = e("#ProductSection");
          return !!t.length && t.data("cart-enable-ajax");
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._updateCartCount = function (t) {
          var r = e("#CartCount"),
            n = t.item_count;
          r.html(n);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/NarrativeAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r.updateCartInfo(), r._openDrawerCart(e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartBubble(t);
          });
        }),
        (r.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.sections &&
            window.theme.sections.isInstance("cart-drawer")
          );
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._openDrawerCart = function (t) {
          if (
            window.theme &&
            window.theme.sections &&
            window.theme.sections.instances
          ) {
            var e = window.theme.sections.instances[0];
            e.refresh(),
              e.drawerOpen(),
              e.$ajaxCart.removeClass("cart-drawer--empty"),
              t();
          }
        }),
        (r._updateCartBubble = function (t) {
          var r = e(".site-header__cart-bubble"),
            n = t.item_count,
            i = "site-header__cart-bubble--visible";
          0 == n ? r.removeClass(i) : r.addClass(i);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/SupplyAjaxCart",
    [
      "core/util/ajax-carts/ThemeAjaxCart",
      "core/util/StringUtil",
      "lib/jquery-private",
    ],
    function (t, e, r) {
      function n() {}
      return (
        Object.assign(n, t),
        (n.prototype.constructor = function () {
          t.call(this);
        }),
        (n.loadAjaxCart = function (t, e) {
          n._loadCart(e);
        }),
        (n.updateCartInfo = function () {
          n._getCart(function (t) {
            n._updateCartCount(t);
          });
        }),
        (n.isAjaxCart = function () {
          return (
            window.theme.settings &&
            window.theme.settings.cartType &&
            ("drawer" === window.theme.settings.cartType ||
              "modal" === window.theme.settings.cartType)
          );
        }),
        (n.isCartPage = function () {
          return (
            window.theme.settings &&
            window.theme.settings.cartType &&
            "page" === window.theme.settings.cartType
          );
        }),
        (n._loadCart = function (t) {
          n._getCart(function (e) {
            n._cartUpdateCallback(e), t();
          }, t);
        }),
        (n._updateCartCount = function (t) {
          var e = r(".cart-count"),
            n = t.item_count;
          0 === n
            ? e.addClass("hidden-count")
            : e.html(n).removeClass("hidden-count");
        }),
        (n._cartUpdateCallback = function (t) {
          switch ((n._updateCountPrice(t), window.theme.settings.cartType)) {
            case "modal":
              n._buildCart(t);
              break;
            case "drawer":
              n._buildCart(t);
              r("#ajaxifyDrawer").hasClass("is-visible")
                ? n._scrollTop()
                : n._showDrawer();
          }
        }),
        (n._updateCountPrice = function (t) {
          var e = r(".cart-count"),
            n = r("#cartCost");
          e.length &&
            (e.html(t.item_count).removeClass("hidden-count"),
            0 === t.item_count && e.addClass("hidden-count")),
            n.length &&
              n.html(
                window.Shopify.formatMoney(t.total_price, settings.moneyFormat)
              );
        }),
        (n._buildCart = function (t) {
          var e = r("#ajaxifyCart");
          if (0 !== t.item_count) n._cartTemplate(t);
          else
            switch (
              (e.empty(),
              e.append(
                '<h2>Your cart is currently empty.</h2><span class="cart--continue-message">Continue browsing <a href="/collections/all">here</a>.</span><span class="cart--cookie-message">Enable cookies to use the shopping cart</span>'
              ),
              window.theme.settings.cartType)
            ) {
              case "modal":
                n._sizeModal("resize");
            }
        }),
        (n._cartTemplate = function (t) {
          r("#ajaxifyCart").load('/cart form[action="/cart"]', function () {
            switch ((n._adjustCart(), window.theme.settings.cartType)) {
              case "modal":
                n._loadCartImages();
                break;
              case "drawer":
                t.item_count > 0 ? n._loadCartImages() : n._sizeDrawer(!0);
            }
          });
        }),
        (n._adjustCart = function () {
          n._createQuantitySelectors();
          var t = r(".ajaxifyCart--qty span");
          t.off("click"),
            t.on("click", function (t) {
              var e = r(t.currentTarget),
                i = e.siblings(".ajaxifyCart--num");
              (this.line = e.data("line")),
                (this.qty = n._validateQuantity(
                  i.val() ? parseInt(i.val().replace(/\D/g, "")) : 0
                )),
                e.hasClass("ajaxifyCart--add")
                  ? (this.qty = this.qty + 1)
                  : ((this.qty = this.qty - 1),
                    this.qty <= 0 && (this.qty = 0)),
                this.line
                  ? n._updateQuantity(this.line, this.qty)
                  : i.val(this.qty);
            });
          var e = r(".ajaxifyCart--num");
          e.off("change"),
            e.on("change", function (t) {
              var e = r(t.currentTarget);
              (this.line = e.data("line")),
                (this.qty = n._validateQuantity(
                  parseInt(e.val().replace(/\D/g, ""))
                )),
                this.line && n._updateQuantity(this.line, this.qty);
            }),
            r('form[action^="/cart"]').on("submit", function (t) {
              "input" === document.activeElement.nodeName.toLowerCase() &&
                t.preventDefault();
            }),
            e.off("focus"),
            e.on("focus", function () {
              var t = r(this);
              setTimeout(function () {
                t.select();
              }, 50);
            }),
            r(".ajaxifyCart--remove").on("click", function (t) {
              var e = r(t.currentTarget);
              (this.line = e.data("line") || null),
                (this.qty = 0),
                this.line &&
                  (t.preventDefault(), n._updateQuantity(this.line, this.qty));
            });
          var i = r('textarea[name="note"]');
          i.off("change"),
            i.on("change", function () {
              var t = r(this).val();
              window.Shopify.updateCartNote(t, function (t) {});
            }),
            window.Shopify &&
              window.Shopify.StorefrontExpressButtons &&
              window.Shopify.StorefrontExpressButtons.initialize();
        }),
        (n._updateQuantity = function (t, e) {
          var i = r('.cart__row[data-line="' + t + '"]').addClass(
            "ajaxifyCart--is-loading"
          );
          0 === e && i.addClass("is-removed"), n._debouncedChangedItem(t, e);
        }),
        (n._createQuantitySelectors = function () {
          var t = r("#ajaxifyCart");
          r('input[type="number"]', t).length &&
            r('input[type="number"]', t).each(function () {
              var t = r(this),
                e = parseInt(t.val()),
                n = e + 1,
                i = e - 1,
                o = e,
                a = r("#ajaxifyQty").html(),
                c = Handlebars.compile(a),
                s = {
                  key: t.data("id"),
                  line: t.data("line"),
                  itemQty: o,
                  itemAdd: n,
                  itemMinus: i,
                };
              t.after(c(s)).remove();
            }),
            r('a[href^="/cart/change"]', t).length &&
              r('a[href^="/cart/change"]', t).each(function () {
                r(this).addClass("ajaxifyCart--remove");
              });
        }),
        (n._validateQuantity = function (t) {
          return (parseFloat(t) != parseInt(t) || isNaN(t)) && (t = 1), t;
        }),
        (n._loadCartImages = function () {
          var t = r("#ajaxifyCart"),
            e = r("img", t),
            i = e.length,
            o = 0;
          e.on("load", function () {
            if (++o == i)
              switch (window.theme.settings.cartType) {
                case "modal":
                  n._sizeModal();
              }
          });
        }),
        (n._sizeModal = function (t) {
          var e = r("#ajaxifyModal");
          t || e.css("opacity", 0),
            e.css({ "margin-left": -e.outerWidth() / 2, opacity: 1 });
          var i = r(".ajaxifyCart--close"),
            o = r("#ajaxifyCart");
          i.css({ top: 10 + o.find("h1").height() / 2 }),
            e.addClass("is-visible"),
            n._scrollTop();
        }),
        (n._scrollTop = function () {
          (r("body").scrollTop() > 0 || r("html").scrollTop() > 0) &&
            r("html, body").animate({ scrollTop: 0 }, 250, "swing");
        }),
        (n._showDrawer = function () {
          var t = r("#ajaxifyDrawer");
          n._sizeDrawer(), t.addClass("is-visible"), n._scrollTop();
        }),
        (n._hideDrawer = function () {
          r("#ajaxifyDrawer").removeAttr("style").removeClass("is-visible"),
            n._scrollTop();
        }),
        (n._debouncedChangedItem = function (t, e) {
          window.Shopify.changeItem(t, e, n._adjustCartCallback);
        }),
        (n._adjustCartCallback = function (t) {
          n._updateCountPrice(t),
            0 === t.item_count &&
              "drawer" === window.theme.settings.cartType &&
              n._hideDrawer(),
            setTimeout(function () {
              n._getCart(function (t) {
                n._buildCart(t);
              });
            }, 150);
        }),
        (n._sizeDrawer = function (t) {
          var e = r("#ajaxifyDrawer");
          if (t) e.css("height", "0px");
          else {
            var n = r("#ajaxifyCart"),
              i = n.outerHeight();
            r(".cart-row img").css("width", "auto"), e.css("height", i + "px");
          }
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/PopAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadCart(e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartCount(t);
          });
        }),
        (r.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.cartType &&
            "drawer" === window.theme.cartType
          );
        }),
        (r.isCartPage = function () {
          return (
            window.theme &&
            window.theme.cartType &&
            "page" === window.theme.cartType
          );
        }),
        (r._loadCart = function (t) {
          r._getCart(function (e) {
            r._cartUpdateCallback(e), t();
          }, t);
        }),
        (r._updateCartCount = function (t) {
          var r = e("#cartCount"),
            n = t.item_count;
          0 === n
            ? r.addClass("hidden-count")
            : r.html("(" + n + ")").removeClass("hidden-count");
        }),
        (r._cartUpdateCallback = function (t) {
          switch ((r._updateCountPrice(t), window.theme.cartType)) {
            case "modal":
              r._buildCart(t);
              break;
            case "drawer":
              r._buildCart(t), r._showDrawer();
          }
        }),
        (r._updateCountPrice = function (t) {
          var r = e("#cartCount"),
            n = e("#cartCost");
          r.length &&
            (r.html("(" + t.item_count + ")").removeClass("hidden-count"),
            0 === t.item_count && r.addClass("hidden-count")),
            n.length &&
              n.html(
                window.Shopify.formatMoney(
                  t.total_price,
                  window.theme.moneyFormat
                )
              );
        }),
        (r._buildCart = function (t) {
          var n = e("#ajaxifyCart");
          if (0 !== t.item_count) r._cartTemplate(t);
          else
            switch (
              (n.empty(),
              n
                .append('<h2 class="text-center">Your Cart</h2>')
                .append(
                  '<p class="cart--empty-message text-center">Your cart is currently empty.</p>'
                )
                .append(
                  '<div class="cart--cookie-message text-center"><p>Enable cookies to use the shopping cart</p></div>'
                ),
              window.theme.cartType)
            ) {
              case "modal":
                r._sizeModal("resize");
            }
        }),
        (r._cartTemplate = function (t) {
          e("#ajaxifyCart").load('/cart form[action="/cart"]', function () {
            switch ((r._adjustCart(), window.theme.cartType)) {
              case "modal":
                r._loadCartImages();
                break;
              case "drawer":
                t.item_count > 0 && r._loadCartImages();
            }
          });
        }),
        (r._adjustCart = function () {
          function t(t, n) {
            var i = e('.cart__row[data-line="' + t + '"]').addClass(
              "ajaxifyCart--is-loading"
            );
            0 === n && i.addClass("is-removed"), r._debouncedChangedItem(t, n);
          }
          r._createQuantitySelectors();
          var n = e(".ajaxifyCart--qty span");
          n.off("click"),
            n.on("click", function (t) {
              var n = e(t.currentTarget),
                i = n.siblings(".ajaxifyCart--num");
              (this.line = n.data("line")),
                (this.qty = r._validateQuantity(
                  i.val() ? parseInt(i.val().replace(/\D/g, "")) : 0
                )),
                n.hasClass("ajaxifyCart--add")
                  ? (this.qty = this.qty + 1)
                  : ((this.qty = this.qty - 1),
                    this.qty <= 0 && (this.qty = 0)),
                this.line
                  ? r._updateQuantity(this.line, this.qty)
                  : i.val(this.qty);
            });
          var i = e(".ajaxifyCart--num");
          i.off("change"),
            i.on("change", function (t) {
              var n = e(t.currentTarget);
              (this.line = n.data("line")),
                (this.qty = validateQuantity(
                  parseInt(n.val().replace(/\D/g, ""))
                )),
                this.line && r._updateQuantity(this.line, this.qty);
            }),
            e('form[action^="/cart"]').on("submit", function (t) {
              "input" === document.activeElement.nodeName.toLowerCase() &&
                t.preventDefault();
            }),
            i.off("focus"),
            i.on("focus", function () {
              var t = e(this);
              setTimeout(function () {
                t.select();
              }, 50);
            }),
            e(".ajaxifyCart--remove").on("click", function (r) {
              var n = e(r.currentTarget);
              (this.line = n.data("line") || null),
                (this.qty = 0),
                this.line && (r.preventDefault(), t(this.line, this.qty));
            });
          var o = e('textarea[name="note"]');
          o.off("change"),
            o.on("change", function () {
              var t = e(this).val();
              window.Shopify.updateCartNote(t, function (t) {});
            }),
            window.Shopify &&
              window.Shopify.StorefrontExpressButtons &&
              window.Shopify.StorefrontExpressButtons.initialize();
        }),
        (r._createQuantitySelectors = function () {
          var t = e("#ajaxifyCart");
          e('input[type="number"]', t).length &&
            e('input[type="number"]', t).each(function () {
              var t = e(this),
                r = parseInt(t.val()),
                n = r + 1,
                i = r - 1,
                o = r,
                a = e("#ajaxifyQty").html(),
                c = Handlebars.compile(a),
                s = {
                  key: t.data("id"),
                  line: t.data("line"),
                  itemQty: o,
                  itemAdd: n,
                  itemMinus: i,
                };
              t.after(c(s)).remove();
            }),
            e('a[href^="/cart/change"]', t).length &&
              e('a[href^="/cart/change"]', t).each(function () {
                e(this).addClass("ajaxifyCart--remove");
              });
        }),
        (r._validateQuantity = function (t) {
          return (parseFloat(t) != parseInt(t) || isNaN(t)) && (t = 1), t;
        }),
        (r._loadCartImages = function () {
          var t = e("#ajaxifyCart"),
            n = e("img", t),
            i = n.length,
            o = 0;
          n.on("load", function () {
            if (++o == i)
              switch (window.theme.cartType) {
                case "modal":
                  r._sizeModal();
              }
          });
        }),
        (r._sizeModal = function (t) {
          var n = e("#ajaxifyModal");
          t || n.css("opacity", 0),
            n.css({ "margin-left": -n.outerWidth() / 2, opacity: 1 });
          var i = e(".ajaxifyCart--close"),
            o = e("#ajaxifyCart");
          i.css({ top: 10 + o.find("h1").height() / 2 }),
            n.addClass("is-visible"),
            r._scrollTop();
        }),
        (r._scrollTop = function () {
          (e("body").scrollTop() > 0 || e("html").scrollTop() > 0) &&
            e("html, body").animate({ scrollTop: 0 }, 250, "swing");
        }),
        (r._showDrawer = function () {
          e("#ajaxifyDrawer").addClass("is-visible"),
            e("body").addClass("page-move--cart"),
            setTimeout(function () {
              e("html").addClass("page-move--toggled"),
                e("body").addClass("mobile-drawer--open");
            }, 600),
            e(".page-element").on("click.mobileDrawerOpen", function () {
              e("body").hasClass("mobile-drawer--open") && r._hideDrawer();
            });
        }),
        (r._hideDrawer = function () {
          e("#ajaxifyDrawer").removeClass("is-visible"),
            e("html").removeClass("page-move--toggled"),
            e("body").removeClass("mobile-drawer--open page-move--cart"),
            e(".page-element").off("click.mobileDrawerOpen");
        }),
        (r._debouncedChangedItem = function (t, e) {
          window.Shopify.changeItem(t, e, r._adjustCartCallback);
        }),
        (r._adjustCartCallback = function (t) {
          r._updateCountPrice(t),
            0 === t.item_count &&
              "drawer" === window.theme.cartType &&
              r._hideDrawer(),
            setTimeout(function () {
              r._getCart(function (t) {
                r._buildCart(t);
              });
            }, 150);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/PrestigeAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._triggerProductAddedEvent(t, r);
        }),
        (e.isAjaxCart = function () {
          var t = e._sidebarCartSettings();
          return !!t && "drawer" === t.type;
        }),
        (e.isCartPage = function () {
          return !e.isAjaxCart();
        }),
        (e._sidebarCartSettings = function () {
          var t = document.getElementById("sidebar-cart");
          return t && t.dataset && t.dataset.sectionSettings
            ? JSON.parse(t.dataset.sectionSettings)
            : null;
        }),
        (e._triggerProductAddedEvent = function (t, e) {
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: !0,
              detail: { variant: t.variantId, quantity: t.quantity },
            })
          ),
            e();
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/BoosterAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartSummary(t), r._triggerCurrencyConversion();
          });
        }),
        (r.isCartPage = function () {
          if (void 0 != window.buyitnowaction)
            return !0 === window.buyitnowaction;
          var t = e('form input[name="return_to"]');
          return t.length > 0 && -1 !== t[0].value.indexOf("cart");
        }),
        (r.isCheckoutPage = function () {
          return !r.isCartPage();
        }),
        (r._updateCartSummary = function (t) {
          r._updateCartCount(t.item_count), r._updateCartTotal(t.total_price);
        }),
        (r._updateCartCount = function (t) {
          e("#CartCount").html(t);
        }),
        (r._updateCartTotal = function (t) {
          var r = e("#CartCost"),
            n = window.theme.Currency.formatMoney(t, window.theme.moneyFormat);
          r.html(n);
        }),
        (r._triggerCurrencyConversion = function () {
          "function" == typeof convertCurrencies && convertCurrencies();
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ShoptimizedAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadCart(e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartCount(t);
          });
        }),
        (r.isCartPage = function () {
          return e("#CartDrawer").length >= 1;
        }),
        (r._loadCart = function (t) {
          r._drawerCartExists() &&
            (r._openDrawerCart(),
            r._getCart(function (e) {
              window.timber.cartUpdatePopup(e), t();
            }, t));
        }),
        (r._drawerCartExists = function () {
          return (
            window.timber &&
            window.timber.RightDrawer &&
            window.timber.RightDrawer.config
          );
        }),
        (r._openDrawerCart = function () {
          window.timber.RightDrawer.config.onDrawerOpen();
        }),
        (r._updateCartCount = function (t) {
          var r = e(".CartCount"),
            n = t.item_count;
          r.html(n);
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/EmpireAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r.updateCartInfo(), e();
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartInfo(t);
          });
        }),
        (r.isAjaxCart = function () {
          return !r.isCartPage();
        }),
        (r.isCartPage = function () {
          var t = e('[data-section-type="static-product"]').text();
          if (t) {
            var r = JSON.parse(t);
            return r.settings && r.settings.cart_redirection;
          }
          return !1;
        }),
        (r._updateCartInfo = function (t) {
          var e = t.item_count;
          0 === e ? r._hideCartCount() : r._updateCartCount(e);
        }),
        (r._hideCartCount = function () {
          e(".site-header-cart--count").removeClass("visible");
        }),
        (r._updateCartCount = function (t) {
          e(".site-header-cart--count")
            .attr("data-header-cart-count", t)
            .addClass("visible");
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/DistrictAjaxCart",
    [
      "core/util/ajax-carts/ThemeAjaxCart",
      "core/util/ShopifyCart",
      "lib/jquery-private",
      "core/util/AjaxGet",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        Object.assign(i, t),
        (i.prototype.constructor = function () {
          t.call(this);
        }),
        (i.loadAjaxCart = function (t, e) {
          i._displayNotification(t, e);
        }),
        (i.isAjaxCart = function () {
          return i._ajaxCartEnabled();
        }),
        (i.isCartPage = function () {
          return !i.isAjaxCart();
        }),
        (i._ajaxCartEnabled = function () {
          return i._OS20AjaxEnabled() || i._oldAjaxEnabled();
        }),
        (i._OS20AjaxEnabled = function () {
          return null !== i._getCartNotification();
        }),
        (i._getCartNotification = function () {
          return document.querySelector("cart-notification");
        }),
        (i._oldAjaxEnabled = function () {
          return window.StyleHatch && window.StyleHatch.ajaxCartEnable;
        }),
        (i._displayNotification = function (t, e) {
          i._oldAjaxEnabled()
            ? i._displayOldNotification(t, e)
            : i._OS20AjaxEnabled() && i._loadCartSections(t, e);
        }),
        (i._loadCartSections = function (t, e) {
          var r = i._getSectionsParams(t);
          n.jsonGetNoCache(
            "/",
            r,
            function (r) {
              1 === t.quantity
                ? i._loadNotification(t, r, e)
                : t.quantity > 1 && (i._updateHeaderIcon(r), e());
            },
            function (t) {}
          );
        }),
        (i._getSectionsParams = function (t) {
          var e = "sections=" + HEADER_ICON_SECTION;
          return (
            1 === t.quantity &&
              (e += ",cart-notification-product,cart-notification-links"),
            e
          );
        }),
        (i._loadNotification = function (t, r, n) {
          i._getCart(function (o) {
            var a = t.variantId,
              c = e.findLastAddedProduct(o, t);
            i
              ._getCartNotification()
              .renderContents({ id: a, key: c.key, sections: r }),
              n();
          }, n);
        }),
        (i._updateHeaderIcon = function (t) {
          document.getElementById(HEADER_ICON_SECTION).innerHTML =
            t[HEADER_ICON_SECTION];
        }),
        (i._displayOldNotification = function (t, e) {
          i._getCart(function (r) {
            i._updateOldCartSummary(r),
              i._loadOldCartPreview(r, t),
              i._triggerOldCurrencyConversion(),
              e();
          }, e);
        }),
        (i._updateOldCartSummary = function (t) {
          i._updateOldCartTotal(t.total_price),
            i._updateOldCartCount(t.item_count);
        }),
        (i._loadOldCartPreview = function (t, e) {
          i._oldCartPreviewEnabled() &&
            1 === e.quantity &&
            i._renderOldCartPreview(t, e);
        }),
        (i._triggerOldCurrencyConversion = function () {
          if (i._oldThemeCurrencyConverterAvailable()) {
            var t = window.StyleHatch.shopCurrency,
              e = r("[name=currencies]");
            window.Currency.convertAll(t, e.val());
          }
        }),
        (i._updateOldCartTotal = function (t) {
          var e = window.StyleHatch.currencyFormat,
            n = window.theme.Currency.formatMoney(t, e),
            i = r("#CartCost");
          i.empty(), i.html('<span class="money">' + n + "</span>");
        }),
        (i._updateOldCartCount = function (t) {
          r("#CartCount").html(t);
        }),
        (i._renderOldCartPreview = function (t, r) {
          var n = e.findLastAddedProduct(t, r),
            i = JSON.stringify(n);
          window.StyleHatch.AjaxCart.showCartPreview(i, t);
        }),
        (i._oldCartPreviewEnabled = function () {
          return (
            "function" == typeof window.StyleHatch.AjaxCart.showCartPreview &&
            i._oldCartPreviewProperFunction()
          );
        }),
        (i._oldCartPreviewProperFunction = function () {
          return 2 === window.StyleHatch.AjaxCart.showCartPreview.length;
        }),
        (i._oldThemeCurrencyConverterAvailable = function () {
          return (
            window.StyleHatch &&
            window.StyleHatch.currencyConverter &&
            window.Currency
          );
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/The4AjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._refreshAjaxCart(r);
        }),
        (e.isAjaxCart = function () {
          return (
            window.geckoShopify &&
            "object" == typeof window.geckoShopify &&
            window.geckoShopify.onCartUpdate &&
            "function" == typeof window.geckoShopify.onCartUpdate
          );
        }),
        (e._refreshAjaxCart = function (t) {
          window.geckoShopify.onCartUpdate(1, 1), t();
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ArchetypeAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._loadCart(r), e.updateCartInfo();
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            e._manualUpdateCartBubble(t),
              document.dispatchEvent(
                new CustomEvent("updateCart.ajaxcart", {
                  detail: { items: t.items },
                })
              );
          });
        }),
        (e.isAjaxCart = function () {
          return e._isDrawerCart() || e._isStickyCart() || e._isDropdownCart();
        }),
        (e.isCartPage = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "page" === window.theme.settings.cartType
          );
        }),
        (e._isDrawerCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "drawer" === window.theme.settings.cartType
          );
        }),
        (e._isStickyCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "sticky" === window.theme.settings.cartType
          );
        }),
        (e._isDropdownCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "dropdown" === window.theme.settings.cartType
          );
        }),
        (e._loadCart = function (t) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: { addToCartBtn: null },
            })
          ),
            window.$ &&
              (window.$(document.body).trigger("added.ajaxProduct"),
              e._getCart(function (t) {
                window.$(document.body).trigger("updateCart", t);
              })),
            t();
        }),
        (e._manualUpdateCartBubble = function (t) {
          var e = document.querySelector(".cart-link__bubble"),
            r = t.item_count;
          0 == r
            ? e.classList.remove("cart-link__bubble--visible")
            : e.classList.add("cart-link__bubble--visible");
          var n = document.querySelector(".cart-link__count");
          n && (n.textContent = r);
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ShowTimeAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadCart(e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateCartCount(t);
          });
        }),
        (r.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.HeaderSection &&
            -1 ===
              window.theme.HeaderSection.toString()
                .substring(0, 400)
                .indexOf("$(location)")
          );
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._loadCart = function (t) {
          r._getCart(function (e) {
            window.Shopify.updateQuickCart(e), t();
          }, t);
        }),
        (r._updateCartCount = function (t) {
          var r = e(".cart-icon .count"),
            n = t.item_count;
          0 === n ? r.addClass("hidden") : r.html(n).removeClass("hidden");
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/DebutAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "core/util/ShopifyCart"],
    function (t, e) {
      function r() {}
      Object.assign(r, t);
      return (
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._refreshCartPopup(t, e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateHeaderIcon(t);
          });
        }),
        (r.isAjaxCart = function () {
          return r._isCompatibleVersion();
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._isCompatibleVersion = function () {
          return r._cartPopupFeatureExists() && r._notificationEnabled();
        }),
        (r._cartPopupFeatureExists = function () {
          return (
            null !== document.querySelector('[data-section-type="product"]') &&
            "object" == typeof window.theme &&
            "function" == typeof window.theme.Product &&
            "function" ==
              typeof window.theme.Product.prototype._setupCartPopup &&
            "function" ==
              typeof window.theme.Product.prototype._setCartCountBubble
          );
        }),
        (r._notificationEnabled = function () {
          var t = document.querySelector("#ProductSection-product-template");
          return t && "true" === t.getAttribute("data-ajax-enabled");
        }),
        (r._refreshCartPopup = function (t, e) {
          r._closeCartPopupIfPresent(),
            r._getCart(function (n) {
              1 === t.quantity
                ? r._showCartPopup(n, t)
                : t.quantity > 1 && r._updateHeaderIcon(n),
                e();
            }, e);
        }),
        (r._showCartPopup = function (t, r) {
          var n = e.findLastAddedProduct(t, r),
            i = document.querySelector('[data-section-type="product"]');
          new window.theme.Product(i)._setupCartPopup(n);
        }),
        (r._updateHeaderIcon = function (t) {
          var e = document.querySelector('[data-section-type="product"]');
          new window.theme.Product(e)._setCartCountBubble(t.item_count);
        }),
        (r._closeCartPopupIfPresent = function () {
          var t = document.querySelector(".cart-popup-wrapper");
          t && t.classList.add("critical-hidden", "cart-popup-wrapper--hidden");
          var e = document.querySelector(".cart-popup-item__image-wrapper");
          e && e.setAttribute("data-image-loading-animation", "");
          var r = document.querySelector(".cart-popup-item__image");
          r && r.remove();
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/DebutifyAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._loadCart(r);
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            e._updateCartBubble(t);
          });
        }),
        (e.isAjaxCart = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "drawer" === window.theme.settings.cartType
          );
        }),
        (e.isCartPage = function () {
          return (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType &&
            "page" === window.theme.settings.cartType
          );
        }),
        (e._loadCart = function (t) {
          const r = e._getLoadFunction();
          r && (r(), t());
        }),
        (e._getLoadFunction = function () {
          return window.ajaxCart &&
            window.ajaxCart.load &&
            "function" == typeof window.ajaxCart.load
            ? window.ajaxCart.load
            : window.theme.ajaxCart &&
              window.theme.ajaxCart.update &&
              "function" == typeof window.theme.ajaxCart.update
            ? window.theme.ajaxCart.update
            : null;
        }),
        (e._updateCartBubble = function (t) {
          var e = window.theme.cache.$siteHeaderCart,
            r = t.item_count;
          0 == r
            ? e.removeClass("cart-bubble--visible")
            : e.addClass("cart-bubble--visible");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ExpressAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadCart(t, e);
        }),
        (r.isAjaxCart = function () {
          return null != e("button.header__cart-button");
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._loadCart = function (t, e) {
          r._renderCart(t),
            document.dispatchEvent(new CustomEvent("productAddedToCart")),
            e();
        }),
        (r._renderCart = function (t) {
          window.carts.forEach(function (e) {
            e.onCartUpdated(t.productId);
          });
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/WarehouseAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._triggerProductAddedEvent(t, r);
        }),
        (e.isAjaxCart = function () {
          return e._isDrawer() || e._isMessage();
        }),
        (e.isCartPage = function () {
          return (
            window.theme &&
            window.theme.cartType &&
            "page" === window.theme.cartType
          );
        }),
        (e._isDrawer = function () {
          return (
            window.theme &&
            window.theme.cartType &&
            "drawer" === window.theme.cartType
          );
        }),
        (e._isMessage = function () {
          return (
            window.theme &&
            window.theme.cartType &&
            "message" === window.theme.cartType
          );
        }),
        (e._triggerProductAddedEvent = function (t, e) {
          var r = new CustomEvent("product:added", {
            bubbles: !0,
            detail: { quantity: t.quantity },
          });
          document.documentElement.dispatchEvent(r), e();
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/VenueAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._showAjaxCart(r);
        }),
        (e.isAjaxCart = function () {
          return (
            window.ajaxCart &&
            "object" == typeof window.ajaxCart &&
            window.theme &&
            "object" == typeof window.theme &&
            "function" == typeof window.theme.mfpOpen
          );
        }),
        (e._showAjaxCart = function (t) {
          window.ajaxCart.load(),
            setTimeout(function () {
              window.theme.mfpOpen("cart");
            }, 100),
            t();
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/TurboAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._refreshAjaxCart(e);
        }),
        (r.isAjaxCart = function () {
          var t =
              window.Shopify &&
              window.Shopify.theme_settings &&
              window.Shopify.theme_settings.cart_action &&
              "ajax" === window.Shopify.theme_settings.cart_action,
            e = r._hasAjaxEvent(),
            n = window.refreshCart && "function" == typeof window.refreshCart;
          return (t || e) && n;
        }),
        (r.isCartPage = function () {
          return !r.isCheckoutPage() && !r.isAjaxCart() && !r._refreshEnabled();
        }),
        (r.isCheckoutPage = function () {
          var t =
              window.Shopify &&
              window.Shopify.theme_settings &&
              window.Shopify.theme_settings.cart_action &&
              "redirect_checkout" === window.Shopify.theme_settings.cart_action,
            r = "/checkout" === e('form input[name="return_to"]').val();
          return t || r;
        }),
        (r.isRefresh = function () {
          var t =
              window.Shopify &&
              window.Shopify.theme_settings &&
              window.Shopify.theme_settings.cart_action &&
              "reload_page" === window.Shopify.theme_settings.cart_action,
            r = "back" === e('form input[name="return_to"]').val();
          return t || r;
        }),
        (r._refreshAjaxCart = function (t) {
          r._getCart(function (e) {
            window.refreshCart(e), r._manualShowAjaxCart(), t();
          }, t);
        }),
        (r._hasAjaxEvent = function () {
          var t = window.$._data(window.document.body, "events");
          if (
            t &&
            void 0 !== t.submit &&
            void 0 !==
              t.submit.find(function (t) {
                return t.handler.toString().includes("/cart/aadd.js");
              })
          )
            return !0;
          var e = window.$._data(window.document, "events");
          return !(
            !e ||
            void 0 === e.click ||
            void 0 ===
              e.click.find(function (t) {
                return (
                  ".ajax-submit" === t.selector &&
                  t.handler.toString().includes("/cart/adda.js")
                );
              })
          );
        }),
        (r._manualShowAjaxCart = function () {
          e("#header").is(":visible")
            ? e("#header .cart-container, #header .cart_container").addClass(
                "active_link"
              )
            : e(".sticky_nav--stick").length
            ? e(
                ".sticky_nav .cart-container, .sticky_nav .cart_container"
              ).addClass("active_link")
            : e(
                ".top-bar .cart-container, .top-bar .cart_container, .top_bar .cart_container"
              ).addClass("active_link");
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/EllaAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          var n = e._getThemeInstance();
          e._showPopUpCart(n), r();
        }),
        (e.isAjaxCart = function () {
          return e._getThemeInstance() && e._isPopUpCart();
        }),
        (e._getThemeInstance = function () {
          return e._isEllaInstance(window.f)
            ? window.f
            : e._isEllaInstance(window.ella)
            ? window.ella
            : null;
        }),
        (e._showPopUpCart = function (t) {
          t.getPopupShoppingCart(!0);
        }),
        (e._isPopUpCart = function () {
          return window.ajax_cart && "upsell" === window.ajax_cart;
        }),
        (e._isEllaInstance = function (t) {
          return (
            t &&
            "object" == typeof t &&
            "function" == typeof t.getPopupShoppingCart
          );
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/FlexAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t) {
          r._refreshAjaxCart(t);
        }),
        (r.isAjaxCart = function () {
          return (
            window.Shopify.theme.jsAjaxCart &&
            window.Shopify.theme.jsAjaxCart.cart_action &&
            ("drawer" === window.Shopify.theme.jsAjaxCart.cart_action ||
              "mini_cart" === window.Shopify.theme.jsAjaxCart.cart_action) &&
            window.Shopify.theme.jsAjaxCart.showDrawer &&
            "function" == typeof window.Shopify.theme.jsAjaxCart.showDrawer &&
            window.Shopify.theme.jsAjaxCart.updateView &&
            "function" == typeof window.Shopify.theme.jsAjaxCart.updateView
          );
        }),
        (r._refreshAjaxCart = function (t) {
          Shopify.theme.jsAjaxCart.updateView(),
            Shopify.theme.jsAjaxCart.showDrawer(),
            r._showMiniCart(),
            t();
        }),
        (r._showMiniCart = function () {
          e(".header-cart").addClass("show-mini-cart");
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/DawnAjaxCart",
    [
      "core/util/ajax-carts/ThemeAjaxCart",
      "core/util/AjaxGet",
      "core/util/ShopifyCart",
    ],
    function (t, e, r) {
      function n() {}
      Object.assign(n, t);
      return (
        (n.prototype.constructor = function () {
          t.call(this);
        }),
        (n.loadAjaxCart = function (t, e) {
          this._isDrawerCart()
            ? this._loadDrawerSections(t, e)
            : this._isCartNotification() &&
              this._loadCartNotificationSections(t, e);
        }),
        (n.isAjaxCart = function () {
          return this._isDrawerCart() || this._isCartNotification();
        }),
        (n.isCartPage = function () {
          var t = this._findProductForm();
          return (
            !!this._isFormCartType(t, "page") ||
            (!this._isDrawerCart() && !this._isCartNotification())
          );
        }),
        (n.updateCartInfo = function () {
          var t = this,
            r = this._getHeaderIconParams();
          e.jsonGetNoCache(
            "/",
            r,
            function (e) {
              t._updateHeaderIcon(e);
            },
            function (t) {}
          );
        }),
        (n._isDrawerCart = function () {
          var t = this._findProductForm();
          return (
            !!this._isFormCartType(t, "drawer") ||
            null !== this._findDrawerCart()
          );
        }),
        (n._isCartNotification = function () {
          var t = this._findProductForm();
          return (
            !!this._isFormCartType(t, "notification") ||
            !(!t || !t.cartNotification) ||
            null !== this._findCartNotification()
          );
        }),
        (n._isFormCartType = function (t, e) {
          return (
            t && t.dataset && t.dataset.cartType && t.dataset.cartType === e
          );
        }),
        (n._findProductForm = function () {
          return document.querySelector("product-form");
        }),
        (n._findCartNotification = function () {
          return document.querySelector("cart-notification");
        }),
        (n._findDrawerCart = function () {
          return document.querySelector("cart-drawer");
        }),
        (n._findStickyHeader = function () {
          return document.querySelector("sticky-header");
        }),
        (n._loadDrawerSections = function (t, r) {
          var n = this,
            i = this._getDrawerParams();
          e.jsonGetNoCache(
            "/",
            i,
            function (e) {
              n._loadDrawer(t, e, r);
            },
            function (t) {
              r();
            }
          );
        }),
        (n._loadCartNotificationSections = function (t, r) {
          var n = this,
            i = this._getNotificationParams(t);
          e.jsonGetNoCache(
            "/",
            i,
            function (e) {
              1 === t.quantity
                ? n._loadNotification(t, e, r)
                : t.quantity > 1 && (n._updateHeaderIcon(e), r());
            },
            function (t) {
              r();
            }
          );
        }),
        (n._getNotificationParams = function (t) {
          var e = "sections=cart-icon-bubble";
          return (
            1 === t.quantity &&
              (e += ",cart-notification-product,cart-notification-button"),
            e
          );
        }),
        (n._getDrawerParams = function () {
          return "sections=cart-icon-bubble,cart-drawer";
        }),
        (n._getHeaderIconParams = function () {
          return "sections=cart-icon-bubble";
        }),
        (n._loadDrawer = function (t, e, n) {
          var i = this;
          this._getCart(function (o) {
            var a = t.variantId,
              c = r.findLastAddedProduct(o, t),
              s = i._findDrawerCart();
            s.classList.remove("is-empty"),
              s.renderContents({ id: a, key: c.key, sections: e }),
              n();
          }, n);
        }),
        (n._loadNotification = function (t, e, n) {
          var i = this;
          this._getCart(function (o) {
            var a = t.variantId,
              c = r.findLastAddedProduct(o, t);
            i
              ._findCartNotification()
              .renderContents({ id: a, key: c.key, sections: e }),
              n();
          }, n);
        }),
        (n._updateHeaderIcon = function (t) {
          document.getElementById("cart-icon-bubble").innerHTML =
            t["cart-icon-bubble"];
          var e = this._findStickyHeader();
          e && e.reveal();
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/WokieeAjaxCart",
    [
      "core/util/ajax-carts/ThemeAjaxCart",
      "core/util/AjaxGet",
      "core/util/ShopifyCart",
    ],
    function (t, e, r) {
      function n() {}
      return (
        Object.assign(n, t),
        (n.prototype.constructor = function () {
          t.call(this);
        }),
        (n.loadAjaxCart = function (t, e) {
          n._fireAddedCallback(t, e);
        }),
        (n.isAjaxCart = function () {
          return (
            window.Shopify.onItemAdded &&
            "function" == typeof window.Shopify.onItemAdded
          );
        }),
        (n._fireAddedCallback = function (t, e) {
          n._getCart(function (n) {
            var i = r.findLastAddedProduct(n, t);
            window.Shopify.onItemAdded(i), e();
          }, e);
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/BlockshopAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "lib/jquery-private"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadAjaxCart(t), e();
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            var r = t.item_count,
              n = e(
                ".cart-link .number-wrapper, .header--mobile--cart-link .number-wrapper"
              );
            e(".cart-link .number, .header--mobile--cart-link .number").html(r),
              r ? n.removeClass("hide") : n.addClass("hide");
          });
        }),
        (r.isAjaxCart = function () {
          return r._is2xVersion() || r._is5xVersion() || r._isNewVersion();
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._loadAjaxCart = function (t) {
          r._is2xVersion() &&
            (1 === t.quantity
              ? window.addToCartSuccessCallback()
              : r.updateCartInfo()),
            r._is5xVersion() &&
              (1 === t.quantity
                ? window.theme.partials.cart.recentCartItemPopUp()
                : r.updateCartInfo()),
            r._isNewVersion() &&
              (window.theme.partials.Cart.updateTotals(),
              window.theme.partials.Cart.updateAllHtml(function () {
                window.theme.partials.Product.addProductComplete();
              }));
        }),
        (r._is2xVersion = function () {
          return (
            window.addToCartSuccessCallback &&
            "function" == typeof window.addToCartSuccessCallback
          );
        }),
        (r._is5xVersion = function () {
          return (
            window.theme &&
            window.theme.partials &&
            window.theme.partials.cart &&
            window.theme.partials.cart.recentCartItemPopUp &&
            "function" == typeof window.theme.partials.cart.recentCartItemPopUp
          );
        }),
        (r._isNewVersion = function () {
          return r._isNewVersionAvailable() && r._isNewVersionDrawer();
        }),
        (r._isNewVersionDrawer = function () {
          return (
            (window.theme &&
              window.theme.partials &&
              window.theme.partials.Cart &&
              window.theme.partials.Cart.is_drawer) ||
            (window.theme.settings &&
              window.theme.settings.cart_type &&
              "drawer" === window.theme.settings.cart_type)
          );
        }),
        (r._isNewVersionAvailable = function () {
          return (
            window.theme &&
            window.theme.partials &&
            window.theme.partials.Cart &&
            window.theme.partials.Cart.updateTotals &&
            "function" == typeof window.theme.partials.Cart.updateTotals &&
            window.theme.partials.Cart &&
            window.theme.partials.Cart.updateAllHtml &&
            "function" == typeof window.theme.partials.Cart.updateAllHtml &&
            window.theme.partials.Product &&
            window.theme.partials.Product.addProductComplete &&
            "function" ==
              typeof window.theme.partials.Product.addProductComplete
          );
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/IconAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._loadCart(r);
        }),
        (e.isAjaxCart = function () {
          return e._isNewVersion() || e._isOldVersion();
        }),
        (e.isCartPage = function () {
          return !e.isAjaxCart();
        }),
        (e._isNewVersion = function () {
          var t = e._findConfig();
          return !!t && (e._isDrawerCart(t) || e._isModalCart(t));
        }),
        (e._findConfig = function () {
          var t = document.getElementById("cart-config");
          return t ? JSON.parse(t.innerHTML) : null;
        }),
        (e._isDrawerCart = function (t) {
          return "drawer" === t.cart_action;
        }),
        (e._isModalCart = function (t) {
          return "modal_cart" === t.cart_action;
        }),
        (e._isOldVersion = function () {
          return (
            window.ajaxCart &&
            window.ajaxCart.load &&
            "function" == typeof window.ajaxCart.load
          );
        }),
        (e._loadCart = function (t) {
          e._isNewVersion()
            ? e._showNewVersion(t)
            : e._isOldVersion() && (window.ajaxCart.load(), t());
        }),
        (e._showNewVersion = function (t) {
          e._getCart(function (r) {
            var n = e._findConfig();
            window.Shopify.theme.ajaxCart.updateView(n, r),
              e._isDrawerCart(n)
                ? window.Shopify.theme.ajaxCart.showDrawer(n)
                : e._isModalCart(n) &&
                  window.Shopify.theme.ajaxCart.showModal(n),
              t();
          }, t);
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/SpeedflyThemeAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          e._loadCart(r);
        }),
        (e.isAjaxCart = function () {
          return (
            window.ajaxifyShopify &&
            window.ajaxifyShopify.cartUpdateCallback &&
            "function" == typeof window.ajaxifyShopify.cartUpdateCallback
          );
        }),
        (e._loadCart = function (t) {
          e._getCart(function (e) {
            window.ajaxifyShopify.cartUpdateCallback(e), t();
          }, t);
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/BroadcastAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "core/util/ShopifyCart"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._loadAjaxCart(t, e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateHeaderIcon(t);
          });
        }),
        (r.isAjaxCart = function () {
          var t = r._is1xVersion(),
            e = r._isNewVersion();
          return t || e;
        }),
        (r.isCartPage = function () {
          return !r.isAjaxCart();
        }),
        (r._is1xVersion = function () {
          return (
            window.addToCartOkay && "function" == typeof window.addToCartOkay
          );
        }),
        (r._isNewVersion = function () {
          return r._isNewVersionAvailable() && r._isNewVersionDrawer();
        }),
        (r._isNewVersionDrawer = function () {
          return (
            window.cart &&
            window.cart.settings &&
            window.cart.settings.cartDrawerEnabled
          );
        }),
        (r._isNewVersionAvailable = function () {
          return (
            window.cart &&
            window.cart.openCartDropdown &&
            "function" == typeof window.cart.openCartDropdown
          );
        }),
        (r._loadNotification = function (t, e) {
          r._getCart(function (n) {
            1 === t.quantity
              ? r._renderNotification(n, t)
              : r._updateHeaderIcon(n),
              e();
          }, e);
        }),
        (r._renderNotification = function (t, r) {
          var n = e.findLastAddedProduct(t, r);
          window.addToCartOkay(n);
        }),
        (r._updateHeaderIcon = function (t) {
          var e = document.querySelector("#CartButton .cart-count-js"),
            r = t.item_count;
          (e.textContent = r), (e.style.display = r ? "" : "none");
        }),
        (r._loadAjaxCart = function (t, e) {
          r._is1xVersion()
            ? r._loadNotification(t, e)
            : r._isNewVersion() &&
              (window.cart.getCart(), window.cart.openCartDropdown(), e());
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/PipelineAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart", "core/util/ShopifyCart"],
    function (t, e) {
      function r() {}
      return (
        Object.assign(r, t),
        (r.prototype.constructor = function () {
          t.call(this);
        }),
        (r.loadAjaxCart = function (t, e) {
          r._triggerAjaxCartEvent(t, e);
        }),
        (r.updateCartInfo = function () {
          r._getCart(function (t) {
            r._updateHeaderIcon(t);
          });
        }),
        (r.isAjaxCart = function () {
          return !0;
        }),
        (r._triggerAjaxCartEvent = function (t, e) {
          r._getCart(function (n) {
            1 === t.quantity
              ? r._showPopDown(n, t)
              : t.quantity > 1 && r._updateHeaderIcon(n),
              e();
          }, e);
        }),
        (r._showPopDown = function (t, r) {
          var n = e.findLastAddedProduct(t, r);
          document.dispatchEvent(
            new CustomEvent("theme:cart:popdown", { detail: { variant: n } })
          );
        }),
        (r._updateHeaderIcon = function (t) {
          document.dispatchEvent(
            new CustomEvent("theme:cart:change", { detail: { cart: t } })
          );
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/FlowAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      Object.assign(e, t);
      return (
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, r) {
          var n = e._findCartAction();
          "drawer" === n
            ? (e._showDrawer(), r())
            : "added" === n && e.updateCartInfo();
        }),
        (e.updateCartInfo = function () {
          e._getCart(function (t) {
            window.wetheme.updateCartDrawer(t);
          });
        }),
        (e.isAjaxCart = function () {
          var t = e._findCartAction();
          return "drawer" === t || "added" === t;
        }),
        (e.isCartPage = function () {
          return "page" === e._findCartAction();
        }),
        (e._findCartAction = function () {
          var t = this._findRegisteredComponents();
          if (!t) return "page";
          for (var e = "added", r = 0; r < t.length; r++) {
            var n = t[r];
            if (n.cartAction) {
              e = n.cartAction;
              break;
            }
          }
          return e;
        }),
        (e._showDrawer = function () {
          e._getCart(function (t) {
            window.wetheme.toggleRightDrawer("cart", !0, { cart: t });
          });
        }),
        (e._findRegisteredComponents = function () {
          return window.wetheme && window.wetheme.registeredComponents
            ? window.wetheme.registeredComponents
            : null;
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/MinimalAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.isCartPage = function () {
          return !0;
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/JumpstartAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.isCartPage = function () {
          return !0;
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ajax-carts/ShellaAjaxCart",
    ["core/util/ajax-carts/ThemeAjaxCart"],
    function (t) {
      function e() {}
      return (
        Object.assign(e, t),
        (e.prototype.constructor = function () {
          t.call(this);
        }),
        (e.loadAjaxCart = function (t, e) {
          this._isCodeAvailable()
            ? this._loadDrawer(e)
            : this._isOldCodeAvailable()
            ? (this._loadOldDrawer(), e())
            : e();
        }),
        (e.updateCartInfo = function () {
          this._isCodeAvailable()
            ? window.theme.cart.updateData().then(function () {
                window.theme.cart.updateCounter();
              })
            : this._isOldCodeAvailable() && window.theme.Cart.updateValues();
        }),
        (e.isAjaxCart = function () {
          return this._isAjaxCart() || this._isOldAjaxCart();
        }),
        (e._isAjaxCart = function () {
          return !!this._isCodeAvailable() && 1 === theme.cart.$popup.length;
        }),
        (e.isCartPage = function () {
          return !this._isCodeAvailable() && !this._isOldAjaxCart();
        }),
        (e._isCodeAvailable = function () {
          return (
            window.theme &&
            window.theme.cart &&
            window.theme.cart.updateData &&
            "function" == typeof window.theme.cart.updateData &&
            window.theme.cart.updateCounter &&
            "function" == typeof window.theme.cart.updateCounter &&
            window.theme.cart.updateCart &&
            "function" == typeof window.theme.cart.updateCart &&
            window.theme.Popups &&
            window.theme.Popups.callByName &&
            "function" == typeof window.theme.Popups.callByName
          );
        }),
        (e._isOldAjaxCart = function () {
          return !!this._isOldCodeAvailable();
        }),
        (e._isOldCodeAvailable = function () {
          return (
            window.theme &&
            window.theme.Cart &&
            window.theme.Cart.updateValues &&
            "function" == typeof window.theme.Cart.updateValues &&
            window.theme.Popups &&
            window.theme.Popups.callByName &&
            "function" == typeof window.theme.Popups.callByName
          );
        }),
        (e._loadDrawer = function (t) {
          window.theme.cart.updateData().then(function () {
            window.theme.cart.updateCart(),
              window.theme.Popups.callByName("cart"),
              t();
          });
        }),
        (e._loadOldDrawer = function () {
          window.theme.Cart.updateValues(),
            window.theme.Popups.callByName("cart");
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/AddToCartButtonUtil",
    [
      "core/util/StringUtil",
      "core/util/ajax-carts/ThemeAjaxCart",
      "core/util/ajax-carts/BrooklynAjaxCart",
      "core/util/ajax-carts/BoundlessAjaxCart",
      "core/util/ajax-carts/EnvyAjaxCart",
      "core/util/ajax-carts/FastlaneAjaxCart",
      "core/util/ajax-carts/VentureAjaxCart",
      "core/util/ajax-carts/SimpleAjaxCart",
      "core/util/ajax-carts/NarrativeAjaxCart",
      "core/util/ajax-carts/SupplyAjaxCart",
      "core/util/ajax-carts/PopAjaxCart",
      "core/util/ajax-carts/PrestigeAjaxCart",
      "core/util/ajax-carts/BoosterAjaxCart",
      "core/util/ajax-carts/ShoptimizedAjaxCart",
      "core/util/ajax-carts/EmpireAjaxCart",
      "core/util/ajax-carts/DistrictAjaxCart",
      "core/util/ajax-carts/The4AjaxCart",
      "core/util/ajax-carts/ArchetypeAjaxCart",
      "core/util/ajax-carts/ShowTimeAjaxCart",
      "core/util/ajax-carts/DebutAjaxCart",
      "core/util/ajax-carts/DebutifyAjaxCart",
      "core/util/ajax-carts/ExpressAjaxCart",
      "core/util/ajax-carts/WarehouseAjaxCart",
      "core/util/ajax-carts/VenueAjaxCart",
      "core/util/ajax-carts/TurboAjaxCart",
      "core/util/ajax-carts/EllaAjaxCart",
      "core/util/ajax-carts/FlexAjaxCart",
      "core/util/ajax-carts/DawnAjaxCart",
      "core/util/ajax-carts/WokieeAjaxCart",
      "core/util/ajax-carts/BlockshopAjaxCart",
      "core/util/ajax-carts/IconAjaxCart",
      "core/util/ajax-carts/SpeedflyThemeAjaxCart",
      "core/util/ajax-carts/BroadcastAjaxCart",
      "core/util/ajax-carts/PipelineAjaxCart",
      "core/util/ajax-carts/FlowAjaxCart",
      "core/util/ajax-carts/MinimalAjaxCart",
      "core/util/ajax-carts/JumpstartAjaxCart",
      "core/util/ajax-carts/ShellaAjaxCart",
    ],
    function (
      t,
      e,
      r,
      n,
      i,
      o,
      a,
      c,
      s,
      u,
      l,
      d,
      f,
      h,
      p,
      m,
      g,
      y,
      b,
      v,
      _,
      w,
      C,
      x,
      P,
      A,
      k,
      S,
      T,
      D,
      F,
      E,
      j,
      I,
      R,
      M,
      q,
      N
    ) {
      function O() {}
      return (
        (O.getAjaxCart = function (t) {
          switch (O._normalizeTheme(t)) {
            case "debut":
              return v;
            case "minimal":
              return M;
            case "jumpstart":
              return q;
            case "brooklyn":
              return r;
            case "boundless":
              return n;
            case "envy":
              return i;
            case "fastlane":
              return o;
            case "venture":
              return a;
            case "simple":
              return c;
            case "narrative":
              return s;
            case "supply":
              return u;
            case "pop":
              return l;
            case "prestige":
              return d;
            case "booster":
              return f;
            case "shoptimized":
              return h;
            case "empire":
              return p;
            case "district":
              return m;
            case "gecko":
            case "kalles":
              return g;
            case "impulse":
            case "motion":
            case "streamline":
            case "expanse":
              return y;
            case "showtime":
              return b;
            case "debutify":
              return _;
            case "express":
              return w;
            case "warehouse":
              return C;
            case "ella":
              return A;
            case "turbo":
              return P;
            case "venue":
              return x;
            case "flex":
              return k;
            case "dawn":
            case "crave":
            case "sense":
            case "craft":
            case "taste":
            case "studio":
            case "ride":
            case "colorblock":
            case "refresh":
              return S;
            case "wokiee":
              return T;
            case "blockshop":
              return D;
            case "icon":
            case "testament":
              return F;
            case "speedfly theme":
              return E;
            case "broadcast":
              return j;
            case "pipeline":
              return I;
            case "flow":
              return R;
            case "shella":
              return N;
            default:
              return e;
          }
        }),
        (O._normalizeTheme = function (e) {
          return t.isNotEmpty(e) ? e.toLowerCase() : "";
        }),
        (O.prototype = {}),
        O
      );
    }
  ),
  codeblackbelt.define("core/util/ShopifyCartAttribute", [], function () {
    function t(t, e) {
      (this.key = t), (this.theme = e);
    }
    return (
      (t.build = function (e, r) {
        return new t(e, r);
      }),
      (t.prototype = {
        toJson: function () {
          var t = '{"' + this._key() + '":null}';
          return JSON.parse(t);
        },
        _key: function () {
          return "__" + this.key;
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/ProductUrlBuilder",
    ["core/util/UrlUtil", "core/util/StringUtil", "core/util/Objects"],
    function (t, e, r) {
      function n(t) {
        this.handle = t;
      }
      var i = t.getInternationalContext() + "/products/";
      return (
        (n.withHandle = function (t) {
          return new n(t);
        }),
        (n.prototype = {
          withInternationalContext: function (t) {
            return (this.context = t), this;
          },
          withVariant: function (t) {
            return (this.variantId = t), this;
          },
          url: function () {
            if (e.isEmpty(this.handle)) return this.context + "/products/";
            if (t.isAbsolute(this.handle)) return this.handle;
            var r;
            r = e.isNotEmpty(this.context)
              ? this.context + "/products/" + this.handle
              : i + this.handle;
            var n = this._safeVariantString();
            return e.isNotEmpty(n) && (r += "?variant=" + n), r;
          },
          _safeVariantString: function () {
            return r.isNull(this.variantId)
              ? ""
              : "number" == typeof this.variantId
              ? Number(this.variantId).toString()
              : this.variantId;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/model/Variant",
    [
      "core/util/ShopifyUtil",
      "core/util/price/SalePriceChecker",
      "core/util/ProductUrlBuilder",
    ],
    function (t, e, r) {
      function n(t, e, r) {
        (this.variantData = t),
          (this.productUrl = e),
          (this.priceFormatter = r);
      }
      return (
        (n.prototype = {
          getId: function () {
            return this.variantData.id;
          },
          getLabel: function () {
            return this.variantData.label;
          },
          getVariantUrl: function () {
            return r
              .withHandle(this.productUrl)
              .withVariant(this.getId())
              .url();
          },
          getImageUrl: function () {
            return this.variantData.image_url;
          },
          isBuyable: function () {
            return this.variantData.buyable;
          },
          isNonDefaultVariant: function () {
            return !this.variantData.default_variant;
          },
          setPrice: function (t) {
            this.variantData.price = t;
          },
          setCompareAtPrice: function (t) {
            this.variantData.compare_at_price = t;
          },
          getPrice: function (t) {
            return t.isDefaultMarket()
              ? this.variantData.shop_currency_price
              : this.variantData.price;
          },
          getCompareAtPrice: function (t) {
            return t.isDefaultMarket()
              ? this.variantData.shop_currency_compare_at_price
              : this.variantData.compare_at_price;
          },
          getNumericPrice: function (t) {
            return Number(this.getPrice(t));
          },
          getNumericCompareAtPrice: function (t) {
            return Number(this.getCompareAtPrice(t));
          },
          getNumericCompareAtPriceOrPrice: function (t) {
            var e = this.getNumericPrice(t),
              r = this.getNumericCompareAtPrice(t);
            return r > e ? r : e;
          },
          getPriceFormatted: function (t) {
            var e = this.getPrice(t);
            return this.priceFormatter.formattedPrice(e);
          },
          getCompareAtPriceFormatted: function (t) {
            var e = this.getCompareAtPrice(t);
            return this.priceFormatter.formattedPrice(e);
          },
          getForFreePriceFormatted: function () {
            return this.priceFormatter.formattedPrice("0.00");
          },
          isOnSale: function (t) {
            var r = this.getNumericPrice(t),
              n = this.getNumericCompareAtPrice(t);
            return e.isOnSale(r, n);
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/model/Product",
    [
      "core/util/ShopifyUtil",
      "core/util/price/SalePriceChecker",
      "core/model/Variant",
      "core/util/ProductUrlBuilder",
    ],
    function (t, e, r, n) {
      function i(t) {
        (this.productData = t),
          (this.mainProduct = !1),
          (this.lastProduct = !1);
      }
      return (
        (i.prototype = {
          setIsMainProduct: function () {
            this.mainProduct = !0;
          },
          setIsLastProduct: function () {
            this.lastProduct = !0;
          },
          setVariants: function (t) {
            this.variants = t;
          },
          getId: function () {
            return this.productData.id;
          },
          getVariantId: function () {
            return this.productData.variant_id;
          },
          getVariantSku: function () {
            return this.productData.variant_sku;
          },
          getSingleVariant: function () {
            return this.variants[0];
          },
          getNameFormatted: function () {
            return this.productData.name;
          },
          getVendorFormatted: function () {
            return this.productData.vendor;
          },
          getDescriptionFormatted: function () {
            return this.productData.description;
          },
          getUrl: function () {
            return n.withHandle(this.productData.url).url();
          },
          getHandle: function () {
            return this.productData.url;
          },
          getVariantUrl: function () {
            return n
              .withHandle(this.productData.url)
              .withVariant(this.productData.variant_id)
              .url();
          },
          firstVariant: function () {
            return this.getVariants()[0];
          },
          isMainProduct: function () {
            return this.mainProduct;
          },
          isLastProduct: function () {
            return this.lastProduct;
          },
          hasVariants: function () {
            if (this.variants && this.variants.length > 1) return !0;
            if (this.variants && 1 === this.variants.length) {
              return this.variants[0].isNonDefaultVariant();
            }
            return !1;
          },
          getVariants: function () {
            return this.variants;
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ProductBuilder",
    ["core/model/Product", "core/model/Variant", "core/util/Objects"],
    function (t, e, r) {
      function n() {}
      return (
        (n.buildProducts = function (t, e) {
          for (var r = [], i = 0; i < t.length; i++) {
            var o = t[i];
            n._isLastProduct(i, t)
              ? r.push(n._buildLastProduct(o, e))
              : r.push(n._buildProduct(o, e));
          }
          return r;
        }),
        (n.buildMainProduct = function (e, r) {
          var i = new t(e);
          return (
            i.setIsMainProduct(),
            i.setVariants(n._buildVariants(i, e.variants, r)),
            i
          );
        }),
        (n._buildProduct = function (e, r) {
          var i = new t(e);
          return i.setVariants(n._buildVariants(i, e.variants, r)), i;
        }),
        (n._buildLastProduct = function (e, r) {
          var i = new t(e);
          return (
            i.setIsLastProduct(),
            i.setVariants(n._buildVariants(i, e.variants, r)),
            i
          );
        }),
        (n._buildVariants = function (t, n, i) {
          var o = new Array();
          if (r.isNull(n)) return o;
          for (var a = 0; a < n.length; a++) {
            var c = new e(n[a], t.getHandle(), i);
            c.isBuyable() && o.push(c);
          }
          return o;
        }),
        (n._isLastProduct = function (t, e) {
          return t == e.length - 1;
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/RedirectUtil",
    ["core/util/DomainUtil", "core/util/UrlUtil"],
    function (t, e) {
      function r() {}
      var n = e.getInternationalContext() + "/cart",
        i = e.getInternationalContext() + "/checkout/";
      return (
        (r.redirectToCartPage = function () {
          document.location.href = r._currentPageOrUrl(n);
        }),
        (r.redirectToCheckoutPage = function () {
          document.location.href = r._currentPageOrUrl(i);
        }),
        (r.refreshPage = function () {
          document.location.reload();
        }),
        (r._currentPageOrUrl = function (e) {
          return t.isLocalhost() ? document.location.href : e;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/facebook/FacebookPixelHelper",
    [],
    function () {
      function t() {}
      return (
        (t.productAddedToCartContent = function (t, e) {
          return { id: t, quantity: 1, item_price: e };
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define("core/util/facebook/FacebookPixelData", [], function () {
    function t(t, e, r, n, i, o) {
      (this.contentIds = t),
        (this.contentName = e),
        (this.contentType = r),
        (this.currency = n),
        (this.value = i),
        (this.contents = o);
    }
    return (
      (t.prototype = {
        toJson: function () {
          return {
            content_ids: this.contentIds,
            content_name: this.contentName,
            content_type: this.contentType,
            currency: this.currency,
            value: this.value,
            contents: this.contents,
          };
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/facebook/FacebookPixelAdapter",
    [],
    function () {
      function t() {}
      return (
        (t.isLibraryAvailable = function () {
          return window.fbq && "function" == typeof window.fbq;
        }),
        (t.track = function (t) {
          window.fbq("track", "AddToCart", t.toJson());
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/facebook/FacebookPixelTracker",
    ["core/util/facebook/FacebookPixelAdapter", "core/util/Logger"],
    function (t, e) {
      function r(t) {
        this.isFacebookPixelEnabled = t;
      }
      return (
        (r.prototype = {
          track: function (t) {
            this._skipTrack() || this._trackAsync(t);
          },
          _trackAsync: function (t) {
            var r = this;
            new Promise(function (e) {
              e(r._track(t));
            }).catch(function (t) {
              e.log("Failed to track Facebook Pixel: " + t);
            });
          },
          _skipTrack: function () {
            return !this.isFacebookPixelEnabled || !t.isLibraryAvailable();
          },
          _track: function (r) {
            e.debug(
              "Facebook Pixel data to be sent: " + JSON.stringify(r.toJson())
            ),
              t.track(r);
          },
        }),
        r
      );
    }
  );
codeblackbelt.define(
  "core/frequently-bought/facebook/FacebookPixelBundleTracker",
  [
    "core/frequently-bought/util/ProductViewUtil",
    "core/util/facebook/FacebookPixelHelper",
    "core/util/facebook/FacebookPixelData",
    "core/util/facebook/FacebookPixelTracker",
  ],
  function (t, e, r, n) {
    function i(t, e) {
      (this.tracker = new n(t)), (this.market = e);
    }
    return (
      (i.prototype = {
        track: function (t) {
          this.tracker.track(this._buildMultipleProductsData(t));
        },
        _buildMultipleProductsData: function (e) {
          var n = t.variantIds(e),
            i = t.productNames(e),
            o = t.totalAmount(e, this.market),
            a = this._multipleProductsAddedToCartContents(e, this.market);
          return new r(n, i, "product_group", this.market.currency(), o, a);
        },
        _multipleProductsAddedToCartContents: function (t, r) {
          return t.map(function (t) {
            var n = t.getVariant();
            return e.productAddedToCartContent(n.getId(), n.getPrice(r));
          });
        },
      }),
      i
    );
  }
),
  codeblackbelt.define(
    "core/frequently-bought/FrequentlyBought",
    [
      "core/frequently-bought/BoxUI",
      "core/frequently-bought/TitleUI",
      "core/frequently-bought/ProductsUI",
      "core/frequently-bought/SelectorsUI",
      "core/frequently-bought/ProductUI",
      "core/frequently-bought/SelectorUI",
      "core/frequently-bought/AddToCartButtonUI",
      "core/frequently-bought/TotalPriceUI",
      "core/frequently-bought/ErrorUI",
      "core/frequently-bought/discount/DiscountCalculator",
      "core/frequently-bought/discount/DiscountCreator",
      "core/frequently-bought/discount/DiscountRemover",
      "core/frequently-bought/discount/DiscountMessageUI",
      "core/frequently-bought/discount/DiscountApplicabilityManager",
      "core/frequently-bought/ProductView",
      "core/frequently-bought/util/MarketManager",
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/events/Events",
      "core/frequently-bought/events/EventDataFactory",
      "core/util/AddToCartButtonUtil",
      "core/util/ShopifyCart",
      "core/util/ShopifyCartAttribute",
      "core/util/ProductBuilder",
      "core/util/CustomScripts",
      "core/util/RedirectUtil",
      "core/util/StatUtil",
      "core/util/ShopifyUtil",
      "core/util/RatingUtil",
      "core/util/PageCssClassAdder",
      "core/frequently-bought/facebook/FacebookPixelBundleTracker",
    ],
    function (
      t,
      e,
      r,
      n,
      i,
      o,
      a,
      c,
      s,
      u,
      l,
      d,
      f,
      h,
      p,
      m,
      g,
      y,
      b,
      v,
      _,
      w,
      C,
      x,
      P,
      A,
      k,
      S,
      T,
      D
    ) {
      function F(t) {
        (this.preferences = t),
          (this.facebookPixelTracker = new D(
            t.isFacebookPixelEnabled,
            t.market
          )),
          (this.discountApplicabilityManager = new h(t)),
          (this.products = []),
          (this.productViews = []),
          (this.cart = new _());
      }
      var E = "frequently-bought-together";
      return (
        (F.prototype = {
          init: function (t) {
            t && this._showWidget(),
              this.discountApplicabilityManager.startCheckingOnPageLoad();
          },
          _showWidget: function () {
            this.preferences.notEmptyRecommendations() &&
              (T.addPageClassToBody(),
              this._buildUI(),
              this._addMainProduct(),
              this._addRecommendations(),
              this._initAddToCartButton(),
              this._showRatings(),
              this._applyActiveMarket());
          },
          _buildUI: function () {
            (this.errorUI = new s()),
              (this.productsUI = new r(
                this.preferences.numberOfBundleProducts()
              )),
              (this.selectorsUI = new n()),
              (this.titleUI = new e(this.preferences.titlePreferences)),
              (this.discountMessageUI = new f(
                this.preferences.discountMessagePreferences
              )),
              (this.totalPriceUI = new c(
                this.preferences.totalPricePreferences,
                this.preferences.priceFormatter
              )),
              (this.addToCartButtonUI = new a(
                this.preferences.addToCartButtonPreferences
              )),
              (this.boxUI = new t(
                this.preferences.boxPreferences,
                this.titleUI,
                this.discountMessageUI,
                this.productsUI,
                this.selectorsUI,
                this.totalPriceUI,
                this.addToCartButtonUI,
                this.errorUI
              )),
              (this.discountCreator = new l(
                this.preferences.discountPreferences,
                this.addToCartButtonUI,
                this.errorUI
              )),
              (this.discountCalculator = new u(
                this.productViews,
                this.totalPriceUI,
                this.selectorsUI,
                this.discountMessageUI,
                this.preferences
              ));
          },
          _addMainProduct: function () {
            this.preferences.isMainProductAvailable() &&
              this._addProduct(
                C.buildMainProduct(
                  this.preferences.currentProduct,
                  this.preferences.priceFormatter
                )
              );
          },
          _addRecommendations: function () {
            C.buildProducts(
              this.preferences.recommendations,
              this.preferences.priceFormatter
            ).forEach(this._addProduct, this);
          },
          _addProduct: function (t) {
            var e = new i(
                t,
                this.preferences.productPreferences,
                this.preferences.numberOfBundleProducts(),
                this.boxUI.width()
              ),
              r = new o(
                t,
                this.preferences.selectorPreferences,
                e,
                this.errorUI,
                this.discountCalculator
              ),
              n = new p(t, e, r);
            this.products.push(t),
              this.productViews.push(n),
              this.productsUI.addProduct(n.getProductUI()),
              this.selectorsUI.addSelector(n.getSelectorUI());
          },
          _applyActiveMarket: function () {
            new m(
              this.products,
              this.discountCalculator,
              this.preferences
            ).applyActiveMarket();
          },
          _initAddToCartButton: function () {
            var t = this;
            this.addToCartButtonUI.onClick(function () {
              if (
                (t.errorUI.hide(),
                t.addToCartButtonUI.showDisabledButton(),
                t.discountCalculator.isDiscountApplicable())
              ) {
                var e = g.productIds(t.products),
                  r = t.discountCalculator.getSelectedProductIdList(),
                  n = t.discountCalculator.getSelectedVariantIdList();
                t.discountCreator.createAndApplyDiscountCode(
                  t.preferences.currentProduct.id,
                  e,
                  r,
                  n,
                  function () {
                    t._addProductsToCart();
                  }
                );
              } else t._addProductsToCart();
            });
          },
          _showRatings: function () {
            this.preferences.showRating &&
              S.showAllRating(
                E,
                this.products,
                this.selectorsUI.getRatingBoxes(),
                this.preferences.selectorPreferences.ratingPreferences
              );
          },
          _addProductsToCart: function () {
            var t = this,
              e = function () {
                var e = t.discountCalculator.getSelectedProductIdList(),
                  r = t.discountCalculator.getSelectedVariantIdList();
                A.productsDirectlyAdded(E, e),
                  t.facebookPixelTracker.track(
                    g.checkedProducts(t.productViews)
                  ),
                  t.discountApplicabilityManager.startCheckingAfterAddingToTheCart();
                var n = b.buildAddedEventData(e, r);
                y.triggerAddedEvent(n), t._redirect(n);
              },
              r = function (e) {
                t._removeDiscountIfPresent(),
                  t.addToCartButtonUI.showEnabledButton(),
                  t.errorUI.show(e);
              };
            this.cart.addVariants(
              this.discountCalculator.getSelectedVariantIdList(),
              this._cartAttribute(),
              e,
              r
            );
          },
          _cartAttribute: function () {
            return this.preferences.isTrackingEnabled
              ? w.build(
                  "Added with Frequently Bought Together button",
                  this.preferences.theme
                )
              : null;
          },
          _redirect: function (t) {
            var e = this,
              r = v.getAjaxCart(this.preferences.theme);
            r.isAjaxCart() &&
            (this.preferences.themeDefaultPolicy ||
              this.preferences.dontRedirectPolicy)
              ? (e.addToCartButtonUI.showDisabledAddedButton(),
                r.safeLoadAjaxCart(t, function () {
                  e.addToCartButtonUI.showDisabledAddedAndEnabledButton();
                }))
              : this.preferences.redirectToCartPagePolicy ||
                (this.preferences.themeDefaultPolicy && r.isCartPage())
              ? P.redirectToCartPage()
              : this.preferences.redirectToCheckoutPolicy ||
                (this.preferences.themeDefaultPolicy && r.isCheckoutPage())
              ? P.redirectToCheckoutPage()
              : this.preferences.themeDefaultPolicy && r.isRefresh()
              ? P.refreshPage()
              : (r.updateCartInfo(),
                e.addToCartButtonUI.showDisabledAddedAndEnabledButton());
          },
          _removeDiscountIfPresent: function () {
            this.discountCalculator.isDiscountApplicable() &&
              d.removeDiscount();
          },
        }),
        F
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/TitlePreferences",
    [],
    function () {
      function t(t) {
        (this.text = t.title),
          (this.size = t.title_size),
          (this.color = t.title_color),
          (this.isBold = t.title_bold),
          (this.additionalStyles = t.title_additional_styles);
      }
      return (
        (t.from = function (e) {
          return new t(e);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountPreferences",
    [],
    function () {
      function t(t, e) {
        (this.numberOfRecommendationsToOfferDiscount = Number(
          t.number_of_recommendations_to_offer_discount
        )),
          (this.discountType = t.discount_type),
          (this.discountMinimumAmountRequirement = Number(
            t.discount_minimum_amount_requirement
          )),
          (this.relaxDiscountRequirementInSecondaryMarkets =
            t.discount_requirements_relaxed_in_secondary_markets),
          (this.discountPercentage = Number(t.discount_percentage)),
          (this.discountAmount = Number(t.discount_amount)),
          (this.discountHmac = t.discount_hmac),
          (this.discountTimestamp = t.discount_timestamp),
          (this.market = e);
      }
      return (
        (t.from = function (e, r) {
          return new t(e, r);
        }),
        (t.prototype = {
          isPercentageDiscount: function () {
            return "PERCENTAGE" == this.discountType;
          },
          isFixedAmountDiscount: function () {
            return "FIXED_AMOUNT" == this.discountType;
          },
          isCheapestItemForFreeDiscount: function () {
            return "CHEAPEST_ITEM_FOR_FREE" == this.discountType;
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountMessagePreferences",
    [],
    function () {
      function t(t) {
        (this.discountMessage = t.discount_message),
          (this.size = t.discount_message_size),
          (this.bold = t.discount_message_bold),
          (this.color = t.discount_message_color),
          (this.backgroundColor = t.discount_message_background_color),
          (this.border = t.discount_message_border),
          (this.borderColor = t.discount_message_border_color),
          (this.verticalPadding = t.discount_message_vertical_padding),
          (this.horizontalPadding = t.discount_message_horizontal_padding),
          (this.additionalStyles = t.discount_message_additional_styles);
      }
      return (
        (t.from = function (e) {
          return new t(e);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountAppliedMessagePreferences",
    [],
    function () {
      function t(t) {
        (this.additionalStyles = t.discount_applied_message_additional_styles),
          (this.discountAppliedMessageTarget =
            t.discount_applied_message_target),
          (this.discountAppliedMessageTargetPlacement =
            t.discount_applied_message_target_placement),
          (this.discountAppliedMessageMobileTarget =
            t.discount_applied_message_mobile_target),
          (this.discountAppliedMessageMobileTargetPlacement =
            t.discount_applied_message_mobile_target_placement);
      }
      return (
        (t.from = function (e) {
          return new t(e);
        }),
        (t.prototype = {
          getDiscountAppliedMessageTargetPreferences: function () {
            return {
              target: this.discountAppliedMessageTarget,
              targetPlacement: this.discountAppliedMessageTargetPlacement,
              mobileTarget: this.discountAppliedMessageMobileTarget,
              mobileTargetPlacement:
                this.discountAppliedMessageMobileTargetPlacement,
            };
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/util/AmountRequirementCheckerUtil",
    ["core/frequently-bought/util/ProductViewUtil"],
    function (t) {
      function e() {}
      return (
        (e.isTotalInDefaultMarketAboveTheMinimumAmountRequirement = function (
          e,
          r,
          n
        ) {
          var i = t.totalAmount(e, n.defaultMarket());
          return this.isAboveTheMinimumAmountRequirement(i, r);
        }),
        (e.isTotalInTwinMarketAboveTheMinimumAmountRequirement = function (
          e,
          r,
          n,
          i
        ) {
          var o = t.totalAmount(e, i),
            a = t.totalAmount(e, i.defaultMarket());
          return n
            ? this.isAboveTheMinimumAmountRequirement(o, r)
            : this.isAboveTheMinimumAmountRequirement(o, r) && o >= a;
        }),
        (e.estimatedTotalAmountInDefaultMarket = function (e, r) {
          var n = t.totalAmount(e, r),
            i = n / r.currencyRate();
          return Number(i.toFixed(2));
        }),
        (e.isAboveTheMinimumAmountRequirement = function (t, e) {
          return t >= e;
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/AmountRequirementChecker",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/util/AmountRequirementCheckerUtil",
      "core/util/Objects",
    ],
    function (t, e, r) {
      function n(t) {
        (this.products = t),
          (this.relaxDiscountRequirementInSecondaryMarkets = !1);
      }
      return (
        (n.isBundle = function (t) {
          if (r.isNull(t))
            throw new Error("Illegal argument exception: null products array");
          return new n(t);
        }),
        (n.prototype = {
          aboveMinimumAmountRequirement: function (t) {
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: minimum amount requirement cannot be null"
              );
            return (this.minimumAmountRequirement = t), this;
          },
          withRelaxedDiscountRequirement: function (t) {
            return (
              r.isNull(t) &&
                (this.relaxDiscountRequirementInSecondaryMarkets = !1),
              (this.relaxDiscountRequirementInSecondaryMarkets = t),
              this
            );
          },
          inMarket: function (t) {
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: market cannot be null"
              );
            return (this.market = t), this._isBundleTotalAboveTheRequirement();
          },
          _isBundleTotalAboveTheRequirement: function () {
            return this.market.isDefaultMarket()
              ? this._isTotalInDefaultMarketAboveTheMinimumAmountRequirement()
              : this.market.isTwinMarket()
              ? this._isTotalInTwinMarketAboveTheMinimumAmountRequirement()
              : this._isTotalInSecondaryMarketAboveTheRequirement();
          },
          _isTotalInDefaultMarketAboveTheMinimumAmountRequirement: function () {
            return e.isTotalInDefaultMarketAboveTheMinimumAmountRequirement(
              this.products,
              this.minimumAmountRequirement,
              this.market
            );
          },
          _isTotalInTwinMarketAboveTheMinimumAmountRequirement: function () {
            return e.isTotalInTwinMarketAboveTheMinimumAmountRequirement(
              this.products,
              this.minimumAmountRequirement,
              this.relaxDiscountRequirementInSecondaryMarkets,
              this.market
            );
          },
          _isTotalInSecondaryMarketAboveTheRequirement: function () {
            return (
              this._isTotalInDefaultMarketAboveTheMinimumAmountRequirement() &&
              this._estimatedTotalAboveTheRequirement()
            );
          },
          _estimatedTotalAboveTheRequirement: function () {
            return this.relaxDiscountRequirementInSecondaryMarkets
              ? this._checkRelaxedConditions()
              : this._checkStrictConditions();
          },
          _checkRelaxedConditions: function () {
            var t = e.estimatedTotalAmountInDefaultMarket(
              this.products,
              this.market
            );
            return e.isAboveTheMinimumAmountRequirement(
              t,
              this.minimumAmountRequirement
            );
          },
          _checkStrictConditions: function () {
            var r = t.totalAmount(this.products, this.market.defaultMarket()),
              n = e.estimatedTotalAmountInDefaultMarket(
                this.products,
                this.market
              );
            return (
              e.isAboveTheMinimumAmountRequirement(
                n,
                this.minimumAmountRequirement
              ) && n >= r
            );
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/ProductsSelectedChecker",
    ["core/util/Objects"],
    function (t) {
      function e(t) {
        this.numberOfRecommendationsToOfferDiscount = t;
      }
      return (
        (e.checkMinimumNumberOfRecommendationsRequirement = function (r) {
          if (t.isNull(r))
            throw new Error(
              "Illegal argument exception: null numberOfRecommendationsToOfferDiscount requirement"
            );
          return new e(r);
        }),
        (e.prototype = {
          on: function (e) {
            if (t.isNull(e))
              throw new Error("Illegal argument exception: null products");
            var r = this.numberOfRecommendationsToOfferDiscount + 1;
            return e.length >= r;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountedBundleTotalChecker",
    ["core/frequently-bought/util/ProductViewUtil", "core/util/Objects"],
    function (t, e) {
      function r(t) {
        this.bundle = t;
      }
      function r(t) {
        this.discountedBundleTotal = t;
      }
      return (
        (r.isDiscountedAmountGreaterThanZero = function (t) {
          if (e.isNull(t))
            throw new Error(
              "Illegal argument exception: null discounted bundle total"
            );
          return new r(t);
        }),
        (r.prototype = {
          andBelow: function (t) {
            if (e.isNull(t))
              throw new Error("Illegal argument exception: null bundle total");
            return (
              (this.bundleTotal = t), this._discountedTotalGreaterThanZero()
            );
          },
          _discountedTotalGreaterThanZero: function () {
            return (
              this.discountedBundleTotal > 0 &&
              this.discountedBundleTotal < this.bundleTotal
            );
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/FixedAmountDiscountCalculator",
    ["core/util/Objects"],
    function (t) {
      function e(t) {
        this.fixedAmount = t;
      }
      return (
        (e.deductAmount = function (r) {
          if (t.isNull(r))
            throw new Error(
              "Illegal argument exception: fixed amount discount cannot be null"
            );
          return new e(r);
        }),
        (e.prototype = {
          from: function (e) {
            if (t.isNull(e))
              throw new Error(
                "Illegal argument exception: total cannot be null"
              );
            return (this.total = e), this._applyFixedAmountDiscount();
          },
          _applyFixedAmountDiscount: function () {
            return this.fixedAmount > this.total
              ? 0
              : this._roundedDiscountedTotal();
          },
          _roundedDiscountedTotal: function () {
            var t = this.total - this.fixedAmount;
            return Number(t.toFixed(2));
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/PercentageCalculator",
    ["core/util/Objects"],
    function (t) {
      function e(t) {
        this.percentage = t;
      }
      return (
        (e.percentage = function (r) {
          if (t.isNull(r))
            throw new Error(
              "Illegal argument exception: percentage must not be null"
            );
          return new e(r);
        }),
        (e.prototype = {
          of: function (e) {
            if (t.isNull(e))
              throw new Error(
                "Illegal argument exception: value must not be null"
              );
            return (this.value = e), this._calculate();
          },
          _calculate: function () {
            var t = 100 * this.value;
            return (this.percentage * t) / 1e4;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/EstimatedPercentageDiscountCalculator",
    [
      "core/frequently-bought/discount/FixedAmountDiscountCalculator",
      "core/frequently-bought/discount/PercentageCalculator",
      "core/util/Objects",
    ],
    function (t, e, r) {
      function n(t) {
        this.discountPercentage = t;
      }
      return (
        (n.calculateDiscountPercent = function (t) {
          if (r.isNull(t))
            throw new Error(
              "Illegal argument exception: discount percentage cannot be null"
            );
          return new n(t);
        }),
        (n.prototype = {
          of: function (t) {
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: total cannot be null"
              );
            return (this.total = t), this;
          },
          atExchangeRate: function (t) {
            if (r.isNull(this.total))
              throw new Error(
                "Illegal state exception: total must be provided"
              );
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: exchangeRate cannot be null"
              );
            return (this.exchangeRate = t), this;
          },
          andDeductFrom: function (e) {
            var r = this._calculateDiscount();
            return t.deductAmount(r).from(e);
          },
          _calculateDiscount: function () {
            var t = this._calculateDiscountAmount() * this.exchangeRate;
            return Number(t.toFixed(2));
          },
          _calculateDiscountAmount: function () {
            var t = e.percentage(this.discountPercentage).of(this.total);
            return Number(t.toFixed(2));
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/PercentageDiscount",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/AmountRequirementChecker",
      "core/frequently-bought/discount/ProductsSelectedChecker",
      "core/frequently-bought/discount/DiscountedBundleTotalChecker",
      "core/frequently-bought/discount/EstimatedPercentageDiscountCalculator",
      "core/util/ShopifyUtil",
      "core/util/Logger",
      "core/util/Objects",
    ],
    function (t, e, r, n, i, o, a, c) {
      function s(t, e, r, n, i) {
        (this.market = t),
          (this.discountPercentage = e),
          (this.discountMinimumAmountRequirement = r),
          (this.relaxDiscountRequirementInSecondaryMarkets = n),
          (this.numberOfRecommendationsToOfferDiscount = i);
      }
      return (
        (s.prototype = {
          isApplicable: function (t, e) {
            if (c.isNull(e))
              return (
                a.debug(
                  "The Percentage discount cannot be applied: the main product is not available"
                ),
                !1
              );
            var r = this._isCurrentProductChecked(t, e),
              n = this._isMinimumNumberOfProductsSelected(t),
              i = this._isMinimumAmountReached(t),
              o = this._isValidDiscountedAmount(t),
              s = [
                { "Is the main product checked?: ": r },
                { "Is the minimum number of products checked?: ": n },
                { "Is the total above the minimum amount threshold?: ": i },
                { "Is the discount amount valid?: ": o },
              ];
            return (
              a.debugGroup("Checking percentage discount", s), r && n && i && o
            );
          },
          calculateDiscountedTotal: function (e) {
            var r = t.totalAmount(e, this.market.defaultMarket()),
              n = t.totalAmount(e, this.market),
              c = i
                .calculateDiscountPercent(this.discountPercentage)
                .of(r)
                .atExchangeRate(o.getPresentmentCurrencyRate())
                .andDeductFrom(n),
              s = [
                {
                  "Minimum amount requirement":
                    this.discountMinimumAmountRequirement,
                },
                { "Discount percentage": this.discountPercentage },
                { "Total in default market": r },
                { "Exchange rate": o.getPresentmentCurrencyRate() },
                { "Total in active market": n },
                { "Bundle price": c },
              ];
            return a.debugGroup("Applying percentage discount", s), c;
          },
          _isCurrentProductChecked: function (e, r) {
            return t.isProductChecked(e, r.id);
          },
          _isMinimumNumberOfProductsSelected: function (t) {
            return r
              .checkMinimumNumberOfRecommendationsRequirement(
                this.numberOfRecommendationsToOfferDiscount
              )
              .on(t);
          },
          _isMinimumAmountReached: function (t) {
            return e
              .isBundle(t)
              .aboveMinimumAmountRequirement(
                this.discountMinimumAmountRequirement
              )
              .withRelaxedDiscountRequirement(
                this.relaxDiscountRequirementInSecondaryMarkets
              )
              .inMarket(this.market);
          },
          _isValidDiscountedAmount: function (e) {
            var r = t.totalAmount(e, this.market),
              i = this.calculateDiscountedTotal(e);
            return n.isDiscountedAmountGreaterThanZero(i).andBelow(r);
          },
        }),
        s
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/EstimatedFixedAmountDiscountCalculator",
    [
      "core/frequently-bought/discount/FixedAmountDiscountCalculator",
      "core/frequently-bought/discount/PercentageCalculator",
      "core/util/Objects",
    ],
    function (t, e, r) {
      function n(t) {
        this.discountAmount = t;
      }
      return (
        (n.calculateFixedDiscount = function (t) {
          if (r.isNull(t))
            throw new Error(
              "Illegal argument exception: discount amount cannot be null"
            );
          return new n(t);
        }),
        (n.prototype = {
          atExchangeRate: function (t) {
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: exchangeRate cannot be null"
              );
            return (this.exchangeRate = t), this;
          },
          andDeductFrom: function (e) {
            var r = this._calculateDiscount();
            return t.deductAmount(r).from(e);
          },
          _calculateDiscount: function () {
            var t = r.isNull(this.exchangeRate) ? 1 : this.exchangeRate;
            return this.discountAmount * t;
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/FixedAmountDiscount",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/AmountRequirementChecker",
      "core/frequently-bought/discount/ProductsSelectedChecker",
      "core/frequently-bought/discount/DiscountedBundleTotalChecker",
      "core/frequently-bought/discount/EstimatedFixedAmountDiscountCalculator",
      "core/util/ShopifyUtil",
      "core/util/Logger",
      "core/util/Objects",
    ],
    function (t, e, r, n, i, o, a, c) {
      function s(t, e, r, n, i) {
        (this.market = t),
          (this.discountAmount = e),
          (this.discountMinimumAmountRequirement = r),
          (this.relaxDiscountRequirementInSecondaryMarkets = n),
          (this.numberOfRecommendationsToOfferDiscount = i);
      }
      return (
        (s.prototype = {
          isApplicable: function (t, e) {
            if (c.isNull(e))
              return (
                a.debug(
                  "The Fixed amount discount cannot be applied: the main product is not available"
                ),
                !1
              );
            var r = this._isCurrentProductChecked(t, e),
              n = this._isMinimumNumberOfProductsSelected(t),
              i = this._isMinimumAmountReached(t),
              o = this._isValidDiscountedAmount(t),
              s = [
                { "Is the main product checked?: ": r },
                { "Is the minimum number of products checked?: ": n },
                { "Is the total above the minimum amount threshold?: ": i },
                { "Is the discount amount valid?: ": o },
              ];
            return (
              a.debugGroup("Checking fixed amount discount", s),
              r && n && i && o
            );
          },
          calculateDiscountedTotal: function (e) {
            var r = t.totalAmount(e, this.market),
              n = i
                .calculateFixedDiscount(this.discountAmount)
                .atExchangeRate(o.getPresentmentCurrencyRate())
                .andDeductFrom(r),
              c = [
                {
                  "Minimum amount requirement":
                    this.discountMinimumAmountRequirement,
                },
                { "Discount amount": this.discountAmount },
                { "Exchange rate": o.getPresentmentCurrencyRate() },
                { "Total in active market": r },
                { "Bundle price": n },
              ];
            return a.debugGroup("Applying fixed amount discount", c), n;
          },
          _isCurrentProductChecked: function (e, r) {
            return t.isProductChecked(e, r.id);
          },
          _isMinimumNumberOfProductsSelected: function (t) {
            return r
              .checkMinimumNumberOfRecommendationsRequirement(
                this.numberOfRecommendationsToOfferDiscount
              )
              .on(t);
          },
          _isMinimumAmountReached: function (t) {
            return e
              .isBundle(t)
              .aboveMinimumAmountRequirement(
                this.discountMinimumAmountRequirement
              )
              .withRelaxedDiscountRequirement(
                this.relaxDiscountRequirementInSecondaryMarkets
              )
              .inMarket(this.market);
          },
          _isValidDiscountedAmount: function (e) {
            var r = t.totalAmount(e, this.market),
              i = this.calculateDiscountedTotal(e);
            return n.isDiscountedAmountGreaterThanZero(i).andBelow(r);
          },
        }),
        s
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/BxGetOneAmountRequirementChecker",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/util/AmountRequirementCheckerUtil",
      "core/util/Objects",
      "core/util/Arrays",
    ],
    function (t, e, r, n) {
      function i(t) {
        (this.products = t),
          (this.relaxDiscountRequirementInSecondaryMarkets = !1);
      }
      return (
        (i.isBundle = function (t) {
          if (r.isNull(t))
            throw new Error("Illegal argument exception: null products array");
          return new i(t);
        }),
        (i.prototype = {
          aboveMinimumAmountRequirement: function (t) {
            if (r.isNull(t))
              throw new Error(
                "Illegal argument exception: null minimum amount requirement"
              );
            return (this.minimumAmountRequirement = t), this;
          },
          withRelaxedDiscountRequirement: function (t) {
            return (
              r.isNull(t) &&
                (this.relaxDiscountRequirementInSecondaryMarkets = !1),
              (this.relaxDiscountRequirementInSecondaryMarkets = t),
              this
            );
          },
          inMarket: function (t) {
            if (r.isNull(t))
              throw new Error("Illegal argument exception: null market");
            return (this.market = t), this._isTotalAboveTheRequirement();
          },
          _isTotalAboveTheRequirement: function () {
            return (
              !n.isEmpty(this.products) &&
              (this.market.isDefaultMarket()
                ? this._isTotalInDefaultMarketAboveTheMinimumAmountRequirement()
                : this.market.isTwinMarket()
                ? this._isBxGetOneSameInSecondaryMarket() &&
                  this._isTotalInTwinMarketAboveTheMinimumAmountRequirement()
                : this._isBxGetOneSameInSecondaryMarket() &&
                  this._isTotalInDefaultMarketAboveTheMinimumAmountRequirement())
            );
          },
          _isTotalInDefaultMarketAboveTheMinimumAmountRequirement: function () {
            return e.isTotalInDefaultMarketAboveTheMinimumAmountRequirement(
              this.products,
              this.minimumAmountRequirement,
              this.market
            );
          },
          _isBxGetOneSameInSecondaryMarket: function () {
            return (
              t.cheapestVariant(this.products, this.market.defaultMarket()) ==
              t.cheapestVariant(this.products, this.market)
            );
          },
          _isTotalInTwinMarketAboveTheMinimumAmountRequirement: function () {
            return e.isTotalInTwinMarketAboveTheMinimumAmountRequirement(
              this.products,
              this.minimumAmountRequirement,
              this.relaxDiscountRequirementInSecondaryMarkets,
              this.market
            );
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/BxGetOneDiscount",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/BxGetOneAmountRequirementChecker",
      "core/frequently-bought/discount/ProductsSelectedChecker",
      "core/frequently-bought/discount/DiscountedBundleTotalChecker",
      "core/frequently-bought/discount/EstimatedFixedAmountDiscountCalculator",
      "core/util/Logger",
      "core/util/Objects",
      "core/util/Arrays",
    ],
    function (t, e, r, n, i, o, a, c) {
      function s(t, e, r, n) {
        (this.market = t),
          (this.discountMinimumAmountRequirement = e),
          (this.relaxDiscountRequirementInSecondaryMarkets = r),
          (this.numberOfRecommendationsToOfferDiscount = n);
      }
      return (
        (s.prototype = {
          isApplicable: function (t, e) {
            if (a.isNull(e))
              return (
                o.debug(
                  "The BxGetOne discount cannot be applied: the main product is not available"
                ),
                !1
              );
            var r = this._isCurrentProductChecked(t, e),
              n = this._isMinimumNumberOfProductsSelected(t),
              i = this._isMinimumAmountReached(t),
              c = this._isValidDiscountedAmount(t),
              s = [
                { "Is the main product checked?: ": r },
                { "Is the minimum number of products checked?: ": n },
                { "Is the total above the minimum amount threshold?: ": i },
                { "Is the discount amount valid?: ": c },
              ];
            return (
              o.debugGroup("Checking BxGetOne discount", s), r && n && i && c
            );
          },
          calculateDiscountedTotal: function (e) {
            var r = t.totalAmount(e, this.market);
            if (c.isEmpty(e)) return r;
            var n = t.cheapestVariant(e, this.market.defaultMarket()),
              a = n.getNumericPrice(this.market.defaultMarket()),
              s = i
                .calculateFixedDiscount(a)
                .atExchangeRate(1)
                .andDeductFrom(r),
              u = [
                {
                  "Minimum amount requirement":
                    this.discountMinimumAmountRequirement,
                },
                { "Cheapest variant price": a },
                { "Exchange rate (hardcoded)": 1 },
                { "Total in active market": r },
                { "Bundle price": s },
              ];
            return o.debugGroup("Applying BuyXGetOne discount", u), s;
          },
          _isCurrentProductChecked: function (e, r) {
            return t.isProductChecked(e, r.id);
          },
          _isMinimumNumberOfProductsSelected: function (t) {
            return r
              .checkMinimumNumberOfRecommendationsRequirement(
                this.numberOfRecommendationsToOfferDiscount
              )
              .on(t);
          },
          _isMinimumAmountReached: function (t) {
            return e
              .isBundle(t)
              .aboveMinimumAmountRequirement(
                this.discountMinimumAmountRequirement
              )
              .withRelaxedDiscountRequirement(
                this.relaxDiscountRequirementInSecondaryMarkets
              )
              .inMarket(this.market);
          },
          _isValidDiscountedAmount: function (e) {
            var r = t.totalAmount(e, this.market),
              i = this.calculateDiscountedTotal(e);
            return n.isDiscountedAmountGreaterThanZero(i).andBelow(r);
          },
        }),
        s
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/FreeShippingDiscount",
    [
      "core/frequently-bought/util/ProductViewUtil",
      "core/frequently-bought/discount/AmountRequirementChecker",
      "core/frequently-bought/discount/ProductsSelectedChecker",
      "core/util/Logger",
      "core/util/Objects",
    ],
    function (t, e, r, n, i) {
      function o(t, e, r, n) {
        (this.market = t),
          (this.discountMinimumAmountRequirement = e),
          (this.relaxDiscountRequirementInSecondaryMarkets = r),
          (this.numberOfRecommendationsToOfferDiscount = n);
      }
      return (
        (o.prototype = {
          isApplicable: function (t, e) {
            if (i.isNull(e))
              return (
                n.debug(
                  "The Fixed amount discount cannot be applied: the main product is not available"
                ),
                !1
              );
            var r = this._isCurrentProductChecked(t, e),
              o = this._isMinimumNumberOfProductsSelected(t),
              a = this._isMinimumAmountReached(t),
              c = [
                { "Is the main product checked?: ": r },
                { "Is the minimum number of products checked?: ": o },
                { "Is the total above the minimum amount threshold?: ": a },
              ];
            return (
              n.debugGroup("Checking Free Shipping discount", c), r && o && a
            );
          },
          calculateDiscountedTotal: function (e) {
            var r = t.totalAmount(e, this.market),
              i = [
                {
                  "Minimum amount requirement":
                    this.discountMinimumAmountRequirement,
                },
                { "Bundle price": r },
              ];
            return n.debugGroup("Applying free shipping discount", i), r;
          },
          _isCurrentProductChecked: function (e, r) {
            return t.isProductChecked(e, r.id);
          },
          _isMinimumNumberOfProductsSelected: function (t) {
            return r
              .checkMinimumNumberOfRecommendationsRequirement(
                this.numberOfRecommendationsToOfferDiscount
              )
              .on(t);
          },
          _isMinimumAmountReached: function (t) {
            return e
              .isBundle(t)
              .aboveMinimumAmountRequirement(
                this.discountMinimumAmountRequirement
              )
              .withRelaxedDiscountRequirement(
                this.relaxDiscountRequirementInSecondaryMarkets
              )
              .inMarket(this.market);
          },
        }),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/discount/DiscountFactory",
    [
      "core/frequently-bought/discount/PercentageDiscount",
      "core/frequently-bought/discount/FixedAmountDiscount",
      "core/frequently-bought/discount/BxGetOneDiscount",
      "core/frequently-bought/discount/FreeShippingDiscount",
    ],
    function (t, e, r, n) {
      function i() {}
      return (
        (i.discount = function (t, e) {
          return e.isPercentageDiscount()
            ? i._percentageDiscount(t, e)
            : e.isFixedAmountDiscount()
            ? i._fixedAmountDiscount(t, e)
            : e.isCheapestItemForFreeDiscount()
            ? i._bxGetOneDiscount(t, e)
            : i._freeShippingDiscount(t, e);
        }),
        (i._percentageDiscount = function (e, r) {
          return new t(
            e,
            r.discountPercentage,
            r.discountMinimumAmountRequirement,
            r.relaxDiscountRequirementInSecondaryMarkets,
            r.numberOfRecommendationsToOfferDiscount
          );
        }),
        (i._fixedAmountDiscount = function (t, r) {
          return new e(
            t,
            r.discountAmount,
            r.discountMinimumAmountRequirement,
            r.relaxDiscountRequirementInSecondaryMarkets,
            r.numberOfRecommendationsToOfferDiscount
          );
        }),
        (i._bxGetOneDiscount = function (t, e) {
          return new r(
            t,
            e.discountMinimumAmountRequirement,
            e.relaxDiscountRequirementInSecondaryMarkets,
            e.numberOfRecommendationsToOfferDiscount
          );
        }),
        (i._freeShippingDiscount = function (t, e) {
          return new n(
            t,
            e.discountMinimumAmountRequirement,
            e.relaxDiscountRequirementInSecondaryMarkets,
            e.numberOfRecommendationsToOfferDiscount
          );
        }),
        (i.prototype = {}),
        i
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/TotalPricePreferences",
    [],
    function () {
      function t(t) {
        (this.label = t.total_price_label),
          (this.labelColor = t.name_color),
          (this.labelBold = t.name_bold),
          (this.showPrice = t.show_price),
          (this.showCompareAtPrice = t.show_compare_at_price),
          (this.offerDiscount = t.offer_discount),
          (this.regularPriceColor = t.regular_price_color),
          (this.regularPriceBold = t.regular_price_bold),
          (this.regularPriceAdditionalStyles =
            t.regular_price_additional_styles),
          (this.salePriceColor = t.sale_price_color),
          (this.salePriceBold = t.sale_price_bold),
          (this.salePriceAdditionalStyles = t.sale_price_additional_styles),
          (this.compareAtPriceColor = t.compare_at_price_color),
          (this.compareAtPriceBold = t.compare_at_price_bold),
          (this.compareAtPriceAdditionalStyles =
            t.compare_at_price_additional_styles),
          (this.showCompareAtPriceFirst = t.show_compare_at_price_first);
      }
      return (
        (t.from = function (e) {
          return new t(e);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/AddToCartButtonPreferences",
    ["core/util/StringUtil"],
    function (t) {
      function e(t) {
        (this.label = t.button_label),
          (this.addedLabel = t.added_button_label),
          (this.color = t.button_color),
          (this.backgroundColor = t.button_background_color),
          (this.additionalStyles = t.button_additional_styles),
          (this.hoverColor = t.button_hover_color),
          (this.hoverBackgroundColor = t.button_hover_background_color);
      }
      return (
        (e.from = function (t) {
          return new e(t);
        }),
        (e.prototype = {
          hasAddToCartColor: function () {
            return t.isNotEmpty(this.color);
          },
          hasAddToCartBackgroundColor: function () {
            return t.isNotEmpty(this.backgroundColor);
          },
          hasAddToCartHoverColor: function () {
            return t.isNotEmpty(this.hoverColor);
          },
          hasAddToCartHoverBackgroundColor: function () {
            return t.isNotEmpty(this.hoverBackgroundColor);
          },
          mustSetStylesOnHover: function () {
            return (
              this.hasAddToCartHoverColor() ||
              this.hasAddToCartHoverBackgroundColor()
            );
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/BoxPreferences",
    [],
    function () {
      function t(t) {
        (this.target = t.target),
          (this.targetPlacement = t.target_placement),
          (this.mobileTarget = t.mobile_target),
          (this.mobileTargetPlacement = t.mobile_target_placement),
          (this.padding = t.vertical_padding),
          (this.backgroundColor = t.background_color),
          (this.showBorder = t.show_border),
          (this.borderColor = t.border_color),
          (this.maxWidth = t.max_width),
          (this.additionalPreferences = t.box_additional_styles);
      }
      return (
        (t.from = function (e) {
          return new t(e);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/ProductPreferences",
    [],
    function () {
      function t(t) {
        (this.imageHeight = t.image_height),
          (this.imageWidth = t.image_width),
          (this.imageMargins = t.image_margins),
          (this.isFitted = t.image_fitted),
          (this.imageAdditionalStyles = t.image_additional_styles),
          (this.whitePlusIcon = t.white_plus_icon);
      }
      return (
        (t.from = function (e, r) {
          return new t(e, r);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define("core/util/VariantSelectorPreferences", [], function () {
    function t(t) {
      (this.color = t.variant_selector_color),
        (this.backgroundColor = t.variant_selector_background_color),
        (this.borderColor = t.variant_selector_border_color),
        (this.additionalStyles = t.variant_selector_additional_styles);
    }
    return (
      (t.prototype = {}),
      (t.from = function (e) {
        return new t(e);
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/frequently-bought/RatingPreferences",
    [],
    function () {
      function t(t) {
        (this.showRating = t.show_rating),
          (this.starRatingColor = t.star_rating_color),
          (this.starRatingAdditionalStyles = t.star_rating_additional_styles),
          (this.showReviewCount = t.show_review_count),
          (this.reviewCountColor = t.review_count_color),
          (this.reviewCountAdditionalStyles = t.review_count_additional_styles),
          (this.reviewsApp = t.reviews_app),
          (this.stampedApiKey = t.stamped_api_key),
          (this.yotpoAppKey = t.yotpo_app_key),
          (this.alireviewsRatingCharacter = t.alireviews_rating_character),
          (this.shopId = t.shop_id);
      }
      return (
        (t.prototype = {}),
        (t.from = function (e) {
          return new t(e);
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/SelectorPreferences",
    [
      "core/util/VariantSelectorPreferences",
      "core/frequently-bought/RatingPreferences",
    ],
    function (t, e) {
      function r(r, n) {
        (this.thisItemLabel = r.this_item_label),
          (this.showDescription = r.show_description),
          (this.showPrice = r.show_price),
          (this.showCompareAtPrice = r.show_compare_at_price),
          (this.offerDiscount = r.offer_discount),
          (this.regularPriceColor = r.regular_price_color),
          (this.regularPriceBold = r.regular_price_bold),
          (this.regularPriceAdditionalStyles =
            r.regular_price_additional_styles),
          (this.salePriceColor = r.sale_price_color),
          (this.salePriceBold = r.sale_price_bold),
          (this.salePriceAdditionalStyles = r.sale_price_additional_styles),
          (this.compareAtPriceColor = r.compare_at_price_color),
          (this.compareAtPriceBold = r.compare_at_price_bold),
          (this.compareAtPriceAdditionalStyles =
            r.compare_at_price_additional_styles),
          (this.ratingPreferences = e.from(r)),
          (this.nameColor = r.name_color),
          (this.nameBold = r.name_bold),
          (this.nameAdditionalStyles = r.name_additional_styles),
          (this.descriptionColor = r.description_color),
          (this.descriptionBold = r.description_bold),
          (this.descriptionAdditionalStyles = r.description_additional_styles),
          (this.variantSelectorPreferences = t.from(r)),
          (this.showCompareAtPriceFirst = r.show_compare_at_price_first),
          (this.theme = r.theme),
          (this.market = n);
      }
      return (
        (r.from = function (t, e) {
          return new r(t, e);
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/Market",
    ["core/util/ShopifyUtil"],
    function (t) {
      function e(t, e, r, n, i) {
        (this.shopCountry = t),
          (this.shopCurrency = e),
          (this._country = r),
          (this._currency = n),
          (this._currencyRate = i);
      }
      return (
        (e.from = function (r) {
          return new e(
            r.shop_country_code,
            r.shop_default_currency,
            t.getCountry(),
            t.getPresentmentCurrency(),
            t.getPresentmentCurrencyRate()
          );
        }),
        (e.build = function (t, r, n, i, o) {
          return new e(t, r, n, i, o);
        }),
        (e.prototype = {
          switchToDefaultMarket: function () {
            (this._country = this.shopCountry),
              (this._currency = this.shopCurrency),
              (this._currencyRate = 1);
          },
          defaultMarket: function () {
            return new e(
              this.shopCountry,
              this.shopCurrency,
              this.shopCountry,
              this.shopCurrency,
              1
            );
          },
          isDefaultMarket: function () {
            return (
              this._country == this.shopCountry &&
              this._currency == this.shopCurrency
            );
          },
          isTwinMarket: function () {
            return (
              this._country != this.shopCountry &&
              this._currency == this.shopCurrency
            );
          },
          isSecondaryMarket: function () {
            return !this.isDefaultMarket() && !this.isTwinMarket();
          },
          currencyRate: function () {
            return this._currencyRate;
          },
          country: function () {
            return this._country;
          },
          currency: function () {
            return this._currency;
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountFormatterUtil",
    ["core/util/StringUtil"],
    function (t) {
      function e() {}
      return (
        (e.decimalsOf = function (e) {
          if (t.isNotString(e))
            throw new Error(
              "Illegal argument exception: price must be a string [decimalsOf]"
            );
          if (t.isEmpty(e))
            throw new Error(
              "Illegal argument exception: price must not be null or empty"
            );
          if (-1 == e.indexOf(".")) return "00";
          var r = e.split(".")[1];
          return 1 == r.length ? r + "0" : r;
        }),
        (e.integerPartOf = function (e) {
          if (t.isNotString(e))
            throw new Error(
              "Illegal argument exception: price must be a string [integerPartOf]"
            );
          if (t.isEmpty(e))
            throw new Error(
              "Illegal argument exception: price must not be null or empty"
            );
          var r = e.indexOf(".");
          return -1 != r ? e.substring(0, r) : e;
        }),
        (e.formatWithThousandSymbolAndDecimalSymbol = function (t, r, n, i) {
          var o = e.formatIntegerWithThousandsSymbol(t, n);
          return r.length > 0 ? o + i + r : o;
        }),
        (e.formatIntegerWithThousandsSymbol = function (e, r) {
          if (t.isNotString(e) || t.isEmpty(e))
            throw new Error(
              "Illegal argument exception: price must not be a null or an empty string"
            );
          if (Number(e) < 1e3) return e;
          for (
            var n = t.reverse(e), i = n.match(/.{1,3}/g), o = "", a = 0;
            a < i.length;
            a++
          )
            (o += i[a]), a != i.length - 1 && (o += r);
          return t.reverse(o);
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/Decimals",
    ["core/util/StringUtil"],
    function (t) {
      function e() {}
      return (
        (e.numberOfDecimals = function (t) {
          switch (t) {
            case "BIF":
            case "CLP":
            case "DJF":
            case "GNF":
            case "ISK":
            case "JPY":
            case "KMF":
            case "KRW":
            case "PYG":
            case "RWF":
            case "UGX":
            case "VND":
            case "VUV":
            case "XAF":
            case "XPF":
              return 0;
            case "MGA":
              return 1;
            case "BHD":
            case "IQD":
            case "JOD":
            case "KWD":
            case "LYD":
            case "OMR":
            case "TND":
              return 3;
            default:
              return 2;
          }
        }),
        (e.adjustDecimalsInCurrency = function (r, n) {
          var i = e.numberOfDecimals(n);
          return r.length > i ? r.slice(0, i) : t.padEnd(r, i, "0");
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountFormatter",
    ["core/util/price/AmountFormatterUtil", "core/util/price/Decimals"],
    function (t, e) {
      function r() {}
      return (
        (r.isFormatterForPriceFormat = function (t) {
          return -1 !== t.indexOf("{{amount}}");
        }),
        (r.prototype = {
          formatInCurrency: function (r, n, i) {
            var o = t.integerPartOf(r),
              a = t.decimalsOf(r),
              c = e.adjustDecimalsInCurrency(a, i),
              s = t.formatWithThousandSymbolAndDecimalSymbol(o, c, ",", ".");
            return this._formatAmount(s, n);
          },
          hasDecimalPart: function () {
            return !0;
          },
          decimalSymbol: function () {
            return ".";
          },
          _formatAmount: function (t, e) {
            return e.replace("{{amount}}0", t).replace("{{amount}}", t);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountNoDecimalsFormatter",
    ["core/util/price/AmountFormatterUtil"],
    function (t) {
      function e() {}
      return (
        (e.isFormatterForPriceFormat = function (t) {
          return -1 !== t.indexOf("{{amount_no_decimals}}");
        }),
        (e.prototype = {
          formatInCurrency: function (e, r, n) {
            var i = this._roundUp(e),
              o = t.formatIntegerWithThousandsSymbol(i.toString(), ",");
            return this._formatAmount(o, r);
          },
          hasDecimalPart: function () {
            return !1;
          },
          decimalSymbol: function () {
            throw new Error(
              "This amount format does not support decimal digits"
            );
          },
          _roundUp: function (t) {
            return Math.round(t);
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_no_decimals}}0", t)
              .replace("{{amount_no_decimals}}", t);
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountNoDecimalsWithCommaSeparatorFormatter",
    ["core/util/price/AmountFormatterUtil"],
    function (t) {
      function e() {}
      return (
        (e.isFormatterForPriceFormat = function (t) {
          return (
            -1 !== t.indexOf("{{amount_no_decimals_with_comma_separator}}")
          );
        }),
        (e.prototype = {
          formatInCurrency: function (e, r, n) {
            var i = this._roundUp(e),
              o = t.formatIntegerWithThousandsSymbol(i.toString(), ".");
            return this._formatAmount(o, r);
          },
          hasDecimalPart: function () {
            return !1;
          },
          decimalSymbol: function () {
            throw new Error(
              "This amount format does not support decimal digits"
            );
          },
          _roundUp: function (t) {
            return Math.round(t);
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_no_decimals_with_comma_separator}}0", t)
              .replace("{{amount_no_decimals_with_comma_separator}}", t);
          },
        }),
        e
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountNoDecimalsWithSpaceSeparatorFormatter",
    ["core/util/price/AmountFormatterUtil", "core/util/Logger"],
    function (t, e) {
      function r() {}
      return (
        (r.isFormatterForPriceFormat = function (t) {
          return (
            -1 !== t.indexOf("{{amount_no_decimals_with_space_separator}}")
          );
        }),
        (r.prototype = {
          formatInCurrency: function (e, r, n) {
            var i = this._roundUp(e),
              o = t.formatIntegerWithThousandsSymbol(i.toString(), " ");
            return this._formatAmount(o, r);
          },
          hasDecimalPart: function () {
            return !1;
          },
          decimalSymbol: function () {
            throw new Error(
              "This amount format does not support decimal digits"
            );
          },
          _roundUp: function (t) {
            return Math.round(t);
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_no_decimals_with_space_separator}}0", t)
              .replace("{{amount_no_decimals_with_space_separator}}", t);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountWithApostropheSeparatorFormatter",
    ["core/util/price/AmountFormatterUtil", "core/util/price/Decimals"],
    function (t, e) {
      function r() {}
      return (
        (r.isFormatterForPriceFormat = function (t) {
          return -1 !== t.indexOf("{{amount_with_apostrophe_separator}}");
        }),
        (r.prototype = {
          formatInCurrency: function (r, n, i) {
            var o = t.integerPartOf(r),
              a = t.decimalsOf(r),
              c = e.adjustDecimalsInCurrency(a, i),
              s = t.formatWithThousandSymbolAndDecimalSymbol(o, c, "'", ".");
            return this._formatAmount(s, n);
          },
          hasDecimalPart: function () {
            return !0;
          },
          decimalSymbol: function () {
            return ".";
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_with_apostrophe_separator}}0", t)
              .replace("{{amount_with_apostrophe_separator}}", t);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountWithCommaSeparatorFormatter",
    ["core/util/price/AmountFormatterUtil", "core/util/price/Decimals"],
    function (t, e) {
      function r() {}
      return (
        (r.isFormatterForPriceFormat = function (t) {
          return -1 !== t.indexOf("{{amount_with_comma_separator}}");
        }),
        (r.prototype = {
          formatInCurrency: function (r, n, i) {
            var o = t.integerPartOf(r),
              a = t.decimalsOf(r),
              c = e.adjustDecimalsInCurrency(a, i),
              s = t.formatWithThousandSymbolAndDecimalSymbol(o, c, ".", ",");
            return this._formatAmount(s, n);
          },
          hasDecimalPart: function () {
            return !0;
          },
          decimalSymbol: function () {
            return ",";
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_with_comma_separator}}0", t)
              .replace("{{amount_with_comma_separator}}", t);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/AmountWithSpaceSeparatorFormatter",
    ["core/util/price/AmountFormatterUtil", "core/util/price/Decimals"],
    function (t, e) {
      function r() {}
      return (
        (r.isFormatterForPriceFormat = function (t) {
          return -1 !== t.indexOf("{{amount_with_space_separator}}");
        }),
        (r.prototype = {
          formatInCurrency: function (r, n, i) {
            var o = t.integerPartOf(r),
              a = t.decimalsOf(r),
              c = e.adjustDecimalsInCurrency(a, i),
              s = t.formatWithThousandSymbolAndDecimalSymbol(o, c, " ", ",");
            return this._formatAmount(s, n);
          },
          hasDecimalPart: function () {
            return !0;
          },
          decimalSymbol: function () {
            return ",";
          },
          _formatAmount: function (t, e) {
            return e
              .replace("{{amount_with_space_separator}}0", t)
              .replace("{{amount_with_space_separator}}", t);
          },
        }),
        r
      );
    }
  ),
  codeblackbelt.define("core/util/price/NoOpAmountFormatter", [], function () {
    function t() {}
    var e = /\{\{(.*)\}\}/;
    return (
      (t.prototype = {
        formatInCurrency: function (t, r, n) {
          return r.replace(e, t);
        },
        hasDecimalPart: function () {
          return !0;
        },
        decimalSymbol: function () {
          return ".";
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/price/AmountFormatterFactory",
    [
      "core/util/price/AmountFormatter",
      "core/util/price/AmountNoDecimalsFormatter",
      "core/util/price/AmountNoDecimalsWithCommaSeparatorFormatter",
      "core/util/price/AmountNoDecimalsWithSpaceSeparatorFormatter",
      "core/util/price/AmountWithApostropheSeparatorFormatter",
      "core/util/price/AmountWithCommaSeparatorFormatter",
      "core/util/price/AmountWithSpaceSeparatorFormatter",
      "core/util/price/NoOpAmountFormatter",
    ],
    function (t, e, r, n, i, o, a, c) {
      function s() {}
      return (
        (s.formatterForPriceFormat = function (s) {
          return t.isFormatterForPriceFormat(s)
            ? new t()
            : e.isFormatterForPriceFormat(s)
            ? new e()
            : r.isFormatterForPriceFormat(s)
            ? new r()
            : n.isFormatterForPriceFormat(s)
            ? new n()
            : i.isFormatterForPriceFormat(s)
            ? new i()
            : o.isFormatterForPriceFormat(s)
            ? new o()
            : a.isFormatterForPriceFormat(s)
            ? new a()
            : new c();
        }),
        (s.prototype = {}),
        s
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/SuperscriptAmountFormatter",
    [],
    function () {
      function t(t) {
        this.amountFormatter = t;
      }
      return (
        (t.prototype = {
          formatWithSuperscriptDecimals: function (t) {
            var e = t;
            return (
              this.amountFormatter.hasDecimalPart() &&
                ((e = this._addSuperscriptStartTag(e)),
                (e = this._addSuperscriptEndTag(e))),
              e
            );
          },
          _addSuperscriptStartTag: function (t) {
            var e = this.amountFormatter.decimalSymbol();
            return -1 != t.indexOf(e) ? t.replace(e, "<sup>") : t;
          },
          _addSuperscriptEndTag: function (t) {
            var e = t.indexOf("<sup>");
            return -1 == e
              ? t
              : -1 == t.substring(e).indexOf(" ")
              ? t.concat("</sup>")
              : t.substring(0, e) + t.substring(e).replace(" ", "</sup> ");
          },
        }),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/PresentmentPriceFormat",
    ["core/util/StringUtil", "core/util/Logger"],
    function (t, e) {
      function r() {}
      var n = {
        AED: {
          moneyFormat: "Dhs. {{amount}}",
          moneyWithCurrencyFormat: "Dhs. {{amount}} AED",
        },
        AFN: {
          moneyFormat: "{{amount}}؋",
          moneyWithCurrencyFormat: "{{amount}}؋ AFN",
        },
        ALL: {
          moneyFormat: "Lek {{amount}}",
          moneyWithCurrencyFormat: "Lek {{amount}} ALL",
        },
        AMD: {
          moneyFormat: "{{amount}} AMD",
          moneyWithCurrencyFormat: "{{amount}} AMD",
        },
        ANG: {
          moneyFormat: "ƒ;{{amount}}",
          moneyWithCurrencyFormat: "{{amount}} NAƒ;",
        },
        AOA: {
          moneyFormat: "Kz{{amount}}",
          moneyWithCurrencyFormat: "Kz{{amount}} AOA",
        },
        ARS: {
          moneyFormat: "${{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "${{amount_with_comma_separator}} ARS",
        },
        AUD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} AUD",
        },
        AWG: {
          moneyFormat: "Afl{{amount}}",
          moneyWithCurrencyFormat: "Afl{{amount}} AWG",
        },
        AZN: {
          moneyFormat: "m.{{amount}}",
          moneyWithCurrencyFormat: "m.{{amount}} AZN",
        },
        BAM: {
          moneyFormat: "KM {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "KM {{amount_with_comma_separator}} BAM",
        },
        BBD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} Bds",
        },
        BDT: {
          moneyFormat: "Tk {{amount}}",
          moneyWithCurrencyFormat: "Tk {{amount}} BDT",
        },
        BGN: {
          moneyFormat: "{{amount}} лв",
          moneyWithCurrencyFormat: "{{amount}} лв BGN",
        },
        BIF: {
          moneyFormat: "FBu. {{amount_no_decimals}}",
          moneyWithCurrencyFormat: "FBu. {{amount_no_decimals}} BIF",
        },
        BMD: {
          moneyFormat: "BD${{amount}}",
          moneyWithCurrencyFormat: "BD${{amount}} BMD",
        },
        BND: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} BND",
        },
        BOB: {
          moneyFormat: "Bs{{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "Bs{{amount_with_comma_separator}} BOB",
        },
        BRL: {
          moneyFormat: "R$ {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "R$ {{amount_with_comma_separator}} BRL",
        },
        BSD: {
          moneyFormat: "BS${{amount}}",
          moneyWithCurrencyFormat: "BS${{amount}} BSD",
        },
        BWP: {
          moneyFormat: "P{{amount}}",
          moneyWithCurrencyFormat: "P{{amount}} BWP",
        },
        BZD: {
          moneyFormat: "BZ${{amount}}",
          moneyWithCurrencyFormat: "BZ${{amount}} BZD",
        },
        CAD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} CAD",
        },
        CDF: {
          moneyFormat: "FC{{amount}}",
          moneyWithCurrencyFormat: "FC{{amount}} CDF",
        },
        CHF: {
          moneyFormat: "CHF {{amount}}",
          moneyWithCurrencyFormat: "CHF {{amount}}",
        },
        CLP: {
          moneyFormat: "${{amount_no_decimals_with_comma_separator}}",
          moneyWithCurrencyFormat:
            "${{amount_no_decimals_with_comma_separator}} CLP",
        },
        CNY: {
          moneyFormat: "¥{{amount}}",
          moneyWithCurrencyFormat: "¥{{amount}} CNY",
        },
        COP: {
          moneyFormat: "${{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "${{amount_with_comma_separator}} COP",
        },
        CRC: {
          moneyFormat: "₡ {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "₡ {{amount_with_comma_separator}} CRC",
        },
        CVE: {
          moneyFormat: "{{amount_with_space_separator}}$",
          moneyWithCurrencyFormat: "{{amount_with_space_separator}}$ CVE",
        },
        CZK: {
          moneyFormat: "{{amount_with_comma_separator}} Kč",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} Kč",
        },
        DJF: {
          moneyFormat: "{{amount_no_decimals_with_comma_separator}} Fdj",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_comma_separator}} DJF",
        },
        DKK: {
          moneyFormat: "{{amount_with_comma_separator}} kr",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} DKK",
        },
        DOP: {
          moneyFormat: "RD$ {{amount}}",
          moneyWithCurrencyFormat: "RD$ {{amount}}",
        },
        DZD: {
          moneyFormat: "DA {{amount}}",
          moneyWithCurrencyFormat: "DA {{amount}} DZD",
        },
        EGP: {
          moneyFormat: "LE {{amount}}",
          moneyWithCurrencyFormat: "LE {{amount}} EGP",
        },
        ETB: {
          moneyFormat: "Br{{amount}}",
          moneyWithCurrencyFormat: "Br{{amount}} ETB",
        },
        EUR: {
          moneyFormat: "€{{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "€{{amount_with_comma_separator}} EUR",
        },
        FJD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "FJ${{amount}}",
        },
        FKP: {
          moneyFormat: "£{{amount}}",
          moneyWithCurrencyFormat: "£{{amount}} FKP",
        },
        GBP: {
          moneyFormat: "£{{amount}}",
          moneyWithCurrencyFormat: "£{{amount}} GBP",
        },
        GEL: {
          moneyFormat: "{{amount}} GEL",
          moneyWithCurrencyFormat: "{{amount}} GEL",
        },
        GIP: {
          moneyFormat: "£{{amount}}",
          moneyWithCurrencyFormat: "£{{amount}} GIP",
        },
        GMD: {
          moneyFormat: "D {{amount}}",
          moneyWithCurrencyFormat: "D {{amount}} GMD",
        },
        GNF: {
          moneyFormat: "FG {{amount_no_decimals}}",
          moneyWithCurrencyFormat: "FG {{amount_no_decimals}} GNF",
        },
        GTQ: {
          moneyFormat: "Q{{amount}}",
          moneyWithCurrencyFormat: "{{amount}} GTQ",
        },
        GYD: {
          moneyFormat: "G${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} GYD",
        },
        HKD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "HK${{amount}}",
        },
        HNL: {
          moneyFormat: "L {{amount}}",
          moneyWithCurrencyFormat: "L {{amount}} HNL",
        },
        HRK: {
          moneyFormat: "{{amount_with_comma_separator}} kn",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} kn HRK",
        },
        HTG: {
          moneyFormat: "G {{amount}}",
          moneyWithCurrencyFormat: "{{amount}} HTG",
        },
        HUF: {
          moneyFormat: "{{amount_no_decimals_with_comma_separator}}",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_comma_separator}} Ft",
        },
        IDR: {
          moneyFormat: "Rp {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "Rp {{amount_with_comma_separator}} IDR",
        },
        ILS: {
          moneyFormat: "{{amount}} NIS",
          moneyWithCurrencyFormat: "{{amount}} NIS",
        },
        INR: {
          moneyFormat: "Rs. {{amount}}",
          moneyWithCurrencyFormat: "Rs. {{amount}}",
        },
        ISK: {
          moneyFormat: "{{amount_no_decimals_with_comma_separator}} kr",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_comma_separator}} ISK",
        },
        JMD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} JMD",
        },
        JPY: {
          moneyFormat: "¥{{amount_no_decimals}}",
          moneyWithCurrencyFormat: "¥{{amount_no_decimals}} JPY",
        },
        KES: {
          moneyFormat: "KSh{{amount}}",
          moneyWithCurrencyFormat: "KSh{{amount}}",
        },
        KGS: {
          moneyFormat: "лв{{amount}}",
          moneyWithCurrencyFormat: "лв{{amount}}",
        },
        KHR: {
          moneyFormat: "KHR{{amount}}",
          moneyWithCurrencyFormat: "KHR{{amount}}",
        },
        KMF: {
          moneyFormat: "{{amount_no_decimals_with_comma_separator}} CF",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_comma_separator}} CF",
        },
        KRW: {
          moneyFormat: "₩{{amount_no_decimals}}",
          moneyWithCurrencyFormat: "₩{{amount_no_decimals}} KRW",
        },
        KYD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} KYD",
        },
        KZT: {
          moneyFormat: "{{amount}} KZT",
          moneyWithCurrencyFormat: "{{amount}} KZT",
        },
        LAK: {
          moneyFormat: "₭{{amount}}",
          moneyWithCurrencyFormat: "₭{{amount}} LAK",
        },
        LBP: {
          moneyFormat: "L£{{amount}}",
          moneyWithCurrencyFormat: "L£{{amount}} LBP",
        },
        LKR: {
          moneyFormat: "Rs {{amount}}",
          moneyWithCurrencyFormat: "Rs {{amount}} LKR",
        },
        LRD: {
          moneyFormat: "L${{amount}}",
          moneyWithCurrencyFormat: "L${{amount}} LRD",
        },
        LSL: {
          moneyFormat: "M{{amount}}",
          moneyWithCurrencyFormat: "M{{amount}} LSL",
        },
        MAD: {
          moneyFormat: "{{amount}} dh",
          moneyWithCurrencyFormat: "Dh {{amount}} MAD",
        },
        MDL: {
          moneyFormat: "{{amount}} MDL",
          moneyWithCurrencyFormat: "{{amount}} MDL",
        },
        MKD: {
          moneyFormat: "ден {{amount}}",
          moneyWithCurrencyFormat: "ден {{amount}} MKD",
        },
        MMK: {
          moneyFormat: "K{{amount}}",
          moneyWithCurrencyFormat: "K{{amount}} MMK",
        },
        MNT: {
          moneyFormat: "{{amount_no_decimals}} ₮",
          moneyWithCurrencyFormat: "{{amount_no_decimals}} MNT",
        },
        MOP: {
          moneyFormat: "MOP${{amount}}",
          moneyWithCurrencyFormat: "MOP${{amount}}",
        },
        MUR: {
          moneyFormat: "Rs {{amount}}",
          moneyWithCurrencyFormat: "Rs {{amount}} MUR",
        },
        MVR: {
          moneyFormat: "Rf{{amount}}",
          moneyWithCurrencyFormat: "Rf{{amount}} MRf",
        },
        MWK: {
          moneyFormat: "Mk{{amount}}",
          moneyWithCurrencyFormat: "Mk{{amount}} MWK",
        },
        MXN: {
          moneyFormat: "$ {{amount}}",
          moneyWithCurrencyFormat: "$ {{amount}} MXN",
        },
        MYR: {
          moneyFormat: "RM{{amount}} MYR",
          moneyWithCurrencyFormat: "RM{{amount}} MYR",
        },
        MZN: {
          moneyFormat: "{{amount}} Mt",
          moneyWithCurrencyFormat: "Mt {{amount}} MZN",
        },
        NAD: {
          moneyFormat: "N${{amount}}",
          moneyWithCurrencyFormat: "N${{amount}} NAD",
        },
        NGN: {
          moneyFormat: "₦{{amount}}",
          moneyWithCurrencyFormat: "₦{{amount}} NGN",
        },
        NIO: {
          moneyFormat: "C${{amount}}",
          moneyWithCurrencyFormat: "C${{amount}} NIO",
        },
        NOK: {
          moneyFormat: "{{amount_with_comma_separator}} kr",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} NOK",
        },
        NPR: {
          moneyFormat: "Rs{{amount}}",
          moneyWithCurrencyFormat: "Rs{{amount}} NPR",
        },
        NZD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} NZD",
        },
        PAB: {
          moneyFormat: "B/. {{amount}}",
          moneyWithCurrencyFormat: "B/. {{amount}} PAB",
        },
        PEN: {
          moneyFormat: "S/. {{amount}}",
          moneyWithCurrencyFormat: "S/. {{amount}} PEN",
        },
        PGK: {
          moneyFormat: "K {{amount}}",
          moneyWithCurrencyFormat: "K {{amount}} PGK",
        },
        PHP: {
          moneyFormat: "₱{{amount}}",
          moneyWithCurrencyFormat: "₱{{amount}} PHP",
        },
        PKR: {
          moneyFormat: "Rs.{{amount}}",
          moneyWithCurrencyFormat: "Rs.{{amount}} PKR",
        },
        PLN: {
          moneyFormat: "{{amount_with_comma_separator}} zl",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} zl PLN",
        },
        PYG: {
          moneyFormat: "Gs. {{amount_no_decimals_with_comma_separator}}",
          moneyWithCurrencyFormat:
            "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
        },
        QAR: {
          moneyFormat: "QAR {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "QAR {{amount_with_comma_separator}}",
        },
        RON: {
          moneyFormat: "{{amount_with_comma_separator}} lei",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} lei RON",
        },
        RSD: {
          moneyFormat: "{{amount}} RSD",
          moneyWithCurrencyFormat: "{{amount}} RSD",
        },
        RUB: {
          moneyFormat: "руб{{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "руб{{amount_with_comma_separator}} RUB",
        },
        RWF: {
          moneyFormat: "{{amount_no_decimals}} RF",
          moneyWithCurrencyFormat: "{{amount_no_decimals}} RWF",
        },
        SAR: {
          moneyFormat: "{{amount}} SR",
          moneyWithCurrencyFormat: "{{amount}} SAR",
        },
        SBD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} SBD",
        },
        SCR: {
          moneyFormat: "Rs {{amount}}",
          moneyWithCurrencyFormat: "Rs {{amount}} SCR",
        },
        SEK: {
          moneyFormat: "{{amount_no_decimals_with_space_separator}} kr",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_space_separator}} SEK",
        },
        SGD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} SGD",
        },
        SHP: {
          moneyFormat: "£{{amount}}",
          moneyWithCurrencyFormat: "£{{amount}} SHP",
        },
        SLL: {
          moneyFormat: "Le {{amount}}",
          moneyWithCurrencyFormat: "Le {{amount}} SLL",
        },
        SRD: {
          moneyFormat: "SRD {{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "SRD {{amount_with_comma_separator}}",
        },
        STD: {
          moneyFormat: "Db {{amount}}",
          moneyWithCurrencyFormat: "Db {{amount}} STD",
        },
        SZL: {
          moneyFormat: "L {{amount}}",
          moneyWithCurrencyFormat: "L {{amount}} SZL",
        },
        THB: {
          moneyFormat: "{{amount}} ฿",
          moneyWithCurrencyFormat: "{{amount}} ฿ THB",
        },
        TJS: {
          moneyFormat: "TJS {{amount}}",
          moneyWithCurrencyFormat: "TJS {{amount}}",
        },
        TOP: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} TOP",
        },
        TRY: {
          moneyFormat: "{{amount}}TL",
          moneyWithCurrencyFormat: "{{amount}}TL",
        },
        TTD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} TTD",
        },
        TWD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} TWD",
        },
        TZS: {
          moneyFormat: "{{amount}} TZS",
          moneyWithCurrencyFormat: "{{amount}} TZS",
        },
        UAH: {
          moneyFormat: "₴{{amount}}",
          moneyWithCurrencyFormat: "₴{{amount}} UAH",
        },
        UGX: {
          moneyFormat: "Ush {{amount_no_decimals}}",
          moneyWithCurrencyFormat: "Ush {{amount_no_decimals}} UGX",
        },
        USD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "${{amount}} USD",
        },
        UYU: {
          moneyFormat: "${{amount_with_comma_separator}}",
          moneyWithCurrencyFormat: "${{amount_with_comma_separator}} UYU",
        },
        UZS: {
          moneyFormat: "{{amount_no_decimals_with_space_separator}} som",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_space_separator}} UZS",
        },
        VND: {
          moneyFormat: "{{amount_no_decimals_with_comma_separator}}₫",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_comma_separator}} VND",
        },
        VUV: {
          moneyFormat: "${{amount_no_decimals}}",
          moneyWithCurrencyFormat: "${{amount_no_decimals}}VT",
        },
        WST: {
          moneyFormat: "WS$ {{amount}}",
          moneyWithCurrencyFormat: "WS$ {{amount}} WST",
        },
        XAF: {
          moneyFormat: "FCFA{{amount_no_decimals}}",
          moneyWithCurrencyFormat: "FCFA{{amount_no_decimals}} XAF",
        },
        XCD: {
          moneyFormat: "${{amount}}",
          moneyWithCurrencyFormat: "EC${{amount}}",
        },
        XOF: {
          moneyFormat: "CFA{{amount_no_decimals}}",
          moneyWithCurrencyFormat: "CFA{{amount_no_decimals}} XOF",
        },
        XPF: {
          moneyFormat: "{{amount_no_decimals_with_space_separator}} XPF",
          moneyWithCurrencyFormat:
            "{{amount_no_decimals_with_space_separator}} XPF",
        },
        YER: {
          moneyFormat: "{{amount_with_comma_separator}} YER",
          moneyWithCurrencyFormat: "{{amount_with_comma_separator}} YER",
        },
        ZAR: {
          moneyFormat: "R {{amount}}",
          moneyWithCurrencyFormat: "R {{amount}} ZAR",
        },
        ZMW: {
          moneyFormat: "K{{amount_no_decimals_with_comma_separator}}",
          moneyWithCurrencyFormat:
            "ZMW{{amount_no_decimals_with_comma_separator}}",
        },
      };
      return (
        (r.moneyFormat = function (t) {
          return r._isSupported(t)
            ? n[t].moneyFormat
            : (e.log(
                "Presentment currency " +
                  t +
                  " not found. Using the failsafe money format"
              ),
              r._failsafeMoneyFormat(t));
        }),
        (r.moneyWithCurrencyFormat = function (t) {
          return r._isSupported(t)
            ? n[t].moneyWithCurrencyFormat
            : (e.log(
                "Presentment currency " +
                  t +
                  " not found. Using the failsafe money format"
              ),
              r._failsafeMoneyFormat(t));
        }),
        (r._isSupported = function (e) {
          return t.isNotEmpty(e) && void 0 !== n[e];
        }),
        (r._failsafeMoneyFormat = function (t) {
          return "{{amount}} " + t;
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/MoneyFormatResolver",
    [
      "core/util/price/PresentmentPriceFormat",
      "core/util/StringUtil",
      "lib/jquery-private",
    ],
    function (t, e, r) {
      function n(t) {
        this.shopMoneyFormat = t;
      }
      return (
        (n.resolveMoneyFormat = function (t) {
          return new n(t);
        }),
        (n.prototype = {
          orMoneyWithCurrencyFormat: function (t, e) {
            return (
              (this.shopMoneyWithCurrencyFormat = t),
              (this.showPriceCurrency = e),
              this
            );
          },
          inMarket: function (t) {
            return (this.market = t), this._resolveMoneyFormat();
          },
          _resolveMoneyFormat: function () {
            return this._formatUsingShopCurrency()
              ? this._resolveShopMoneyFormat()
              : this._resolvePresentmentMoneyFormat();
          },
          _formatUsingShopCurrency: function () {
            return !(
              !this.market.isDefaultMarket() && !this.market.isTwinMarket()
            );
          },
          _resolveShopMoneyFormat: function () {
            return this.showPriceCurrency
              ? this._plainMoneyFormat(this.shopMoneyWithCurrencyFormat)
              : this._plainMoneyFormat(this.shopMoneyFormat);
          },
          _resolvePresentmentMoneyFormat: function () {
            return this.showPriceCurrency
              ? t.moneyWithCurrencyFormat(this.market.currency())
              : t.moneyFormat(this.market.currency());
          },
          _plainMoneyFormat: function (t) {
            return r("<p></p>").html(t).text();
          },
        }),
        n
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/PresentmentPriceFormatter",
    [
      "core/util/price/AmountFormatterFactory",
      "core/util/price/SuperscriptAmountFormatter",
      "core/util/price/MoneyFormatResolver",
      "core/util/price/Decimals",
      "core/util/Logger",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o) {
      function a(t) {
        (this.market = t.market),
          (this.shopMoneyFormat = t.priceFormat),
          (this.shopMoneyWithCurrencyFormat = t.priceFormatWithCurrency),
          (this.showPriceCurrency = t.showPriceCurrency),
          (this.useSuperscriptDecimals = t.useSuperscriptDecimals);
      }
      return (
        (a.prototype = {
          formattedPrice: function (t) {
            var e = this._resolveMoneyFormat(),
              r = this._formatPrice(t, e);
            return this._htmlPrice(r);
          },
          _resolveMoneyFormat: function () {
            return r
              .resolveMoneyFormat(this.shopMoneyFormat)
              .orMoneyWithCurrencyFormat(
                this.shopMoneyWithCurrencyFormat,
                this.showPriceCurrency
              )
              .inMarket(this.market);
          },
          _formatPrice: function (r, n) {
            var i = t.formatterForPriceFormat(n),
              o = i.formatInCurrency(r, n, this.market.currency());
            if (this.useSuperscriptDecimals) {
              o = new e(i).formatWithSuperscriptDecimals(o);
            }
            return o;
          },
          _htmlPrice: function (t) {
            var e = o("<span></span>");
            return (
              e.addClass("money"),
              e.css({
                color: "inherit",
                "font-weight": "inherit",
                "font-size": "inherit",
                "text-decoration": "inherit",
                "white-space": "nowrap",
              }),
              e.html(t),
              e
            );
          },
        }),
        a
      );
    }
  ),
  codeblackbelt.define(
    "core/util/price/PriceFormatterPreferences",
    [],
    function () {
      function t(t, e) {
        (this.market = e),
          (this.priceFormat = t.money_format),
          (this.priceFormatWithCurrency = t.money_with_currency_format),
          (this.showPriceCurrency = t.show_price_with_currency),
          (this.useSuperscriptDecimals = t.use_superscript_decimals);
      }
      return (
        (t.from = function (e, r) {
          return new t(e, r);
        }),
        (t.prototype = {}),
        t
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/FrequentlyBoughtPreferences",
    [
      "core/frequently-bought/TitlePreferences",
      "core/frequently-bought/discount/DiscountPreferences",
      "core/frequently-bought/discount/DiscountMessagePreferences",
      "core/frequently-bought/discount/DiscountAppliedMessagePreferences",
      "core/frequently-bought/discount/DiscountFactory",
      "core/frequently-bought/TotalPricePreferences",
      "core/frequently-bought/AddToCartButtonPreferences",
      "core/frequently-bought/BoxPreferences",
      "core/frequently-bought/ProductPreferences",
      "core/frequently-bought/SelectorPreferences",
      "core/util/Market",
      "core/util/price/PresentmentPriceFormatter",
      "core/util/price/PriceFormatterPreferences",
      "core/util/StringUtil",
      "core/util/Objects",
    ],
    function (t, e, r, n, i, o, a, c, s, u, l, d, f, h, p) {
      function m(h) {
        (this.customCss = h.custom_css), (this.customJs = h.custom_js);
        var p = h.preferences[0];
        (this.theme = p.theme),
          (this.currentProduct = p.product),
          (this.recommendations = p.products),
          (this.isTrackingEnabled = p.enable_tracking),
          (this.isFacebookPixelEnabled = p.enable_facebook_pixel),
          (this.dontRedirectPolicy = "DO_NOT_REDIRECT" === p.redirect_policy),
          (this.themeDefaultPolicy = "THEME_DEFAULT" === p.redirect_policy),
          (this.redirectToCheckoutPolicy =
            "REDIRECT_TO_CHECKOUT" === p.redirect_policy),
          (this.redirectToCartPagePolicy =
            "REDIRECT_TO_CART_PAGE" === p.redirect_policy),
          (this.offerDiscount = p.offer_discount),
          (this.showRating = p.show_rating),
          (this.discountMessage = p.discount_message),
          (this.market = l.from(p)),
          (this.discountPreferences = e.from(p, this.market)),
          (this.discount = i.discount(this.market, this.discountPreferences)),
          (this.titlePreferences = t.from(p)),
          (this.discountMessagePreferences = r.from(p)),
          (this.discountAppliedMessagePreferences = n.from(p)),
          (this.totalPricePreferences = o.from(p)),
          (this.addToCartButtonPreferences = a.from(p)),
          (this.boxPreferences = c.from(p)),
          (this.productPreferences = s.from(p)),
          (this.selectorPreferences = u.from(p, this.market)),
          (this.priceFormatter = new d(f.from(p, this.market)));
      }
      return (
        (m.prototype = {
          isMainProductAvailable: function () {
            return p.nonNull(this.currentProduct);
          },
          numberOfBundleProducts: function () {
            return this.isMainProductAvailable()
              ? this._numberOfRecommendations() + 1
              : this._numberOfRecommendations();
          },
          notEmptyRecommendations: function () {
            return this._numberOfRecommendations() > 0;
          },
          notEmptyDiscountMessage: function () {
            return h.isNotEmpty(this.discountMessage);
          },
          _numberOfRecommendations: function () {
            return p.nonNull(this.recommendations)
              ? this.recommendations.length
              : 0;
          },
        }),
        m
      );
    }
  ),
  codeblackbelt.define(
    "core/util/PreferencesLoader",
    [
      "core/util/ShopifyUtil",
      "core/util/UrlUtil",
      "core/util/DomainUtil",
      "core/util/AjaxGet",
      "core/util/Logger",
      "core/util/dom/Watcher",
      "lib/jquery-private",
    ],
    function (t, e, r, n, i, o, a) {
      function c(t) {
        this.appId = t;
      }
      return (
        (c.prototype = {
          load: function (t, e) {
            this.loadWhen(!0, t, e);
          },
          loadWhen: function (e, r, n) {
            if (e) {
              var a = this;
              o.checkIf(t.isShopPresent)
                .nowAndEvery(10)
                .during(1e4)
                .then(function () {
                  a._load(r, n);
                })
                .otherwise(function () {
                  i.log(
                    "The Shopify domain was not found. Preferences load aborted."
                  );
                })
                .watch();
            }
          },
          _load: function (e, o) {
            var c = r.baseUrl() + "/json/preferences/" + this.appId + ".json",
              s = o || {};
            a.extend(s, {
              shop: t.getShop(),
              marketCountry: t.getCountry(),
              marketCurrency: t.getPresentmentCurrency(),
              path: location.pathname,
              version: this._versionString(),
            }),
              n.jsonGet(
                c,
                s,
                function (t) {
                  t.error || e(t);
                },
                function (t) {
                  var e = t.responseJSON.status + " " + t.responseJSON.message;
                  i.log("Could not load preferences: " + e);
                }
              );
          },
          _versionString: function () {
            return new Date().toISOString().slice(0, 16).replace(/[-:T]/g, "");
          },
        }),
        c
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ShopifyProductUtil",
    ["lib/jquery-private"],
    function (t) {
      function e() {}
      var r = [
        "#ProductJson-product-template",
        "script[data-product-json]",
        'script[id*="ProductJson-product_"]:last',
      ];
      return (
        (e.productId = function () {
          var n = e._getIdFromTurbo();
          if (null !== n) return n;
          var i = e._getIdFromTurbo4();
          if (null !== i) return i;
          var o = window.__st;
          if (o && t.isNumeric(o.rid)) return o.rid;
          for (var a = 0; a < r.length; a++) {
            var c = e._getIdFromJson(r[a]);
            if (null !== c) return c;
          }
          return null;
        }),
        (e._getIdFromJson = function (e) {
          try {
            var r = t(e);
            if (r && r.length > 0) {
              var n = JSON.parse(r.text());
              if (t.isNumeric(n.id)) return n.id;
            }
          } catch (t) {
            return null;
          }
        }),
        (e._getIdFromTurbo = function () {
          try {
            var e = window.Shopify ? window.Shopify.theme.name : "";
            if (-1 === e.indexOf("Turbo") && -1 === e.indexOf("turbo"))
              return null;
            var r = t(".rv-product:eq(0)").attr("class"),
              n = /.*product\-(\d*)\D*/.exec(r)[1];
            return t.isNumeric(n) ? n : null;
          } catch (t) {
            return null;
          }
        }),
        (e._getIdFromTurbo4 = function () {
          try {
            var e = window.Shopify ? window.Shopify.theme.name : "";
            if (-1 === e.indexOf("Turbo") && -1 === e.indexOf("turbo"))
              return null;
            var r = t(".product_form:eq(0)");
            if (0 === r.length) return null;
            var n = r.attr("data-product-id");
            return t.isNumeric(n) ? n : null;
          } catch (t) {
            return null;
          }
        }),
        (e.prototype = {}),
        e
      );
    }
  ),
  codeblackbelt.define("core/util/ThankYouPageChecker", [], function () {
    function t() {}
    return (
      (t.isThankYouPage = function () {
        return window.Shopify && window.Shopify.checkout;
      }),
      (t.prototype = {}),
      t
    );
  }),
  codeblackbelt.define("core/util/CartLineItem", [], function () {
    function t(t, e) {
      (this.id = t), (this.quantity = e);
    }
    return (
      (t.parseCartLineItems = function (e) {
        for (var r = [], n = 0; n < e.length; n++) {
          var i = e[n],
            o = new t(i.product_id, i.quantity);
          r.push(o);
        }
        return r;
      }),
      (t.prototype = {
        getId: function () {
          return this.id;
        },
        getQuantity: function () {
          return this.quantity;
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/CartStatUtil",
    [
      "core/util/ShopifyCart",
      "core/util/StatUtil",
      "core/util/UrlUtil",
      "core/util/ThankYouPageChecker",
      "core/util/CartLineItem",
    ],
    function (t, e, r, n, i) {
      function o() {}
      return (
        (o.checkCart = function (t) {
          if (!n.isThankYouPage()) {
            var e = r.isCartPage() ? 1e3 : 1e4,
              i = this;
            setTimeout(function () {
              i._checkCart(t);
            }, e);
          }
        }),
        (o._checkCart = function (r) {
          t.getCart(function (t) {
            var n = o._products(t);
            e.checkCartProducts(r, n);
          });
        }),
        (o._products = function (t) {
          return i.parseCartLineItems(t.items);
        }),
        (o.prototype = {}),
        o
      );
    }
  ),
  codeblackbelt.define(
    "core/util/ApiUtil",
    ["core/util/dom/Watcher", "core/util/EventUtil"],
    function (t, e) {
      function r() {}
      return (
        (r.watch = function (e, r) {
          var n = null;
          t.checkIf(function () {
            return null !== (n = document.querySelector(e));
          })
            .nowAndEvery(100)
            .during(6e4)
            .then(function () {
              r(n);
            })
            .watch();
        }),
        (r.on = function (t, r, n) {
          for (
            var i = document.querySelectorAll(r), o = t.split(" "), a = 0;
            a < o.length;
            a++
          ) {
            var c = o[a];
            e.addEventToAll(i, c, n);
          }
        }),
        (r.prototype = {}),
        r
      );
    }
  ),
  codeblackbelt.define(
    "core/frequently-bought/FrequentlyBoughtTogetherApi",
    [
      "core/util/GlobalProperties",
      "core/frequently-bought/variant/ThisItemVariantSelector",
      "core/util/Logger",
      "core/util/ApiUtil",
    ],
    function (t, e, r, n) {
      function i(t) {
        (this.loadProductRecommendationsCallback = t),
          (this.flag = o + "Loaded");
      }
      var o = "frequently-bought-together";
      return (
        (i.prototype = {
          enableDebug: function () {
            r.enableDebug();
          },
          disableDebug: function () {
            r.disableDebug();
          },
          loadProductRecommendations: function (e) {
            r.debug(
              "Loading Frequently Bought Together product recommendations for product with id " +
                e
            ),
              t.setProperty(this.flag, !1),
              this.loadProductRecommendationsCallback(e);
          },
          selectThisItemVariant: function (t) {
            e.selectVariant(t);
          },
          watch: function (t, e) {
            n.watch(t, e);
          },
          on: function (t, e, r) {
            n.on(t, e, r);
          },
        }),
        i
      );
    }
  ),
  codeblackbelt.define("core/util/CheckoutLineItem", [], function () {
    function t(t, e, r) {
      (this.id = t), (this.price = e), (this.quantity = r);
    }
    return (
      (t.parseCheckoutLineItems = function (e) {
        for (var r = [], n = 0; n < e.length; n++) {
          var i = e[n],
            o = new t(i.product_id, i.price, i.quantity);
          r.push(o);
        }
        return r;
      }),
      (t.prototype = {
        getId: function () {
          return this.id;
        },
        getPrice: function () {
          return Number(this.price);
        },
        getQuantity: function () {
          return this.quantity;
        },
      }),
      t
    );
  }),
  codeblackbelt.define(
    "core/util/ThankYouPageStatUtil",
    [
      "core/util/StatUtil",
      "core/util/CheckoutLineItem",
      "core/util/LocalStorage",
    ],
    function (t, e, r) {
      function n() {}
      return (
        (n.checkCart = function (e) {
          if (!n._emptyProducts()) {
            var r = n._orderKey(e);
            if (!n._cartAlreadyProcessed(r)) {
              var i = n._purchasedProducts();
              t.checkThankYouProducts(e, i, function () {
                n._markCartAsProcessed(r);
              });
            }
          }
        }),
        (n._cartAlreadyProcessed = function (t) {
          return r.hasItem(t);
        }),
        (n._markCartAsProcessed = function (t) {
          r.setItem(t, !0);
        }),
        (n._orderKey = function (t) {
          return (
            "cbb-thank-you-page-id-" +
            t +
            "-" +
            window.Shopify.checkout.order_id
          );
        }),
        (n._purchasedProducts = function () {
          return e.parseCheckoutLineItems(window.Shopify.checkout.line_items);
        }),
        (n._emptyProducts = function () {
          return !n._notEmptyProducts();
        }),
        (n._notEmptyProducts = function () {
          return (
            window.Shopify &&
            window.Shopify.checkout &&
            window.Shopify.checkout.line_items &&
            window.Shopify.checkout.line_items.length > 0
          );
        }),
        (n.prototype = {}),
        n
      );
    }
  ),
  codeblackbelt.requirejs.config({
    baseUrl: "../js",
    deps: ["lib/ie8-object-create"],
  }),
  codeblackbelt.require(
    [
      "core/util/AppLoadedChecker",
      "core/frequently-bought/FrequentlyBought",
      "core/frequently-bought/FrequentlyBoughtPreferences",
      "core/util/PreferencesLoader",
      "core/util/UrlUtil",
      "core/util/ShopifyUtil",
      "core/util/ShopifyProductUtil",
      "core/util/CartStatUtil",
      "core/util/GlobalProperties",
      "core/frequently-bought/FrequentlyBoughtTogetherApi",
      "core/util/ThankYouPageStatUtil",
      "core/util/Objects",
      "core/util/Logger",
    ],
    function (t, e, r, n, i, o, a, c, s, u, l, d, f) {
      function h(t, o) {
        var a = p(t);
        new n(y).load(function (t) {
          var n = i.isProductPage() || i.isDemoPage() || o,
            a = new r(t);
          new e(a).init(n);
        }, a);
      }
      function p(t) {
        return d.nonNull(t) ? { productId: t } : {};
      }
      function m() {
        c.checkCart(y), i.isCheckoutEndPage() && l.checkCart(y);
      }
      function g() {
        var t = new u(function (t) {
          h(t, !0);
        });
        s.setProperty(b, t);
      }
      var y = "frequently-bought-together",
        b = "frequently-bought-togetherApi";
      !(function () {
        if (!t.hasLoadedBefore(y)) {
          if (o.isInsideThemeEditor())
            return void f.log(
              "Frequenlty Bought Together was not loaded because was called inside the Shopify Theme Editor"
            );
          h(a.productId(), !1), g(), m();
        }
      })();
    }
  ),
  codeblackbelt.define(
    "modules/frequently-bought-together/main.min",
    function () {}
  );

$(function () {
  /**
   * Owl Carousel v2.3.4
   * Copyright 2013-2018 David Deutsch
   * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
   */
  !(function (a, b, c, d) {
    function e(b, c) {
      (this.settings = null),
        (this.options = a.extend({}, e.Defaults, c)),
        (this.$element = a(b)),
        (this._handlers = {}),
        (this._plugins = {}),
        (this._supress = {}),
        (this._current = null),
        (this._speed = null),
        (this._coordinates = []),
        (this._breakpoint = null),
        (this._width = null),
        (this._items = []),
        (this._clones = []),
        (this._mergers = []),
        (this._widths = []),
        (this._invalidated = {}),
        (this._pipe = []),
        (this._drag = {
          time: null,
          target: null,
          pointer: null,
          stage: { start: null, current: null },
          direction: null,
        }),
        (this._states = {
          current: {},
          tags: {
            initializing: ["busy"],
            animating: ["busy"],
            dragging: ["interacting"],
          },
        }),
        a.each(
          ["onResize", "onThrottledResize"],
          a.proxy(function (b, c) {
            this._handlers[c] = a.proxy(this[c], this);
          }, this)
        ),
        a.each(
          e.Plugins,
          a.proxy(function (a, b) {
            this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
          }, this)
        ),
        a.each(
          e.Workers,
          a.proxy(function (b, c) {
            this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
          }, this)
        ),
        this.setup(),
        this.initialize();
    }
    (e.Defaults = {
      items: 3,
      loop: !1,
      center: !1,
      rewind: !1,
      checkVisibility: !0,
      mouseDrag: !0,
      touchDrag: !0,
      pullDrag: !0,
      freeDrag: !1,
      margin: 0,
      stagePadding: 0,
      merge: !1,
      mergeFit: !0,
      autoWidth: !1,
      startPosition: 0,
      rtl: !1,
      smartSpeed: 250,
      fluidSpeed: !1,
      dragEndSpeed: !1,
      responsive: {},
      responsiveRefreshRate: 200,
      responsiveBaseElement: b,
      fallbackEasing: "swing",
      slideTransition: "",
      info: !1,
      nestedItemSelector: !1,
      itemElement: "div",
      stageElement: "div",
      refreshClass: "owl-refresh",
      loadedClass: "owl-loaded",
      loadingClass: "owl-loading",
      rtlClass: "owl-rtl",
      responsiveClass: "owl-responsive",
      dragClass: "owl-drag",
      itemClass: "owl-item",
      stageClass: "owl-stage",
      stageOuterClass: "owl-stage-outer",
      grabClass: "owl-grab",
    }),
      (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
      (e.Type = { Event: "event", State: "state" }),
      (e.Plugins = {}),
      (e.Workers = [
        {
          filter: ["width", "settings"],
          run: function () {
            this._width = this.$element.width();
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (a) {
            a.current =
              this._items && this._items[this.relative(this._current)];
          },
        },
        {
          filter: ["items", "settings"],
          run: function () {
            this.$stage.children(".cloned").remove();
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (a) {
            var b = this.settings.margin || "",
              c = !this.settings.autoWidth,
              d = this.settings.rtl,
              e = {
                width: "auto",
                "margin-left": d ? b : "",
                "margin-right": d ? "" : b,
              };
            !c && this.$stage.children().css(e), (a.css = e);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (a) {
            var b =
                (this.width() / this.settings.items).toFixed(3) -
                this.settings.margin,
              c = null,
              d = this._items.length,
              e = !this.settings.autoWidth,
              f = [];
            for (a.items = { merge: !1, width: b }; d--; )
              (c = this._mergers[d]),
                (c =
                  (this.settings.mergeFit &&
                    Math.min(c, this.settings.items)) ||
                  c),
                (a.items.merge = c > 1 || a.items.merge),
                (f[d] = e ? b * c : this._items[d].width());
            this._widths = f;
          },
        },
        {
          filter: ["items", "settings"],
          run: function () {
            var b = [],
              c = this._items,
              d = this.settings,
              e = Math.max(2 * d.items, 4),
              f = 2 * Math.ceil(c.length / 2),
              g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
              h = "",
              i = "";
            for (g /= 2; g > 0; )
              b.push(this.normalize(b.length / 2, !0)),
                (h += c[b[b.length - 1]][0].outerHTML),
                b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
                (i = c[b[b.length - 1]][0].outerHTML + i),
                (g -= 1);
            (this._clones = b),
              a(h).addClass("cloned").appendTo(this.$stage),
              a(i).addClass("cloned").prependTo(this.$stage);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function () {
            for (
              var a = this.settings.rtl ? 1 : -1,
                b = this._clones.length + this._items.length,
                c = -1,
                d = 0,
                e = 0,
                f = [];
              ++c < b;

            )
              (d = f[c - 1] || 0),
                (e = this._widths[this.relative(c)] + this.settings.margin),
                f.push(d + e * a);
            this._coordinates = f;
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function () {
            var a = this.settings.stagePadding,
              b = this._coordinates,
              c = {
                width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
                "padding-left": a || "",
                "padding-right": a || "",
              };
            this.$stage.css(c);
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (a) {
            var b = this._coordinates.length,
              c = !this.settings.autoWidth,
              d = this.$stage.children();
            if (c && a.items.merge)
              for (; b--; )
                (a.css.width = this._widths[this.relative(b)]),
                  d.eq(b).css(a.css);
            else c && ((a.css.width = a.items.width), d.css(a.css));
          },
        },
        {
          filter: ["items"],
          run: function () {
            this._coordinates.length < 1 && this.$stage.removeAttr("style");
          },
        },
        {
          filter: ["width", "items", "settings"],
          run: function (a) {
            (a.current = a.current
              ? this.$stage.children().index(a.current)
              : 0),
              (a.current = Math.max(
                this.minimum(),
                Math.min(this.maximum(), a.current)
              )),
              this.reset(a.current);
          },
        },
        {
          filter: ["position"],
          run: function () {
            this.animate(this.coordinates(this._current));
          },
        },
        {
          filter: ["width", "position", "items", "settings"],
          run: function () {
            var a,
              b,
              c,
              d,
              e = this.settings.rtl ? 1 : -1,
              f = 2 * this.settings.stagePadding,
              g = this.coordinates(this.current()) + f,
              h = g + this.width() * e,
              i = [];
            for (c = 0, d = this._coordinates.length; c < d; c++)
              (a = this._coordinates[c - 1] || 0),
                (b = Math.abs(this._coordinates[c]) + f * e),
                ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                  (this.op(b, "<", g) && this.op(b, ">", h))) &&
                  i.push(c);
            this.$stage.children(".active").removeClass("active"),
              this.$stage
                .children(":eq(" + i.join("), :eq(") + ")")
                .addClass("active"),
              this.$stage.children(".center").removeClass("center"),
              this.settings.center &&
                this.$stage.children().eq(this.current()).addClass("center");
          },
        },
      ]),
      (e.prototype.initializeStage = function () {
        (this.$stage = this.$element.find("." + this.settings.stageClass)),
          this.$stage.length ||
            (this.$element.addClass(this.options.loadingClass),
            (this.$stage = a("<" + this.settings.stageElement + ">", {
              class: this.settings.stageClass,
            }).wrap(a("<div/>", { class: this.settings.stageOuterClass }))),
            this.$element.append(this.$stage.parent()));
      }),
      (e.prototype.initializeItems = function () {
        var b = this.$element.find(".owl-item");
        if (b.length)
          return (
            (this._items = b.get().map(function (b) {
              return a(b);
            })),
            (this._mergers = this._items.map(function () {
              return 1;
            })),
            void this.refresh()
          );
        this.replace(this.$element.children().not(this.$stage.parent())),
          this.isVisible() ? this.refresh() : this.invalidate("width"),
          this.$element
            .removeClass(this.options.loadingClass)
            .addClass(this.options.loadedClass);
      }),
      (e.prototype.initialize = function () {
        if (
          (this.enter("initializing"),
          this.trigger("initialize"),
          this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
          this.settings.autoWidth && !this.is("pre-loading"))
        ) {
          var a, b, c;
          (a = this.$element.find("img")),
            (b = this.settings.nestedItemSelector
              ? "." + this.settings.nestedItemSelector
              : d),
            (c = this.$element.children(b).width()),
            a.length && c <= 0 && this.preloadAutoWidthImages(a);
        }
        this.initializeStage(),
          this.initializeItems(),
          this.registerEventHandlers(),
          this.leave("initializing"),
          this.trigger("initialized");
      }),
      (e.prototype.isVisible = function () {
        return !this.settings.checkVisibility || this.$element.is(":visible");
      }),
      (e.prototype.setup = function () {
        var b = this.viewport(),
          c = this.options.responsive,
          d = -1,
          e = null;
        c
          ? (a.each(c, function (a) {
              a <= b && a > d && (d = Number(a));
            }),
            (e = a.extend({}, this.options, c[d])),
            "function" == typeof e.stagePadding &&
              (e.stagePadding = e.stagePadding()),
            delete e.responsive,
            e.responsiveClass &&
              this.$element.attr(
                "class",
                this.$element
                  .attr("class")
                  .replace(
                    new RegExp(
                      "(" + this.options.responsiveClass + "-)\\S+\\s",
                      "g"
                    ),
                    "$1" + d
                  )
              ))
          : (e = a.extend({}, this.options)),
          this.trigger("change", { property: { name: "settings", value: e } }),
          (this._breakpoint = d),
          (this.settings = e),
          this.invalidate("settings"),
          this.trigger("changed", {
            property: { name: "settings", value: this.settings },
          });
      }),
      (e.prototype.optionsLogic = function () {
        this.settings.autoWidth &&
          ((this.settings.stagePadding = !1), (this.settings.merge = !1));
      }),
      (e.prototype.prepare = function (b) {
        var c = this.trigger("prepare", { content: b });
        return (
          c.data ||
            (c.data = a("<" + this.settings.itemElement + "/>")
              .addClass(this.options.itemClass)
              .append(b)),
          this.trigger("prepared", { content: c.data }),
          c.data
        );
      }),
      (e.prototype.update = function () {
        for (
          var b = 0,
            c = this._pipe.length,
            d = a.proxy(function (a) {
              return this[a];
            }, this._invalidated),
            e = {};
          b < c;

        )
          (this._invalidated.all ||
            a.grep(this._pipe[b].filter, d).length > 0) &&
            this._pipe[b].run(e),
            b++;
        (this._invalidated = {}), !this.is("valid") && this.enter("valid");
      }),
      (e.prototype.width = function (a) {
        switch ((a = a || e.Width.Default)) {
          case e.Width.Inner:
          case e.Width.Outer:
            return this._width;
          default:
            return (
              this._width -
              2 * this.settings.stagePadding +
              this.settings.margin
            );
        }
      }),
      (e.prototype.refresh = function () {
        this.enter("refreshing"),
          this.trigger("refresh"),
          this.setup(),
          this.optionsLogic(),
          this.$element.addClass(this.options.refreshClass),
          this.update(),
          this.$element.removeClass(this.options.refreshClass),
          this.leave("refreshing"),
          this.trigger("refreshed");
      }),
      (e.prototype.onThrottledResize = function () {
        b.clearTimeout(this.resizeTimer),
          (this.resizeTimer = b.setTimeout(
            this._handlers.onResize,
            this.settings.responsiveRefreshRate
          ));
      }),
      (e.prototype.onResize = function () {
        return (
          !!this._items.length &&
          this._width !== this.$element.width() &&
          !!this.isVisible() &&
          (this.enter("resizing"),
          this.trigger("resize").isDefaultPrevented()
            ? (this.leave("resizing"), !1)
            : (this.invalidate("width"),
              this.refresh(),
              this.leave("resizing"),
              void this.trigger("resized")))
        );
      }),
      (e.prototype.registerEventHandlers = function () {
        a.support.transition &&
          this.$stage.on(
            a.support.transition.end + ".owl.core",
            a.proxy(this.onTransitionEnd, this)
          ),
          !1 !== this.settings.responsive &&
            this.on(b, "resize", this._handlers.onThrottledResize),
          this.settings.mouseDrag &&
            (this.$element.addClass(this.options.dragClass),
            this.$stage.on(
              "mousedown.owl.core",
              a.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              "dragstart.owl.core selectstart.owl.core",
              function () {
                return !1;
              }
            )),
          this.settings.touchDrag &&
            (this.$stage.on(
              "touchstart.owl.core",
              a.proxy(this.onDragStart, this)
            ),
            this.$stage.on(
              "touchcancel.owl.core",
              a.proxy(this.onDragEnd, this)
            ));
      }),
      (e.prototype.onDragStart = function (b) {
        var d = null;
        3 !== b.which &&
          (a.support.transform
            ? ((d = this.$stage
                .css("transform")
                .replace(/.*\(|\)| /g, "")
                .split(",")),
              (d = {
                x: d[16 === d.length ? 12 : 4],
                y: d[16 === d.length ? 13 : 5],
              }))
            : ((d = this.$stage.position()),
              (d = {
                x: this.settings.rtl
                  ? d.left +
                    this.$stage.width() -
                    this.width() +
                    this.settings.margin
                  : d.left,
                y: d.top,
              })),
          this.is("animating") &&
            (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
            this.invalidate("position")),
          this.$element.toggleClass(
            this.options.grabClass,
            "mousedown" === b.type
          ),
          this.speed(0),
          (this._drag.time = new Date().getTime()),
          (this._drag.target = a(b.target)),
          (this._drag.stage.start = d),
          (this._drag.stage.current = d),
          (this._drag.pointer = this.pointer(b)),
          a(c).on(
            "mouseup.owl.core touchend.owl.core",
            a.proxy(this.onDragEnd, this)
          ),
          a(c).one(
            "mousemove.owl.core touchmove.owl.core",
            a.proxy(function (b) {
              var d = this.difference(this._drag.pointer, this.pointer(b));
              a(c).on(
                "mousemove.owl.core touchmove.owl.core",
                a.proxy(this.onDragMove, this)
              ),
                (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                  (b.preventDefault(),
                  this.enter("dragging"),
                  this.trigger("drag"));
            }, this)
          ));
      }),
      (e.prototype.onDragMove = function (a) {
        var b = null,
          c = null,
          d = null,
          e = this.difference(this._drag.pointer, this.pointer(a)),
          f = this.difference(this._drag.stage.start, e);
        this.is("dragging") &&
          (a.preventDefault(),
          this.settings.loop
            ? ((b = this.coordinates(this.minimum())),
              (c = this.coordinates(this.maximum() + 1) - b),
              (f.x = ((((f.x - b) % c) + c) % c) + b))
            : ((b = this.settings.rtl
                ? this.coordinates(this.maximum())
                : this.coordinates(this.minimum())),
              (c = this.settings.rtl
                ? this.coordinates(this.minimum())
                : this.coordinates(this.maximum())),
              (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
              (f.x = Math.max(Math.min(f.x, b + d), c + d))),
          (this._drag.stage.current = f),
          this.animate(f.x));
      }),
      (e.prototype.onDragEnd = function (b) {
        var d = this.difference(this._drag.pointer, this.pointer(b)),
          e = this._drag.stage.current,
          f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
        a(c).off(".owl.core"),
          this.$element.removeClass(this.options.grabClass),
          ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
            (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
            this.current(
              this.closest(e.x, 0 !== d.x ? f : this._drag.direction)
            ),
            this.invalidate("position"),
            this.update(),
            (this._drag.direction = f),
            (Math.abs(d.x) > 3 ||
              new Date().getTime() - this._drag.time > 300) &&
              this._drag.target.one("click.owl.core", function () {
                return !1;
              })),
          this.is("dragging") &&
            (this.leave("dragging"), this.trigger("dragged"));
      }),
      (e.prototype.closest = function (b, c) {
        var e = -1,
          f = 30,
          g = this.width(),
          h = this.coordinates();
        return (
          this.settings.freeDrag ||
            a.each(
              h,
              a.proxy(function (a, i) {
                return (
                  "left" === c && b > i - f && b < i + f
                    ? (e = a)
                    : "right" === c && b > i - g - f && b < i - g + f
                    ? (e = a + 1)
                    : this.op(b, "<", i) &&
                      this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) &&
                      (e = "left" === c ? a + 1 : a),
                  -1 === e
                );
              }, this)
            ),
          this.settings.loop ||
            (this.op(b, ">", h[this.minimum()])
              ? (e = b = this.minimum())
              : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())),
          e
        );
      }),
      (e.prototype.animate = function (b) {
        var c = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(),
          c && (this.enter("animating"), this.trigger("translate")),
          a.support.transform3d && a.support.transition
            ? this.$stage.css({
                transform: "translate3d(" + b + "px,0px,0px)",
                transition:
                  this.speed() / 1e3 +
                  "s" +
                  (this.settings.slideTransition
                    ? " " + this.settings.slideTransition
                    : ""),
              })
            : c
            ? this.$stage.animate(
                { left: b + "px" },
                this.speed(),
                this.settings.fallbackEasing,
                a.proxy(this.onTransitionEnd, this)
              )
            : this.$stage.css({ left: b + "px" });
      }),
      (e.prototype.is = function (a) {
        return this._states.current[a] && this._states.current[a] > 0;
      }),
      (e.prototype.current = function (a) {
        if (a === d) return this._current;
        if (0 === this._items.length) return d;
        if (((a = this.normalize(a)), this._current !== a)) {
          var b = this.trigger("change", {
            property: { name: "position", value: a },
          });
          b.data !== d && (a = this.normalize(b.data)),
            (this._current = a),
            this.invalidate("position"),
            this.trigger("changed", {
              property: { name: "position", value: this._current },
            });
        }
        return this._current;
      }),
      (e.prototype.invalidate = function (b) {
        return (
          "string" === a.type(b) &&
            ((this._invalidated[b] = !0),
            this.is("valid") && this.leave("valid")),
          a.map(this._invalidated, function (a, b) {
            return b;
          })
        );
      }),
      (e.prototype.reset = function (a) {
        (a = this.normalize(a)) !== d &&
          ((this._speed = 0),
          (this._current = a),
          this.suppress(["translate", "translated"]),
          this.animate(this.coordinates(a)),
          this.release(["translate", "translated"]));
      }),
      (e.prototype.normalize = function (a, b) {
        var c = this._items.length,
          e = b ? 0 : this._clones.length;
        return (
          !this.isNumeric(a) || c < 1
            ? (a = d)
            : (a < 0 || a >= c + e) &&
              (a = ((((a - e / 2) % c) + c) % c) + e / 2),
          a
        );
      }),
      (e.prototype.relative = function (a) {
        return (a -= this._clones.length / 2), this.normalize(a, !0);
      }),
      (e.prototype.maximum = function (a) {
        var b,
          c,
          d,
          e = this.settings,
          f = this._coordinates.length;
        if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
        else if (e.autoWidth || e.merge) {
          if ((b = this._items.length))
            for (
              c = this._items[--b].width(), d = this.$element.width();
              b-- &&
              !((c += this._items[b].width() + this.settings.margin) > d);

            );
          f = b + 1;
        } else
          f = e.center ? this._items.length - 1 : this._items.length - e.items;
        return a && (f -= this._clones.length / 2), Math.max(f, 0);
      }),
      (e.prototype.minimum = function (a) {
        return a ? 0 : this._clones.length / 2;
      }),
      (e.prototype.items = function (a) {
        return a === d
          ? this._items.slice()
          : ((a = this.normalize(a, !0)), this._items[a]);
      }),
      (e.prototype.mergers = function (a) {
        return a === d
          ? this._mergers.slice()
          : ((a = this.normalize(a, !0)), this._mergers[a]);
      }),
      (e.prototype.clones = function (b) {
        var c = this._clones.length / 2,
          e = c + this._items.length,
          f = function (a) {
            return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2;
          };
        return b === d
          ? a.map(this._clones, function (a, b) {
              return f(b);
            })
          : a.map(this._clones, function (a, c) {
              return a === b ? f(c) : null;
            });
      }),
      (e.prototype.speed = function (a) {
        return a !== d && (this._speed = a), this._speed;
      }),
      (e.prototype.coordinates = function (b) {
        var c,
          e = 1,
          f = b - 1;
        return b === d
          ? a.map(
              this._coordinates,
              a.proxy(function (a, b) {
                return this.coordinates(b);
              }, this)
            )
          : (this.settings.center
              ? (this.settings.rtl && ((e = -1), (f = b + 1)),
                (c = this._coordinates[b]),
                (c +=
                  ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
              : (c = this._coordinates[f] || 0),
            (c = Math.ceil(c)));
      }),
      (e.prototype.duration = function (a, b, c) {
        return 0 === c
          ? 0
          : Math.min(Math.max(Math.abs(b - a), 1), 6) *
              Math.abs(c || this.settings.smartSpeed);
      }),
      (e.prototype.to = function (a, b) {
        var c = this.current(),
          d = null,
          e = a - this.relative(c),
          f = (e > 0) - (e < 0),
          g = this._items.length,
          h = this.minimum(),
          i = this.maximum();
        this.settings.loop
          ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
            (a = c + e),
            (d = ((((a - h) % g) + g) % g) + h) !== a &&
              d - e <= i &&
              d - e > 0 &&
              ((c = d - e), (a = d), this.reset(c)))
          : this.settings.rewind
          ? ((i += 1), (a = ((a % i) + i) % i))
          : (a = Math.max(h, Math.min(i, a))),
          this.speed(this.duration(c, a, b)),
          this.current(a),
          this.isVisible() && this.update();
      }),
      (e.prototype.next = function (a) {
        (a = a || !1), this.to(this.relative(this.current()) + 1, a);
      }),
      (e.prototype.prev = function (a) {
        (a = a || !1), this.to(this.relative(this.current()) - 1, a);
      }),
      (e.prototype.onTransitionEnd = function (a) {
        if (
          a !== d &&
          (a.stopPropagation(),
          (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
        )
          return !1;
        this.leave("animating"), this.trigger("translated");
      }),
      (e.prototype.viewport = function () {
        var d;
        return (
          this.options.responsiveBaseElement !== b
            ? (d = a(this.options.responsiveBaseElement).width())
            : b.innerWidth
            ? (d = b.innerWidth)
            : c.documentElement && c.documentElement.clientWidth
            ? (d = c.documentElement.clientWidth)
            : console.warn("Can not detect viewport width."),
          d
        );
      }),
      (e.prototype.replace = function (b) {
        this.$stage.empty(),
          (this._items = []),
          b && (b = b instanceof jQuery ? b : a(b)),
          this.settings.nestedItemSelector &&
            (b = b.find("." + this.settings.nestedItemSelector)),
          b
            .filter(function () {
              return 1 === this.nodeType;
            })
            .each(
              a.proxy(function (a, b) {
                (b = this.prepare(b)),
                  this.$stage.append(b),
                  this._items.push(b),
                  this._mergers.push(
                    1 *
                      b
                        .find("[data-merge]")
                        .addBack("[data-merge]")
                        .attr("data-merge") || 1
                  );
              }, this)
            ),
          this.reset(
            this.isNumeric(this.settings.startPosition)
              ? this.settings.startPosition
              : 0
          ),
          this.invalidate("items");
      }),
      (e.prototype.add = function (b, c) {
        var e = this.relative(this._current);
        (c = c === d ? this._items.length : this.normalize(c, !0)),
          (b = b instanceof jQuery ? b : a(b)),
          this.trigger("add", { content: b, position: c }),
          (b = this.prepare(b)),
          0 === this._items.length || c === this._items.length
            ? (0 === this._items.length && this.$stage.append(b),
              0 !== this._items.length && this._items[c - 1].after(b),
              this._items.push(b),
              this._mergers.push(
                1 *
                  b
                    .find("[data-merge]")
                    .addBack("[data-merge]")
                    .attr("data-merge") || 1
              ))
            : (this._items[c].before(b),
              this._items.splice(c, 0, b),
              this._mergers.splice(
                c,
                0,
                1 *
                  b
                    .find("[data-merge]")
                    .addBack("[data-merge]")
                    .attr("data-merge") || 1
              )),
          this._items[e] && this.reset(this._items[e].index()),
          this.invalidate("items"),
          this.trigger("added", { content: b, position: c });
      }),
      (e.prototype.remove = function (a) {
        (a = this.normalize(a, !0)) !== d &&
          (this.trigger("remove", { content: this._items[a], position: a }),
          this._items[a].remove(),
          this._items.splice(a, 1),
          this._mergers.splice(a, 1),
          this.invalidate("items"),
          this.trigger("removed", { content: null, position: a }));
      }),
      (e.prototype.preloadAutoWidthImages = function (b) {
        b.each(
          a.proxy(function (b, c) {
            this.enter("pre-loading"),
              (c = a(c)),
              a(new Image())
                .one(
                  "load",
                  a.proxy(function (a) {
                    c.attr("src", a.target.src),
                      c.css("opacity", 1),
                      this.leave("pre-loading"),
                      !this.is("pre-loading") &&
                        !this.is("initializing") &&
                        this.refresh();
                  }, this)
                )
                .attr(
                  "src",
                  c.attr("src") ||
                    c.attr("data-src") ||
                    c.attr("data-src-retina")
                );
          }, this)
        );
      }),
      (e.prototype.destroy = function () {
        this.$element.off(".owl.core"),
          this.$stage.off(".owl.core"),
          a(c).off(".owl.core"),
          !1 !== this.settings.responsive &&
            (b.clearTimeout(this.resizeTimer),
            this.off(b, "resize", this._handlers.onThrottledResize));
        for (var d in this._plugins) this._plugins[d].destroy();
        this.$stage.children(".cloned").remove(),
          this.$stage.unwrap(),
          this.$stage.children().contents().unwrap(),
          this.$stage.children().unwrap(),
          this.$stage.remove(),
          this.$element
            .removeClass(this.options.refreshClass)
            .removeClass(this.options.loadingClass)
            .removeClass(this.options.loadedClass)
            .removeClass(this.options.rtlClass)
            .removeClass(this.options.dragClass)
            .removeClass(this.options.grabClass)
            .attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                  ""
                )
            )
            .removeData("owl.carousel");
      }),
      (e.prototype.op = function (a, b, c) {
        var d = this.settings.rtl;
        switch (b) {
          case "<":
            return d ? a > c : a < c;
          case ">":
            return d ? a < c : a > c;
          case ">=":
            return d ? a <= c : a >= c;
          case "<=":
            return d ? a >= c : a <= c;
        }
      }),
      (e.prototype.on = function (a, b, c, d) {
        a.addEventListener
          ? a.addEventListener(b, c, d)
          : a.attachEvent && a.attachEvent("on" + b, c);
      }),
      (e.prototype.off = function (a, b, c, d) {
        a.removeEventListener
          ? a.removeEventListener(b, c, d)
          : a.detachEvent && a.detachEvent("on" + b, c);
      }),
      (e.prototype.trigger = function (b, c, d, f, g) {
        var h = { item: { count: this._items.length, index: this.current() } },
          i = a.camelCase(
            a
              .grep(["on", b, d], function (a) {
                return a;
              })
              .join("-")
              .toLowerCase()
          ),
          j = a.Event(
            [b, "owl", d || "carousel"].join(".").toLowerCase(),
            a.extend({ relatedTarget: this }, h, c)
          );
        return (
          this._supress[b] ||
            (a.each(this._plugins, function (a, b) {
              b.onTrigger && b.onTrigger(j);
            }),
            this.register({ type: e.Type.Event, name: b }),
            this.$element.trigger(j),
            this.settings &&
              "function" == typeof this.settings[i] &&
              this.settings[i].call(this, j)),
          j
        );
      }),
      (e.prototype.enter = function (b) {
        a.each(
          [b].concat(this._states.tags[b] || []),
          a.proxy(function (a, b) {
            this._states.current[b] === d && (this._states.current[b] = 0),
              this._states.current[b]++;
          }, this)
        );
      }),
      (e.prototype.leave = function (b) {
        a.each(
          [b].concat(this._states.tags[b] || []),
          a.proxy(function (a, b) {
            this._states.current[b]--;
          }, this)
        );
      }),
      (e.prototype.register = function (b) {
        if (b.type === e.Type.Event) {
          if (
            (a.event.special[b.name] || (a.event.special[b.name] = {}),
            !a.event.special[b.name].owl)
          ) {
            var c = a.event.special[b.name]._default;
            (a.event.special[b.name]._default = function (a) {
              return !c ||
                !c.apply ||
                (a.namespace && -1 !== a.namespace.indexOf("owl"))
                ? a.namespace && a.namespace.indexOf("owl") > -1
                : c.apply(this, arguments);
            }),
              (a.event.special[b.name].owl = !0);
          }
        } else
          b.type === e.Type.State &&
            (this._states.tags[b.name]
              ? (this._states.tags[b.name] = this._states.tags[b.name].concat(
                  b.tags
                ))
              : (this._states.tags[b.name] = b.tags),
            (this._states.tags[b.name] = a.grep(
              this._states.tags[b.name],
              a.proxy(function (c, d) {
                return a.inArray(c, this._states.tags[b.name]) === d;
              }, this)
            )));
      }),
      (e.prototype.suppress = function (b) {
        a.each(
          b,
          a.proxy(function (a, b) {
            this._supress[b] = !0;
          }, this)
        );
      }),
      (e.prototype.release = function (b) {
        a.each(
          b,
          a.proxy(function (a, b) {
            delete this._supress[b];
          }, this)
        );
      }),
      (e.prototype.pointer = function (a) {
        var c = { x: null, y: null };
        return (
          (a = a.originalEvent || a || b.event),
          (a =
            a.touches && a.touches.length
              ? a.touches[0]
              : a.changedTouches && a.changedTouches.length
              ? a.changedTouches[0]
              : a),
          a.pageX
            ? ((c.x = a.pageX), (c.y = a.pageY))
            : ((c.x = a.clientX), (c.y = a.clientY)),
          c
        );
      }),
      (e.prototype.isNumeric = function (a) {
        return !isNaN(parseFloat(a));
      }),
      (e.prototype.difference = function (a, b) {
        return { x: a.x - b.x, y: a.y - b.y };
      }),
      (a.fn.owlCarousel = function (b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return this.each(function () {
          var d = a(this),
            f = d.data("owl.carousel");
          f ||
            ((f = new e(this, "object" == typeof b && b)),
            d.data("owl.carousel", f),
            a.each(
              [
                "next",
                "prev",
                "to",
                "destroy",
                "refresh",
                "replace",
                "add",
                "remove",
              ],
              function (b, c) {
                f.register({ type: e.Type.Event, name: c }),
                  f.$element.on(
                    c + ".owl.carousel.core",
                    a.proxy(function (a) {
                      a.namespace &&
                        a.relatedTarget !== this &&
                        (this.suppress([c]),
                        f[c].apply(this, [].slice.call(arguments, 1)),
                        this.release([c]));
                    }, f)
                  );
              }
            )),
            "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
        });
      }),
      (a.fn.owlCarousel.Constructor = e);
  })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._interval = null),
          (this._visible = null),
          (this._handlers = {
            "initialized.owl.carousel": a.proxy(function (a) {
              a.namespace && this._core.settings.autoRefresh && this.watch();
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers);
      };
      (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
        (e.prototype.watch = function () {
          this._interval ||
            ((this._visible = this._core.isVisible()),
            (this._interval = b.setInterval(
              a.proxy(this.refresh, this),
              this._core.settings.autoRefreshInterval
            )));
        }),
        (e.prototype.refresh = function () {
          this._core.isVisible() !== this._visible &&
            ((this._visible = !this._visible),
            this._core.$element.toggleClass("owl-hidden", !this._visible),
            this._visible &&
              this._core.invalidate("width") &&
              this._core.refresh());
        }),
        (e.prototype.destroy = function () {
          var a, c;
          b.clearInterval(this._interval);
          for (a in this._handlers)
            this._core.$element.off(a, this._handlers[a]);
          for (c in Object.getOwnPropertyNames(this))
            "function" != typeof this[c] && (this[c] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._loaded = []),
          (this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
              a.proxy(function (b) {
                if (
                  b.namespace &&
                  this._core.settings &&
                  this._core.settings.lazyLoad &&
                  ((b.property && "position" == b.property.name) ||
                    "initialized" == b.type)
                ) {
                  var c = this._core.settings,
                    e = (c.center && Math.ceil(c.items / 2)) || c.items,
                    f = (c.center && -1 * e) || 0,
                    g =
                      (b.property && b.property.value !== d
                        ? b.property.value
                        : this._core.current()) + f,
                    h = this._core.clones().length,
                    i = a.proxy(function (a, b) {
                      this.load(b);
                    }, this);
                  for (
                    c.lazyLoadEager > 0 &&
                    ((e += c.lazyLoadEager),
                    c.loop && ((g -= c.lazyLoadEager), e++));
                    f++ < e;

                  )
                    this.load(h / 2 + this._core.relative(g)),
                      h && a.each(this._core.clones(this._core.relative(g)), i),
                      g++;
                }
              }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers);
      };
      (e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }),
        (e.prototype.load = function (c) {
          var d = this._core.$stage.children().eq(c),
            e = d && d.find(".owl-lazy");
          !e ||
            a.inArray(d.get(0), this._loaded) > -1 ||
            (e.each(
              a.proxy(function (c, d) {
                var e,
                  f = a(d),
                  g =
                    (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                    f.attr("data-src") ||
                    f.attr("data-srcset");
                this._core.trigger("load", { element: f, url: g }, "lazy"),
                  f.is("img")
                    ? f
                        .one(
                          "load.owl.lazy",
                          a.proxy(function () {
                            f.css("opacity", 1),
                              this._core.trigger(
                                "loaded",
                                { element: f, url: g },
                                "lazy"
                              );
                          }, this)
                        )
                        .attr("src", g)
                    : f.is("source")
                    ? f
                        .one(
                          "load.owl.lazy",
                          a.proxy(function () {
                            this._core.trigger(
                              "loaded",
                              { element: f, url: g },
                              "lazy"
                            );
                          }, this)
                        )
                        .attr("srcset", g)
                    : ((e = new Image()),
                      (e.onload = a.proxy(function () {
                        f.css({
                          "background-image": 'url("' + g + '")',
                          opacity: "1",
                        }),
                          this._core.trigger(
                            "loaded",
                            { element: f, url: g },
                            "lazy"
                          );
                      }, this)),
                      (e.src = g));
              }, this)
            ),
            this._loaded.push(d.get(0)));
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
          for (b in Object.getOwnPropertyNames(this))
            "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (c) {
        (this._core = c),
          (this._previousHeight = null),
          (this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": a.proxy(
              function (a) {
                a.namespace && this._core.settings.autoHeight && this.update();
              },
              this
            ),
            "changed.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.settings.autoHeight &&
                "position" === a.property.name &&
                this.update();
            }, this),
            "loaded.owl.lazy": a.proxy(function (a) {
              a.namespace &&
                this._core.settings.autoHeight &&
                a.element
                  .closest("." + this._core.settings.itemClass)
                  .index() === this._core.current() &&
                this.update();
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers),
          (this._intervalId = null);
        var d = this;
        a(b).on("load", function () {
          d._core.settings.autoHeight && d.update();
        }),
          a(b).resize(function () {
            d._core.settings.autoHeight &&
              (null != d._intervalId && clearTimeout(d._intervalId),
              (d._intervalId = setTimeout(function () {
                d.update();
              }, 250)));
          });
      };
      (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
        (e.prototype.update = function () {
          var b = this._core._current,
            c = b + this._core.settings.items,
            d = this._core.settings.lazyLoad,
            e = this._core.$stage.children().toArray().slice(b, c),
            f = [],
            g = 0;
          a.each(e, function (b, c) {
            f.push(a(c).height());
          }),
            (g = Math.max.apply(null, f)),
            g <= 1 && d && this._previousHeight && (g = this._previousHeight),
            (this._previousHeight = g),
            this._core.$stage
              .parent()
              .height(g)
              .addClass(this._core.settings.autoHeightClass);
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this._handlers)
            this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this))
            "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._videos = {}),
          (this._playing = null),
          (this._handlers = {
            "initialized.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.register({
                  type: "state",
                  name: "playing",
                  tags: ["interacting"],
                });
            }, this),
            "resize.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.settings.video &&
                this.isInFullScreen() &&
                a.preventDefault();
            }, this),
            "refreshed.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.is("resizing") &&
                this._core.$stage.find(".cloned .owl-video-frame").remove();
            }, this),
            "changed.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                "position" === a.property.name &&
                this._playing &&
                this.stop();
            }, this),
            "prepared.owl.carousel": a.proxy(function (b) {
              if (b.namespace) {
                var c = a(b.content).find(".owl-video");
                c.length &&
                  (c.css("display", "none"), this.fetch(c, a(b.content)));
              }
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this._core.$element.on(this._handlers),
          this._core.$element.on(
            "click.owl.video",
            ".owl-video-play-icon",
            a.proxy(function (a) {
              this.play(a);
            }, this)
          );
      };
      (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
        (e.prototype.fetch = function (a, b) {
          var c = (function () {
              return a.attr("data-vimeo-id")
                ? "vimeo"
                : a.attr("data-vzaar-id")
                ? "vzaar"
                : "youtube";
            })(),
            d =
              a.attr("data-vimeo-id") ||
              a.attr("data-youtube-id") ||
              a.attr("data-vzaar-id"),
            e = a.attr("data-width") || this._core.settings.videoWidth,
            f = a.attr("data-height") || this._core.settings.videoHeight,
            g = a.attr("href");
          if (!g) throw new Error("Missing video URL.");
          if (
            ((d = g.match(
              /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
            )),
            d[3].indexOf("youtu") > -1)
          )
            c = "youtube";
          else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
          else {
            if (!(d[3].indexOf("vzaar") > -1))
              throw new Error("Video URL not supported.");
            c = "vzaar";
          }
          (d = d[6]),
            (this._videos[g] = { type: c, id: d, width: e, height: f }),
            b.attr("data-video", g),
            this.thumbnail(a, this._videos[g]);
        }),
        (e.prototype.thumbnail = function (b, c) {
          var d,
            e,
            f,
            g =
              c.width && c.height
                ? "width:" + c.width + "px;height:" + c.height + "px;"
                : "",
            h = b.find("img"),
            i = "src",
            j = "",
            k = this._core.settings,
            l = function (c) {
              (e = '<div class="owl-video-play-icon"></div>'),
                (d = k.lazyLoad
                  ? a("<div/>", { class: "owl-video-tn " + j, srcType: c })
                  : a("<div/>", {
                      class: "owl-video-tn",
                      style: "opacity:1;background-image:url(" + c + ")",
                    })),
                b.after(d),
                b.after(e);
            };
          if (
            (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })),
            this._core.settings.lazyLoad &&
              ((i = "data-src"), (j = "owl-lazy")),
            h.length)
          )
            return l(h.attr(i)), h.remove(), !1;
          "youtube" === c.type
            ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
            : "vimeo" === c.type
            ? a.ajax({
                type: "GET",
                url: "//vimeo.com/api/v2/video/" + c.id + ".json",
                jsonp: "callback",
                dataType: "jsonp",
                success: function (a) {
                  (f = a[0].thumbnail_large), l(f);
                },
              })
            : "vzaar" === c.type &&
              a.ajax({
                type: "GET",
                url: "//vzaar.com/api/videos/" + c.id + ".json",
                jsonp: "callback",
                dataType: "jsonp",
                success: function (a) {
                  (f = a.framegrab_url), l(f);
                },
              });
        }),
        (e.prototype.stop = function () {
          this._core.trigger("stop", null, "video"),
            this._playing.find(".owl-video-frame").remove(),
            this._playing.removeClass("owl-video-playing"),
            (this._playing = null),
            this._core.leave("playing"),
            this._core.trigger("stopped", null, "video");
        }),
        (e.prototype.play = function (b) {
          var c,
            d = a(b.target),
            e = d.closest("." + this._core.settings.itemClass),
            f = this._videos[e.attr("data-video")],
            g = f.width || "100%",
            h = f.height || this._core.$stage.height();
          this._playing ||
            (this._core.enter("playing"),
            this._core.trigger("play", null, "video"),
            (e = this._core.items(this._core.relative(e.index()))),
            this._core.reset(e.index()),
            (c = a(
              '<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'
            )),
            c.attr("height", h),
            c.attr("width", g),
            "youtube" === f.type
              ? c.attr(
                  "src",
                  "//www.youtube.com/embed/" +
                    f.id +
                    "?autoplay=1&rel=0&v=" +
                    f.id
                )
              : "vimeo" === f.type
              ? c.attr(
                  "src",
                  "//player.vimeo.com/video/" + f.id + "?autoplay=1"
                )
              : "vzaar" === f.type &&
                c.attr(
                  "src",
                  "//view.vzaar.com/" + f.id + "/player?autoplay=true"
                ),
            a(c)
              .wrap('<div class="owl-video-frame" />')
              .insertAfter(e.find(".owl-video")),
            (this._playing = e.addClass("owl-video-playing")));
        }),
        (e.prototype.isInFullScreen = function () {
          var b =
            c.fullscreenElement ||
            c.mozFullScreenElement ||
            c.webkitFullscreenElement;
          return b && a(b).parent().hasClass("owl-video-frame");
        }),
        (e.prototype.destroy = function () {
          var a, b;
          this._core.$element.off("click.owl.video");
          for (a in this._handlers)
            this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this))
            "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Video = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this.core = b),
          (this.core.options = a.extend({}, e.Defaults, this.core.options)),
          (this.swapping = !0),
          (this.previous = d),
          (this.next = d),
          (this.handlers = {
            "change.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                "position" == a.property.name &&
                ((this.previous = this.core.current()),
                (this.next = a.property.value));
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
              a.proxy(function (a) {
                a.namespace && (this.swapping = "translated" == a.type);
              }, this),
            "translate.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this.swapping &&
                (this.core.options.animateOut || this.core.options.animateIn) &&
                this.swap();
            }, this),
          }),
          this.core.$element.on(this.handlers);
      };
      (e.Defaults = { animateOut: !1, animateIn: !1 }),
        (e.prototype.swap = function () {
          if (
            1 === this.core.settings.items &&
            a.support.animation &&
            a.support.transition
          ) {
            this.core.speed(0);
            var b,
              c = a.proxy(this.clear, this),
              d = this.core.$stage.children().eq(this.previous),
              e = this.core.$stage.children().eq(this.next),
              f = this.core.settings.animateIn,
              g = this.core.settings.animateOut;
            this.core.current() !== this.previous &&
              (g &&
                ((b =
                  this.core.coordinates(this.previous) -
                  this.core.coordinates(this.next)),
                d
                  .one(a.support.animation.end, c)
                  .css({ left: b + "px" })
                  .addClass("animated owl-animated-out")
                  .addClass(g)),
              f &&
                e
                  .one(a.support.animation.end, c)
                  .addClass("animated owl-animated-in")
                  .addClass(f));
          }
        }),
        (e.prototype.clear = function (b) {
          a(b.target)
            .css({ left: "" })
            .removeClass("animated owl-animated-out owl-animated-in")
            .removeClass(this.core.settings.animateIn)
            .removeClass(this.core.settings.animateOut),
            this.core.onTransitionEnd();
        }),
        (e.prototype.destroy = function () {
          var a, b;
          for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
          for (b in Object.getOwnPropertyNames(this))
            "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      var e = function (b) {
        (this._core = b),
          (this._call = null),
          (this._time = 0),
          (this._timeout = 0),
          (this._paused = !0),
          (this._handlers = {
            "changed.owl.carousel": a.proxy(function (a) {
              a.namespace && "settings" === a.property.name
                ? this._core.settings.autoplay
                  ? this.play()
                  : this.stop()
                : a.namespace &&
                  "position" === a.property.name &&
                  this._paused &&
                  (this._time = 0);
            }, this),
            "initialized.owl.carousel": a.proxy(function (a) {
              a.namespace && this._core.settings.autoplay && this.play();
            }, this),
            "play.owl.autoplay": a.proxy(function (a, b, c) {
              a.namespace && this.play(b, c);
            }, this),
            "stop.owl.autoplay": a.proxy(function (a) {
              a.namespace && this.stop();
            }, this),
            "mouseover.owl.autoplay": a.proxy(function () {
              this._core.settings.autoplayHoverPause &&
                this._core.is("rotating") &&
                this.pause();
            }, this),
            "mouseleave.owl.autoplay": a.proxy(function () {
              this._core.settings.autoplayHoverPause &&
                this._core.is("rotating") &&
                this.play();
            }, this),
            "touchstart.owl.core": a.proxy(function () {
              this._core.settings.autoplayHoverPause &&
                this._core.is("rotating") &&
                this.pause();
            }, this),
            "touchend.owl.core": a.proxy(function () {
              this._core.settings.autoplayHoverPause && this.play();
            }, this),
          }),
          this._core.$element.on(this._handlers),
          (this._core.options = a.extend({}, e.Defaults, this._core.options));
      };
      (e.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1,
      }),
        (e.prototype._next = function (d) {
          (this._call = b.setTimeout(
            a.proxy(this._next, this, d),
            this._timeout * (Math.round(this.read() / this._timeout) + 1) -
              this.read()
          )),
            this._core.is("interacting") ||
              c.hidden ||
              this._core.next(d || this._core.settings.autoplaySpeed);
        }),
        (e.prototype.read = function () {
          return new Date().getTime() - this._time;
        }),
        (e.prototype.play = function (c, d) {
          var e;
          this._core.is("rotating") || this._core.enter("rotating"),
            (c = c || this._core.settings.autoplayTimeout),
            (e = Math.min(this._time % (this._timeout || c), c)),
            this._paused
              ? ((this._time = this.read()), (this._paused = !1))
              : b.clearTimeout(this._call),
            (this._time += (this.read() % c) - e),
            (this._timeout = c),
            (this._call = b.setTimeout(a.proxy(this._next, this, d), c - e));
        }),
        (e.prototype.stop = function () {
          this._core.is("rotating") &&
            ((this._time = 0),
            (this._paused = !0),
            b.clearTimeout(this._call),
            this._core.leave("rotating"));
        }),
        (e.prototype.pause = function () {
          this._core.is("rotating") &&
            !this._paused &&
            ((this._time = this.read()),
            (this._paused = !0),
            b.clearTimeout(this._call));
        }),
        (e.prototype.destroy = function () {
          var a, b;
          this.stop();
          for (a in this._handlers)
            this._core.$element.off(a, this._handlers[a]);
          for (b in Object.getOwnPropertyNames(this))
            "function" != typeof this[b] && (this[b] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      "use strict";
      var e = function (b) {
        (this._core = b),
          (this._initialized = !1),
          (this._pages = []),
          (this._controls = {}),
          (this._templates = []),
          (this.$element = this._core.$element),
          (this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to,
          }),
          (this._handlers = {
            "prepared.owl.carousel": a.proxy(function (b) {
              b.namespace &&
                this._core.settings.dotsData &&
                this._templates.push(
                  '<div class="' +
                    this._core.settings.dotClass +
                    '">' +
                    a(b.content)
                      .find("[data-dot]")
                      .addBack("[data-dot]")
                      .attr("data-dot") +
                    "</div>"
                );
            }, this),
            "added.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.settings.dotsData &&
                this._templates.splice(a.position, 0, this._templates.pop());
            }, this),
            "remove.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._core.settings.dotsData &&
                this._templates.splice(a.position, 1);
            }, this),
            "changed.owl.carousel": a.proxy(function (a) {
              a.namespace && "position" == a.property.name && this.draw();
            }, this),
            "initialized.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                !this._initialized &&
                (this._core.trigger("initialize", null, "navigation"),
                this.initialize(),
                this.update(),
                this.draw(),
                (this._initialized = !0),
                this._core.trigger("initialized", null, "navigation"));
            }, this),
            "refreshed.owl.carousel": a.proxy(function (a) {
              a.namespace &&
                this._initialized &&
                (this._core.trigger("refresh", null, "navigation"),
                this.update(),
                this.draw(),
                this._core.trigger("refreshed", null, "navigation"));
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this.$element.on(this._handlers);
      };
      (e.Defaults = {
        nav: !1,
        navText: [
          '<span aria-label="Previous">&#x2039;</span>',
          '<span aria-label="Next">&#x203a;</span>',
        ],
        navSpeed: !1,
        navElement: 'button type="button" role="presentation"',
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1,
      }),
        (e.prototype.initialize = function () {
          var b,
            c = this._core.settings;
          (this._controls.$relative = (
            c.navContainer
              ? a(c.navContainer)
              : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
          ).addClass("disabled")),
            (this._controls.$previous = a("<" + c.navElement + ">")
              .addClass(c.navClass[0])
              .html(c.navText[0])
              .prependTo(this._controls.$relative)
              .on(
                "click",
                a.proxy(function (a) {
                  this.prev(c.navSpeed);
                }, this)
              )),
            (this._controls.$next = a("<" + c.navElement + ">")
              .addClass(c.navClass[1])
              .html(c.navText[1])
              .appendTo(this._controls.$relative)
              .on(
                "click",
                a.proxy(function (a) {
                  this.next(c.navSpeed);
                }, this)
              )),
            c.dotsData ||
              (this._templates = [
                a('<button role="button">')
                  .addClass(c.dotClass)
                  .append(a("<span>"))
                  .prop("outerHTML"),
              ]),
            (this._controls.$absolute = (
              c.dotsContainer
                ? a(c.dotsContainer)
                : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
            ).addClass("disabled")),
            this._controls.$absolute.on(
              "click",
              "button",
              a.proxy(function (b) {
                var d = a(b.target).parent().is(this._controls.$absolute)
                  ? a(b.target).index()
                  : a(b.target).parent().index();
                b.preventDefault(), this.to(d, c.dotsSpeed);
              }, this)
            );
          for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
        }),
        (e.prototype.destroy = function () {
          var a, b, c, d, e;
          e = this._core.settings;
          for (a in this._handlers) this.$element.off(a, this._handlers[a]);
          for (b in this._controls)
            "$relative" === b && e.navContainer
              ? this._controls[b].html("")
              : this._controls[b].remove();
          for (d in this.overides) this._core[d] = this._overrides[d];
          for (c in Object.getOwnPropertyNames(this))
            "function" != typeof this[c] && (this[c] = null);
        }),
        (e.prototype.update = function () {
          var a,
            b,
            c,
            d = this._core.clones().length / 2,
            e = d + this._core.items().length,
            f = this._core.maximum(!0),
            g = this._core.settings,
            h =
              g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
          if (
            ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
            g.dots || "page" == g.slideBy)
          )
            for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
              if (b >= h || 0 === b) {
                if (
                  (this._pages.push({
                    start: Math.min(f, a - d),
                    end: a - d + h - 1,
                  }),
                  Math.min(f, a - d) === f)
                )
                  break;
                (b = 0), ++c;
              }
              b += this._core.mergers(this._core.relative(a));
            }
        }),
        (e.prototype.draw = function () {
          var b,
            c = this._core.settings,
            d = this._core.items().length <= c.items,
            e = this._core.relative(this._core.current()),
            f = c.loop || c.rewind;
          this._controls.$relative.toggleClass("disabled", !c.nav || d),
            c.nav &&
              (this._controls.$previous.toggleClass(
                "disabled",
                !f && e <= this._core.minimum(!0)
              ),
              this._controls.$next.toggleClass(
                "disabled",
                !f && e >= this._core.maximum(!0)
              )),
            this._controls.$absolute.toggleClass("disabled", !c.dots || d),
            c.dots &&
              ((b =
                this._pages.length -
                this._controls.$absolute.children().length),
              c.dotsData && 0 !== b
                ? this._controls.$absolute.html(this._templates.join(""))
                : b > 0
                ? this._controls.$absolute.append(
                    new Array(b + 1).join(this._templates[0])
                  )
                : b < 0 &&
                  this._controls.$absolute.children().slice(b).remove(),
              this._controls.$absolute.find(".active").removeClass("active"),
              this._controls.$absolute
                .children()
                .eq(a.inArray(this.current(), this._pages))
                .addClass("active"));
        }),
        (e.prototype.onTrigger = function (b) {
          var c = this._core.settings;
          b.page = {
            index: a.inArray(this.current(), this._pages),
            count: this._pages.length,
            size:
              c &&
              (c.center || c.autoWidth || c.dotsData
                ? 1
                : c.dotsEach || c.items),
          };
        }),
        (e.prototype.current = function () {
          var b = this._core.relative(this._core.current());
          return a
            .grep(
              this._pages,
              a.proxy(function (a, c) {
                return a.start <= b && a.end >= b;
              }, this)
            )
            .pop();
        }),
        (e.prototype.getPosition = function (b) {
          var c,
            d,
            e = this._core.settings;
          return (
            "page" == e.slideBy
              ? ((c = a.inArray(this.current(), this._pages)),
                (d = this._pages.length),
                b ? ++c : --c,
                (c = this._pages[((c % d) + d) % d].start))
              : ((c = this._core.relative(this._core.current())),
                (d = this._core.items().length),
                b ? (c += e.slideBy) : (c -= e.slideBy)),
            c
          );
        }),
        (e.prototype.next = function (b) {
          a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
        }),
        (e.prototype.prev = function (b) {
          a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
        }),
        (e.prototype.to = function (b, c, d) {
          var e;
          !d && this._pages.length
            ? ((e = this._pages.length),
              a.proxy(this._overrides.to, this._core)(
                this._pages[((b % e) + e) % e].start,
                c
              ))
            : a.proxy(this._overrides.to, this._core)(b, c);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      "use strict";
      var e = function (c) {
        (this._core = c),
          (this._hashes = {}),
          (this.$element = this._core.$element),
          (this._handlers = {
            "initialized.owl.carousel": a.proxy(function (c) {
              c.namespace &&
                "URLHash" === this._core.settings.startPosition &&
                a(b).trigger("hashchange.owl.navigation");
            }, this),
            "prepared.owl.carousel": a.proxy(function (b) {
              if (b.namespace) {
                var c = a(b.content)
                  .find("[data-hash]")
                  .addBack("[data-hash]")
                  .attr("data-hash");
                if (!c) return;
                this._hashes[c] = b.content;
              }
            }, this),
            "changed.owl.carousel": a.proxy(function (c) {
              if (c.namespace && "position" === c.property.name) {
                var d = this._core.items(
                    this._core.relative(this._core.current())
                  ),
                  e = a
                    .map(this._hashes, function (a, b) {
                      return a === d ? b : null;
                    })
                    .join();
                if (!e || b.location.hash.slice(1) === e) return;
                b.location.hash = e;
              }
            }, this),
          }),
          (this._core.options = a.extend({}, e.Defaults, this._core.options)),
          this.$element.on(this._handlers),
          a(b).on(
            "hashchange.owl.navigation",
            a.proxy(function (a) {
              var c = b.location.hash.substring(1),
                e = this._core.$stage.children(),
                f = this._hashes[c] && e.index(this._hashes[c]);
              f !== d &&
                f !== this._core.current() &&
                this._core.to(this._core.relative(f), !1, !0);
            }, this)
          );
      };
      (e.Defaults = { URLhashListener: !1 }),
        (e.prototype.destroy = function () {
          var c, d;
          a(b).off("hashchange.owl.navigation");
          for (c in this._handlers)
            this._core.$element.off(c, this._handlers[c]);
          for (d in Object.getOwnPropertyNames(this))
            "function" != typeof this[d] && (this[d] = null);
        }),
        (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
    })(window.Zepto || window.jQuery, window, document),
    (function (a, b, c, d) {
      function e(b, c) {
        var e = !1,
          f = b.charAt(0).toUpperCase() + b.slice(1);
        return (
          a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
            if (g[b] !== d) return (e = !c || b), !1;
          }),
          e
        );
      }
      function f(a) {
        return e(a, !0);
      }
      var g = a("<support>").get(0).style,
        h = "Webkit Moz O ms".split(" "),
        i = {
          transition: {
            end: {
              WebkitTransition: "webkitTransitionEnd",
              MozTransition: "transitionend",
              OTransition: "oTransitionEnd",
              transition: "transitionend",
            },
          },
          animation: {
            end: {
              WebkitAnimation: "webkitAnimationEnd",
              MozAnimation: "animationend",
              OAnimation: "oAnimationEnd",
              animation: "animationend",
            },
          },
        },
        j = {
          csstransforms: function () {
            return !!e("transform");
          },
          csstransforms3d: function () {
            return !!e("perspective");
          },
          csstransitions: function () {
            return !!e("transition");
          },
          cssanimations: function () {
            return !!e("animation");
          },
        };
      j.csstransitions() &&
        ((a.support.transition = new String(f("transition"))),
        (a.support.transition.end = i.transition.end[a.support.transition])),
        j.cssanimations() &&
          ((a.support.animation = new String(f("animation"))),
          (a.support.animation.end = i.animation.end[a.support.animation])),
        j.csstransforms() &&
          ((a.support.transform = new String(f("transform"))),
          (a.support.transform3d = j.csstransforms3d()));
    })(window.Zepto || window.jQuery, window, document);

  $(".beelee__ingredients-item-mobile").on("click", function (e) {
    e.preventDefault();
    $("#beelee__ingredients-modal").modal({});
  });
  $(".modal-close").on("click", function () {
    $("#beelee__ingredients-modal").modal("hide");
  });
  $(".beelee__ingredients-items .owl-carousel").owlCarousel({
    loop: false,
    responsiveClass: true,
    items: 1,
    nav: false,
    dots: true,
    margin: 20,
    stagePadding: 40,
    navText: [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10L3.125 10" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 15.625L3.125 10L8.75 4.375" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsive: {
      0: {
        items: 1,
        margin: 15,
        stagePadding: 0,
        nav: false,
        dots: true,
        loop: true,
      },
      768: {
        items: 3,
        margin: 40,
        stagePadding: 80,
        dots: false,
        nav: true,
      },
    },
  });
  $(".modal-ingredients.owl-carousel").owlCarousel({
    loop: false,
    responsiveClass: true,
    items: 1,
    nav: false,
    dots: true,
    margin: 20,
    stagePadding: 40,
    navText: [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10L3.125 10" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 15.625L3.125 10L8.75 4.375" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsive: {
      0: {
        items: 1,
        margin: 40,
        stagePadding: 60,
        nav: false,
        dots: false,
      },
      768: {
        items: 3,
        margin: 80,
        stagePadding: 80,
        dots: false,
        nav: true,
      },
    },
  });
});

$(function () {
  function random(owlSelector) {
    owlSelector
      .children()
      .sort(function () {
        return Math.round(Math.random()) - 0.5;
      })
      .each(function () {
        $(this).appendTo(owlSelector);
      });
  }
  var owl = $(".beelee__similar-items .owl-carousel");
  owl.owlCarousel({
    loop: true,
    responsiveClass: true,
    items: 2,
    nav: false,
    dots: true,
    margin: 20,
    stagePadding: 0,
    navText: [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10L3.125 10" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 15.625L3.125 10L8.75 4.375" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsive: {
      0: {
        items: 2,
        margin: 15,
        stagePadding: 0,
        nav: false,
        dots: true,
      },
      768: {
        items: 4,
        margin: 40,
        stagePadding: 0,
        dots: false,
        nav: true,
      },
    },
  });
  owl.on("initialize.owl.carousel", function (event) {
    console.log("owl init");
  });
});

$(".beelee__ingredients-item-title").on("click", function (e) {
  e.preventDefault();
  var wrapper = $(this).closest(".beelee__ingredients-item");
  if (wrapper.hasClass("active")) {
    wrapper.removeClass("active");
    $(".beelee__ingredients-item-content", wrapper).slideUp();
  } else {
    wrapper.addClass("active");
    $(".beelee__ingredients-item-content", wrapper).slideDown();
  }
});

var bny_product = {
  id: 6572377014370,
  title: "Sonnenschutzcreme für Körper mit Propolis",
  handle: "apicare-propolis-korper-sonnenschutzcreme-80ml",
  description:
    "\u003ch2\u003eWas ist Apicare Sonnenschutzcreme für Körper mit Propolis (80ml)\u003c/h2\u003e\n\u003cul\u003e\n\u003cli\u003eUnsere Sonnenschutzcreme bedeckt die Haut und bildet eine transparente dünne Schicht auf der Haut und zieht nicht ein.\u003cbr\u003eDas von uns verwendete Mineral ist das patentierte Nan-Nano-Mineral Zink und hinterlässt beim Auftragen keine weiße Schicht.\u003c/li\u003e\n\u003cli\u003eWährend es Ihre Haut mit Propolis und natürlichem Mineralfilter vor den schädlichen Sonnenstrahlen schützt, sorgt es mit seiner einzigartigen Formel für den Feuchtigkeitshaushalt Ihrer Haut.\u003c/li\u003e\n\u003c/ul\u003e\n\u003ch2\u003e7 Wirkungen von ApiCare Körper Sonnenschutzcreme mit Propolis \u003c/h2\u003e\n\u003col\u003e\n\u003cli\u003eWährend es mit wertvollen phenolischen und flavonoiden Bestandteilen wie Koffein (Kaffeesäure-Phenethylester), Quercetin, Pinosembrin, Galangin, Chrysin zur Ernährung und zum Schutz der Haut beiträgt, beugt es der Hautalterung und Verfärbung vor , Faltenbildung durch die schädlichen UV-Strahlen der Sonne und verhindert die Bildung von Hautton. \u003c/li\u003e\n\u003cli\u003eDarüber hinaus entgiftet es die Haut mit der starken antioxidativen Wirkung von Propolis und hilft, abgestorbene Zellen und Giftstoffe aus der Haut zu entfernen. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eAloe Vera:\u003c/strong\u003e Hilft der Haut, die durch Sonneneinstrahlung Wasser verloren hat, ihre Feuchtigkeit zurückzugewinnen. Es reduziert das ((((((Abblättern ))))) und stellt die Flexibilität wieder her. Dies verbessert das Erscheinungsbild trockener oder geschädigter Haut. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eMineral Zink:\u003c/strong\u003e Der effektive Filter mit Nicht-Nano-Zinkgehalt bietet Schutz vor UV-Strahlen. In dünner Schicht aufgetragen hilft es, den Wasserverlust der Haut zu verhindern. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eSheabutter:\u003c/strong\u003e Mit ihrer hohen feuchtigkeitsspendenden Eigenschaft hilft sie, die Trockenheit der Haut zu entfernen. Bei regelmäßiger Anwendung verleiht es der Haut ein glattes und lebendiges Aussehen. Es ist eine reiche Quelle natürlicher Antioxidantien in den Vitaminen A, E und D. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eVitamin E\u003c/strong\u003e: Vitamin E, das für eine gesunde Haut und Haut notwendig ist, nimmt einen wichtigen Platz unter den Hautpflegeprodukten ein, da es die Alterung verzögert und Altersflecken verhindert. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eJojobaöl\u003c/strong\u003e: Bietet den natürlichen Feuchtigkeits- und Ölhalt der Haut und hilft, ihre Textur und Weichheit zu bewahren. Es stärkt die Haut gegen Sonnenbrand und beugt Irritationen vor.\u003c/li\u003e\n\u003c/ol\u003e",
  published_at: "2021-09-01T16:19:47+02:00",
  created_at: "2021-06-30T10:55:34+02:00",
  vendor: "Bee\u0026You Deutschland",
  type: "Creme",
  tags: [
    "aloe-vera",
    "apicare",
    "Propolis",
    "sheabutter",
    "single",
    "tax19",
    "vitamin-b5",
    "vitamin-e",
    "zink",
  ],
  price: 2295,
  price_min: 2295,
  price_max: 2295,
  available: true,
  price_varies: false,
  compare_at_price: null,
  compare_at_price_min: 0,
  compare_at_price_max: 0,
  compare_at_price_varies: false,
  variants: [
    {
      id: 39359157141602,
      title: "Default Title",
      option1: "Default Title",
      option2: null,
      option3: null,
      sku: "SNS-ADL",
      requires_shipping: true,
      taxable: true,
      featured_image: null,
      available: true,
      name: "Sonnenschutzcreme für Körper mit Propolis",
      public_title: null,
      options: ["Default Title"],
      price: 2295,
      weight: 0,
      compare_at_price: null,
      inventory_management: "shopify",
      barcode: "19085300167",
      unit_price: 2869,
      unit_price_measurement: {
        measured_type: "volume",
        quantity_value: "80.0",
        quantity_unit: "ml",
        reference_value: 100,
        reference_unit: "ml",
      },
      requires_selling_plan: false,
      selling_plan_allocations: [
        {
          price_adjustments: [
            {
              position: 1,
              price: 1951,
            },
          ],
          price: 1951,
          compare_at_price: 2295,
          per_delivery_price: 1951,
          unit_price: 2439,
          selling_plan_id: 434012258,
          selling_plan_group_id: "df96ccf856803af5acea1cbbd1290dc51f71431d",
        },
      ],
    },
  ],
  images: [
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/2_Natural_Mineral_Sunscreen_shopify_1080x1254_b1752d74-e751-4994-b25b-b5a14dd1cc48.jpg?v=1662972879",
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/1_1080x1254_5.jpg?v=1662972879",
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/6_1080x1254_5.jpg?v=1662972879",
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/2_1080x1254_5.jpg?v=1662972879",
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/4_1080x1254_5.jpg?v=1662972879",
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/5_1080x1254_5.jpg?v=1662972879",
  ],
  featured_image:
    "//cdn.shopify.com/s/files/1/0072/5450/7572/products/2_Natural_Mineral_Sunscreen_shopify_1080x1254_b1752d74-e751-4994-b25b-b5a14dd1cc48.jpg?v=1662972879",
  options: ["Title"],
  media: [
    {
      alt: null,
      id: 33741500809482,
      position: 1,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/2_Natural_Mineral_Sunscreen_shopify_1080x1254_b1752d74-e751-4994-b25b-b5a14dd1cc48.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/2_Natural_Mineral_Sunscreen_shopify_1080x1254_b1752d74-e751-4994-b25b-b5a14dd1cc48.jpg?v=1662972879",
      width: 1080,
    },
    {
      alt: null,
      id: 33313023688970,
      position: 2,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/1_1080x1254_5.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/1_1080x1254_5.jpg?v=1662972879",
      width: 1080,
    },
    {
      alt: null,
      id: 33313023525130,
      position: 3,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/6_1080x1254_5.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/6_1080x1254_5.jpg?v=1662972879",
      width: 1080,
    },
    {
      alt: null,
      id: 33313023656202,
      position: 4,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/2_1080x1254_5.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/2_1080x1254_5.jpg?v=1662972879",
      width: 1080,
    },
    {
      alt: null,
      id: 33313023590666,
      position: 5,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/4_1080x1254_5.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/4_1080x1254_5.jpg?v=1662972879",
      width: 1080,
    },
    {
      alt: null,
      id: 33313023557898,
      position: 6,
      preview_image: {
        aspect_ratio: 0.861,
        height: 1254,
        width: 1080,
        src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/5_1080x1254_5.jpg?v=1662972879",
      },
      aspect_ratio: 0.861,
      height: 1254,
      media_type: "image",
      src: "https://cdn.shopify.com/s/files/1/0072/5450/7572/products/5_1080x1254_5.jpg?v=1662972879",
      width: 1080,
    },
  ],
  requires_selling_plan: false,
  selling_plan_groups: [
    {
      id: "df96ccf856803af5acea1cbbd1290dc51f71431d",
      name: "Abonnieren",
      options: [
        {
          name: "Deliver every",
          position: 1,
          values: ["jeden zwei Monate  (-15%)"],
        },
      ],
      selling_plans: [
        {
          id: 434012258,
          name: "jeden zwei Monate geliefert",
          description: null,
          options: [
            {
              name: "Deliver every",
              position: 1,
              value: "jeden zwei Monate  (-15%)",
            },
          ],
          recurring_deliveries: true,
          price_adjustments: [
            {
              order_count: null,
              position: 1,
              value_type: "percentage",
              value: 15,
            },
          ],
          checkout_charge: {
            value_type: "percentage",
            value: 100,
          },
        },
      ],
      app_id: null,
    },
  ],
  content:
    "\u003ch2\u003eWas ist Apicare Sonnenschutzcreme für Körper mit Propolis (80ml)\u003c/h2\u003e\n\u003cul\u003e\n\u003cli\u003eUnsere Sonnenschutzcreme bedeckt die Haut und bildet eine transparente dünne Schicht auf der Haut und zieht nicht ein.\u003cbr\u003eDas von uns verwendete Mineral ist das patentierte Nan-Nano-Mineral Zink und hinterlässt beim Auftragen keine weiße Schicht.\u003c/li\u003e\n\u003cli\u003eWährend es Ihre Haut mit Propolis und natürlichem Mineralfilter vor den schädlichen Sonnenstrahlen schützt, sorgt es mit seiner einzigartigen Formel für den Feuchtigkeitshaushalt Ihrer Haut.\u003c/li\u003e\n\u003c/ul\u003e\n\u003ch2\u003e7 Wirkungen von ApiCare Körper Sonnenschutzcreme mit Propolis \u003c/h2\u003e\n\u003col\u003e\n\u003cli\u003eWährend es mit wertvollen phenolischen und flavonoiden Bestandteilen wie Koffein (Kaffeesäure-Phenethylester), Quercetin, Pinosembrin, Galangin, Chrysin zur Ernährung und zum Schutz der Haut beiträgt, beugt es der Hautalterung und Verfärbung vor , Faltenbildung durch die schädlichen UV-Strahlen der Sonne und verhindert die Bildung von Hautton. \u003c/li\u003e\n\u003cli\u003eDarüber hinaus entgiftet es die Haut mit der starken antioxidativen Wirkung von Propolis und hilft, abgestorbene Zellen und Giftstoffe aus der Haut zu entfernen. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eAloe Vera:\u003c/strong\u003e Hilft der Haut, die durch Sonneneinstrahlung Wasser verloren hat, ihre Feuchtigkeit zurückzugewinnen. Es reduziert das ((((((Abblättern ))))) und stellt die Flexibilität wieder her. Dies verbessert das Erscheinungsbild trockener oder geschädigter Haut. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eMineral Zink:\u003c/strong\u003e Der effektive Filter mit Nicht-Nano-Zinkgehalt bietet Schutz vor UV-Strahlen. In dünner Schicht aufgetragen hilft es, den Wasserverlust der Haut zu verhindern. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eSheabutter:\u003c/strong\u003e Mit ihrer hohen feuchtigkeitsspendenden Eigenschaft hilft sie, die Trockenheit der Haut zu entfernen. Bei regelmäßiger Anwendung verleiht es der Haut ein glattes und lebendiges Aussehen. Es ist eine reiche Quelle natürlicher Antioxidantien in den Vitaminen A, E und D. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eVitamin E\u003c/strong\u003e: Vitamin E, das für eine gesunde Haut und Haut notwendig ist, nimmt einen wichtigen Platz unter den Hautpflegeprodukten ein, da es die Alterung verzögert und Altersflecken verhindert. \u003c/li\u003e\n\u003cli\u003e\n\u003cstrong\u003eJojobaöl\u003c/strong\u003e: Bietet den natürlichen Feuchtigkeits- und Ölhalt der Haut und hilft, ihre Textur und Weichheit zu bewahren. Es stärkt die Haut gegen Sonnenbrand und beugt Irritationen vor.\u003c/li\u003e\n\u003c/ol\u003e",
};

function serialize(form) {
  var arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (
      !field.name ||
      field.disabled ||
      ["file", "reset", "submit", "button"].indexOf(field.type) > -1
    )
      return;
    if (field.type === "select-multiple") {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push(
          encodeURIComponent(field.name) +
            "=" +
            encodeURIComponent(option.value)
        );
      });
      return;
    }
    if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
      return;
    arr.push(
      encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
    );
  });
  return arr.join("&");
}

var accordeon = {
  reset: function () {
    if (!$('.beelee-product_tabs-acc[data-index="0"]').hasClass("active")) {
      this.close();
    }
  },
  open: function (index) {
    $(".beelee-product_tabs-acc").removeClass("active");
    $('.beelee-product_tabs-acc[data-index="' + index + '"]').addClass(
      "active"
    );
    $(".beelee-product_tabs-content").slideUp(400);
    $('.beelee-product_tabs-content[data-index="' + index + '"]').slideDown(
      400
    );
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop:
            $('.beelee-product_tabs-acc[data-index="' + index + '"]').offset()
              .top - 200,
        },
        400
      );
    }, 500);
  },
  close: function () {
    $(".beelee-product_tabs-acc").removeClass("active");
    $(".beelee-product_tabs-content").removeClass("active");
    $(".beelee-product_tabs-content").slideUp();
  },
};
var tabs = {
  reset: function () {
    if (
      !$('.beelee-product_tabs-control a[data-index="0"]').hasClass("active")
    ) {
      this.open(0);
      // $('.beelee-product_tabs-content').show();
    }
  },
  open: function (index) {
    $(".beelee-product_tabs-content").removeClass("active");
    $('.beelee-product_tabs-content[data-index="' + index + '"]').addClass(
      "active"
    );
    $(".beelee-product_tabs-controls a").removeClass("active");
    $('.beelee-product_tabs-controls a[data-index="' + index + '"]').addClass(
      "active"
    );
  },
  close: function (index) {},
};
var purchase = {
  quantity: 0,
  isSubscription: false,
};
$(window).on("resize", function (e) {
  var win = $(this);
  var width = win.width();
  if (width < 992) {
    accordeon.reset();
  } else {
    tabs.reset();
  }
});
var width = $(window).width();
if (width > 992) {
  $(".beelee-product_tabs-content").first().addClass("active");
}
$(window).on("scroll", function (e) {
  var scroll = $(window).scrollTop();
  var el = $(".beelee-product__form-mobile");
  if (scroll > 300) {
    $(".beelee__whatsapp").addClass("pull");
    if (el.hasClass("hide")) el.removeClass("hide");
  } else {
    $(".beelee__whatsapp").removeClass("pull");
    if (!el.hasClass("hide")) el.addClass("hide");
  }
});
$(document).ready(function () {
  $("video").prop("muted", true);
  $("#mute-video").click(function () {
    $("video").prop("muted", true);
  });
  setTimeout(function () {
    console.log($(".active .owl-video-play-icon"));
    $(".active .owl-video-play-icon").trigger("click");
  }, 1000);
});
$(document).on("click", ".owl-thumbs img", function () {
  if ($(".owl-item.active").hasClass("owl-video-playing")) {
  } else {
    setTimeout(function () {
      $(".active .owl-video-play-icon").trigger("click");
    }, 1000);
  }
});
$(function () {
  $(".beelee-product__form-subscription-option").on("click", function (e) {
    e.preventDefault();
    var type = $(this).data("type");
    $(".beelee-product__form-subscription-option").removeClass("selected");
    $(".beelee-product__form-button-section :radio").prop("checked", false);
    $(this).addClass("selected");
    $(".beelee-product__form-button-section :radio", this).prop(
      "checked",
      true
    );
    if (type == "subscription") {
      // prepare subscription inputs
    } else {
      // prepare one time inputs
    }
  });
  $(".beelee-product_tabs-control a").on("click", function (e) {
    e.preventDefault();
    var index = $(this).data("index");
    var isActive = $(this).hasClass("active");
    if (!isActive) {
      tabs.open(index);
    }
  });
  $(".beelee-product_tabs-acc").on("click", function (e) {
    e.preventDefault();
    var index = $(this).data("index");
    var isActive = $(this).hasClass("active");
    if (isActive) {
      accordeon.close(index);
    } else {
      accordeon.open(index);
    }
  });
  var slider = $(".beelee-product__slider .owl-carousel");

  function zoomThis(zoomTarget) {
    zoomTarget.trigger("zoom.destroy");
    var zoom_options = {
      url: zoomTarget.data("src"),
      callback: false,
      target: zoomTarget,
      duration: 200, // Transition in milli seconds (default is 120)
      on: "mouseover", // other options: grab, click, toggle (default is mouseover)
      touch: false, // enables a touch fallback
      onZoomIn: false,
      onZoomOut: false,
    };
  }
  slider.owlCarousel({
    items: 1,
    responsiveClass: true,
    navText: [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10L3.125 10" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 15.625L3.125 10L8.75 4.375" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    nav: true,
    loop: true,
    video: true,
    onInitialized: function (e) {
      var target = e.currentTarget;
      (i = e.item.index),
        (zoomTarget = $(target).find(".owl-item").eq(i).find(".item"));
      zoomThis(zoomTarget);
    },
    onChanged: function (e) {
      var target = e.currentTarget;
      (i = e.item.index),
        (zoomTarget = $(target).find(".owl-item").eq(i).find(".item"));
      console.log(target);
      zoomThis(zoomTarget);
    },
    afterAction: function (current) {},
  });
  $(".owl-thumbs img").first().addClass("active");
  $(".owl-thumbs img").on("click", function (e) {
    $(".owl-thumbs img").removeClass("active");
    $(this).addClass("active");
    var number = $(this).index();
    slider.data("owl.carousel").to(number, 300, true);
  });
  var variant_sku = "SNS-ADL";
  var summaryBadge = new productStickerSummary();
  summaryBadge.showSummary({
    tsId: "XC9C051982385D33C7E10EBE1B0B219A7",
    sku: ["SNS-ADL"],
    element: "#trusted-shops-SNS-ADL",
    starColor: "#FFD800",
    starSize: "20px",
    fontSize: "16px",
    showRating: "true",
    scrollToReviews: "true",
    enablePlaceholder: "true",
  });
  $(".beelee__ingredients-items .owl-carousel").owlCarousel({
    loop: true,
    responsiveClass: true,
    items: 1,
    nav: false,
    dots: true,
    margin: 20,
    stagePadding: 40,
    navText: [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.875 10L3.125 10" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 15.625L3.125 10L8.75 4.375" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.125 10H16.875" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="#291E19" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    responsive: {
      0: {
        items: 1,
        margin: 15,
        stagePadding: 0,
        nav: false,
        dots: true,
      },
      768: {
        items: 3,
        margin: 40,
        stagePadding: 80,
        dots: false,
        nav: true,
      },
    },
  });
  $(".beelee-product__form-subscription-info-button").on("click", function (e) {
    e.preventDefault();
    var popup = $(".beelee-product__form-subscription-popup");
    if (popup.is(":visible")) {
      $(".beelee-product__form-subscription-popup").hide();
    } else {
      $(".beelee-product__form-subscription-popup").show();
    }
  });
  $(".beelee-sub-close").on("click", function () {
    $(".beelee-product__form-subscription-popup").hide();
  });
  $("[beelee-product-item-increment]").on("click", function (e) {
    e.preventDefault();
    var id = $(this).attr("beelee-cart-item-increment");
    var quantity = +$("#quantity").val() + 1;
    $(".belee-product__quantity-amount").text(quantity);
    $("#quantity").val(quantity);
  });
  $("[beelee-product-item-decrement]").on("click", function (e) {
    e.preventDefault();
    var id = $(this).attr("beelee-cart-item-decrement");
    var quantity = +$("#quantity").val() - 1;
    if (quantity < 1) quantity = 1;
    $(".belee-product__quantity-amount").text(quantity);
    $("#quantity").val(quantity);
  });
  $("#trusted-expand").on("click", function () {
    if ($(".ts-wrapper").length > 0) {
      $(".ts-wrapper").addClass("open");
      $(this).hide();
    }
  });
});
